// This file is auto-generated by @hey-api/openapi-ts

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type Account = {
    readonly uid: string;
    readonly lookup: string;
    readonly email: string;
    readonly agreed_to_terms_and_privacy: (string) | null;
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     */
    readonly username: string;
    first_name: string;
    last_name: string;
    readonly date_joined: string;
    avatar_file?: (string) | null;
    date_of_birth?: (string) | null;
    country: CountryEnum;
    phone_number?: string;
    disable_help_popup_app?: boolean;
    disable_help_popup_portal?: boolean;
    /**
     * Max three initials
     */
    initials?: string;
    readonly last_activity: (string) | null;
    language?: string;
    preferred_organisation?: (string) | null;
    preferred_stable?: (string) | null;
    color?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type ActivityContactRole = {
    role_uid?: (string) | null;
    contact_uid: string;
    primary?: boolean;
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type ActivityType = {
    readonly uid: string;
    name?: string;
    /**
     * (in legend/daily overview, e.g. "1")
     */
    order?: (number) | null;
    default?: (ActivityTypeDefaultEnum | BlankEnum);
    /**
     * Order is the number you can click on to mark an activity as done.
     */
    hide_order?: boolean;
    hidden?: boolean;
    /**
     * Show this activity type in the quick add menu on the weekly overview and in the app.
     */
    enable_quick_add?: boolean;
    /**
     * Select which activity types should always be shown in the daily overview (even when no horses are attached)
     */
    stable_settings_activity_types_general?: Array<(string)>;
    color?: string;
    category?: ActivityTypeCategoryEnum;
    /**
     * Number of days a notification is send before a planned activity with reminder
     */
    notify_before?: (number) | null;
    facility_uids?: Array<(string)>;
    extra_info_fields?: Array<(ExtraInfoFieldsEnum | BlankEnum)>;
    possible_roles?: Array<((string) | null)>;
};

/**
 * * `SPORT` - sport
 * * `BREEDING` - breeding
 * * `CARE` - care
 */
export enum ActivityTypeCategoryEnum {
    SPORT = 'SPORT',
    BREEDING = 'BREEDING',
    CARE = 'CARE'
}

/**
 * * `RIDING` - Riding
 * * `PADDOCK` - Paddock
 * * `LUNGING` - Lunging
 * * `FARRIER` - Farrier
 * * `VACCINATION` - Vaccination
 * * `VETERINARY` - Veterinary
 * * `SHOW` - Show
 * * `CUSTOMER` - Customer
 * * `DEWORM` - Deworm
 * * `DENTIST` - Dentist
 * * `LESSON` - Lesson
 * * `INSEMINATION` - Insemination
 * * `FOALING` - Foaling
 * * `MARE_CYCLE_CHECK` - Mare Cycle Check
 * * `RHINO` - Rhino
 * * `STALLION_MOUNT` - Stallion Mount
 */
export enum ActivityTypeDefaultEnum {
    RIDING = 'RIDING',
    PADDOCK = 'PADDOCK',
    LUNGING = 'LUNGING',
    FARRIER = 'FARRIER',
    VACCINATION = 'VACCINATION',
    VETERINARY = 'VETERINARY',
    SHOW = 'SHOW',
    CUSTOMER = 'CUSTOMER',
    DEWORM = 'DEWORM',
    DENTIST = 'DENTIST',
    LESSON = 'LESSON',
    INSEMINATION = 'INSEMINATION',
    FOALING = 'FOALING',
    MARE_CYCLE_CHECK = 'MARE_CYCLE_CHECK',
    RHINO = 'RHINO',
    STALLION_MOUNT = 'STALLION_MOUNT'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type ActivityTypePrice = {
    readonly uid: string;
    activity_type_uid: string;
    price: string;
    readonly price_currency: string;
    vat_percentage_uid: string;
    /**
     * The category used when creating an invoice line for this activity type.
     */
    category_uid: string;
    vat_included_in_price?: boolean;
    readonly created_on: string;
    readonly last_modified_on: string;
};

/**
 * * `fcm_equinem` - Equinem
 */
export enum ApplicationIdEnum {
    FCM_EQUINEM = 'fcm_equinem'
}

/**
 * * `arrival` - arrival
 * * `departure` - departure
 */
export enum ArrivalOrDepartureEnum {
    ARRIVAL = 'arrival',
    DEPARTURE = 'departure'
}

export type Authorize = {
    code?: string;
    state?: string;
    KoppelSleutel?: string;
    ReferenceKey?: string;
};

/**
 * Serializer for the Availability class.
 */
export type Availability = {
    readonly uid: string;
    all_day_event?: boolean;
    availability_type?: AvailabilityTypeEnum;
    contact_uid: string;
    readonly created_by_contact_uid: string;
    readonly created_by_employee: boolean;
    readonly created_on: string;
    description?: (string) | null;
    readonly employment_uid: string;
    readonly has_leave_allowance_impact: boolean;
    readonly impact_hours: string;
    status?: (AvailabilityStatusEnum);
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    endTimeUnspecified?: boolean;
    recurrence?: string;
};

/**
 * Serializer for the approve and reject actions of the Availability class.
 */
export type AvailabilityApproveDecline = {
    readonly uid: string;
    readonly all_day_event: boolean;
    readonly availability_type: (AvailabilityTypeEnum);
    readonly contact_uid: string;
    readonly created_by_contact_uid: string;
    readonly created_by_employee: boolean;
    readonly created_on: string;
    readonly description: (string) | null;
    readonly employment_uid: string;
    readonly has_leave_allowance_impact: boolean;
    readonly impact_hours: string;
    readonly status: (AvailabilityStatusEnum);
    readonly start: (DatetimeOrDateField);
    readonly end: (DatetimeOrDateField);
    readonly endTimeUnspecified: boolean;
    readonly recurrence: string;
};

/**
 * Serializer for updates from employees to the Availability class.
 */
export type AvailabilityEmployeeUpdate = {
    description?: (string) | null;
    end?: DatetimeOrDateField;
    readonly start: (DatetimeOrDateField);
    readonly all_day_event: boolean;
    readonly endTimeUnspecified: boolean;
    readonly status: (AvailabilityStatusEnum);
    readonly recurrence: string;
};

/**
 * Serializer for the (manager) Availability class.
 */
export type AvailabilityManager = {
    readonly uid: string;
    all_day_event?: boolean;
    availability_type?: AvailabilityTypeEnum;
    contact_uid: string;
    readonly created_by_contact_uid: string;
    readonly created_by_employee: boolean;
    readonly created_on: string;
    description?: (string) | null;
    readonly employment_uid: string;
    readonly has_leave_allowance_impact: boolean;
    readonly impact_hours: string;
    status?: (AvailabilityStatusEnum);
    readonly hours_exceeded_current_budget: string;
    readonly hours_exceeded_end_of_year_budget: string;
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    endTimeUnspecified?: boolean;
    recurrence?: string;
};

/**
 * Serializer for updates from manager to the Availability class.
 */
export type AvailabilityManagerUpdate = {
    availability_type?: AvailabilityTypeEnum;
    end?: DatetimeOrDateField;
    has_leave_allowance_impact?: boolean;
    status?: (AvailabilityStatusEnum);
    readonly start: (DatetimeOrDateField);
    readonly all_day_event: boolean;
    readonly endTimeUnspecified: boolean;
    readonly recurrence: string;
};

/**
 * * `confirmed` - Confirmed
 * * `tentative` - Tentative
 * * `cancelled` - Cancelled
 * * `rejected` - Rejected
 */
export enum AvailabilityStatusEnum {
    CONFIRMED = 'confirmed',
    TENTATIVE = 'tentative',
    CANCELLED = 'cancelled',
    REJECTED = 'rejected'
}

/**
 * * `sick` - Sick
 * * `leave` - Leave
 * * `overtime` - Overtime
 */
export enum AvailabilityTypeEnum {
    SICK = 'sick',
    LEAVE = 'leave',
    OVERTIME = 'overtime'
}

/**
 * * `YES` - Yes
 * * `NO` - No
 * * `MAYBE` - Maybe
 * * `UNKNOWN` - Unknown
 */
export enum AvailableEnum {
    YES = 'YES',
    NO = 'NO',
    MAYBE = 'MAYBE',
    UNKNOWN = 'UNKNOWN'
}

/**
 * * `MONDAY` - monday
 * * `TUESDAY` - tuesday
 * * `WEDNESDAY` - wednesday
 * * `THURSDAY` - thursday
 * * `FRIDAY` - friday
 * * `SATURDAY` - saturday
 * * `SUNDAY` - sunday
 */
export enum AvailableWeekdaysEnum {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY'
}

export type AveragedHistoricHorseCount = {
    samples: Array<HistoricHorseCount>;
    average: HistoricHorseCount;
};

export type BackGroundTask = {
    task_id?: string;
    state?: StateEnum;
    result?: string;
    progress?: Progress;
    exception?: unknown;
};

/**
 * * `BE` - België
 * * `BG` - Bulgarije
 * * `CY` - Cyprus
 * * `DK` - Denemarken
 * * `DE` - Duitsland
 * * `EE` - Estland
 * * `FI` - Finland
 * * `FR` - Frankrijk
 * * `EL` - Griekenland
 * * `UK` - Groot-brittannië
 * * `HU` - Hongarije
 * * `IE` - Ierland
 * * `IT` - Italië
 * * `HR` - Kroatië
 * * `LV` - Letland
 * * `LT` - Litouwen
 * * `LU` - Luxemburg
 * * `MT` - Malta
 * * `NL` - Nederland
 * * `XI` - Noord-ierland
 * * `AT` - Oostenrijk
 * * `PL` - Polen
 * * `PT` - Portugal
 * * `RO` - Roemenië
 * * `SI` - Slovenië
 * * `SK` - Slowakije
 * * `ES` - Spanje
 * * `ES2` - Spanje catalonië
 * * `CZ` - Tsjechië
 * * `SE` - Zweden
 */
export enum BestemmingLandCodeEnum {
    BE = 'BE',
    BG = 'BG',
    CY = 'CY',
    DK = 'DK',
    DE = 'DE',
    EE = 'EE',
    FI = 'FI',
    FR = 'FR',
    EL = 'EL',
    UK = 'UK',
    HU = 'HU',
    IE = 'IE',
    IT = 'IT',
    HR = 'HR',
    LV = 'LV',
    LT = 'LT',
    LU = 'LU',
    MT = 'MT',
    NL = 'NL',
    XI = 'XI',
    AT = 'AT',
    PL = 'PL',
    PT = 'PT',
    RO = 'RO',
    SI = 'SI',
    SK = 'SK',
    ES = 'ES',
    ES2 = 'ES2',
    CZ = 'CZ',
    SE = 'SE'
}

/**
 * Billable items are created when the following so called 'source material' is made and or
 * due for invoicing: OrderItem, RealActivity, TransactionItem and ServiceContract.
 *
 * Before a billable item can be invoiced, certain fields like price, vat_percentage and category
 * must have a value. BillableItem will try and fill those by itself, but you can set or override
 * those fields if needed. The list of `missing_fields_for_invoicing` must be empty before the
 * respective item can be invoiced.
 *
 * Note:
 * - If the vat_percentage is missing, this can be inferred from a category: you can try setting that.
 * - If the category is missing, this can be inferred from a product: you can try setting that.
 */
export type BillableItem = {
    readonly uid: string;
    customer_uid?: (string) | null;
    readonly organisation_uid: string;
    readonly horse_uid: (string) | null;
    readonly activity_uid: (string) | null;
    readonly transaction_item_uid: (string) | null;
    readonly transaction_uid: (string) | null;
    readonly order_item_uid: (string) | null;
    readonly order_uid: (string) | null;
    readonly service_contract_uid: (string) | null;
    /**
     * The moment the respective source of this billable item (i.e. service contract, order item, etc) was purchased or the start of a period that is billed if the respective source item has recurringproperties or affects a period, like a service contract.
     */
    readonly start_dt: string;
    /**
     * End of the period for this billable item for the service contract. Required when a service contract is provided, else optional.
     */
    readonly end_dt: (string) | null;
    readonly invoice_uid: (string) | null;
    readonly invoice_item_uid: (string) | null;
    /**
     * hide an item to move it from to-invoice to not-to-invoice
     */
    hidden?: boolean;
    readonly hidden_dt: (string) | null;
    related_activities?: Array<(string)>;
    /**
     * Shows the fields for which this billable item requires a value before it can be invoiced.
     */
    missing_fields_for_invoicing: Array<(string)>;
    /**
     * Shows the price that should be charged to this customer, considering the ownership and 100% price at the _time of creation_. This can be overridden.
     */
    price: (Money | null);
    /**
     * Shows the price considering the _current_ ownership and source material unit price.
     */
    readonly current_price: (Money | null);
    category_uid?: (string) | null;
    product_uid?: (string) | null;
    vat_percentage_uid?: (string) | null;
    vat_included_in_price?: (boolean) | null;
    /**
     * The source material is any of [order_item, service_contract, transaction_item, activity], depending on which of these relations is set. This price shows the *current* 100% price of that regardless of ownership.
     */
    readonly source_material_unit_price: (Money | null);
    /**
     * Defaults to 'full'. This indicates whethergit this billable item fully represents its source material or only a part of it, and which part.
     *
     * * `FULL` - full
     * * `UPFRONT` - upfront
     * * `REMAINDER` - remainder
     */
    readonly payment_part: (PaymentPartEnum);
};

/**
 * (De)serializes just the uid field of a Billable item, e.g. `{"uid": "BI8gZkz"}`
 */
export type BillableItemUid = {
    readonly uid: string;
};

export enum BlankEnum {
    EMPTY_STRING = ''
}

/**
 * BreedingPlan is a plan for a breeding mare for a given year
 */
export type BreedingPlan = {
    readonly uid: string;
    /**
     * The mare who is the subject of this plan. Can be the carrying mare or biological mare.
     */
    mare_uid: string;
    /**
     * The biological mare in case the plan's mare only carried the foal.
     */
    biological_mare_uid?: (string) | null;
    readonly biological_mare: (PublicHorse);
    year: number;
    readonly sequence: number;
    /**
     * Breeding plans where this horse is the stallion.
     */
    stallion_uid?: (string) | null;
    readonly stallion: (PublicHorse);
    /**
     * Not-empty, generated number, unique per organization.
     */
    readonly number: number;
    semen_type?: (SemenTypeEnum | BlankEnum);
    usage_type?: (UsageTypeEnum | BlankEnum);
    studbook?: (StudbookEnum | BlankEnum);
    requester_uid?: (string) | null;
};

/**
 * * `1` - per invoice (wire)
 * * `2` - via braintree (Creditcard/Paypal)
 * * `3` - Via GoCardLess (Direct Debt)
 * * `4` - via Apple (IAP)
 * * `5` - via Google (IAP)
 * * `6` - The payment is processed by Mollie
 */
export enum BrokerTypeEnum {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6
}

/**
 * * `1` - Training
 * * `2` - Revalidation
 * * `3` - Clinic
 * * `4` - Other
 */
export enum BusinessTypeEnum {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4
}

export type CannotCreateHorse = {
    horse: EquineMHorseSearchDetail;
    soortFoutIndicator: string;
};

/**
 * Serializes products that can be ordered with the provided organisation. Note that products come
 * in various categories and that some default categories have extra fields. For example a BREEDING product will
 * nest a stallion, and a SHIPPING product will have a not-null shipping_provider_name.
 */
export type CatalogueProduct = {
    readonly uid: string;
    readonly name: string;
    readonly description: string;
    /**
     * The date is exclusive: on this date the product will not be available anymore.
     */
    readonly available_until: (string) | null;
    readonly category: (PublicCategory);
    /**
     * Pick a plan for which you want to offer a subscription in your organisation's catalogue.
     */
    readonly plan: (string) | null;
    /**
     * Every product needs a product type. This is used in the business logic to identify the type of the product.
     *
     * * `HEALTH_CERTIFICATE` - health certificate
     * * `BREEDING_ADMINISTRATION` - breeding administration
     * * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     * * `ACTIVITY` - Activity
     */
    readonly product_type: (ProductTypeEnum);
    /**
     * The number of instances (for a credits or tiered plan) that should be permitted by a contract on the plan's module. Leave blank to indicate there is no no limit (in case of a flat fee plan). This is only relevant for subscription products.
     */
    readonly max_amount: (number) | null;
    /**
     * discount percentage [0-100] if the customer pays for a whole year in the first invoice
     */
    readonly yearly_invoice_discount_percentage: number;
    /**
     * The unit this product comes in, e.g. 'ml', 'portion', 'kg'
     */
    readonly qualifier: string;
    /**
     * Indicates if orders with this product should include at least one shipping product.
     */
    readonly requires_shipping: boolean;
    price: string;
    price_currency: string;
    readonly price_points: Array<PricePoint>;
    /**
     * Indicates the amount for this product that will be applied as down payment on the invoice. Set to 0 to apply the full amount.
     */
    readonly upfront_cost: string;
    readonly upfront_cost_currency: string;
    readonly shipping_provider_name: (string) | null;
    readonly shipping_service_type: (ShippingServiceTypeEnum | NullEnum);
    readonly postcodes_for_staff_delivery: string;
    readonly shipping_countries: Array<(CountryEnum | BlankEnum)>;
    stallion: (PublicHorse | null);
    readonly fresh_available: boolean;
    readonly frozen_available: boolean;
    readonly show_in_shop: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type Category = {
    readonly uid: string;
    p_s_type?: PSTypeEnum;
    name: string;
    exactnl_ledger_code?: string;
    moneybird_ledger_code?: string;
    yuki_ledger_code?: string;
    readonly default: (DefaultProductTypeEnum | NullEnum);
    vatLevelCountry: Array<VatLevelCountry>;
};

/**
 * * `1` - black
 * * `2` - brown
 * * `3` - baybrown
 * * `4` - darkbrown
 * * `5` - chestnut
 * * `6` - grey
 * * `7` - strawberry
 * * `8` - piebald
 * * `9` - skewbald
 * * `10` - dun
 * * `11` - cream
 * * `12` - palomino
 * * `13` - appaloosa
 */
export enum ColorEnum {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
    '_7' = 7,
    '_8' = 8,
    '_9' = 9,
    '_10' = 10,
    '_11' = 11,
    '_12' = 12,
    '_13' = 13
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type Contact = {
    readonly uid: string;
    color?: string;
    readonly user_uid: (string) | null;
    stables?: Array<((string) | null)>;
    /**
     * Max three initials
     */
    initials?: string;
    readonly hidden: boolean;
    roles?: Array<((string) | null)>;
    first_name?: string;
    last_name?: string;
    studbook_preference?: (StudbookEnum | BlankEnum);
    business_name?: string;
    phone_number?: string;
    email?: string;
    external_location?: boolean;
    customer_id?: string;
    moneybird_contact_id?: (number) | null;
    exactnl_contact_id?: string;
    snelstart_contact_id?: string;
    is_inseminator?: boolean;
    is_semen_collection_station?: boolean;
    is_insemination_station?: boolean;
    /**
     * only show orders where requester is a contact with use_for_picking in the picklist
     */
    use_for_picking?: boolean;
    vat_number?: string;
    readonly vat_number_checked: (boolean) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    address_line1?: string;
    address_line2?: string;
    address_line3?: string;
    country?: (CountryEnum | BlankEnum);
    state?: string;
    postcode?: string;
    city?: string;
    title?: (TitleEnum | BlankEnum);
    date_of_birth?: (string) | null;
    show_in_daily?: boolean;
    show_in_work_schedule?: boolean;
    note?: string;
    readonly stable_location_uid: string;
    UBN?: string;
    invoice_language?: (InvoiceLanguageEnum | BlankEnum);
    business_type?: (BusinessTypeEnum | NullEnum);
    readonly lookup: string;
    readonly manage_horse_location_history: boolean;
    readonly machtiging_rvo_gegeven: (string) | null;
    readonly machtiging_rvo_gegeven_by_uid: (string) | null;
    readonly invitation: (SentInvitation | null);
    create_user_invitation?: boolean;
    parent_stable?: (string) | null;
    IBAN?: string;
    bank_code?: string;
    account_number?: string;
    bank_name?: string;
    second_phone_number?: string;
    company_registration_number?: string;
    /**
     * In case the contact represents a (supplier side) customer, this product can be used as suggestion or default in orders, that require shipping.
     */
    default_shipping_product?: (string) | null;
};

/**
 * '
 * Adds support for UID fields.
 *
 * Also remove all fields with value 'null' (None) from the output.
 */
export type ContactData = {
    first_name?: string;
    last_name?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type ContactDetail = {
    readonly uid: string;
    color?: string;
    readonly user_uid: (string) | null;
    stables?: Array<((string) | null)>;
    /**
     * Max three initials
     */
    initials?: string;
    readonly hidden: boolean;
    roles?: Array<((string) | null)>;
    first_name?: string;
    last_name?: string;
    studbook_preference?: (StudbookEnum | BlankEnum);
    business_name?: string;
    phone_number?: string;
    email?: string;
    external_location?: boolean;
    customer_id?: string;
    moneybird_contact_id?: (number) | null;
    exactnl_contact_id?: string;
    snelstart_contact_id?: string;
    is_inseminator?: boolean;
    is_semen_collection_station?: boolean;
    is_insemination_station?: boolean;
    /**
     * only show orders where requester is a contact with use_for_picking in the picklist
     */
    use_for_picking?: boolean;
    vat_number?: string;
    readonly vat_number_checked: (boolean) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    address_line1?: string;
    address_line2?: string;
    address_line3?: string;
    country?: (CountryEnum | BlankEnum);
    state?: string;
    postcode?: string;
    city?: string;
    title?: (TitleEnum | BlankEnum);
    date_of_birth?: (string) | null;
    show_in_daily?: boolean;
    show_in_work_schedule?: boolean;
    note?: string;
    readonly stable_location_uid: string;
    UBN?: string;
    invoice_language?: (InvoiceLanguageEnum | BlankEnum);
    business_type?: (BusinessTypeEnum | NullEnum);
    readonly lookup: string;
    readonly manage_horse_location_history: boolean;
    readonly machtiging_rvo_gegeven: (string) | null;
    readonly machtiging_rvo_gegeven_by_uid: (string) | null;
    readonly invitation: (SentInvitation | null);
    create_user_invitation?: boolean;
    parent_stable?: (string) | null;
    IBAN?: string;
    bank_code?: string;
    account_number?: string;
    bank_name?: string;
    second_phone_number?: string;
    company_registration_number?: string;
    /**
     * In case the contact represents a (supplier side) customer, this product can be used as suggestion or default in orders, that require shipping.
     */
    default_shipping_product?: (string) | null;
    readonly duplicates: Array<(string)>;
};

/**
 * * `AF` - Afghanistan
 * * `AX` - Åland Islands
 * * `AL` - Albania
 * * `DZ` - Algeria
 * * `AS` - American Samoa
 * * `AD` - Andorra
 * * `AO` - Angola
 * * `AI` - Anguilla
 * * `AQ` - Antarctica
 * * `AG` - Antigua and Barbuda
 * * `AR` - Argentina
 * * `AM` - Armenia
 * * `AW` - Aruba
 * * `AU` - Australia
 * * `AT` - Austria
 * * `AZ` - Azerbaijan
 * * `BS` - Bahamas
 * * `BH` - Bahrain
 * * `BD` - Bangladesh
 * * `BB` - Barbados
 * * `BY` - Belarus
 * * `BE` - Belgium
 * * `BZ` - Belize
 * * `BJ` - Benin
 * * `BM` - Bermuda
 * * `BT` - Bhutan
 * * `BO` - Bolivia
 * * `BQ` - Bonaire, Sint Eustatius and Saba
 * * `BA` - Bosnia and Herzegovina
 * * `BW` - Botswana
 * * `BV` - Bouvet Island
 * * `BR` - Brazil
 * * `IO` - British Indian Ocean Territory
 * * `BN` - Brunei
 * * `BG` - Bulgaria
 * * `BF` - Burkina Faso
 * * `BI` - Burundi
 * * `CV` - Cabo Verde
 * * `KH` - Cambodia
 * * `CM` - Cameroon
 * * `CA` - Canada
 * * `KY` - Cayman Islands
 * * `CF` - Central African Republic
 * * `TD` - Chad
 * * `CL` - Chile
 * * `CN` - China
 * * `CX` - Christmas Island
 * * `CC` - Cocos (Keeling) Islands
 * * `CO` - Colombia
 * * `KM` - Comoros
 * * `CG` - Congo
 * * `CD` - Congo (the Democratic Republic of the)
 * * `CK` - Cook Islands
 * * `CR` - Costa Rica
 * * `CI` - Côte d'Ivoire
 * * `HR` - Croatia
 * * `CU` - Cuba
 * * `CW` - Curaçao
 * * `CY` - Cyprus
 * * `CZ` - Czechia
 * * `DK` - Denmark
 * * `DJ` - Djibouti
 * * `DM` - Dominica
 * * `DO` - Dominican Republic
 * * `EC` - Ecuador
 * * `EG` - Egypt
 * * `SV` - El Salvador
 * * `GQ` - Equatorial Guinea
 * * `ER` - Eritrea
 * * `EE` - Estonia
 * * `SZ` - Eswatini
 * * `ET` - Ethiopia
 * * `FK` - Falkland Islands (Malvinas)
 * * `FO` - Faroe Islands
 * * `FJ` - Fiji
 * * `FI` - Finland
 * * `FR` - France
 * * `GF` - French Guiana
 * * `PF` - French Polynesia
 * * `TF` - French Southern Territories
 * * `GA` - Gabon
 * * `GM` - Gambia
 * * `GE` - Georgia
 * * `DE` - Germany
 * * `GH` - Ghana
 * * `GI` - Gibraltar
 * * `GR` - Greece
 * * `GL` - Greenland
 * * `GD` - Grenada
 * * `GP` - Guadeloupe
 * * `GU` - Guam
 * * `GT` - Guatemala
 * * `GG` - Guernsey
 * * `GN` - Guinea
 * * `GW` - Guinea-Bissau
 * * `GY` - Guyana
 * * `HT` - Haiti
 * * `HM` - Heard Island and McDonald Islands
 * * `VA` - Holy See
 * * `HN` - Honduras
 * * `HK` - Hong Kong
 * * `HU` - Hungary
 * * `IS` - Iceland
 * * `IN` - India
 * * `ID` - Indonesia
 * * `IR` - Iran
 * * `IQ` - Iraq
 * * `IE` - Ireland
 * * `IM` - Isle of Man
 * * `IL` - Israel
 * * `IT` - Italy
 * * `JM` - Jamaica
 * * `JP` - Japan
 * * `JE` - Jersey
 * * `JO` - Jordan
 * * `KZ` - Kazakhstan
 * * `KE` - Kenya
 * * `KI` - Kiribati
 * * `KW` - Kuwait
 * * `KG` - Kyrgyzstan
 * * `LA` - Laos
 * * `LV` - Latvia
 * * `LB` - Lebanon
 * * `LS` - Lesotho
 * * `LR` - Liberia
 * * `LY` - Libya
 * * `LI` - Liechtenstein
 * * `LT` - Lithuania
 * * `LU` - Luxembourg
 * * `MO` - Macao
 * * `MG` - Madagascar
 * * `MW` - Malawi
 * * `MY` - Malaysia
 * * `MV` - Maldives
 * * `ML` - Mali
 * * `MT` - Malta
 * * `MH` - Marshall Islands
 * * `MQ` - Martinique
 * * `MR` - Mauritania
 * * `MU` - Mauritius
 * * `YT` - Mayotte
 * * `MX` - Mexico
 * * `FM` - Micronesia
 * * `MD` - Moldova
 * * `MC` - Monaco
 * * `MN` - Mongolia
 * * `ME` - Montenegro
 * * `MS` - Montserrat
 * * `MA` - Morocco
 * * `MZ` - Mozambique
 * * `MM` - Myanmar
 * * `NA` - Namibia
 * * `NR` - Nauru
 * * `NP` - Nepal
 * * `NL` - Netherlands
 * * `NC` - New Caledonia
 * * `NZ` - New Zealand
 * * `NI` - Nicaragua
 * * `NE` - Niger
 * * `NG` - Nigeria
 * * `NU` - Niue
 * * `NF` - Norfolk Island
 * * `KP` - North Korea
 * * `MK` - North Macedonia
 * * `MP` - Northern Mariana Islands
 * * `NO` - Norway
 * * `OM` - Oman
 * * `PK` - Pakistan
 * * `PW` - Palau
 * * `PS` - Palestine, State of
 * * `PA` - Panama
 * * `PG` - Papua New Guinea
 * * `PY` - Paraguay
 * * `PE` - Peru
 * * `PH` - Philippines
 * * `PN` - Pitcairn
 * * `PL` - Poland
 * * `PT` - Portugal
 * * `PR` - Puerto Rico
 * * `QA` - Qatar
 * * `RE` - Réunion
 * * `RO` - Romania
 * * `RU` - Russia
 * * `RW` - Rwanda
 * * `BL` - Saint Barthélemy
 * * `SH` - Saint Helena, Ascension and Tristan da Cunha
 * * `KN` - Saint Kitts and Nevis
 * * `LC` - Saint Lucia
 * * `MF` - Saint Martin (French part)
 * * `PM` - Saint Pierre and Miquelon
 * * `VC` - Saint Vincent and the Grenadines
 * * `WS` - Samoa
 * * `SM` - San Marino
 * * `ST` - Sao Tome and Principe
 * * `SA` - Saudi Arabia
 * * `SN` - Senegal
 * * `RS` - Serbia
 * * `SC` - Seychelles
 * * `SL` - Sierra Leone
 * * `SG` - Singapore
 * * `SX` - Sint Maarten (Dutch part)
 * * `SK` - Slovakia
 * * `SI` - Slovenia
 * * `SB` - Solomon Islands
 * * `SO` - Somalia
 * * `ZA` - South Africa
 * * `GS` - South Georgia and the South Sandwich Islands
 * * `KR` - South Korea
 * * `SS` - South Sudan
 * * `ES` - Spain
 * * `LK` - Sri Lanka
 * * `SD` - Sudan
 * * `SR` - Suriname
 * * `SJ` - Svalbard and Jan Mayen
 * * `SE` - Sweden
 * * `CH` - Switzerland
 * * `SY` - Syria
 * * `TW` - Taiwan
 * * `TJ` - Tajikistan
 * * `TZ` - Tanzania
 * * `TH` - Thailand
 * * `TL` - Timor-Leste
 * * `TG` - Togo
 * * `TK` - Tokelau
 * * `TO` - Tonga
 * * `TT` - Trinidad and Tobago
 * * `TN` - Tunisia
 * * `TR` - Türkiye
 * * `TM` - Turkmenistan
 * * `TC` - Turks and Caicos Islands
 * * `TV` - Tuvalu
 * * `UG` - Uganda
 * * `UA` - Ukraine
 * * `AE` - United Arab Emirates
 * * `GB` - United Kingdom
 * * `UM` - United States Minor Outlying Islands
 * * `US` - United States of America
 * * `UY` - Uruguay
 * * `UZ` - Uzbekistan
 * * `VU` - Vanuatu
 * * `VE` - Venezuela
 * * `VN` - Vietnam
 * * `VG` - Virgin Islands (British)
 * * `VI` - Virgin Islands (U.S.)
 * * `WF` - Wallis and Futuna
 * * `EH` - Western Sahara
 * * `YE` - Yemen
 * * `ZM` - Zambia
 * * `ZW` - Zimbabwe
 */
export enum CountryEnum {
    AF = 'AF',
    AX = 'AX',
    AL = 'AL',
    DZ = 'DZ',
    AS = 'AS',
    AD = 'AD',
    AO = 'AO',
    AI = 'AI',
    AQ = 'AQ',
    AG = 'AG',
    AR = 'AR',
    AM = 'AM',
    AW = 'AW',
    AU = 'AU',
    AT = 'AT',
    AZ = 'AZ',
    BS = 'BS',
    BH = 'BH',
    BD = 'BD',
    BB = 'BB',
    BY = 'BY',
    BE = 'BE',
    BZ = 'BZ',
    BJ = 'BJ',
    BM = 'BM',
    BT = 'BT',
    BO = 'BO',
    BQ = 'BQ',
    BA = 'BA',
    BW = 'BW',
    BV = 'BV',
    BR = 'BR',
    IO = 'IO',
    BN = 'BN',
    BG = 'BG',
    BF = 'BF',
    BI = 'BI',
    CV = 'CV',
    KH = 'KH',
    CM = 'CM',
    CA = 'CA',
    KY = 'KY',
    CF = 'CF',
    TD = 'TD',
    CL = 'CL',
    CN = 'CN',
    CX = 'CX',
    CC = 'CC',
    CO = 'CO',
    KM = 'KM',
    CG = 'CG',
    CD = 'CD',
    CK = 'CK',
    CR = 'CR',
    CI = 'CI',
    HR = 'HR',
    CU = 'CU',
    CW = 'CW',
    CY = 'CY',
    CZ = 'CZ',
    DK = 'DK',
    DJ = 'DJ',
    DM = 'DM',
    DO = 'DO',
    EC = 'EC',
    EG = 'EG',
    SV = 'SV',
    GQ = 'GQ',
    ER = 'ER',
    EE = 'EE',
    SZ = 'SZ',
    ET = 'ET',
    FK = 'FK',
    FO = 'FO',
    FJ = 'FJ',
    FI = 'FI',
    FR = 'FR',
    GF = 'GF',
    PF = 'PF',
    TF = 'TF',
    GA = 'GA',
    GM = 'GM',
    GE = 'GE',
    DE = 'DE',
    GH = 'GH',
    GI = 'GI',
    GR = 'GR',
    GL = 'GL',
    GD = 'GD',
    GP = 'GP',
    GU = 'GU',
    GT = 'GT',
    GG = 'GG',
    GN = 'GN',
    GW = 'GW',
    GY = 'GY',
    HT = 'HT',
    HM = 'HM',
    VA = 'VA',
    HN = 'HN',
    HK = 'HK',
    HU = 'HU',
    IS = 'IS',
    IN = 'IN',
    ID = 'ID',
    IR = 'IR',
    IQ = 'IQ',
    IE = 'IE',
    IM = 'IM',
    IL = 'IL',
    IT = 'IT',
    JM = 'JM',
    JP = 'JP',
    JE = 'JE',
    JO = 'JO',
    KZ = 'KZ',
    KE = 'KE',
    KI = 'KI',
    KW = 'KW',
    KG = 'KG',
    LA = 'LA',
    LV = 'LV',
    LB = 'LB',
    LS = 'LS',
    LR = 'LR',
    LY = 'LY',
    LI = 'LI',
    LT = 'LT',
    LU = 'LU',
    MO = 'MO',
    MG = 'MG',
    MW = 'MW',
    MY = 'MY',
    MV = 'MV',
    ML = 'ML',
    MT = 'MT',
    MH = 'MH',
    MQ = 'MQ',
    MR = 'MR',
    MU = 'MU',
    YT = 'YT',
    MX = 'MX',
    FM = 'FM',
    MD = 'MD',
    MC = 'MC',
    MN = 'MN',
    ME = 'ME',
    MS = 'MS',
    MA = 'MA',
    MZ = 'MZ',
    MM = 'MM',
    NA = 'NA',
    NR = 'NR',
    NP = 'NP',
    NL = 'NL',
    NC = 'NC',
    NZ = 'NZ',
    NI = 'NI',
    NE = 'NE',
    NG = 'NG',
    NU = 'NU',
    NF = 'NF',
    KP = 'KP',
    MK = 'MK',
    MP = 'MP',
    NO = 'NO',
    OM = 'OM',
    PK = 'PK',
    PW = 'PW',
    PS = 'PS',
    PA = 'PA',
    PG = 'PG',
    PY = 'PY',
    PE = 'PE',
    PH = 'PH',
    PN = 'PN',
    PL = 'PL',
    PT = 'PT',
    PR = 'PR',
    QA = 'QA',
    RE = 'RE',
    RO = 'RO',
    RU = 'RU',
    RW = 'RW',
    BL = 'BL',
    SH = 'SH',
    KN = 'KN',
    LC = 'LC',
    MF = 'MF',
    PM = 'PM',
    VC = 'VC',
    WS = 'WS',
    SM = 'SM',
    ST = 'ST',
    SA = 'SA',
    SN = 'SN',
    RS = 'RS',
    SC = 'SC',
    SL = 'SL',
    SG = 'SG',
    SX = 'SX',
    SK = 'SK',
    SI = 'SI',
    SB = 'SB',
    SO = 'SO',
    ZA = 'ZA',
    GS = 'GS',
    KR = 'KR',
    SS = 'SS',
    ES = 'ES',
    LK = 'LK',
    SD = 'SD',
    SR = 'SR',
    SJ = 'SJ',
    SE = 'SE',
    CH = 'CH',
    SY = 'SY',
    TW = 'TW',
    TJ = 'TJ',
    TZ = 'TZ',
    TH = 'TH',
    TL = 'TL',
    TG = 'TG',
    TK = 'TK',
    TO = 'TO',
    TT = 'TT',
    TN = 'TN',
    TR = 'TR',
    TM = 'TM',
    TC = 'TC',
    TV = 'TV',
    UG = 'UG',
    UA = 'UA',
    AE = 'AE',
    GB = 'GB',
    UM = 'UM',
    US = 'US',
    UY = 'UY',
    UZ = 'UZ',
    VU = 'VU',
    VE = 'VE',
    VN = 'VN',
    VG = 'VG',
    VI = 'VI',
    WF = 'WF',
    EH = 'EH',
    YE = 'YE',
    ZM = 'ZM',
    ZW = 'ZW'
}

export type CountryYear = {
    country: CountryEnum;
    year: number;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type CreateReportedHorseRelocation = {
    horselocation_uid: string;
    report_type: (ReportTypeEnum);
    submit?: boolean;
    dierHaarKleur?: string;
    dierHerkomstLandCode?: string;
    dierBestemmingLandCode?: string;
};

/**
 * * `XUA` - ADB Unit of Account
 * * `AFN` - Afghan Afghani
 * * `AFA` - Afghan Afghani (1927–2002)
 * * `ALL` - Albanian Lek
 * * `ALK` - Albanian Lek (1946–1965)
 * * `DZD` - Algerian Dinar
 * * `ADP` - Andorran Peseta
 * * `AOA` - Angolan Kwanza
 * * `AOK` - Angolan Kwanza (1977–1991)
 * * `AON` - Angolan New Kwanza (1990–2000)
 * * `AOR` - Angolan Readjusted Kwanza (1995–1999)
 * * `ARA` - Argentine Austral
 * * `ARS` - Argentine Peso
 * * `ARM` - Argentine Peso (1881–1970)
 * * `ARP` - Argentine Peso (1983–1985)
 * * `ARL` - Argentine Peso Ley (1970–1983)
 * * `AMD` - Armenian Dram
 * * `AWG` - Aruban Florin
 * * `AUD` - Australian Dollar
 * * `ATS` - Austrian Schilling
 * * `AZN` - Azerbaijani Manat
 * * `AZM` - Azerbaijani Manat (1993–2006)
 * * `BSD` - Bahamian Dollar
 * * `BHD` - Bahraini Dinar
 * * `BDT` - Bangladeshi Taka
 * * `BBD` - Barbadian Dollar
 * * `BYN` - Belarusian Ruble
 * * `BYB` - Belarusian Ruble (1994–1999)
 * * `BYR` - Belarusian Ruble (2000–2016)
 * * `BEF` - Belgian Franc
 * * `BEC` - Belgian Franc (convertible)
 * * `BEL` - Belgian Franc (financial)
 * * `BZD` - Belize Dollar
 * * `BMD` - Bermudan Dollar
 * * `BTN` - Bhutanese Ngultrum
 * * `BOB` - Bolivian Boliviano
 * * `BOL` - Bolivian Boliviano (1863–1963)
 * * `BOV` - Bolivian Mvdol
 * * `BOP` - Bolivian Peso
 * * `VED` - Bolívar Soberano
 * * `BAM` - Bosnia-Herzegovina Convertible Mark
 * * `BAD` - Bosnia-Herzegovina Dinar (1992–1994)
 * * `BAN` - Bosnia-Herzegovina New Dinar (1994–1997)
 * * `BWP` - Botswanan Pula
 * * `BRC` - Brazilian Cruzado (1986–1989)
 * * `BRZ` - Brazilian Cruzeiro (1942–1967)
 * * `BRE` - Brazilian Cruzeiro (1990–1993)
 * * `BRR` - Brazilian Cruzeiro (1993–1994)
 * * `BRN` - Brazilian New Cruzado (1989–1990)
 * * `BRB` - Brazilian New Cruzeiro (1967–1986)
 * * `BRL` - Brazilian Real
 * * `GBP` - British Pound
 * * `BND` - Brunei Dollar
 * * `BGL` - Bulgarian Hard Lev
 * * `BGN` - Bulgarian Lev
 * * `BGO` - Bulgarian Lev (1879–1952)
 * * `BGM` - Bulgarian Socialist Lev
 * * `BUK` - Burmese Kyat
 * * `BIF` - Burundian Franc
 * * `XPF` - CFP Franc
 * * `KHR` - Cambodian Riel
 * * `CAD` - Canadian Dollar
 * * `CVE` - Cape Verdean Escudo
 * * `KYD` - Cayman Islands Dollar
 * * `XAF` - Central African CFA Franc
 * * `CLE` - Chilean Escudo
 * * `CLP` - Chilean Peso
 * * `CLF` - Chilean Unit of Account (UF)
 * * `CNX` - Chinese People’s Bank Dollar
 * * `CNY` - Chinese Yuan
 * * `CNH` - Chinese Yuan (offshore)
 * * `COP` - Colombian Peso
 * * `COU` - Colombian Real Value Unit
 * * `KMF` - Comorian Franc
 * * `CDF` - Congolese Franc
 * * `CRC` - Costa Rican Colón
 * * `HRD` - Croatian Dinar
 * * `HRK` - Croatian Kuna
 * * `CUC` - Cuban Convertible Peso
 * * `CUP` - Cuban Peso
 * * `CYP` - Cypriot Pound
 * * `CZK` - Czech Koruna
 * * `CSK` - Czechoslovak Hard Koruna
 * * `DKK` - Danish Krone
 * * `DJF` - Djiboutian Franc
 * * `DOP` - Dominican Peso
 * * `NLG` - Dutch Guilder
 * * `XCD` - East Caribbean Dollar
 * * `DDM` - East German Mark
 * * `ECS` - Ecuadorian Sucre
 * * `ECV` - Ecuadorian Unit of Constant Value
 * * `EGP` - Egyptian Pound
 * * `GQE` - Equatorial Guinean Ekwele
 * * `ERN` - Eritrean Nakfa
 * * `EEK` - Estonian Kroon
 * * `ETB` - Ethiopian Birr
 * * `EUR` - Euro
 * * `XBA` - European Composite Unit
 * * `XEU` - European Currency Unit
 * * `XBB` - European Monetary Unit
 * * `XBC` - European Unit of Account (XBC)
 * * `XBD` - European Unit of Account (XBD)
 * * `FKP` - Falkland Islands Pound
 * * `FJD` - Fijian Dollar
 * * `FIM` - Finnish Markka
 * * `FRF` - French Franc
 * * `XFO` - French Gold Franc
 * * `XFU` - French UIC-Franc
 * * `GMD` - Gambian Dalasi
 * * `GEK` - Georgian Kupon Larit
 * * `GEL` - Georgian Lari
 * * `DEM` - German Mark
 * * `GHS` - Ghanaian Cedi
 * * `GHC` - Ghanaian Cedi (1979–2007)
 * * `GIP` - Gibraltar Pound
 * * `XAU` - Gold
 * * `GRD` - Greek Drachma
 * * `GTQ` - Guatemalan Quetzal
 * * `GWP` - Guinea-Bissau Peso
 * * `GNF` - Guinean Franc
 * * `GNS` - Guinean Syli
 * * `GYD` - Guyanaese Dollar
 * * `HTG` - Haitian Gourde
 * * `HNL` - Honduran Lempira
 * * `HKD` - Hong Kong Dollar
 * * `HUF` - Hungarian Forint
 * * `IMP` - IMP
 * * `ISK` - Icelandic Króna
 * * `ISJ` - Icelandic Króna (1918–1981)
 * * `INR` - Indian Rupee
 * * `IDR` - Indonesian Rupiah
 * * `IRR` - Iranian Rial
 * * `IQD` - Iraqi Dinar
 * * `IEP` - Irish Pound
 * * `ILS` - Israeli New Shekel
 * * `ILP` - Israeli Pound
 * * `ILR` - Israeli Shekel (1980–1985)
 * * `ITL` - Italian Lira
 * * `JMD` - Jamaican Dollar
 * * `JPY` - Japanese Yen
 * * `JOD` - Jordanian Dinar
 * * `KZT` - Kazakhstani Tenge
 * * `KES` - Kenyan Shilling
 * * `KWD` - Kuwaiti Dinar
 * * `KGS` - Kyrgystani Som
 * * `LAK` - Laotian Kip
 * * `LVL` - Latvian Lats
 * * `LVR` - Latvian Ruble
 * * `LBP` - Lebanese Pound
 * * `LSL` - Lesotho Loti
 * * `LRD` - Liberian Dollar
 * * `LYD` - Libyan Dinar
 * * `LTL` - Lithuanian Litas
 * * `LTT` - Lithuanian Talonas
 * * `LUL` - Luxembourg Financial Franc
 * * `LUC` - Luxembourgian Convertible Franc
 * * `LUF` - Luxembourgian Franc
 * * `MOP` - Macanese Pataca
 * * `MKD` - Macedonian Denar
 * * `MKN` - Macedonian Denar (1992–1993)
 * * `MGA` - Malagasy Ariary
 * * `MGF` - Malagasy Franc
 * * `MWK` - Malawian Kwacha
 * * `MYR` - Malaysian Ringgit
 * * `MVR` - Maldivian Rufiyaa
 * * `MVP` - Maldivian Rupee (1947–1981)
 * * `MLF` - Malian Franc
 * * `MTL` - Maltese Lira
 * * `MTP` - Maltese Pound
 * * `MRU` - Mauritanian Ouguiya
 * * `MRO` - Mauritanian Ouguiya (1973–2017)
 * * `MUR` - Mauritian Rupee
 * * `MXV` - Mexican Investment Unit
 * * `MXN` - Mexican Peso
 * * `MXP` - Mexican Silver Peso (1861–1992)
 * * `MDC` - Moldovan Cupon
 * * `MDL` - Moldovan Leu
 * * `MCF` - Monegasque Franc
 * * `MNT` - Mongolian Tugrik
 * * `MAD` - Moroccan Dirham
 * * `MAF` - Moroccan Franc
 * * `MZE` - Mozambican Escudo
 * * `MZN` - Mozambican Metical
 * * `MZM` - Mozambican Metical (1980–2006)
 * * `MMK` - Myanmar Kyat
 * * `NAD` - Namibian Dollar
 * * `NPR` - Nepalese Rupee
 * * `ANG` - Netherlands Antillean Guilder
 * * `TWD` - New Taiwan Dollar
 * * `NZD` - New Zealand Dollar
 * * `NIO` - Nicaraguan Córdoba
 * * `NIC` - Nicaraguan Córdoba (1988–1991)
 * * `NGN` - Nigerian Naira
 * * `KPW` - North Korean Won
 * * `NOK` - Norwegian Krone
 * * `OMR` - Omani Rial
 * * `PKR` - Pakistani Rupee
 * * `XPD` - Palladium
 * * `PAB` - Panamanian Balboa
 * * `PGK` - Papua New Guinean Kina
 * * `PYG` - Paraguayan Guarani
 * * `PEI` - Peruvian Inti
 * * `PEN` - Peruvian Sol
 * * `PES` - Peruvian Sol (1863–1965)
 * * `PHP` - Philippine Peso
 * * `XPT` - Platinum
 * * `PLN` - Polish Zloty
 * * `PLZ` - Polish Zloty (1950–1995)
 * * `PTE` - Portuguese Escudo
 * * `GWE` - Portuguese Guinea Escudo
 * * `QAR` - Qatari Riyal
 * * `XRE` - RINET Funds
 * * `RHD` - Rhodesian Dollar
 * * `RON` - Romanian Leu
 * * `ROL` - Romanian Leu (1952–2006)
 * * `RUB` - Russian Ruble
 * * `RUR` - Russian Ruble (1991–1998)
 * * `RWF` - Rwandan Franc
 * * `SVC` - Salvadoran Colón
 * * `WST` - Samoan Tala
 * * `SAR` - Saudi Riyal
 * * `RSD` - Serbian Dinar
 * * `CSD` - Serbian Dinar (2002–2006)
 * * `SCR` - Seychellois Rupee
 * * `SLE` - Sierra Leonean Leone
 * * `SLL` - Sierra Leonean Leone (1964—2022)
 * * `XAG` - Silver
 * * `SGD` - Singapore Dollar
 * * `SKK` - Slovak Koruna
 * * `SIT` - Slovenian Tolar
 * * `SBD` - Solomon Islands Dollar
 * * `SOS` - Somali Shilling
 * * `ZAR` - South African Rand
 * * `ZAL` - South African Rand (financial)
 * * `KRH` - South Korean Hwan (1953–1962)
 * * `KRW` - South Korean Won
 * * `KRO` - South Korean Won (1945–1953)
 * * `SSP` - South Sudanese Pound
 * * `SUR` - Soviet Rouble
 * * `ESP` - Spanish Peseta
 * * `ESA` - Spanish Peseta (A account)
 * * `ESB` - Spanish Peseta (convertible account)
 * * `XDR` - Special Drawing Rights
 * * `LKR` - Sri Lankan Rupee
 * * `SHP` - St. Helena Pound
 * * `XSU` - Sucre
 * * `SDD` - Sudanese Dinar (1992–2007)
 * * `SDG` - Sudanese Pound
 * * `SDP` - Sudanese Pound (1957–1998)
 * * `SRD` - Surinamese Dollar
 * * `SRG` - Surinamese Guilder
 * * `SZL` - Swazi Lilangeni
 * * `SEK` - Swedish Krona
 * * `CHF` - Swiss Franc
 * * `SYP` - Syrian Pound
 * * `STN` - São Tomé & Príncipe Dobra
 * * `STD` - São Tomé & Príncipe Dobra (1977–2017)
 * * `TVD` - TVD
 * * `TJR` - Tajikistani Ruble
 * * `TJS` - Tajikistani Somoni
 * * `TZS` - Tanzanian Shilling
 * * `XTS` - Testing Currency Code
 * * `THB` - Thai Baht
 * * `TPE` - Timorese Escudo
 * * `TOP` - Tongan Paʻanga
 * * `TTD` - Trinidad & Tobago Dollar
 * * `TND` - Tunisian Dinar
 * * `TRY` - Turkish Lira
 * * `TRL` - Turkish Lira (1922–2005)
 * * `TMT` - Turkmenistani Manat
 * * `TMM` - Turkmenistani Manat (1993–2009)
 * * `USD` - US Dollar
 * * `USN` - US Dollar (Next day)
 * * `USS` - US Dollar (Same day)
 * * `UGX` - Ugandan Shilling
 * * `UGS` - Ugandan Shilling (1966–1987)
 * * `UAH` - Ukrainian Hryvnia
 * * `UAK` - Ukrainian Karbovanets
 * * `AED` - United Arab Emirates Dirham
 * * `UYW` - Uruguayan Nominal Wage Index Unit
 * * `UYU` - Uruguayan Peso
 * * `UYP` - Uruguayan Peso (1975–1993)
 * * `UYI` - Uruguayan Peso (Indexed Units)
 * * `UZS` - Uzbekistani Som
 * * `VUV` - Vanuatu Vatu
 * * `VES` - Venezuelan Bolívar
 * * `VEB` - Venezuelan Bolívar (1871–2008)
 * * `VEF` - Venezuelan Bolívar (2008–2018)
 * * `VND` - Vietnamese Dong
 * * `VNN` - Vietnamese Dong (1978–1985)
 * * `CHE` - WIR Euro
 * * `CHW` - WIR Franc
 * * `XOF` - West African CFA Franc
 * * `YDD` - Yemeni Dinar
 * * `YER` - Yemeni Rial
 * * `YUN` - Yugoslavian Convertible Dinar (1990–1992)
 * * `YUD` - Yugoslavian Hard Dinar (1966–1990)
 * * `YUM` - Yugoslavian New Dinar (1994–2002)
 * * `YUR` - Yugoslavian Reformed Dinar (1992–1993)
 * * `ZWN` - ZWN
 * * `ZRN` - Zairean New Zaire (1993–1998)
 * * `ZRZ` - Zairean Zaire (1971–1993)
 * * `ZMW` - Zambian Kwacha
 * * `ZMK` - Zambian Kwacha (1968–2012)
 * * `ZWD` - Zimbabwean Dollar (1980–2008)
 * * `ZWR` - Zimbabwean Dollar (2008)
 * * `ZWL` - Zimbabwean Dollar (2009)
 */
export enum CurrencyEnum {
    XUA = 'XUA',
    AFN = 'AFN',
    AFA = 'AFA',
    ALL = 'ALL',
    ALK = 'ALK',
    DZD = 'DZD',
    ADP = 'ADP',
    AOA = 'AOA',
    AOK = 'AOK',
    AON = 'AON',
    AOR = 'AOR',
    ARA = 'ARA',
    ARS = 'ARS',
    ARM = 'ARM',
    ARP = 'ARP',
    ARL = 'ARL',
    AMD = 'AMD',
    AWG = 'AWG',
    AUD = 'AUD',
    ATS = 'ATS',
    AZN = 'AZN',
    AZM = 'AZM',
    BSD = 'BSD',
    BHD = 'BHD',
    BDT = 'BDT',
    BBD = 'BBD',
    BYN = 'BYN',
    BYB = 'BYB',
    BYR = 'BYR',
    BEF = 'BEF',
    BEC = 'BEC',
    BEL = 'BEL',
    BZD = 'BZD',
    BMD = 'BMD',
    BTN = 'BTN',
    BOB = 'BOB',
    BOL = 'BOL',
    BOV = 'BOV',
    BOP = 'BOP',
    VED = 'VED',
    BAM = 'BAM',
    BAD = 'BAD',
    BAN = 'BAN',
    BWP = 'BWP',
    BRC = 'BRC',
    BRZ = 'BRZ',
    BRE = 'BRE',
    BRR = 'BRR',
    BRN = 'BRN',
    BRB = 'BRB',
    BRL = 'BRL',
    GBP = 'GBP',
    BND = 'BND',
    BGL = 'BGL',
    BGN = 'BGN',
    BGO = 'BGO',
    BGM = 'BGM',
    BUK = 'BUK',
    BIF = 'BIF',
    XPF = 'XPF',
    KHR = 'KHR',
    CAD = 'CAD',
    CVE = 'CVE',
    KYD = 'KYD',
    XAF = 'XAF',
    CLE = 'CLE',
    CLP = 'CLP',
    CLF = 'CLF',
    CNX = 'CNX',
    CNY = 'CNY',
    CNH = 'CNH',
    COP = 'COP',
    COU = 'COU',
    KMF = 'KMF',
    CDF = 'CDF',
    CRC = 'CRC',
    HRD = 'HRD',
    HRK = 'HRK',
    CUC = 'CUC',
    CUP = 'CUP',
    CYP = 'CYP',
    CZK = 'CZK',
    CSK = 'CSK',
    DKK = 'DKK',
    DJF = 'DJF',
    DOP = 'DOP',
    NLG = 'NLG',
    XCD = 'XCD',
    DDM = 'DDM',
    ECS = 'ECS',
    ECV = 'ECV',
    EGP = 'EGP',
    GQE = 'GQE',
    ERN = 'ERN',
    EEK = 'EEK',
    ETB = 'ETB',
    EUR = 'EUR',
    XBA = 'XBA',
    XEU = 'XEU',
    XBB = 'XBB',
    XBC = 'XBC',
    XBD = 'XBD',
    FKP = 'FKP',
    FJD = 'FJD',
    FIM = 'FIM',
    FRF = 'FRF',
    XFO = 'XFO',
    XFU = 'XFU',
    GMD = 'GMD',
    GEK = 'GEK',
    GEL = 'GEL',
    DEM = 'DEM',
    GHS = 'GHS',
    GHC = 'GHC',
    GIP = 'GIP',
    XAU = 'XAU',
    GRD = 'GRD',
    GTQ = 'GTQ',
    GWP = 'GWP',
    GNF = 'GNF',
    GNS = 'GNS',
    GYD = 'GYD',
    HTG = 'HTG',
    HNL = 'HNL',
    HKD = 'HKD',
    HUF = 'HUF',
    IMP = 'IMP',
    ISK = 'ISK',
    ISJ = 'ISJ',
    INR = 'INR',
    IDR = 'IDR',
    IRR = 'IRR',
    IQD = 'IQD',
    IEP = 'IEP',
    ILS = 'ILS',
    ILP = 'ILP',
    ILR = 'ILR',
    ITL = 'ITL',
    JMD = 'JMD',
    JPY = 'JPY',
    JOD = 'JOD',
    KZT = 'KZT',
    KES = 'KES',
    KWD = 'KWD',
    KGS = 'KGS',
    LAK = 'LAK',
    LVL = 'LVL',
    LVR = 'LVR',
    LBP = 'LBP',
    LSL = 'LSL',
    LRD = 'LRD',
    LYD = 'LYD',
    LTL = 'LTL',
    LTT = 'LTT',
    LUL = 'LUL',
    LUC = 'LUC',
    LUF = 'LUF',
    MOP = 'MOP',
    MKD = 'MKD',
    MKN = 'MKN',
    MGA = 'MGA',
    MGF = 'MGF',
    MWK = 'MWK',
    MYR = 'MYR',
    MVR = 'MVR',
    MVP = 'MVP',
    MLF = 'MLF',
    MTL = 'MTL',
    MTP = 'MTP',
    MRU = 'MRU',
    MRO = 'MRO',
    MUR = 'MUR',
    MXV = 'MXV',
    MXN = 'MXN',
    MXP = 'MXP',
    MDC = 'MDC',
    MDL = 'MDL',
    MCF = 'MCF',
    MNT = 'MNT',
    MAD = 'MAD',
    MAF = 'MAF',
    MZE = 'MZE',
    MZN = 'MZN',
    MZM = 'MZM',
    MMK = 'MMK',
    NAD = 'NAD',
    NPR = 'NPR',
    ANG = 'ANG',
    TWD = 'TWD',
    NZD = 'NZD',
    NIO = 'NIO',
    NIC = 'NIC',
    NGN = 'NGN',
    KPW = 'KPW',
    NOK = 'NOK',
    OMR = 'OMR',
    PKR = 'PKR',
    XPD = 'XPD',
    PAB = 'PAB',
    PGK = 'PGK',
    PYG = 'PYG',
    PEI = 'PEI',
    PEN = 'PEN',
    PES = 'PES',
    PHP = 'PHP',
    XPT = 'XPT',
    PLN = 'PLN',
    PLZ = 'PLZ',
    PTE = 'PTE',
    GWE = 'GWE',
    QAR = 'QAR',
    XRE = 'XRE',
    RHD = 'RHD',
    RON = 'RON',
    ROL = 'ROL',
    RUB = 'RUB',
    RUR = 'RUR',
    RWF = 'RWF',
    SVC = 'SVC',
    WST = 'WST',
    SAR = 'SAR',
    RSD = 'RSD',
    CSD = 'CSD',
    SCR = 'SCR',
    SLE = 'SLE',
    SLL = 'SLL',
    XAG = 'XAG',
    SGD = 'SGD',
    SKK = 'SKK',
    SIT = 'SIT',
    SBD = 'SBD',
    SOS = 'SOS',
    ZAR = 'ZAR',
    ZAL = 'ZAL',
    KRH = 'KRH',
    KRW = 'KRW',
    KRO = 'KRO',
    SSP = 'SSP',
    SUR = 'SUR',
    ESP = 'ESP',
    ESA = 'ESA',
    ESB = 'ESB',
    XDR = 'XDR',
    LKR = 'LKR',
    SHP = 'SHP',
    XSU = 'XSU',
    SDD = 'SDD',
    SDG = 'SDG',
    SDP = 'SDP',
    SRD = 'SRD',
    SRG = 'SRG',
    SZL = 'SZL',
    SEK = 'SEK',
    CHF = 'CHF',
    SYP = 'SYP',
    STN = 'STN',
    STD = 'STD',
    TVD = 'TVD',
    TJR = 'TJR',
    TJS = 'TJS',
    TZS = 'TZS',
    XTS = 'XTS',
    THB = 'THB',
    TPE = 'TPE',
    TOP = 'TOP',
    TTD = 'TTD',
    TND = 'TND',
    TRY = 'TRY',
    TRL = 'TRL',
    TMT = 'TMT',
    TMM = 'TMM',
    USD = 'USD',
    USN = 'USN',
    USS = 'USS',
    UGX = 'UGX',
    UGS = 'UGS',
    UAH = 'UAH',
    UAK = 'UAK',
    AED = 'AED',
    UYW = 'UYW',
    UYU = 'UYU',
    UYP = 'UYP',
    UYI = 'UYI',
    UZS = 'UZS',
    VUV = 'VUV',
    VES = 'VES',
    VEB = 'VEB',
    VEF = 'VEF',
    VND = 'VND',
    VNN = 'VNN',
    CHE = 'CHE',
    CHW = 'CHW',
    XOF = 'XOF',
    YDD = 'YDD',
    YER = 'YER',
    YUN = 'YUN',
    YUD = 'YUD',
    YUM = 'YUM',
    YUR = 'YUR',
    ZWN = 'ZWN',
    ZRN = 'ZRN',
    ZRZ = 'ZRZ',
    ZMW = 'ZMW',
    ZMK = 'ZMK',
    ZWD = 'ZWD',
    ZWR = 'ZWR',
    ZWL = 'ZWL'
}

/**
 * '
 * Adds support for UID fields.
 *
 * Also remove all fields with value 'null' (None) from the output.
 */
export type CustomFCMDevice = {
    readonly uid: string;
    name?: (string) | null;
    registration_id: string;
    /**
     * Unique device identifier
     */
    device_id?: (string) | null;
    /**
     * Inactive devices will not be sent notifications
     */
    active?: boolean;
    readonly date_created: (string) | null;
    type: CustomFCMDeviceTypeEnum;
    /**
     * Opaque application identity, should be filled in for multiple key/certificate access
     *
     * * `fcm_equinem` - Equinem
     */
    application_id: (ApplicationIdEnum);
};

/**
 * * `ios` - ios
 * * `android` - android
 * * `web` - web
 */
export enum CustomFCMDeviceTypeEnum {
    IOS = 'ios',
    ANDROID = 'android',
    WEB = 'web'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type DailyNote = {
    readonly uid: string;
    title?: string;
    text: string;
    stable_uid?: (string) | null;
    executable?: boolean;
    done_on?: (string) | null;
    done_by_uid?: (string) | null;
    color?: (string) | null;
    order?: (number) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly created_by_uid: string;
    readonly last_modified_by_uid: (string) | null;
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type DailyNoteSetDoneAndUnDone = {
    readonly uid: string;
    readonly title: string;
    readonly text: string;
    readonly stable_uid: (string) | null;
    readonly executable: boolean;
    readonly done_on: (string) | null;
    readonly done_by_uid: (string) | null;
    readonly color: (string) | null;
    readonly order: (number) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly created_by_uid: string;
    readonly last_modified_by_uid: (string) | null;
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
    events_to_change?: (EventsToChangeEnum);
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type DailyNoteUpdate = {
    readonly uid: string;
    title?: string;
    text: string;
    stable_uid?: (string) | null;
    executable?: boolean;
    done_on?: (string) | null;
    done_by_uid?: (string) | null;
    color?: (string) | null;
    order?: (number) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly created_by_uid: string;
    readonly last_modified_by_uid: (string) | null;
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
    events_to_change?: (EventsToChangeEnum);
};

export type DatetimeOrDateField = {
    datetime?: string;
    date?: string;
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type DayPartStartTime = {
    readonly uid: string;
    /**
     * start time is inclusive
     */
    start_time: string;
    /**
     * For example: late evening
     */
    name?: string;
};

/**
 * '
 * Adds support for UID fields.
 *
 * Also remove all fields with value 'null' (None) from the output.
 */
export type DeclinedInvitation = {
    declined_reason?: string;
};

/**
 * * `BREEDING` - Breeding
 * * `SHIPPING` - Shipping
 * * `SUBSCRIPTION` - Subscription
 */
export enum DefaultProductTypeEnum {
    BREEDING = 'BREEDING',
    SHIPPING = 'SHIPPING',
    SUBSCRIPTION = 'SUBSCRIPTION'
}

/**
 * * `1` - sale to dealer
 * * `2` - sale to private
 * * `3` - retirement
 * * `4` - euthanasia
 * * `5` - show
 * * `6` - Other
 */
export enum DepartureReasonEnum {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6
}

/**
 * * `OVULATED` - Ovulated
 * * `CORPUS HEMORRHAGICUM` - Corpus Hem
 * * `CORPUS LUTHEUM` - Corpus Lutheum
 * * `MFO (MULTIFOLLICULAR OVARIES)` - Multifollicular Ovaries
 */
export enum EggStateEnum {
    OVULATED = 'OVULATED',
    CORPUS_HEMORRHAGICUM = 'CORPUS HEMORRHAGICUM',
    CORPUS_LUTHEUM = 'CORPUS LUTHEUM',
    MFO__MULTIFOLLICULAR_OVARIES_ = 'MFO (MULTIFOLLICULAR OVARIES)'
}

export type Email = {
    email: string;
};

/**
 * * `full` - Full
 * * `limited for training` - Limited for training
 * * `limited for service` - Limited for service
 * * `limited for service and training` - Limited for service and training
 * * `not employable` - Not employable
 */
export enum EmployabilityStatusEnum {
    FULL = 'full',
    LIMITED_FOR_TRAINING = 'limited for training',
    LIMITED_FOR_SERVICE = 'limited for service',
    LIMITED_FOR_SERVICE_AND_TRAINING = 'limited for service and training',
    NOT_EMPLOYABLE = 'not employable'
}

/**
 * Serializer for the Employment class.
 */
export type Employment = {
    readonly uid: string;
    contact_uid: string;
    /**
     * The end date of this specific Employment contract.
     */
    dend?: (string) | null;
    /**
     * The start date of this specific Employment contract.
     */
    dstart?: string;
    readonly employment_start_date: string;
    /**
     * Checks if the employment is the current active employment.
     */
    readonly is_current: boolean;
    readonly leave_allowance: (LeaveAllowance);
    /**
     * Number of leave days per year, between 0 and 366. This is based on a full time contract (40 hours per week).
     */
    leave_days_per_year?: number;
    readonly next_employment: string;
    readonly organisation_uid: string;
    readonly previous_employment: (string) | null;
    work_schedule_even?: (WorkWeek | null);
    work_schedule_odd: (WorkWeek | null);
    /**
     * Calculated work week hours from the work_schedule_odd and work_schedule_even.
     */
    readonly work_week_hours: number;
};

/**
 * * `horses` - Horses
 * * `activities` - Activities
 * * `breeding` - Breeding
 * * `shop` - Shop
 * * `financial` - Financial
 * * `contacts` - Contacts
 * * `feed` - Feed
 * * `facilities` - Facilities
 * * `hr` - HR
 */
export enum EnabledModulesEnum {
    HORSES = 'horses',
    ACTIVITIES = 'activities',
    BREEDING = 'breeding',
    SHOP = 'shop',
    FINANCIAL = 'financial',
    CONTACTS = 'contacts',
    FEED = 'feed',
    FACILITIES = 'facilities',
    HR = 'hr'
}

export type EquineMHorseSearchDetail = {
    display_name?: (string) | null;
    name?: (string) | null;
    date_of_birth?: (string) | null;
    sex?: (SexEnum | NullEnum);
    sire?: (string) | null;
    dam?: (string) | null;
    damsire?: (string) | null;
    studbook?: (string) | null;
    /**
     * Universal Equine Life Number
     */
    UELN?: (string) | null;
    chip_nr?: (string) | null;
    FEI_pass_nr?: (string) | null;
    id_horsetelex?: (string) | null;
    source_db: externalDbEnum;
    current_location_arrival_date?: (string) | null;
};

/**
 * Serializer for requesting a password reset e-mail.
 */
export type EquineMPasswordReset = {
    email: string;
};

export type EquineMRegister = {
    username?: string;
    email: string;
    password1: string;
    password2: string;
    first_name: string;
    last_name: string;
    agreed_to_terms_and_privacy: boolean;
    coupon_code?: string;
    breeding_shop_trial?: boolean;
    expected_no_horses?: (number) | null;
    signup_reference?: (SignupReferenceEnum | BlankEnum);
    type_of_organisation?: (TypeOfOrganisationEnum);
    signup_supplier_shop?: (string) | null;
    UBN?: string;
    postcode?: string;
    address_line1?: string;
    city?: string;
    country?: (CountryEnum | BlankEnum);
    phone_number: string;
    /**
     * streetnumber
     */
    address_line3?: string;
    business_name?: string;
};

export type EquineMSearchLastPage = {
    items: Array<EquineMHorseSearchDetail>;
    is_last_page: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type EventFeeds = {
    readonly uid: string;
    readonly stable: (string) | null;
    readonly user: string;
    readonly last_modified_on: string;
    possible_calendar_hash_objs: (PossibleCalendarHashObjects);
    readonly created_on: string;
    readonly url: string;
};

/**
 * * `confirmed` - Confirmed
 * * `tentative` - Tentative
 * * `cancelled` - Cancelled
 */
export enum EventStatus {
    CONFIRMED = 'confirmed',
    TENTATIVE = 'tentative',
    CANCELLED = 'cancelled'
}

/**
 * * `ONE` - One
 * * `FUTURE` - Future
 * * `ALL` - All
 */
export enum EventsToChangeEnum {
    ONE = 'ONE',
    FUTURE = 'FUTURE',
    ALL = 'ALL'
}

/**
 * * `RvO` - Rvo
 * * `HorseTelex` - Horsetelex
 */
export enum externalDbEnum {
    RV_O = 'RvO',
    HORSE_TELEX = 'HorseTelex'
}

/**
 * * `level` - level
 * * `extra_info` - note
 * * `intensity` - intensity [1-100]
 * * `estimated_intensity` - estimated intensity
 * * `show` - show
 * * `sire` - sire
 * * `external_url` - external URL
 * * `heart_rate` - heart rate
 * * `race_time` - race time
 * * `show_status` - status show
 * * `workload` - workload
 * * `pregnancy_check_term` - pregnancy check term
 */
export enum ExtraInfoFieldsEnum {
    LEVEL = 'level',
    EXTRA_INFO = 'extra_info',
    INTENSITY = 'intensity',
    ESTIMATED_INTENSITY = 'estimated_intensity',
    SHOW = 'show',
    SIRE = 'sire',
    EXTERNAL_URL = 'external_url',
    HEART_RATE = 'heart_rate',
    RACE_TIME = 'race_time',
    SHOW_STATUS = 'show_status',
    WORKLOAD = 'workload',
    PREGNANCY_CHECK_TERM = 'pregnancy_check_term'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type Facility = {
    readonly uid: string;
    name: string;
    description?: string;
    facility_type: FacilityTypeEnum;
    /**
     * Indicate how many days ahead this facility may be planned. Not checked for facility managers.
     */
    planning_window_opens_days_ahead?: (number) | null;
    /**
     * Indicate the minimum amount of hours this facility requires an event to be planned ahead, e.g. at least 0,5 hours. Not checked for facility managers.
     */
    planning_window_closes_hours_before?: (string) | null;
    /**
     * Number of slots this facility has to offer simultaneously. Leave empty to skip validation. This is the same for facility managers.
     */
    slot_capacity?: (number) | null;
    /**
     * Maximum event duration when using this facility, in hours; leave blank for no limit. Not checked for facility managers.
     */
    max_hours_per_event?: (string) | null;
    /**
     * Minimum event duration when using this facility, in hours; leave blank for no limit. Not checked for facility managers.
     */
    min_hours_per_event?: (string) | null;
    available_weekdays: Array<(AvailableWeekdaysEnum | BlankEnum)>;
    /**
     * The facility will be available at this time. Leave blank to indicate continuous availability. Not checked for facility managers.
     */
    available_from?: (string) | null;
    /**
     * The facility will be available till this time. Required is in combination with 'available from'. Not checked for facility managers.
     */
    available_to?: (string) | null;
    /**
     * Uncheck to (temporarily) disable this facility for bookings
     */
    available?: boolean;
    /**
     * Select to soft-delete this facility.
     */
    hidden?: boolean;
    stable_uid?: (string) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly created_by: (string) | null;
    readonly last_modified_by: (string) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type FacilityEvent = {
    readonly uid: string;
    description?: string;
    facility_uid: string;
    activity_uid?: (string) | null;
    horse_uids?: Array<(string)>;
    readonly slots: number;
    /**
     * Optional, to provide info on the contact responsible for this booking
     */
    contact_uid?: (string) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly created_by_uid: string;
    readonly last_modified_by_uid: (string) | null;
    is_private_reservation: boolean;
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type FacilityEventUpdate = {
    readonly uid: string;
    description?: string;
    facility_uid: string;
    activity_uid?: (string) | null;
    horse_uids?: Array<(string)>;
    readonly slots: number;
    /**
     * Optional, to provide info on the contact responsible for this booking
     */
    contact_uid?: (string) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly created_by_uid: string;
    readonly last_modified_by_uid: (string) | null;
    is_private_reservation: boolean;
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
    events_to_change?: (EventsToChangeEnum);
};

/**
 * * `TRANSPORT` - Transport
 * * `WATER_TREADMILL` - Water treadmill
 * * `INDOOR_ARENA` - Indoor arena
 * * `OUTDOOR_ARENA` - Outdoor arena
 * * `GALLOPING_TRACK` - Galloping track
 * * `LUNGING_RING` - Lunging ring
 * * `PADDOCK` - Paddock
 * * `SOLARIUM` - Solarium
 * * `JUMPING_YARD` - Jumping yard
 * * `TREADMILL` - Treadmill
 * * `VIBRATION_PLATE` - Vibration plate
 * * `PASTURES` - Pastures
 * * `WALKER` - walker
 * * `OTHER` - other
 */
export enum FacilityTypeEnum {
    TRANSPORT = 'TRANSPORT',
    WATER_TREADMILL = 'WATER_TREADMILL',
    INDOOR_ARENA = 'INDOOR_ARENA',
    OUTDOOR_ARENA = 'OUTDOOR_ARENA',
    GALLOPING_TRACK = 'GALLOPING_TRACK',
    LUNGING_RING = 'LUNGING_RING',
    PADDOCK = 'PADDOCK',
    SOLARIUM = 'SOLARIUM',
    JUMPING_YARD = 'JUMPING_YARD',
    TREADMILL = 'TREADMILL',
    VIBRATION_PLATE = 'VIBRATION_PLATE',
    PASTURES = 'PASTURES',
    WALKER = 'WALKER',
    OTHER = 'OTHER'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type Feed = {
    readonly uid: string;
    feed_type_uid: string;
    quantity: string;
    start_reason?: string;
    end_reason?: string;
    stable_uid: string;
    horse_uid: string;
    /**
     * To which feeding does this forage belong?
     */
    feeding_uid: string;
    readonly created_on: string;
    readonly last_modified_on: string;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    readonly created_by_uid: string;
    readonly last_modified_by_uid: (string) | null;
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    readonly all_day_event: boolean;
    readonly recurrence: string;
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type Feeding = {
    readonly uid: string;
    /**
     * For example: late evening
     */
    name?: string;
    time: string;
    readonly default_id: (number) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type FeedType = {
    readonly uid: string;
    /**
     * For example 'lumps', or 'hay'
     */
    display_name: string;
    brand: string;
    /**
     * (optional) For example 'wet' for pulp.
     */
    warning?: string;
    readonly created_on: string;
    readonly last_modified_on: string;
    quantity_measure: QuantityMeasureEnum;
    default_quantity: string;
    harvest_date?: (string) | null;
    category: (FeedTypeCategoryEnum);
    hidden?: boolean;
    /**
     * During the waiting time the horse is considered positive for doping and is not allowed to take part in shows.
     */
    wait_time?: (number) | null;
};

/**
 * * `ROUGHAGE` - roughage
 * * `CONCENTRATE` - concentrate
 * * `SUPPLEMENT` - supplement
 * * `MEDICINE` - medicine
 */
export enum FeedTypeCategoryEnum {
    ROUGHAGE = 'ROUGHAGE',
    CONCENTRATE = 'CONCENTRATE',
    SUPPLEMENT = 'SUPPLEMENT',
    MEDICINE = 'MEDICINE'
}

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type FeedUpdate = {
    readonly uid: string;
    feed_type_uid: string;
    quantity: string;
    start_reason?: string;
    end_reason?: string;
    stable_uid: string;
    horse_uid: string;
    /**
     * To which feeding does this forage belong?
     */
    feeding_uid: string;
    readonly created_on: string;
    readonly last_modified_on: string;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    readonly created_by_uid: string;
    readonly last_modified_by_uid: (string) | null;
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    readonly all_day_event: boolean;
    readonly recurrence: string;
    events_to_change?: (EventsToChangeEnum);
};

/**
 * * `ANIMAL_NITROGEN` - nitrogen from animals
 * * `TOTAL_NITROGEN` - total nitrogen
 * * `TOTAL_PHOSPHATE` - total phosphate
 */
export enum FertilizerBudgetTypeEnum {
    ANIMAL_NITROGEN = 'ANIMAL_NITROGEN',
    TOTAL_NITROGEN = 'TOTAL_NITROGEN',
    TOTAL_PHOSPHATE = 'TOTAL_PHOSPHATE'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type FertilizerConsumer = {
    readonly uid: string;
    contact_uid: string;
    /**
     * description of the land or crop eg farm land, grass land, sugar beets, ...
     */
    description: string;
    fertilizer_budget_type: FertilizerBudgetTypeEnum;
    land_type_nitrogen?: (LandTypeNitrogenEnum | BlankEnum);
    land_type_phosphate?: (LandTypePhosphateEnum | BlankEnum);
    /**
     * To indicate if this crop follows an earlier use of the land in this year.
     */
    is_follow_up_crop?: boolean;
    /**
     * e.g. 2025
     */
    year: number;
    has_derogation?: boolean;
    /**
     * the amount of hectares
     */
    area: number;
    /**
     * The yearly amount fertilizer in kg of this type will be consumed by 1 hectare of the land or crop of this description over the period of in 1 year.
     */
    consumption_norm: number;
    readonly total: number;
};

export type FertilizerNorm = {
    /**
     * The year in which this norm was first effective; subsequent years may use the same values until a new norm is stored.
     */
    readonly start_year: number;
    readonly country: (CountryEnum);
    readonly type: (FertilizerNormTypeEnum);
    readonly nitrogen_kg: (string) | null;
    readonly phosphate_kg: (string) | null;
};

/**
 * * `HORSE` - horse
 * * `PONY` - pony
 */
export enum FertilizerNormTypeEnum {
    HORSE = 'HORSE',
    PONY = 'PONY'
}

/**
 * * `ANIMAL_MANURE_SUPPLY` - animal manure supply
 * * `MILK_PRODUCING_COWS` - milk producing cows
 * * `GRAZING_ANIMALS` - grazing animals
 * * `EQUINEM_HORSES` - equinem horses
 * * `STABLE_ANIMALS_FEED` - stable animals feed
 * * `OTHER_ORGANIC_SUPPLY` - other organic supply
 * * `ANORGANIC_SUPPLY` - anorganic supply
 */
export enum FertilizerOriginEnum {
    ANIMAL_MANURE_SUPPLY = 'ANIMAL_MANURE_SUPPLY',
    MILK_PRODUCING_COWS = 'MILK_PRODUCING_COWS',
    GRAZING_ANIMALS = 'GRAZING_ANIMALS',
    EQUINEM_HORSES = 'EQUINEM_HORSES',
    STABLE_ANIMALS_FEED = 'STABLE_ANIMALS_FEED',
    OTHER_ORGANIC_SUPPLY = 'OTHER_ORGANIC_SUPPLY',
    ANORGANIC_SUPPLY = 'ANORGANIC_SUPPLY'
}

/**
 * Serializer for the File POI.
 */
export type FilePointOfInterest = {
    readonly uid: string;
    parent_map_uid: string;
    coordinate_x?: number;
    coordinate_y?: number;
    readonly filename: string;
    description?: string;
    file: string;
    readonly resourcetype: 'FilePointOfInterest';
};

/**
 * * `FilePointOfInterest` - FilePointOfInterest
 */
export enum FilePointOfInterestResourcetypeEnum {
    FILE_POINT_OF_INTEREST = 'FilePointOfInterest'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type FindParentSemenOrderItem = {
    date: string;
    exclude_children?: boolean;
    mare_uid: string;
    usage_type: (UsageTypeEnum | BlankEnum);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type FindParentSemenOrderItemPurchaser = {
    date: string;
    exclude_children?: boolean;
    mare_uid: string;
    usage_type: (UsageTypeEnum | BlankEnum);
    supplier: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type FollowUpInseminationCheck = {
    date: string;
    order_item_uid?: (string) | null;
    /**
     * When was the check (relative to insemination)
     *
     * * `FIRST` - First
     * * `SECOND` - Second
     * * `THIRD` - Third
     */
    pregnancy_check_term?: (PregnancyCheckTermEnum | BlankEnum | NullEnum);
    /**
     * (optional) Write down extra information about this activity.
     */
    extra_info?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type FollowUpMareCycleCheck = {
    date: string;
    order_item_uid?: (string) | null;
    /**
     * When was the check (relative to insemination)
     *
     * * `FIRST` - First
     * * `SECOND` - Second
     * * `THIRD` - Third
     */
    pregnancy_check_term?: (PregnancyCheckTermEnum | BlankEnum | NullEnum);
    /**
     * (optional) Write down extra information about this activity.
     */
    extra_info?: string;
};

export type GetHorsesFromRvo = {
    message: string;
    unprocessable_request?: GetHorseUnprocessable;
    not_found_horse_creation_errors?: Array<CannotCreateHorse> | null;
};

export type GetHorseUnprocessable = {
    no_horses_from_rvo: number;
    rvo_horses_not_found: Array<EquineMHorseSearchDetail>;
    horses_wo_chipnr: Array<Horse>;
};

export type HistoricHorseCount = {
    year: number;
    month: number;
    sample_date: string;
    time_frame: TimeFrameEnum;
    name: string;
    pony_count: string;
    horse_count: string;
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type HolidayEvent = {
    readonly uid: string;
    name?: string;
    country: CountryEnum;
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
};

/**
 * For list
 */
export type Horse = {
    readonly uid: string;
    display_name?: (string) | null;
    avatar_file?: (string) | null;
    box_no?: (number) | null;
    readonly current_employability_status: string;
    readonly current_phase_status: string;
    group_uid?: (string) | null;
    stable_uid?: (string) | null;
    readonly hidden: boolean;
    readonly is_external: boolean;
    name: string;
    nickname?: string;
    date_of_birth?: (string) | null;
    color?: (ColorEnum | NullEnum);
    sex?: (SexEnum | NullEnum);
    sire?: string;
    dam?: string;
    damsire?: string;
    siredam?: string;
    sire_obj_uid?: (string) | null;
    dam_obj_uid?: (string) | null;
    /**
     * Universal Equine Life Number
     */
    UELN?: string;
    chip_nr?: string;
    readonly current_location: (Location);
    readonly future_location: (Location);
    /**
     * Since version 2024-02. Indicates if this horse was created based on another horse instance (and which one), e.g. a supplier's mare will have the purchaser's as source. Rule of thumb: If the horse has a source, it isn't yours.Upgraded 2024-9 to ManyToMany so we can keep track of the related models of all purchasers
     */
    readonly purchaser_horses: Array<(string)>;
    use_in_breeding?: boolean;
    use_in_sport?: boolean;
    use_in_care?: boolean;
    readonly owner_uids: Array<(string)>;
    default_rider_uid?: (string) | null;
    default_groom_uid?: (string) | null;
    default_farrier_uid?: (string) | null;
    default_vet_uid?: (string) | null;
    default_trainer_uid?: (string) | null;
    dentist_weeks?: (number) | null;
    deworm_weeks?: (number) | null;
    rhino_weeks?: (number) | null;
    vaccination_rules_uid?: string;
    /**
     * Make empty to disable automatic scheduling.
     */
    farrier_weeks?: (number) | null;
    default_semen_collection_station?: (string) | null;
    /**
     * This information comes at the exclamation mark in the weekly overview.
     */
    warning?: string;
};

/**
 * For list
 */
export type HorseDetail = {
    readonly uid: string;
    readonly owner_uids: Array<(string)>;
    display_name?: (string) | null;
    group_uid?: (string) | null;
    stable_uid?: (string) | null;
    readonly hidden: boolean;
    readonly is_external: boolean;
    dentist_weeks?: (number) | null;
    deworm_weeks?: (number) | null;
    rhino_weeks?: (number) | null;
    vaccination_rules_uid?: string;
    /**
     * Make empty to disable automatic scheduling.
     */
    farrier_weeks?: (number) | null;
    name: string;
    nickname?: string;
    box_no?: (number) | null;
    date_of_birth?: (string) | null;
    color?: (ColorEnum | NullEnum);
    sex?: (SexEnum | NullEnum);
    readonly duplicates: Array<(string)>;
    weight?: (string) | null;
    temperature?: (string) | null;
    sire_obj_uid?: (string) | null;
    dam_obj_uid?: (string) | null;
    damdam_obj_uid?: (string) | null;
    siresire_obj_uid?: (string) | null;
    damsire_obj_uid?: (string) | null;
    siredam_obj_uid?: (string) | null;
    siregrandsire1_obj_uid?: (string) | null;
    siregrandsire2_obj_uid?: (string) | null;
    siregranddam1_obj_uid?: (string) | null;
    siregranddam2_obj_uid?: (string) | null;
    damgranddam1_obj_uid?: (string) | null;
    damgranddam2_obj_uid?: (string) | null;
    damgrandsire1_obj_uid?: (string) | null;
    damgrandsire2_obj_uid?: (string) | null;
    sire?: string;
    dam?: string;
    damsire?: string;
    breeder?: string;
    studbook?: string;
    /**
     * Use this field for notes.
     */
    note?: string;
    /**
     * This information comes at the exclamation mark in the weekly overview.
     */
    warning?: string;
    damdam?: string;
    siresire?: string;
    siredam?: string;
    siregrandsire1?: string;
    siregrandsire2?: string;
    siregranddam1?: string;
    siregranddam2?: string;
    damgranddam1?: string;
    damgranddam2?: string;
    damgrandsire1?: string;
    damgrandsire2?: string;
    /**
     * Universal Equine Life Number
     */
    UELN?: string;
    FEI_pass_nr?: string;
    local_federation_number?: string;
    chip_nr?: string;
    FEI_expiry_date?: (string) | null;
    default_rider_uid?: (string) | null;
    default_groom_uid?: (string) | null;
    default_farrier_uid?: (string) | null;
    default_vet_uid?: (string) | null;
    default_trainer_uid?: (string) | null;
    /**
     * Instructions for transporting this horse
     */
    transport_instruction?: (string) | null;
    id_horsetelex?: string;
    purchase_date?: (string) | null;
    withers_height?: (number) | null;
    /**
     * In beats per minute
     */
    heart_rate?: (number) | null;
    /**
     * In breaths per minute
     */
    respiratory_rate?: (number) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    avatar_file?: (string) | null;
    readonly current_horselocation: (NestedHorseLocation);
    readonly future_horselocation: (NestedHorseLocation);
    register_move?: (HorseLocationMove);
    new_owners?: Array<(string)>;
    use_in_breeding?: boolean;
    use_in_sport?: boolean;
    use_in_care?: boolean;
    default_semen_collection_station?: (string) | null;
};

/**
 * Returns a horse object with all the fields from the HorseTelexDetailSerializer and converted to the HorseDetailSerializer
 */
export type HorseDetailHorseTelex = {
    display_name?: (string) | null;
    name: string;
    date_of_birth?: (string) | null;
    sex?: (SexEnum | NullEnum);
    sire?: string;
    dam?: string;
    damsire?: string;
    breeder?: string;
    damdam?: string;
    sire_obj_uid?: (string) | null;
    dam_obj_uid?: (string) | null;
    damdam_obj_uid?: (string) | null;
    siresire_obj_uid?: (string) | null;
    damsire_obj_uid?: (string) | null;
    siredam_obj_uid?: (string) | null;
    siregrandsire1_obj_uid?: (string) | null;
    siregrandsire2_obj_uid?: (string) | null;
    siregranddam1_obj_uid?: (string) | null;
    siregranddam2_obj_uid?: (string) | null;
    damgranddam1_obj_uid?: (string) | null;
    damgranddam2_obj_uid?: (string) | null;
    damgrandsire1_obj_uid?: (string) | null;
    damgrandsire2_obj_uid?: (string) | null;
    siresire?: string;
    siredam?: string;
    siregrandsire1?: string;
    siregrandsire2?: string;
    siregranddam1?: string;
    siregranddam2?: string;
    damgranddam1?: string;
    damgranddam2?: string;
    damgrandsire1?: string;
    damgrandsire2?: string;
    /**
     * Universal Equine Life Number
     */
    UELN?: string;
    chip_nr?: string;
    FEI_pass_nr?: string;
    id_horsetelex?: string;
    withers_height?: (number) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type HorseEmployabilityStatus = {
    readonly uid: string;
    employability_status?: (EmployabilityStatusEnum | BlankEnum);
    motivation: string;
    created_on: string;
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type HorseGroup = {
    readonly uid: string;
    name?: string;
    readonly default_id: (number) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type HorseLocation = {
    readonly uid: string;
    location_uid: string;
    origin_uid?: (string) | null;
    arrival_date: string;
    arrival_is_import?: boolean;
    departure_reason?: (DepartureReasonEnum | NullEnum);
    destination_uid?: (string) | null;
    departure_is_export?: boolean;
    departure_is_dead?: boolean;
    departure_date?: (string) | null;
    horse_uid: string;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly arrival_connected_to_departure: (string) | null;
    readonly departure_connected_to_arrival: (string) | null;
    hide_arrival_report_notification?: boolean;
    hide_departure_report_notification?: boolean;
    herkomstLandCode?: (BestemmingLandCodeEnum | BlankEnum);
    bestemmingLandCode?: (BestemmingLandCodeEnum | BlankEnum);
    reportedhorserelocation_set: Array<ReportedHorseRelocation>;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type HorseLocationMove = {
    departure_reason?: (DepartureReasonEnum | NullEnum);
    destination_uid?: (string) | null;
    departure_is_export?: boolean;
    departure_is_dead?: boolean;
    arrival_is_import?: boolean;
    origin_uid?: (string) | null;
    date: string;
    set_inactive?: boolean;
    set_active?: boolean;
    stop_services?: boolean;
    restart_services?: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type HorseLocationMutation = {
    readonly uid: string;
    location_uid: string;
    origin_uid?: (string) | null;
    destination_uid?: (string) | null;
    arrival_date: string;
    departure_date?: (string) | null;
    horse_uid: string;
    arrival_goal_exception?: boolean;
    days_left_for_registration: string;
    arrival_or_departure: ArrivalOrDepartureEnum;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type HorseLocationUpdate = {
    arrival_date: string;
    departure_date?: (string) | null;
    herkomstLandCode?: (BestemmingLandCodeEnum | BlankEnum);
    bestemmingLandCode?: (BestemmingLandCodeEnum | BlankEnum);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type HorseMedia = {
    readonly uid: string;
    file?: (string) | null;
    readonly file_download_url: string;
    filename: string;
    description?: string;
    YTVim?: (string) | null;
    private?: (PrivateEnum);
    horse_uid: string;
    content_type?: string;
    readonly created_on: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type HorseMediaUpdate = {
    readonly uid: string;
    description?: string;
    content_type?: string;
    filename: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type HorseMove = {
    group_uid?: (string) | null;
    departure_reason?: (DepartureReasonEnum | NullEnum);
    destination_uid?: (string) | null;
    departure_is_export?: boolean;
    departure_is_dead?: boolean;
    arrival_is_import?: boolean;
    origin_uid?: (string) | null;
    date: string;
    set_inactive?: boolean;
    set_active?: boolean;
    stop_services?: boolean;
    restart_services?: boolean;
};

export type HorseMoveResponse = {
    message: string;
    horse_uid: string;
    task_id?: string;
    code: string;
    background_task?: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type HorseOwner = {
    readonly uid: string;
    horse_uid: string;
    contact_uid: string;
    percentage?: string;
    owner_since?: (string) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type HorseOwnerHistory = {
    readonly uid: string;
    horse_uid?: (string) | null;
    contact_uid?: (string) | null;
    percentage?: string;
    owner_since?: (string) | null;
    history_date: string;
    history_user_uid?: (string) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type HorsePage = {
    readonly uid: string;
    readonly public_access_uuid: string;
    expires_at?: (string) | null;
    include_medical_documents?: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type HorsePhaseStatus = {
    readonly uid: string;
    phase_status?: (PhaseStatusEnum | BlankEnum);
    created_on: string;
};

export type HorseTelexDetailInput = {
    get_or_create_parent_horses: boolean;
    uid?: (string) | null;
    id_horsetelex?: (string) | null;
};

/**
 * For list
 */
export type HorseWithDuplicates = {
    readonly uid: string;
    display_name?: (string) | null;
    avatar_file?: (string) | null;
    box_no?: (number) | null;
    readonly current_employability_status: string;
    readonly current_phase_status: string;
    group_uid?: (string) | null;
    stable_uid?: (string) | null;
    readonly hidden: boolean;
    readonly is_external: boolean;
    name: string;
    nickname?: string;
    date_of_birth?: (string) | null;
    color?: (ColorEnum | NullEnum);
    sex?: (SexEnum | NullEnum);
    sire?: string;
    dam?: string;
    damsire?: string;
    siredam?: string;
    sire_obj_uid?: (string) | null;
    dam_obj_uid?: (string) | null;
    /**
     * Universal Equine Life Number
     */
    UELN?: string;
    chip_nr?: string;
    readonly current_location: (Location);
    readonly future_location: (Location);
    /**
     * Since version 2024-02. Indicates if this horse was created based on another horse instance (and which one), e.g. a supplier's mare will have the purchaser's as source. Rule of thumb: If the horse has a source, it isn't yours.Upgraded 2024-9 to ManyToMany so we can keep track of the related models of all purchasers
     */
    readonly purchaser_horses: Array<(string)>;
    use_in_breeding?: boolean;
    use_in_sport?: boolean;
    use_in_care?: boolean;
    readonly owner_uids: Array<(string)>;
    default_rider_uid?: (string) | null;
    default_groom_uid?: (string) | null;
    default_farrier_uid?: (string) | null;
    default_vet_uid?: (string) | null;
    default_trainer_uid?: (string) | null;
    dentist_weeks?: (number) | null;
    deworm_weeks?: (number) | null;
    rhino_weeks?: (number) | null;
    vaccination_rules_uid?: string;
    /**
     * Make empty to disable automatic scheduling.
     */
    farrier_weeks?: (number) | null;
    default_semen_collection_station?: (string) | null;
    /**
     * This information comes at the exclamation mark in the weekly overview.
     */
    warning?: string;
    readonly duplicates: Array<(string)>;
};

/**
 * In memory invoices are invoices created during a dry-run: they do not exist in the database, but
 * they do contain valid data that should be accepted as InvoiceDetail when posting to the Invoice API.
 *
 * The serializer yields the same fields as InvoiceDetailSerializer but has empty values for e.g. u(u)id,
 * created, finalized, modified date-times, etc, (because the object doesn't exist in the database).
 */
export type InMemoryInvoiceDetail = {
    readonly uid: string;
    readonly public_access_uuid: string;
    readonly customer_uid: string;
    readonly supplier_uid: string;
    readonly total: string;
    readonly currency: string;
    readonly total_incl_vat: string;
    /**
     * (optional)
     */
    readonly invoice_no: string;
    readonly draft: boolean;
    readonly finalized_on: string;
    readonly date: (string) | null;
    readonly sent_on: (string) | null;
    readonly moneybird_invoice_id: (number) | null;
    readonly exactnl_invoice_id: string;
    readonly snelstart_invoice_id: string;
    readonly yuki_invoice_id: string;
    readonly payment_status: (PaymentStatus);
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly start_date_activities: (string) | null;
    readonly end_date_activities: (string) | null;
    readonly start_date_services: (string) | null;
    readonly end_date_services: (string) | null;
    readonly created_by_uid: string;
    readonly expiration_date: string;
    readonly first_due_interval: number;
    readonly payment_summary: (PaymentSummary);
    readonly automatically_generated: boolean;
    readonly automatic_payment: boolean;
    order?: NestedOrder;
    readonly historic_supplier: (SupplierNameAndAddress);
    readonly language: string;
    items?: Array<NestedInMemoryInvoiceItem>;
    readonly historic_customer: (PurchaserNameAndAddress);
    readonly exactnl_url: (string) | null;
    readonly exactnl_entry_no: string;
    readonly snelstart_entry_no: string;
    /**
     * indicates whether this instance exists in the database or not
     */
    readonly is_persistent: boolean;
    /**
     * defaults to false
     */
    finalize?: boolean;
    /**
     * defaults to false
     */
    send_email?: boolean;
    /**
     * defaults to false
     */
    send_to_accounting_software?: boolean;
};

/**
 * '
 * Adds support for UID fields.
 *
 * Also remove all fields with value 'null' (None) from the output.
 */
export type Inviter = {
    readonly first_name: string;
    readonly last_name: string;
};

/**
 * '
 * Adds support for UID fields.
 *
 * Also remove all fields with value 'null' (None) from the output.
 */
export type InviterOrganisation = {
    readonly name: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type Invoice = {
    readonly uid: string;
    readonly public_access_uuid: (string) | null;
    customer_uid: string;
    supplier_uid: string;
    readonly order_uid: (string) | null;
    readonly total: string;
    readonly currency: string;
    readonly total_incl_vat: string;
    /**
     * (optional)
     */
    invoice_no?: string;
    draft?: boolean;
    readonly finalized_on: (string) | null;
    date?: (string) | null;
    readonly sent_on: (string) | null;
    readonly moneybird_invoice_id: (number) | null;
    readonly exactnl_invoice_id: string;
    readonly snelstart_invoice_id: string;
    readonly yuki_invoice_id: string;
    readonly payment_status: (PaymentStatus);
    readonly created_on: string;
    readonly last_modified_on: string;
    start_date_activities?: (string) | null;
    end_date_activities?: (string) | null;
    start_date_services?: (string) | null;
    end_date_services?: (string) | null;
    readonly created_by_uid: string;
    readonly expiration_date: (string) | null;
    first_due_interval?: number;
    readonly payment_summary: (PaymentSummary);
    readonly automatically_generated: boolean;
    automatic_payment?: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type InvoiceDetail = {
    readonly uid: string;
    readonly public_access_uuid: (string) | null;
    customer_uid: string;
    supplier_uid?: string;
    readonly total: string;
    readonly currency: string;
    readonly total_incl_vat: string;
    /**
     * (optional)
     */
    invoice_no?: string;
    draft?: boolean;
    readonly finalized_on: (string) | null;
    date?: (string) | null;
    readonly sent_on: (string) | null;
    readonly moneybird_invoice_id: (number) | null;
    readonly exactnl_invoice_id: string;
    readonly snelstart_invoice_id: string;
    readonly yuki_invoice_id: string;
    readonly payment_status: (PaymentStatus);
    readonly created_on: (string) | null;
    readonly last_modified_on: (string) | null;
    start_date_activities?: (string) | null;
    end_date_activities?: (string) | null;
    start_date_services?: (string) | null;
    end_date_services?: (string) | null;
    readonly created_by_uid: string;
    readonly expiration_date: (string) | null;
    first_due_interval: number;
    readonly payment_summary: (PaymentSummary);
    readonly automatically_generated: boolean;
    automatic_payment?: boolean;
    order?: NestedOrder;
    readonly historic_supplier: (SupplierNameAndAddress);
    readonly language: string;
    items?: Array<NestedInvoiceItem>;
    readonly historic_customer: (PurchaserNameAndAddress);
    readonly exactnl_url: (string) | null;
    readonly exactnl_entry_no: string;
    readonly snelstart_entry_no: string;
    /**
     * indicates whether this instance exists in the database or not
     */
    readonly is_persistent: boolean;
    /**
     * defaults to false
     */
    finalize?: boolean;
    /**
     * defaults to false
     */
    send_email?: boolean;
    /**
     * defaults to false
     */
    send_to_accounting_software?: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type InvoiceFinalize = {
    send_email?: boolean;
    send_to_accounting_software?: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type InvoiceItem = {
    uid?: string;
    description: string;
    unit_price?: (string) | null;
    readonly unit_price_currency: (string) | null;
    category_uid: string;
    quantity?: (string) | null;
    qualifier?: string;
    vat_percentage_uid?: (string) | null;
    readonly vat_percentage: (NestedVATPercentage | null);
    vat_included_in_price?: boolean;
    deferred?: boolean;
    realactivities?: Array<(string)>;
    service_uid?: (string) | null;
    readonly created_on: (string) | null;
    transactionitems?: Array<(string)>;
    readonly last_modified_on: (string) | null;
    horse_uid?: (string) | null;
    readonly horse: (NamedHorse);
    readonly total_vat: (Money | null);
    billableitem_set: Array<((string) | null)>;
    /**
     * indicates whether this instance exists in the database or not
     */
    readonly is_persistent: boolean;
    invoice_uid: string;
};

/**
 * * `nl` - Dutch
 * * `en` - English
 * * `de` - German
 * * `` - ---
 */
export enum InvoiceLanguageEnum {
    NL = 'nl',
    EN = 'en',
    DE = 'de'
}

/**
 * * `YES` - Yes
 * * `NO` - No
 * * `DUAL_PREGNANCY` - Dual Pregnancy
 */
export enum IsPregnantEnum {
    YES = 'YES',
    NO = 'NO',
    DUAL_PREGNANCY = 'DUAL_PREGNANCY'
}

/**
 * Serializer for JWT authentication.
 */
export type JWT = {
    access: string;
    refresh: string;
    user: UserDetails;
};

/**
 * * `FARM_LAND` - farm land
 * * `NATURE_LAND` - nature land
 * * `WATER_BARRIER` - water barrier
 * * `OTHER` - other
 */
export enum LandTypeNitrogenEnum {
    FARM_LAND = 'FARM_LAND',
    NATURE_LAND = 'NATURE_LAND',
    WATER_BARRIER = 'WATER_BARRIER',
    OTHER = 'OTHER'
}

/**
 * * `FARM_LAND` - farm land
 * * `GRASS_LAND` - grass land
 */
export enum LandTypePhosphateEnum {
    FARM_LAND = 'FARM_LAND',
    GRASS_LAND = 'GRASS_LAND'
}

/**
 * Serializer for the LeaveAllowance field.
 */
export type LeaveAllowance = {
    readonly credit: (LeaveAllowanceCredit);
    readonly used: (LeaveAllowanceUsed);
    readonly overtime: (LeaveAllowanceUsed);
    readonly corrections: number;
};

/**
 * Serializer for the LeaveAllowanceCredit field.
 */
export type LeaveAllowanceCredit = {
    readonly build_up: string;
    readonly expected_build_up: string;
    readonly current_total: string;
    readonly expected_total_end_year: string;
    readonly from_last_year: string;
};

/**
 * Serializer for the LeaveAllowanceMutation class.
 */
export type LeaveAllowanceMutation = {
    readonly id: number;
    readonly uid: string;
    contact: string;
    employment: string;
    date: string;
    amount?: string;
    note?: string;
};

/**
 * Serializer for the LeaveAllowanceUsed field.
 */
export type LeaveAllowanceUsed = {
    readonly confirmed: string;
    readonly tentative: string;
};

export type Location = {
    readonly uid: (string) | null;
    readonly name: string;
    readonly arrival_date: (string) | null;
};

/**
 * * `LEFT` - Left
 * * `RIGHT` - Right
 */
export enum LocationEnum {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT'
}

export type LocationResponse = {
    location_uid: string;
    background_task?: (BackGroundTask | null);
    get_horses_from_rvo_exception?: (GetHorsesFromRvo | null);
};

/**
 * Serializer for the map model.
 */
export type Map = {
    readonly uid: string;
    image_url: string;
    readonly pointofinterest_set: Array<PointOfInterest>;
};

/**
 * Serializer for the Map POI.
 */
export type MapPointOfInterest = {
    readonly uid: string;
    parent_map_uid: string;
    coordinate_x?: number;
    coordinate_y?: number;
    map: string;
    readonly resourcetype: 'MapPointOfInterest';
};

/**
 * * `MapPointOfInterest` - MapPointOfInterest
 */
export enum MapPointOfInterestResourcetypeEnum {
    MAP_POINT_OF_INTEREST = 'MapPointOfInterest'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type MareCycleCheck = {
    readonly uid: string;
    is_pregnant: IsPregnantEnum;
    uterus?: (UterusEnum | BlankEnum);
    uterus_has_fluid?: boolean;
    egg_set?: Array<NestedEgg>;
    cyst_set?: Array<NestedCyst>;
    cervix?: (SoftnessEnum | BlankEnum);
    mare_uid: string;
    date: string;
    readonly created_on: string;
    readonly created_by: string;
    readonly last_modified_on: string;
    add_followup_insemination?: (FollowUpInseminationCheck);
    add_followup_marecyclechecks?: Array<FollowUpMareCycleCheck>;
    readonly breeding_plan: (NestedBreedingPlan);
    stallion_uid?: string;
    requester_uid?: string;
    breeding_plan_uid?: string;
    activity_uid?: string;
    order_item_uid?: (string) | null;
    /**
     * When was the check (relative to insemination)
     *
     * * `FIRST` - First
     * * `SECOND` - Second
     * * `THIRD` - Third
     */
    pregnancy_check_term?: (PregnancyCheckTermEnum | BlankEnum | NullEnum);
    /**
     * (optional) Write down extra information about this activity.
     */
    extra_info?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type MergeContacts = {
    readonly uid: string;
    color?: string;
    readonly user_uid: (string) | null;
    stables?: Array<((string) | null)>;
    /**
     * Max three initials
     */
    initials?: string;
    readonly hidden: boolean;
    roles?: Array<((string) | null)>;
    first_name?: string;
    last_name?: string;
    studbook_preference?: (StudbookEnum | BlankEnum);
    business_name?: string;
    phone_number?: string;
    email?: string;
    external_location?: boolean;
    customer_id?: string;
    moneybird_contact_id?: (number) | null;
    exactnl_contact_id?: string;
    snelstart_contact_id?: string;
    is_inseminator?: boolean;
    is_semen_collection_station?: boolean;
    is_insemination_station?: boolean;
    /**
     * only show orders where requester is a contact with use_for_picking in the picklist
     */
    use_for_picking?: boolean;
    vat_number?: string;
    readonly vat_number_checked: (boolean) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    address_line1?: string;
    address_line2?: string;
    address_line3?: string;
    country?: (CountryEnum | BlankEnum);
    state?: string;
    postcode?: string;
    city?: string;
    title?: (TitleEnum | BlankEnum);
    date_of_birth?: (string) | null;
    show_in_daily?: boolean;
    show_in_work_schedule?: boolean;
    note?: string;
    readonly stable_location_uid: string;
    UBN?: string;
    invoice_language?: (InvoiceLanguageEnum | BlankEnum);
    business_type?: (BusinessTypeEnum | NullEnum);
    readonly lookup: string;
    readonly manage_horse_location_history: boolean;
    readonly machtiging_rvo_gegeven: (string) | null;
    readonly machtiging_rvo_gegeven_by_uid: (string) | null;
    readonly invitation: (SentInvitation | null);
    create_user_invitation?: boolean;
    parent_stable?: (string) | null;
    IBAN?: string;
    bank_code?: string;
    account_number?: string;
    bank_name?: string;
    second_phone_number?: string;
    company_registration_number?: string;
    /**
     * In case the contact represents a (supplier side) customer, this product can be used as suggestion or default in orders, that require shipping.
     */
    default_shipping_product?: (string) | null;
    merge_with_uid: string;
};

/**
 * For list
 */
export type MergeHorses = {
    readonly uid: string;
    readonly owner_uids: Array<(string)>;
    display_name?: string;
    group_uid?: (string) | null;
    stable_uid?: (string) | null;
    readonly hidden: boolean;
    readonly is_external: boolean;
    dentist_weeks?: (number) | null;
    deworm_weeks?: (number) | null;
    rhino_weeks?: (number) | null;
    vaccination_rules_uid?: string;
    /**
     * Make empty to disable automatic scheduling.
     */
    farrier_weeks?: (number) | null;
    name?: string;
    nickname?: string;
    box_no?: (number) | null;
    date_of_birth?: (string) | null;
    color?: (ColorEnum | NullEnum);
    sex?: (SexEnum | NullEnum);
    readonly duplicates: Array<(string)>;
    weight?: (string) | null;
    temperature?: (string) | null;
    sire_obj_uid?: (string) | null;
    dam_obj_uid?: (string) | null;
    damdam_obj_uid?: (string) | null;
    siresire_obj_uid?: (string) | null;
    damsire_obj_uid?: (string) | null;
    siredam_obj_uid?: (string) | null;
    siregrandsire1_obj_uid?: (string) | null;
    siregrandsire2_obj_uid?: (string) | null;
    siregranddam1_obj_uid?: (string) | null;
    siregranddam2_obj_uid?: (string) | null;
    damgranddam1_obj_uid?: (string) | null;
    damgranddam2_obj_uid?: (string) | null;
    damgrandsire1_obj_uid?: (string) | null;
    damgrandsire2_obj_uid?: (string) | null;
    sire?: string;
    dam?: string;
    damsire?: string;
    breeder?: string;
    studbook?: string;
    /**
     * Use this field for notes.
     */
    note?: string;
    /**
     * This information comes at the exclamation mark in the weekly overview.
     */
    warning?: string;
    damdam?: string;
    siresire?: string;
    siredam?: string;
    siregrandsire1?: string;
    siregrandsire2?: string;
    siregranddam1?: string;
    siregranddam2?: string;
    damgranddam1?: string;
    damgranddam2?: string;
    damgrandsire1?: string;
    damgrandsire2?: string;
    /**
     * Universal Equine Life Number
     */
    UELN?: string;
    FEI_pass_nr?: string;
    local_federation_number?: string;
    chip_nr?: string;
    FEI_expiry_date?: (string) | null;
    default_rider_uid?: (string) | null;
    default_groom_uid?: (string) | null;
    default_farrier_uid?: (string) | null;
    default_vet_uid?: (string) | null;
    default_trainer_uid?: (string) | null;
    /**
     * Instructions for transporting this horse
     */
    transport_instruction?: (string) | null;
    id_horsetelex?: string;
    purchase_date?: (string) | null;
    withers_height?: (number) | null;
    /**
     * In beats per minute
     */
    heart_rate?: (number) | null;
    /**
     * In breaths per minute
     */
    respiratory_rate?: (number) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    avatar_file?: (string) | null;
    readonly current_horselocation: (NestedHorseLocation);
    readonly future_horselocation: (NestedHorseLocation);
    register_move?: (HorseLocationMove);
    new_owners?: Array<(string)>;
    use_in_breeding?: boolean;
    use_in_sport?: boolean;
    use_in_care?: boolean;
    default_semen_collection_station?: (string) | null;
    merge_with_uid: string;
};

export type Module = {
    id: string;
    name: string;
};

/**
 * * `ACCOUNTING` - Accounting
 * * `SHOP_AND_BREEDING` - Shop and breeding
 * * `FEED_AND_MEDICINE` - Feed and medicine
 * * `FACILITY_PLANNING` - Facility planning
 * * `FINANCIAL_AND_PAYMENT` - Financial and payment
 * * `WORKFORCE_MANAGEMENT` - Workforce management
 * * `USER_ACCOUNTS` - User accounts
 * * `HORSE_SERVICES_CARE` - Horse services, care
 * * `HORSE_SERVICES_FULL` - Horse services, full
 * * `RVO_REPORTS` - RvO reports
 */
export enum ModuleEnum {
    ACCOUNTING = 'ACCOUNTING',
    SHOP_AND_BREEDING = 'SHOP_AND_BREEDING',
    FEED_AND_MEDICINE = 'FEED_AND_MEDICINE',
    FACILITY_PLANNING = 'FACILITY_PLANNING',
    FINANCIAL_AND_PAYMENT = 'FINANCIAL_AND_PAYMENT',
    WORKFORCE_MANAGEMENT = 'WORKFORCE_MANAGEMENT',
    USER_ACCOUNTS = 'USER_ACCOUNTS',
    HORSE_SERVICES_CARE = 'HORSE_SERVICES_CARE',
    HORSE_SERVICES_FULL = 'HORSE_SERVICES_FULL',
    RVO_REPORTS = 'RVO_REPORTS'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type ModulePermissions = {
    readonly uid: string;
    module_permissions: Array<ModulePermissionsEnum>;
};

/**
 * * `view_own_horses` - View own horse(s)
 * * `view_horses` - View horses
 * * `manage_horses` - Manage horses
 * * `view_horse_files` - View horse media & documents
 * * `edit_horse_files` - Edit horse media & documents
 * * `view_horse_owners` - View horse owners
 * * `view_veterinary_activities` - View veterinary activities
 * * `medical_files` - View medical documents and media
 * * `view_schedule` - View schedule
 * * `view_tasks_and_announcements` - View tasks and announcements
 * * `set_to_done` - Check activities
 * * `manage_schedule` - Manage schedule
 * * `manage_semen_journal` - Manage breeding
 * * `manage_orders` - Manage orders
 * * `pick_orders` - Pick orders
 * * `manage_financial` - Manage financial administration
 * * `view_contacts` - View contacts
 * * `manage_contacts` - Manage contacts
 * * `view_feed` - View feed
 * * `manage_feed` - Manage feed
 * * `plan_own_facilities_events` - Book facilities
 * * `manage_facilities` - Manage facilities
 * * `manage_employments` - Manage employments
 * * `view_workday_schedule` - View workday availability
 */
export enum ModulePermissionsEnum {
    VIEW_OWN_HORSES = 'view_own_horses',
    VIEW_HORSES = 'view_horses',
    MANAGE_HORSES = 'manage_horses',
    VIEW_HORSE_FILES = 'view_horse_files',
    EDIT_HORSE_FILES = 'edit_horse_files',
    VIEW_HORSE_OWNERS = 'view_horse_owners',
    VIEW_VETERINARY_ACTIVITIES = 'view_veterinary_activities',
    MEDICAL_FILES = 'medical_files',
    VIEW_SCHEDULE = 'view_schedule',
    VIEW_TASKS_AND_ANNOUNCEMENTS = 'view_tasks_and_announcements',
    SET_TO_DONE = 'set_to_done',
    MANAGE_SCHEDULE = 'manage_schedule',
    MANAGE_SEMEN_JOURNAL = 'manage_semen_journal',
    MANAGE_ORDERS = 'manage_orders',
    PICK_ORDERS = 'pick_orders',
    MANAGE_FINANCIAL = 'manage_financial',
    VIEW_CONTACTS = 'view_contacts',
    MANAGE_CONTACTS = 'manage_contacts',
    VIEW_FEED = 'view_feed',
    MANAGE_FEED = 'manage_feed',
    PLAN_OWN_FACILITIES_EVENTS = 'plan_own_facilities_events',
    MANAGE_FACILITIES = 'manage_facilities',
    MANAGE_EMPLOYMENTS = 'manage_employments',
    VIEW_WORKDAY_SCHEDULE = 'view_workday_schedule'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type ModulePermissionsList = {
    readonly uid: string;
    module_permissions: Array<ModulePermissionsObject>;
};

export type ModulePermissionsObject = {
    id: string;
    name: string;
    module: Module;
};

export type Money = {
    amount: string;
    currency: string;
};

/**
 * * `BEGIN_AMOUNT` - begin amount
 * * `IMPORT` - import
 * * `PRODUCTION` - production
 * * `EXPORT` - export
 * * `END_AMOUNT` - end amount
 */
export enum MutationTypeEnum {
    BEGIN_AMOUNT = 'BEGIN_AMOUNT',
    IMPORT = 'IMPORT',
    PRODUCTION = 'PRODUCTION',
    EXPORT = 'EXPORT',
    END_AMOUNT = 'END_AMOUNT'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type MyFacilityEvent = {
    readonly uid: string;
    description?: string;
    facility_uid: string;
    activity_uid?: (string) | null;
    horse_uids?: Array<(string)>;
    readonly slots: number;
    /**
     * Optional, to provide info on the contact responsible for this booking
     */
    readonly contact_uid: (string) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly created_by_uid: string;
    readonly last_modified_by_uid: (string) | null;
    is_private_reservation: boolean;
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type MyFacilityEventUpdate = {
    readonly uid: string;
    description?: string;
    facility_uid: string;
    activity_uid?: (string) | null;
    horse_uids?: Array<(string)>;
    readonly slots: number;
    /**
     * Optional, to provide info on the contact responsible for this booking
     */
    readonly contact_uid: (string) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly created_by_uid: string;
    readonly last_modified_by_uid: (string) | null;
    is_private_reservation: boolean;
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
    events_to_change?: (EventsToChangeEnum);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type NamedHorse = {
    readonly uid: string;
    name: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type NestedBreedingPlan = {
    readonly uid: string;
    readonly stallion: (PublicHorse | null);
    readonly requester_uid: (string) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type NestedCyst = {
    uid?: string;
    size_metric: string;
    x: number;
    y: number;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type NestedEgg = {
    uid?: string;
    location: LocationEnum;
    size_metric?: (string) | null;
    hardness?: (SoftnessEnum | BlankEnum);
    egg_state?: (EggStateEnum | BlankEnum);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type NestedEmployment = {
    readonly uid: string;
    /**
     * Checks if the employment is the current active employment.
     */
    readonly is_current: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type NestedHorseLocation = {
    readonly uid: string;
    location_uid: string;
    origin_uid?: (string) | null;
    arrival_date: string;
    arrival_is_import?: boolean;
    departure_reason?: (DepartureReasonEnum | NullEnum);
    destination_uid?: (string) | null;
    departure_is_export?: boolean;
    departure_is_dead?: boolean;
    departure_date?: (string) | null;
};

/**
 * In memory invoice items are invoice items created during a dry-run: they do not exist in the database,
 * but they do contain valid data that should be accepted as NestedInvoiceItem when posted to the Invoice API.
 *
 * The serializer yields the same fields as NestedInvoiceItemSerializer but has empty values for e.g.
 * u(u)id, created, modified date-times, etc, (because the object doesn't exist in the database).
 */
export type NestedInMemoryInvoiceItem = {
    readonly uid: string;
    readonly description: string;
    readonly unit_price: (string) | null;
    readonly unit_price_currency: (string) | null;
    readonly category_uid: string;
    readonly quantity: (string) | null;
    readonly qualifier: string;
    readonly vat_percentage_uid: (string) | null;
    readonly vat_percentage: (NestedVATPercentage | null);
    readonly vat_included_in_price: boolean;
    readonly deferred: boolean;
    readonly realactivities: Array<(string)>;
    readonly service_uid: (string) | null;
    readonly created_on: string;
    readonly transactionitems: Array<(string)>;
    readonly last_modified_on: string;
    readonly horse_uid: (string) | null;
    readonly horse: (NamedHorse);
    readonly total_vat: (Money | null);
    billableitem_set: Array<((string) | null)>;
    /**
     * indicates whether this instance exists in the database or not
     */
    readonly is_persistent: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type NestedInvoiceItem = {
    uid?: string;
    description: string;
    unit_price?: (string) | null;
    readonly unit_price_currency: (string) | null;
    category_uid: string;
    quantity?: (string) | null;
    qualifier?: string;
    vat_percentage_uid?: (string) | null;
    readonly vat_percentage: (NestedVATPercentage | null);
    vat_included_in_price?: boolean;
    deferred?: boolean;
    realactivities?: Array<(string)>;
    service_uid?: (string) | null;
    readonly created_on: (string) | null;
    transactionitems?: Array<(string)>;
    readonly last_modified_on: (string) | null;
    horse_uid?: (string) | null;
    readonly horse: (NamedHorse);
    readonly total_vat: (Money | null);
    billableitem_set: Array<((string) | null)>;
    /**
     * indicates whether this instance exists in the database or not
     */
    readonly is_persistent: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type NestedOrder = {
    readonly uid: string;
    number?: string;
    public_access_uuid?: (string) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type NestedTransactionItem = {
    uid?: string;
    /**
     * Provide a horse if this was purchased for a specific horse. The resulting billable items will be attributed to the customer if provided, else it will be attributed to this horse's owner(s).
     */
    horse_uid?: (string) | null;
    /**
     * Provide a contact if this items was purchased specifically for this customer and should be invoiced as such. A billable item will be generated for this item and customer if provided.
     */
    customer_uid?: (string) | null;
    price: string;
    price_currency?: string;
    transaction_type: TransactionTypeEnum;
    vat_percentage_uid: string;
    readonly vat_percentage: (NestedVATPercentage | null);
    vat_included_in_price?: boolean;
    readonly total_vat: (Money | null);
    description?: (string) | null;
    realactivity_uid?: (string) | null;
    readonly created_on: string;
    readonly created_by_uid: string;
    readonly last_modified_on: string;
    readonly last_modified_by_uid: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type NestedTransactionMedia = {
    readonly uid: string;
    file: string;
    width?: (number) | null;
    height?: (number) | null;
    content_type?: (string) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type NestedVATPercentage = {
    percentage: string;
    vat_category: VatCategoryEnum;
};

/**
 * * `CLEAR` - clear
 * * `PASTEL_GRAY` - Pastel gray
 * * `YELLOW` - Yellow
 * * `PASTEL_YELLOW` - Pastel yellow
 * * `PUTTY` - Putty
 * * `PASTEL_ORANGE` - Pastel orange
 * * `SALMON` - Salmon
 * * `PASTEL_RED` - Pastel red
 * * `PINK` - Pink
 * * `RED` - Red
 * * `PASTEL_BLUE` - Pastel blue
 * * `PURPLE` - Purple
 * * `PASTEL_PISTACHIO` - Pastel pistachio
 * * `GREEN` - Green
 * * `PASTEL_GREEN` - Pastel green
 * * `PISTACHIO_GREEN` - Pistachio green
 * * `` - ---
 */
export enum NIFAStrawColorEnum {
    CLEAR = 'CLEAR',
    PASTEL_GRAY = 'PASTEL_GRAY',
    YELLOW = 'YELLOW',
    PASTEL_YELLOW = 'PASTEL_YELLOW',
    PUTTY = 'PUTTY',
    PASTEL_ORANGE = 'PASTEL_ORANGE',
    SALMON = 'SALMON',
    PASTEL_RED = 'PASTEL_RED',
    PINK = 'PINK',
    RED = 'RED',
    PASTEL_BLUE = 'PASTEL_BLUE',
    PURPLE = 'PURPLE',
    PASTEL_PISTACHIO = 'PASTEL_PISTACHIO',
    GREEN = 'GREEN',
    PASTEL_GREEN = 'PASTEL_GREEN',
    PISTACHIO_GREEN = 'PISTACHIO_GREEN'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type NitrogenApplication = {
    readonly uid: string;
    contact_uid: string;
    /**
     * e.g. 2025
     */
    year: number;
    /**
     * type and origin of this batch, e.g. 'Vaste mest van graasdieren aangevoerd'
     */
    fertilizer_description: string;
    /**
     * type of land over which this batch was spread out, e.g. 'Overige toepassingen op bedrijf met beweiding'
     */
    application_description?: string;
    is_animal_manure: boolean;
    /**
     * nitrogen weight of this batch in kg
     */
    nitrogen_weight: number;
    /**
     * in whole percentages [0, 100]
     */
    application_coefficient?: number;
    readonly effective_nitrogen_weight: number;
};

export type NotificationSettings = {
    /**
     * Notification when there are unfinished activities for today
     */
    daily_unchecked_enabled?: boolean;
    /**
     * Notification when plan for tomorrow is missing
     */
    daily_tomorrow_not_planned_enabled?: boolean;
    /**
     * Notification when my plan is updated
     */
    task_assigned_enabled?: boolean;
    daily_timing?: string;
    /**
     * Notification when an activity is done with horses you own
     */
    activity_done_own_horse_enabled?: boolean;
    /**
     * Notification when the information has not been filled in completely for one or more horses
     */
    daily_horse_incomplete_enabled?: boolean;
    /**
     * Notification when feed has changed
     */
    feed_change_enabled?: boolean;
    enable_push_notifications?: (boolean) | null;
    /**
     * Notification when a file is added to a horse
     */
    horse_media_enabled?: boolean;
    /**
     * Notification of planned activities with reminder
     */
    enable_notify_before?: boolean;
};

export type NullEnum = null;

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type OAuth2Token = {
    readonly uid: string;
    readonly name: string;
    readonly created_by_uid: string;
    readonly created_on: string;
    readonly token_type: string;
};

export enum OperatorEnum {
    ADD = 'ADD',
    SUBTRACT = 'SUBTRACT'
}

/**
 * Serializes a OrderItem's pickedstallionmount_set which should contain all PickedStallionMount objects
 * that are picked for a single OrderItem. When posting you should provide a collection (can be one instance)
 * that fully picks the indicated OrderItem.
 */
export type OrderItemStallionMountPicker = {
    pickedstallionmount_set: Array<PickedStallionMount>;
};

/**
 * * `SUPPLIER` - Supplier
 * * `MARECYCLECHECK` - Marecyclecheck
 * * `SHOP` - Shop
 */
export enum OrderOriginEnum {
    SUPPLIER = 'SUPPLIER',
    MARECYCLECHECK = 'MARECYCLECHECK',
    SHOP = 'SHOP'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type Organisation = {
    readonly uid: string;
    readonly created_by_uid: string;
    readonly last_modified_by_uid: string;
    readonly public_access_uuid: string;
    name: string;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly is_paid: boolean;
    readonly is_bp: boolean;
    readonly is_ssd: boolean;
    shop_terms_conditions?: (string) | null;
    /**
     * Indicate whether the EU One-Stop-Shop (OSS) tax policy applies.
     */
    use_one_stop_shop?: boolean;
    timezone?: TimezoneEnum;
    readonly expected_no_horses: (number) | null;
    /**
     * De vaccination is then automatically added to the mare when the insemination is checked. Leave this empty if you don't like this automatic behaviour.
     */
    weeks_between_insemination_and_vaccination?: (number) | null;
    days_between_insemination_and_pregnancy_check?: (number) | null;
    /**
     * The default, and minimum, is 10 minutes. Set 0 if you don't want automatic refresh to happen.
     */
    equiboard_refresh_rate?: number;
    /**
     * The default is 10 minutes. A screensaver elongates the lifetime of your display and saves the environment by using less energy.
     */
    equiboard_screensaver_time?: number;
    /**
     * The default is 0.2. 0 means completely light, 1 means completely dark.
     */
    equiboard_lockscreendarkness?: number;
    also_send_invoice_to_email?: string;
    website?: string;
    logo?: (string) | null;
    invoice_subject?: string;
    invoice_text?: string;
    currency?: string;
    invoice_footer_1?: string;
    invoice_footer_2?: string;
    max_no_horses?: (number) | null;
    readonly last_information_send: (string) | null;
    readonly number_of_information_send_last_day: (number) | null;
    readonly relatienummer_rvo: string;
    readonly type_of_organisation: (TypeOfOrganisationEnum);
    enabled_modules: Array<(EnabledModulesEnum | BlankEnum)>;
    /**
     * Set this option if you always want EquineM to send the invoice email, even if there is a connection with accounting software.
     */
    invoice_email_by_equinem?: boolean;
    primary_color?: string;
    secondary_color?: string;
    show_logo_on_invoice?: boolean;
    /**
     * Products can be given an upfront cost. This amount will be suggested on new products.
     */
    suggested_breeding_product_down_payment?: string;
    down_payment_permitted_countries: Array<(CountryEnum | BlankEnum)>;
    invoice_first_due_interval?: number;
    readonly can_create_payment_link: boolean;
    readonly only_use_ad: boolean;
    readonly microsoft_ad_group_id: string;
    exactnl_sales_journal?: string;
    no_breeding_boxes?: (number) | null;
    work_week_hours?: (number) | null;
    sick_counts_for_leave_allowance?: (boolean) | null;
    /**
     * If a 0 is filled in no portions will be automatically destroyed
     */
    destroy_fresh_portions_days?: number;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type OrganisationContact = {
    readonly uid: string;
    roles: Array<RoleNames>;
    stables: Array<StableNames>;
    service_contracts: Array<PurchaserServiceContract>;
    employments: Array<NestedEmployment>;
    /**
     * Checks if this employment is part of an active employment series.
     */
    readonly has_active_employment: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type OrganisationList = {
    readonly uid: string;
    name: string;
    readonly is_in_trial: boolean;
    readonly me: (OrganisationContact);
    is_ssd?: boolean;
};

export type OrganisationNAW = {
    email?: string;
    phone_number?: string;
    address_line1?: string;
    address_line2?: string;
    address_line3?: string;
    city?: string;
    state?: string;
    postcode?: string;
    country?: (CountryEnum | BlankEnum);
};

export type OrganisationOAuth = {
    organisation_uid: string;
    provider_name: string;
};

export type PaginatedAvailabilityList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<Availability>;
};

export type PaginatedBillableItemList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<BillableItem>;
};

export type PaginatedBreedingPlanList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<BreedingPlan>;
};

export type PaginatedCatalogueProductList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<CatalogueProduct>;
};

export type PaginatedContactDetailList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<ContactDetail>;
};

export type PaginatedContactList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<Contact>;
};

export type PaginatedFacilityEventList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<FacilityEvent>;
};

export type PaginatedFacilityList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<Facility>;
};

export type PaginatedFeedList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<Feed>;
};

export type PaginatedFertilizerConsumerList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<FertilizerConsumer>;
};

export type PaginatedFertilizerNormList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<FertilizerNorm>;
};

export type PaginatedHorseList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<Horse>;
};

export type PaginatedHorseLocationList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<HorseLocation>;
};

export type PaginatedHorseLocationMutationList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<HorseLocationMutation>;
};

export type PaginatedHorseMediaList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<HorseMedia>;
};

export type PaginatedHorseOwnerHistoryList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<HorseOwnerHistory>;
};

export type PaginatedHorseOwnerList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<HorseOwner>;
};

export type PaginatedHorseWithDuplicatesList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<HorseWithDuplicates>;
};

export type PaginatedInvoiceList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<Invoice>;
};

export type PaginatedMareCycleCheckList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<MareCycleCheck>;
};

export type PaginatedNitrogenApplicationList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<NitrogenApplication>;
};

export type PaginatedPaymentList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<Payment>;
};

export type PaginatedProductionBalanceItemList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<ProductionBalanceItem>;
};

export type PaginatedProductList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<Product>;
};

export type PaginatedPublicHorseList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<PublicHorse>;
};

export type PaginatedPurchaserOrderList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<PurchaserOrder>;
};

export type PaginatedPurchaserPaymentProviderList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<PurchaserPaymentProvider>;
};

export type PaginatedPurchaserServiceContractList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<PurchaserServiceContract>;
};

export type PaginatedRealActivitiesList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<RealActivities>;
};

export type PaginatedReportedHorseRelocationList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<ReportedHorseRelocation>;
};

export type PaginatedShallowContactList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<ShallowContact>;
};

export type PaginatedStallionMountList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<StallionMount>;
};

export type PaginatedSupplierOrderList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<SupplierOrder>;
};

export type PaginatedSupplierServiceContractList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<SupplierServiceContract>;
};

export type PaginatedTransactionItemList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<TransactionItem>;
};

export type PaginatedTransactionList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<Transaction>;
};

export type PaginatedVATPercentageList = {
    count: number;
    next?: (string) | null;
    previous?: (string) | null;
    results: Array<VATPercentage>;
};

export type PasswordChange = {
    old_password: string;
    new_password1: string;
    new_password2: string;
};

/**
 * Serializer for confirming a password reset attempt.
 */
export type PasswordResetConfirm = {
    new_password1: string;
    new_password2: string;
    uid: string;
    token: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedAccount = {
    readonly uid?: string;
    readonly lookup?: string;
    readonly email?: string;
    readonly agreed_to_terms_and_privacy?: (string) | null;
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     */
    readonly username?: string;
    first_name?: string;
    last_name?: string;
    readonly date_joined?: string;
    avatar_file?: (string) | null;
    date_of_birth?: (string) | null;
    country?: CountryEnum;
    phone_number?: string;
    disable_help_popup_app?: boolean;
    disable_help_popup_portal?: boolean;
    /**
     * Max three initials
     */
    initials?: string;
    readonly last_activity?: (string) | null;
    language?: string;
    preferred_organisation?: (string) | null;
    preferred_stable?: (string) | null;
    color?: string;
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type PatchedActivityType = {
    readonly uid?: string;
    name?: string;
    /**
     * (in legend/daily overview, e.g. "1")
     */
    order?: (number) | null;
    default?: (ActivityTypeDefaultEnum | BlankEnum);
    /**
     * Order is the number you can click on to mark an activity as done.
     */
    hide_order?: boolean;
    hidden?: boolean;
    /**
     * Show this activity type in the quick add menu on the weekly overview and in the app.
     */
    enable_quick_add?: boolean;
    /**
     * Select which activity types should always be shown in the daily overview (even when no horses are attached)
     */
    stable_settings_activity_types_general?: Array<(string)>;
    color?: string;
    category?: ActivityTypeCategoryEnum;
    /**
     * Number of days a notification is send before a planned activity with reminder
     */
    notify_before?: (number) | null;
    facility_uids?: Array<(string)>;
    extra_info_fields?: Array<(ExtraInfoFieldsEnum | BlankEnum)>;
    possible_roles?: Array<((string) | null)>;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedActivityTypePrice = {
    readonly uid?: string;
    activity_type_uid?: string;
    price?: string;
    readonly price_currency?: string;
    vat_percentage_uid?: string;
    /**
     * The category used when creating an invoice line for this activity type.
     */
    category_uid?: string;
    vat_included_in_price?: boolean;
    readonly created_on?: string;
    readonly last_modified_on?: string;
};

/**
 * Serializer for the approve and reject actions of the Availability class.
 */
export type PatchedAvailabilityApproveDecline = {
    readonly uid?: string;
    readonly all_day_event?: boolean;
    readonly availability_type?: (AvailabilityTypeEnum);
    readonly contact_uid?: string;
    readonly created_by_contact_uid?: string;
    readonly created_by_employee?: boolean;
    readonly created_on?: string;
    readonly description?: (string) | null;
    readonly employment_uid?: string;
    readonly has_leave_allowance_impact?: boolean;
    readonly impact_hours?: string;
    readonly status?: (AvailabilityStatusEnum);
    readonly start?: (DatetimeOrDateField);
    readonly end?: (DatetimeOrDateField);
    readonly endTimeUnspecified?: boolean;
    readonly recurrence?: string;
};

export type PatchedAvailabilityDestroy = {
    events_to_change?: (EventsToChangeEnum);
};

/**
 * Serializer for updates from employees to the Availability class.
 */
export type PatchedAvailabilityEmployeeUpdate = {
    description?: (string) | null;
    end?: DatetimeOrDateField;
    readonly start?: (DatetimeOrDateField);
    readonly all_day_event?: boolean;
    readonly endTimeUnspecified?: boolean;
    readonly status?: (AvailabilityStatusEnum);
    readonly recurrence?: string;
};

/**
 * Serializer for updates from manager to the Availability class.
 */
export type PatchedAvailabilityManagerUpdate = {
    availability_type?: AvailabilityTypeEnum;
    end?: DatetimeOrDateField;
    has_leave_allowance_impact?: boolean;
    status?: (AvailabilityStatusEnum);
    readonly start?: (DatetimeOrDateField);
    readonly all_day_event?: boolean;
    readonly endTimeUnspecified?: boolean;
    readonly recurrence?: string;
};

/**
 * Billable items are created when the following so called 'source material' is made and or
 * due for invoicing: OrderItem, RealActivity, TransactionItem and ServiceContract.
 *
 * Before a billable item can be invoiced, certain fields like price, vat_percentage and category
 * must have a value. BillableItem will try and fill those by itself, but you can set or override
 * those fields if needed. The list of `missing_fields_for_invoicing` must be empty before the
 * respective item can be invoiced.
 *
 * Note:
 * - If the vat_percentage is missing, this can be inferred from a category: you can try setting that.
 * - If the category is missing, this can be inferred from a product: you can try setting that.
 */
export type PatchedBillableItem = {
    readonly uid?: string;
    customer_uid?: (string) | null;
    readonly organisation_uid?: string;
    readonly horse_uid?: (string) | null;
    readonly activity_uid?: (string) | null;
    readonly transaction_item_uid?: (string) | null;
    readonly transaction_uid?: (string) | null;
    readonly order_item_uid?: (string) | null;
    readonly order_uid?: (string) | null;
    readonly service_contract_uid?: (string) | null;
    /**
     * The moment the respective source of this billable item (i.e. service contract, order item, etc) was purchased or the start of a period that is billed if the respective source item has recurringproperties or affects a period, like a service contract.
     */
    readonly start_dt?: string;
    /**
     * End of the period for this billable item for the service contract. Required when a service contract is provided, else optional.
     */
    readonly end_dt?: (string) | null;
    readonly invoice_uid?: (string) | null;
    readonly invoice_item_uid?: (string) | null;
    /**
     * hide an item to move it from to-invoice to not-to-invoice
     */
    hidden?: boolean;
    readonly hidden_dt?: (string) | null;
    related_activities?: Array<(string)>;
    /**
     * Shows the fields for which this billable item requires a value before it can be invoiced.
     */
    missing_fields_for_invoicing?: Array<(string)>;
    /**
     * Shows the price that should be charged to this customer, considering the ownership and 100% price at the _time of creation_. This can be overridden.
     */
    price?: (Money | null);
    /**
     * Shows the price considering the _current_ ownership and source material unit price.
     */
    readonly current_price?: (Money | null);
    category_uid?: (string) | null;
    product_uid?: (string) | null;
    vat_percentage_uid?: (string) | null;
    vat_included_in_price?: (boolean) | null;
    /**
     * The source material is any of [order_item, service_contract, transaction_item, activity], depending on which of these relations is set. This price shows the *current* 100% price of that regardless of ownership.
     */
    readonly source_material_unit_price?: (Money | null);
    /**
     * Defaults to 'full'. This indicates whethergit this billable item fully represents its source material or only a part of it, and which part.
     *
     * * `FULL` - full
     * * `UPFRONT` - upfront
     * * `REMAINDER` - remainder
     */
    readonly payment_part?: (PaymentPartEnum);
};

/**
 * BreedingPlan is a plan for a breeding mare for a given year
 */
export type PatchedBreedingPlan = {
    readonly uid?: string;
    /**
     * The mare who is the subject of this plan. Can be the carrying mare or biological mare.
     */
    mare_uid?: string;
    /**
     * The biological mare in case the plan's mare only carried the foal.
     */
    biological_mare_uid?: (string) | null;
    readonly biological_mare?: (PublicHorse);
    year?: number;
    readonly sequence?: number;
    /**
     * Breeding plans where this horse is the stallion.
     */
    stallion_uid?: (string) | null;
    readonly stallion?: (PublicHorse);
    /**
     * Not-empty, generated number, unique per organization.
     */
    readonly number?: number;
    semen_type?: (SemenTypeEnum | BlankEnum);
    usage_type?: (UsageTypeEnum | BlankEnum);
    studbook?: (StudbookEnum | BlankEnum);
    requester_uid?: (string) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedCategory = {
    readonly uid?: string;
    p_s_type?: PSTypeEnum;
    name?: string;
    exactnl_ledger_code?: string;
    moneybird_ledger_code?: string;
    yuki_ledger_code?: string;
    readonly default?: (DefaultProductTypeEnum | NullEnum);
    vatLevelCountry?: Array<VatLevelCountry>;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedContactDetail = {
    readonly uid?: string;
    color?: string;
    readonly user_uid?: (string) | null;
    stables?: Array<((string) | null)>;
    /**
     * Max three initials
     */
    initials?: string;
    readonly hidden?: boolean;
    roles?: Array<((string) | null)>;
    first_name?: string;
    last_name?: string;
    studbook_preference?: (StudbookEnum | BlankEnum);
    business_name?: string;
    phone_number?: string;
    email?: string;
    external_location?: boolean;
    customer_id?: string;
    moneybird_contact_id?: (number) | null;
    exactnl_contact_id?: string;
    snelstart_contact_id?: string;
    is_inseminator?: boolean;
    is_semen_collection_station?: boolean;
    is_insemination_station?: boolean;
    /**
     * only show orders where requester is a contact with use_for_picking in the picklist
     */
    use_for_picking?: boolean;
    vat_number?: string;
    readonly vat_number_checked?: (boolean) | null;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    address_line1?: string;
    address_line2?: string;
    address_line3?: string;
    country?: (CountryEnum | BlankEnum);
    state?: string;
    postcode?: string;
    city?: string;
    title?: (TitleEnum | BlankEnum);
    date_of_birth?: (string) | null;
    show_in_daily?: boolean;
    show_in_work_schedule?: boolean;
    note?: string;
    readonly stable_location_uid?: string;
    UBN?: string;
    invoice_language?: (InvoiceLanguageEnum | BlankEnum);
    business_type?: (BusinessTypeEnum | NullEnum);
    readonly lookup?: string;
    readonly manage_horse_location_history?: boolean;
    readonly machtiging_rvo_gegeven?: (string) | null;
    readonly machtiging_rvo_gegeven_by_uid?: (string) | null;
    readonly invitation?: (SentInvitation | null);
    create_user_invitation?: boolean;
    parent_stable?: (string) | null;
    IBAN?: string;
    bank_code?: string;
    account_number?: string;
    bank_name?: string;
    second_phone_number?: string;
    company_registration_number?: string;
    /**
     * In case the contact represents a (supplier side) customer, this product can be used as suggestion or default in orders, that require shipping.
     */
    default_shipping_product?: (string) | null;
    readonly duplicates?: Array<(string)>;
};

/**
 * '
 * Adds support for UID fields.
 *
 * Also remove all fields with value 'null' (None) from the output.
 */
export type PatchedCustomFCMDevice = {
    readonly uid?: string;
    name?: (string) | null;
    registration_id?: string;
    /**
     * Unique device identifier
     */
    device_id?: (string) | null;
    /**
     * Inactive devices will not be sent notifications
     */
    active?: boolean;
    readonly date_created?: (string) | null;
    type?: CustomFCMDeviceTypeEnum;
    /**
     * Opaque application identity, should be filled in for multiple key/certificate access
     *
     * * `fcm_equinem` - Equinem
     */
    application_id?: (ApplicationIdEnum);
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type PatchedDailyNoteSetDoneAndUnDone = {
    readonly uid?: string;
    readonly title?: string;
    readonly text?: string;
    readonly stable_uid?: (string) | null;
    readonly executable?: boolean;
    readonly done_on?: (string) | null;
    readonly done_by_uid?: (string) | null;
    readonly color?: (string) | null;
    readonly order?: (number) | null;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    readonly created_by_uid?: string;
    readonly last_modified_by_uid?: (string) | null;
    start?: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
    events_to_change?: (EventsToChangeEnum);
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type PatchedDailyNoteUpdate = {
    readonly uid?: string;
    title?: string;
    text?: string;
    stable_uid?: (string) | null;
    executable?: boolean;
    done_on?: (string) | null;
    done_by_uid?: (string) | null;
    color?: (string) | null;
    order?: (number) | null;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    readonly created_by_uid?: string;
    readonly last_modified_by_uid?: (string) | null;
    start?: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
    events_to_change?: (EventsToChangeEnum);
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type PatchedDayPartStartTime = {
    readonly uid?: string;
    /**
     * start time is inclusive
     */
    start_time?: string;
    /**
     * For example: late evening
     */
    name?: string;
};

/**
 * '
 * Adds support for UID fields.
 *
 * Also remove all fields with value 'null' (None) from the output.
 */
export type PatchedDeclinedInvitation = {
    declined_reason?: string;
};

/**
 * Serializer for the Employment class.
 */
export type PatchedEmployment = {
    readonly uid?: string;
    contact_uid?: string;
    /**
     * The end date of this specific Employment contract.
     */
    dend?: (string) | null;
    /**
     * The start date of this specific Employment contract.
     */
    dstart?: string;
    readonly employment_start_date?: string;
    /**
     * Checks if the employment is the current active employment.
     */
    readonly is_current?: boolean;
    readonly leave_allowance?: (LeaveAllowance);
    /**
     * Number of leave days per year, between 0 and 366. This is based on a full time contract (40 hours per week).
     */
    leave_days_per_year?: number;
    readonly next_employment?: string;
    readonly organisation_uid?: string;
    readonly previous_employment?: (string) | null;
    work_schedule_even?: (WorkWeek | null);
    work_schedule_odd?: (WorkWeek | null);
    /**
     * Calculated work week hours from the work_schedule_odd and work_schedule_even.
     */
    readonly work_week_hours?: number;
};

export type PatchedEventDestroy = {
    events_to_change?: (EventsToChangeEnum);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedEventFeeds = {
    readonly uid?: string;
    readonly stable?: (string) | null;
    readonly user?: string;
    readonly last_modified_on?: string;
    possible_calendar_hash_objs?: (PossibleCalendarHashObjects);
    readonly created_on?: string;
    readonly url?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedFacility = {
    readonly uid?: string;
    name?: string;
    description?: string;
    facility_type?: FacilityTypeEnum;
    /**
     * Indicate how many days ahead this facility may be planned. Not checked for facility managers.
     */
    planning_window_opens_days_ahead?: (number) | null;
    /**
     * Indicate the minimum amount of hours this facility requires an event to be planned ahead, e.g. at least 0,5 hours. Not checked for facility managers.
     */
    planning_window_closes_hours_before?: (string) | null;
    /**
     * Number of slots this facility has to offer simultaneously. Leave empty to skip validation. This is the same for facility managers.
     */
    slot_capacity?: (number) | null;
    /**
     * Maximum event duration when using this facility, in hours; leave blank for no limit. Not checked for facility managers.
     */
    max_hours_per_event?: (string) | null;
    /**
     * Minimum event duration when using this facility, in hours; leave blank for no limit. Not checked for facility managers.
     */
    min_hours_per_event?: (string) | null;
    available_weekdays?: Array<(AvailableWeekdaysEnum | BlankEnum)>;
    /**
     * The facility will be available at this time. Leave blank to indicate continuous availability. Not checked for facility managers.
     */
    available_from?: (string) | null;
    /**
     * The facility will be available till this time. Required is in combination with 'available from'. Not checked for facility managers.
     */
    available_to?: (string) | null;
    /**
     * Uncheck to (temporarily) disable this facility for bookings
     */
    available?: boolean;
    /**
     * Select to soft-delete this facility.
     */
    hidden?: boolean;
    stable_uid?: (string) | null;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    readonly created_by?: (string) | null;
    readonly last_modified_by?: (string) | null;
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type PatchedFacilityEventUpdate = {
    readonly uid?: string;
    description?: string;
    facility_uid?: string;
    activity_uid?: (string) | null;
    horse_uids?: Array<(string)>;
    readonly slots?: number;
    /**
     * Optional, to provide info on the contact responsible for this booking
     */
    contact_uid?: (string) | null;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    readonly created_by_uid?: string;
    readonly last_modified_by_uid?: (string) | null;
    is_private_reservation?: boolean;
    start?: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
    events_to_change?: (EventsToChangeEnum);
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type PatchedFeeding = {
    readonly uid?: string;
    /**
     * For example: late evening
     */
    name?: string;
    time?: string;
    readonly default_id?: (number) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedFeedType = {
    readonly uid?: string;
    /**
     * For example 'lumps', or 'hay'
     */
    display_name?: string;
    brand?: string;
    /**
     * (optional) For example 'wet' for pulp.
     */
    warning?: string;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    quantity_measure?: QuantityMeasureEnum;
    default_quantity?: string;
    harvest_date?: (string) | null;
    category?: (FeedTypeCategoryEnum);
    hidden?: boolean;
    /**
     * During the waiting time the horse is considered positive for doping and is not allowed to take part in shows.
     */
    wait_time?: (number) | null;
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type PatchedFeedUpdate = {
    readonly uid?: string;
    feed_type_uid?: string;
    quantity?: string;
    start_reason?: string;
    end_reason?: string;
    stable_uid?: string;
    horse_uid?: string;
    /**
     * To which feeding does this forage belong?
     */
    feeding_uid?: string;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    readonly created_by_uid?: string;
    readonly last_modified_by_uid?: (string) | null;
    start?: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    readonly all_day_event?: boolean;
    readonly recurrence?: string;
    events_to_change?: (EventsToChangeEnum);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedFertilizerConsumer = {
    readonly uid?: string;
    contact_uid?: string;
    /**
     * description of the land or crop eg farm land, grass land, sugar beets, ...
     */
    description?: string;
    fertilizer_budget_type?: FertilizerBudgetTypeEnum;
    land_type_nitrogen?: (LandTypeNitrogenEnum | BlankEnum);
    land_type_phosphate?: (LandTypePhosphateEnum | BlankEnum);
    /**
     * To indicate if this crop follows an earlier use of the land in this year.
     */
    is_follow_up_crop?: boolean;
    /**
     * e.g. 2025
     */
    year?: number;
    has_derogation?: boolean;
    /**
     * the amount of hectares
     */
    area?: number;
    /**
     * The yearly amount fertilizer in kg of this type will be consumed by 1 hectare of the land or crop of this description over the period of in 1 year.
     */
    consumption_norm?: number;
    readonly total?: number;
};

/**
 * Serializer for the File POI.
 */
export type PatchedFilePointOfInterest = {
    readonly uid?: string;
    parent_map_uid?: string;
    coordinate_x?: number;
    coordinate_y?: number;
    readonly filename?: string;
    description?: string;
    file?: string;
    readonly resourcetype?: 'file';
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type PatchedHolidayEvent = {
    readonly uid?: string;
    name?: string;
    country?: CountryEnum;
    start?: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
};

/**
 * For list
 */
export type PatchedHorseDetail = {
    readonly uid?: string;
    readonly owner_uids?: Array<(string)>;
    display_name?: (string) | null;
    group_uid?: (string) | null;
    stable_uid?: (string) | null;
    readonly hidden?: boolean;
    readonly is_external?: boolean;
    dentist_weeks?: (number) | null;
    deworm_weeks?: (number) | null;
    rhino_weeks?: (number) | null;
    vaccination_rules_uid?: string;
    /**
     * Make empty to disable automatic scheduling.
     */
    farrier_weeks?: (number) | null;
    name?: string;
    nickname?: string;
    box_no?: (number) | null;
    date_of_birth?: (string) | null;
    color?: (ColorEnum | NullEnum);
    sex?: (SexEnum | NullEnum);
    readonly duplicates?: Array<(string)>;
    weight?: (string) | null;
    temperature?: (string) | null;
    sire_obj_uid?: (string) | null;
    dam_obj_uid?: (string) | null;
    damdam_obj_uid?: (string) | null;
    siresire_obj_uid?: (string) | null;
    damsire_obj_uid?: (string) | null;
    siredam_obj_uid?: (string) | null;
    siregrandsire1_obj_uid?: (string) | null;
    siregrandsire2_obj_uid?: (string) | null;
    siregranddam1_obj_uid?: (string) | null;
    siregranddam2_obj_uid?: (string) | null;
    damgranddam1_obj_uid?: (string) | null;
    damgranddam2_obj_uid?: (string) | null;
    damgrandsire1_obj_uid?: (string) | null;
    damgrandsire2_obj_uid?: (string) | null;
    sire?: string;
    dam?: string;
    damsire?: string;
    breeder?: string;
    studbook?: string;
    /**
     * Use this field for notes.
     */
    note?: string;
    /**
     * This information comes at the exclamation mark in the weekly overview.
     */
    warning?: string;
    damdam?: string;
    siresire?: string;
    siredam?: string;
    siregrandsire1?: string;
    siregrandsire2?: string;
    siregranddam1?: string;
    siregranddam2?: string;
    damgranddam1?: string;
    damgranddam2?: string;
    damgrandsire1?: string;
    damgrandsire2?: string;
    /**
     * Universal Equine Life Number
     */
    UELN?: string;
    FEI_pass_nr?: string;
    local_federation_number?: string;
    chip_nr?: string;
    FEI_expiry_date?: (string) | null;
    default_rider_uid?: (string) | null;
    default_groom_uid?: (string) | null;
    default_farrier_uid?: (string) | null;
    default_vet_uid?: (string) | null;
    default_trainer_uid?: (string) | null;
    /**
     * Instructions for transporting this horse
     */
    transport_instruction?: (string) | null;
    id_horsetelex?: string;
    purchase_date?: (string) | null;
    withers_height?: (number) | null;
    /**
     * In beats per minute
     */
    heart_rate?: (number) | null;
    /**
     * In breaths per minute
     */
    respiratory_rate?: (number) | null;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    avatar_file?: (string) | null;
    readonly current_horselocation?: (NestedHorseLocation);
    readonly future_horselocation?: (NestedHorseLocation);
    register_move?: (HorseLocationMove);
    new_owners?: Array<(string)>;
    use_in_breeding?: boolean;
    use_in_sport?: boolean;
    use_in_care?: boolean;
    default_semen_collection_station?: (string) | null;
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type PatchedHorseGroup = {
    readonly uid?: string;
    name?: string;
    readonly default_id?: (number) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedHorseLocationUpdate = {
    arrival_date?: string;
    departure_date?: (string) | null;
    herkomstLandCode?: (BestemmingLandCodeEnum | BlankEnum);
    bestemmingLandCode?: (BestemmingLandCodeEnum | BlankEnum);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedHorseMediaUpdate = {
    readonly uid?: string;
    description?: string;
    content_type?: string;
    filename?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedHorseOwner = {
    readonly uid?: string;
    horse_uid?: string;
    contact_uid?: string;
    percentage?: string;
    owner_since?: (string) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedInvoiceDetail = {
    readonly uid?: string;
    readonly public_access_uuid?: (string) | null;
    customer_uid?: string;
    supplier_uid?: string;
    readonly total?: string;
    readonly currency?: string;
    readonly total_incl_vat?: string;
    /**
     * (optional)
     */
    invoice_no?: string;
    draft?: boolean;
    readonly finalized_on?: (string) | null;
    date?: (string) | null;
    readonly sent_on?: (string) | null;
    readonly moneybird_invoice_id?: (number) | null;
    readonly exactnl_invoice_id?: string;
    readonly snelstart_invoice_id?: string;
    readonly yuki_invoice_id?: string;
    readonly payment_status?: (PaymentStatus);
    readonly created_on?: (string) | null;
    readonly last_modified_on?: (string) | null;
    start_date_activities?: (string) | null;
    end_date_activities?: (string) | null;
    start_date_services?: (string) | null;
    end_date_services?: (string) | null;
    readonly created_by_uid?: string;
    readonly expiration_date?: (string) | null;
    first_due_interval?: number;
    readonly payment_summary?: (PaymentSummary);
    readonly automatically_generated?: boolean;
    automatic_payment?: boolean;
    order?: NestedOrder;
    readonly historic_supplier?: (SupplierNameAndAddress);
    readonly language?: string;
    items?: Array<NestedInvoiceItem>;
    readonly historic_customer?: (PurchaserNameAndAddress);
    readonly exactnl_url?: (string) | null;
    readonly exactnl_entry_no?: string;
    readonly snelstart_entry_no?: string;
    /**
     * indicates whether this instance exists in the database or not
     */
    readonly is_persistent?: boolean;
    /**
     * defaults to false
     */
    finalize?: boolean;
    /**
     * defaults to false
     */
    send_email?: boolean;
    /**
     * defaults to false
     */
    send_to_accounting_software?: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedInvoiceItem = {
    uid?: string;
    description?: string;
    unit_price?: (string) | null;
    readonly unit_price_currency?: (string) | null;
    category_uid?: string;
    quantity?: (string) | null;
    qualifier?: string;
    vat_percentage_uid?: (string) | null;
    readonly vat_percentage?: (NestedVATPercentage | null);
    vat_included_in_price?: boolean;
    deferred?: boolean;
    realactivities?: Array<(string)>;
    service_uid?: (string) | null;
    readonly created_on?: (string) | null;
    transactionitems?: Array<(string)>;
    readonly last_modified_on?: (string) | null;
    horse_uid?: (string) | null;
    readonly horse?: (NamedHorse);
    readonly total_vat?: (Money | null);
    billableitem_set?: Array<((string) | null)>;
    /**
     * indicates whether this instance exists in the database or not
     */
    readonly is_persistent?: boolean;
    invoice_uid?: string;
};

/**
 * Serializer for the LeaveAllowanceMutation class.
 */
export type PatchedLeaveAllowanceMutation = {
    readonly id?: number;
    readonly uid?: string;
    contact?: string;
    employment?: string;
    date?: string;
    amount?: string;
    note?: string;
};

/**
 * Serializer for the map model.
 */
export type PatchedMap = {
    readonly uid?: string;
    image_url?: string;
    readonly pointofinterest_set?: Array<PointOfInterest>;
};

/**
 * Serializer for the Map POI.
 */
export type PatchedMapPointOfInterest = {
    readonly uid?: string;
    parent_map_uid?: string;
    coordinate_x?: number;
    coordinate_y?: number;
    map?: string;
    readonly resourcetype?: 'map';
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedMareCycleCheck = {
    readonly uid?: string;
    is_pregnant?: IsPregnantEnum;
    uterus?: (UterusEnum | BlankEnum);
    uterus_has_fluid?: boolean;
    egg_set?: Array<NestedEgg>;
    cyst_set?: Array<NestedCyst>;
    cervix?: (SoftnessEnum | BlankEnum);
    mare_uid?: string;
    date?: string;
    readonly created_on?: string;
    readonly created_by?: string;
    readonly last_modified_on?: string;
    add_followup_insemination?: (FollowUpInseminationCheck);
    add_followup_marecyclechecks?: Array<FollowUpMareCycleCheck>;
    readonly breeding_plan?: (NestedBreedingPlan);
    stallion_uid?: string;
    requester_uid?: string;
    breeding_plan_uid?: string;
    activity_uid?: string;
    order_item_uid?: (string) | null;
    /**
     * When was the check (relative to insemination)
     *
     * * `FIRST` - First
     * * `SECOND` - Second
     * * `THIRD` - Third
     */
    pregnancy_check_term?: (PregnancyCheckTermEnum | BlankEnum | NullEnum);
    /**
     * (optional) Write down extra information about this activity.
     */
    extra_info?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedMergeContacts = {
    readonly uid?: string;
    color?: string;
    readonly user_uid?: (string) | null;
    stables?: Array<((string) | null)>;
    /**
     * Max three initials
     */
    initials?: string;
    readonly hidden?: boolean;
    roles?: Array<((string) | null)>;
    first_name?: string;
    last_name?: string;
    studbook_preference?: (StudbookEnum | BlankEnum);
    business_name?: string;
    phone_number?: string;
    email?: string;
    external_location?: boolean;
    customer_id?: string;
    moneybird_contact_id?: (number) | null;
    exactnl_contact_id?: string;
    snelstart_contact_id?: string;
    is_inseminator?: boolean;
    is_semen_collection_station?: boolean;
    is_insemination_station?: boolean;
    /**
     * only show orders where requester is a contact with use_for_picking in the picklist
     */
    use_for_picking?: boolean;
    vat_number?: string;
    readonly vat_number_checked?: (boolean) | null;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    address_line1?: string;
    address_line2?: string;
    address_line3?: string;
    country?: (CountryEnum | BlankEnum);
    state?: string;
    postcode?: string;
    city?: string;
    title?: (TitleEnum | BlankEnum);
    date_of_birth?: (string) | null;
    show_in_daily?: boolean;
    show_in_work_schedule?: boolean;
    note?: string;
    readonly stable_location_uid?: string;
    UBN?: string;
    invoice_language?: (InvoiceLanguageEnum | BlankEnum);
    business_type?: (BusinessTypeEnum | NullEnum);
    readonly lookup?: string;
    readonly manage_horse_location_history?: boolean;
    readonly machtiging_rvo_gegeven?: (string) | null;
    readonly machtiging_rvo_gegeven_by_uid?: (string) | null;
    readonly invitation?: (SentInvitation | null);
    create_user_invitation?: boolean;
    parent_stable?: (string) | null;
    IBAN?: string;
    bank_code?: string;
    account_number?: string;
    bank_name?: string;
    second_phone_number?: string;
    company_registration_number?: string;
    /**
     * In case the contact represents a (supplier side) customer, this product can be used as suggestion or default in orders, that require shipping.
     */
    default_shipping_product?: (string) | null;
    merge_with_uid?: string;
};

/**
 * For list
 */
export type PatchedMergeHorses = {
    readonly uid?: string;
    readonly owner_uids?: Array<(string)>;
    display_name?: string;
    group_uid?: (string) | null;
    stable_uid?: (string) | null;
    readonly hidden?: boolean;
    readonly is_external?: boolean;
    dentist_weeks?: (number) | null;
    deworm_weeks?: (number) | null;
    rhino_weeks?: (number) | null;
    vaccination_rules_uid?: string;
    /**
     * Make empty to disable automatic scheduling.
     */
    farrier_weeks?: (number) | null;
    name?: string;
    nickname?: string;
    box_no?: (number) | null;
    date_of_birth?: (string) | null;
    color?: (ColorEnum | NullEnum);
    sex?: (SexEnum | NullEnum);
    readonly duplicates?: Array<(string)>;
    weight?: (string) | null;
    temperature?: (string) | null;
    sire_obj_uid?: (string) | null;
    dam_obj_uid?: (string) | null;
    damdam_obj_uid?: (string) | null;
    siresire_obj_uid?: (string) | null;
    damsire_obj_uid?: (string) | null;
    siredam_obj_uid?: (string) | null;
    siregrandsire1_obj_uid?: (string) | null;
    siregrandsire2_obj_uid?: (string) | null;
    siregranddam1_obj_uid?: (string) | null;
    siregranddam2_obj_uid?: (string) | null;
    damgranddam1_obj_uid?: (string) | null;
    damgranddam2_obj_uid?: (string) | null;
    damgrandsire1_obj_uid?: (string) | null;
    damgrandsire2_obj_uid?: (string) | null;
    sire?: string;
    dam?: string;
    damsire?: string;
    breeder?: string;
    studbook?: string;
    /**
     * Use this field for notes.
     */
    note?: string;
    /**
     * This information comes at the exclamation mark in the weekly overview.
     */
    warning?: string;
    damdam?: string;
    siresire?: string;
    siredam?: string;
    siregrandsire1?: string;
    siregrandsire2?: string;
    siregranddam1?: string;
    siregranddam2?: string;
    damgranddam1?: string;
    damgranddam2?: string;
    damgrandsire1?: string;
    damgrandsire2?: string;
    /**
     * Universal Equine Life Number
     */
    UELN?: string;
    FEI_pass_nr?: string;
    local_federation_number?: string;
    chip_nr?: string;
    FEI_expiry_date?: (string) | null;
    default_rider_uid?: (string) | null;
    default_groom_uid?: (string) | null;
    default_farrier_uid?: (string) | null;
    default_vet_uid?: (string) | null;
    default_trainer_uid?: (string) | null;
    /**
     * Instructions for transporting this horse
     */
    transport_instruction?: (string) | null;
    id_horsetelex?: string;
    purchase_date?: (string) | null;
    withers_height?: (number) | null;
    /**
     * In beats per minute
     */
    heart_rate?: (number) | null;
    /**
     * In breaths per minute
     */
    respiratory_rate?: (number) | null;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    avatar_file?: (string) | null;
    readonly current_horselocation?: (NestedHorseLocation);
    readonly future_horselocation?: (NestedHorseLocation);
    register_move?: (HorseLocationMove);
    new_owners?: Array<(string)>;
    use_in_breeding?: boolean;
    use_in_sport?: boolean;
    use_in_care?: boolean;
    default_semen_collection_station?: (string) | null;
    merge_with_uid?: string;
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type PatchedMyFacilityEventUpdate = {
    readonly uid?: string;
    description?: string;
    facility_uid?: string;
    activity_uid?: (string) | null;
    horse_uids?: Array<(string)>;
    readonly slots?: number;
    /**
     * Optional, to provide info on the contact responsible for this booking
     */
    readonly contact_uid?: (string) | null;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    readonly created_by_uid?: string;
    readonly last_modified_by_uid?: (string) | null;
    is_private_reservation?: boolean;
    start?: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    status?: (EventStatus);
    recurrence?: string;
    events_to_change?: (EventsToChangeEnum);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedNitrogenApplication = {
    readonly uid?: string;
    contact_uid?: string;
    /**
     * e.g. 2025
     */
    year?: number;
    /**
     * type and origin of this batch, e.g. 'Vaste mest van graasdieren aangevoerd'
     */
    fertilizer_description?: string;
    /**
     * type of land over which this batch was spread out, e.g. 'Overige toepassingen op bedrijf met beweiding'
     */
    application_description?: string;
    is_animal_manure?: boolean;
    /**
     * nitrogen weight of this batch in kg
     */
    nitrogen_weight?: number;
    /**
     * in whole percentages [0, 100]
     */
    application_coefficient?: number;
    readonly effective_nitrogen_weight?: number;
};

export type PatchedNotificationSettings = {
    /**
     * Notification when there are unfinished activities for today
     */
    daily_unchecked_enabled?: boolean;
    /**
     * Notification when plan for tomorrow is missing
     */
    daily_tomorrow_not_planned_enabled?: boolean;
    /**
     * Notification when my plan is updated
     */
    task_assigned_enabled?: boolean;
    daily_timing?: string;
    /**
     * Notification when an activity is done with horses you own
     */
    activity_done_own_horse_enabled?: boolean;
    /**
     * Notification when the information has not been filled in completely for one or more horses
     */
    daily_horse_incomplete_enabled?: boolean;
    /**
     * Notification when feed has changed
     */
    feed_change_enabled?: boolean;
    enable_push_notifications?: (boolean) | null;
    /**
     * Notification when a file is added to a horse
     */
    horse_media_enabled?: boolean;
    /**
     * Notification of planned activities with reminder
     */
    enable_notify_before?: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedOrganisation = {
    readonly uid?: string;
    readonly created_by_uid?: string;
    readonly last_modified_by_uid?: string;
    readonly public_access_uuid?: string;
    name?: string;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    readonly is_paid?: boolean;
    readonly is_bp?: boolean;
    readonly is_ssd?: boolean;
    shop_terms_conditions?: (string) | null;
    /**
     * Indicate whether the EU One-Stop-Shop (OSS) tax policy applies.
     */
    use_one_stop_shop?: boolean;
    timezone?: TimezoneEnum;
    readonly expected_no_horses?: (number) | null;
    /**
     * De vaccination is then automatically added to the mare when the insemination is checked. Leave this empty if you don't like this automatic behaviour.
     */
    weeks_between_insemination_and_vaccination?: (number) | null;
    days_between_insemination_and_pregnancy_check?: (number) | null;
    /**
     * The default, and minimum, is 10 minutes. Set 0 if you don't want automatic refresh to happen.
     */
    equiboard_refresh_rate?: number;
    /**
     * The default is 10 minutes. A screensaver elongates the lifetime of your display and saves the environment by using less energy.
     */
    equiboard_screensaver_time?: number;
    /**
     * The default is 0.2. 0 means completely light, 1 means completely dark.
     */
    equiboard_lockscreendarkness?: number;
    also_send_invoice_to_email?: string;
    website?: string;
    logo?: (string) | null;
    invoice_subject?: string;
    invoice_text?: string;
    currency?: string;
    invoice_footer_1?: string;
    invoice_footer_2?: string;
    max_no_horses?: (number) | null;
    readonly last_information_send?: (string) | null;
    readonly number_of_information_send_last_day?: (number) | null;
    readonly relatienummer_rvo?: string;
    readonly type_of_organisation?: (TypeOfOrganisationEnum);
    enabled_modules?: Array<(EnabledModulesEnum | BlankEnum)>;
    /**
     * Set this option if you always want EquineM to send the invoice email, even if there is a connection with accounting software.
     */
    invoice_email_by_equinem?: boolean;
    primary_color?: string;
    secondary_color?: string;
    show_logo_on_invoice?: boolean;
    /**
     * Products can be given an upfront cost. This amount will be suggested on new products.
     */
    suggested_breeding_product_down_payment?: string;
    down_payment_permitted_countries?: Array<(CountryEnum | BlankEnum)>;
    invoice_first_due_interval?: number;
    readonly can_create_payment_link?: boolean;
    readonly only_use_ad?: boolean;
    readonly microsoft_ad_group_id?: string;
    exactnl_sales_journal?: string;
    no_breeding_boxes?: (number) | null;
    work_week_hours?: (number) | null;
    sick_counts_for_leave_allowance?: (boolean) | null;
    /**
     * If a 0 is filled in no portions will be automatically destroyed
     */
    destroy_fresh_portions_days?: number;
};

/**
 * Serializes Payments related to the orders supplied by the path's organisation.
 * All fields are read only and cannot be altered by this serializer.
 */
export type PatchedPayment = {
    readonly uid?: string;
    type?: (PaymentTypeEnum);
    date?: (string) | null;
    amount?: string;
    readonly amount_currency?: string;
    status?: (PaymentStatus);
    readonly created_on?: string;
    mollie_payment_id?: (string) | null;
    invoice?: (string) | null;
    order?: (string) | null;
};

export type PatchedPointOfInterest = PatchedFilePointOfInterest | PatchedMapPointOfInterest | PatchedURLPointOfInterest;

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedProduct = {
    readonly uid?: string;
    name?: string;
    hidden?: boolean;
    description?: string;
    /**
     * The date is exclusive: on this date the product will not be available anymore.
     */
    available_until?: (string) | null;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    category_uid?: string;
    taxation_type?: (TaxationTypeEnum);
    /**
     * Every product needs a product type. This is used in the business logic to identify the type of the product.
     *
     * * `HEALTH_CERTIFICATE` - health certificate
     * * `BREEDING_ADMINISTRATION` - breeding administration
     * * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     * * `ACTIVITY` - Activity
     */
    product_type?: (ProductTypeEnum);
    /**
     * Pick a plan for which you want to offer a subscription in your organisation's catalogue.
     */
    plan_uid?: (string) | null;
    /**
     * The number of instances (for a credits or tiered plan) that should be permitted by a contract on the plan's module. Leave blank to indicate there is no no limit (in case of a flat fee plan). This is only relevant for subscription products.
     */
    max_amount?: (number) | null;
    /**
     * discount percentage [0-100] if the customer pays for a whole year in the first invoice
     */
    yearly_invoice_discount_percentage?: number;
    /**
     * The unit this product comes in, e.g. 'ml', 'portion', 'kg'
     */
    qualifier?: string;
    readonly price_points?: Array<PricePoint>;
    current_price?: (string) | null;
    current_price_currency?: string;
    future_price?: (string) | null;
    future_price_currency?: string;
    future_price_application_date?: (string) | null;
    /**
     * Indicates the amount for this product that will be applied as down payment on the invoice. Set to 0 to apply the full amount.
     */
    upfront_cost?: string;
    readonly upfront_cost_currency?: string;
    /**
     * Indicates if orders with this product should include at least one shipping product.
     */
    readonly requires_shipping?: boolean;
    /**
     * Select a stallion when the category is breeding.
     */
    stallion_uid?: (string) | null;
    fresh_available?: boolean;
    frozen_available?: boolean;
    shipping_provider_name?: (string) | null;
    postcodes_for_staff_delivery?: string;
    shipping_service_type?: (ShippingServiceTypeEnum | BlankEnum | NullEnum);
    shipping_countries?: Array<('AF' | 'AX' | 'AL' | 'DZ' | 'AS' | 'AD' | 'AO' | 'AI' | 'AQ' | 'AG' | 'AR' | 'AM' | 'AW' | 'AU' | 'AT' | 'AZ' | 'BS' | 'BH' | 'BD' | 'BB' | 'BY' | 'BE' | 'BZ' | 'BJ' | 'BM' | 'BT' | 'BO' | 'BQ' | 'BA' | 'BW' | 'BV' | 'BR' | 'IO' | 'BN' | 'BG' | 'BF' | 'BI' | 'CV' | 'KH' | 'CM' | 'CA' | 'KY' | 'CF' | 'TD' | 'CL' | 'CN' | 'CX' | 'CC' | 'CO' | 'KM' | 'CG' | 'CD' | 'CK' | 'CR' | 'CI' | 'HR' | 'CU' | 'CW' | 'CY' | 'CZ' | 'DK' | 'DJ' | 'DM' | 'DO' | 'EC' | 'EG' | 'SV' | 'GQ' | 'ER' | 'EE' | 'SZ' | 'ET' | 'FK' | 'FO' | 'FJ' | 'FI' | 'FR' | 'GF' | 'PF' | 'TF' | 'GA' | 'GM' | 'GE' | 'DE' | 'GH' | 'GI' | 'GR' | 'GL' | 'GD' | 'GP' | 'GU' | 'GT' | 'GG' | 'GN' | 'GW' | 'GY' | 'HT' | 'HM' | 'VA' | 'HN' | 'HK' | 'HU' | 'IS' | 'IN' | 'ID' | 'IR' | 'IQ' | 'IE' | 'IM' | 'IL' | 'IT' | 'JM' | 'JP' | 'JE' | 'JO' | 'KZ' | 'KE' | 'KI' | 'KW' | 'KG' | 'LA' | 'LV' | 'LB' | 'LS' | 'LR' | 'LY' | 'LI' | 'LT' | 'LU' | 'MO' | 'MG' | 'MW' | 'MY' | 'MV' | 'ML' | 'MT' | 'MH' | 'MQ' | 'MR' | 'MU' | 'YT' | 'MX' | 'FM' | 'MD' | 'MC' | 'MN' | 'ME' | 'MS' | 'MA' | 'MZ' | 'MM' | 'NA' | 'NR' | 'NP' | 'NL' | 'NC' | 'NZ' | 'NI' | 'NE' | 'NG' | 'NU' | 'NF' | 'KP' | 'MK' | 'MP' | 'NO' | 'OM' | 'PK' | 'PW' | 'PS' | 'PA' | 'PG' | 'PY' | 'PE' | 'PH' | 'PN' | 'PL' | 'PT' | 'PR' | 'QA' | 'RE' | 'RO' | 'RU' | 'RW' | 'BL' | 'SH' | 'KN' | 'LC' | 'MF' | 'PM' | 'VC' | 'WS' | 'SM' | 'ST' | 'SA' | 'SN' | 'RS' | 'SC' | 'SL' | 'SG' | 'SX' | 'SK' | 'SI' | 'SB' | 'SO' | 'ZA' | 'GS' | 'KR' | 'SS' | 'ES' | 'LK' | 'SD' | 'SR' | 'SJ' | 'SE' | 'CH' | 'SY' | 'TW' | 'TJ' | 'TZ' | 'TH' | 'TL' | 'TG' | 'TK' | 'TO' | 'TT' | 'TN' | 'TR' | 'TM' | 'TC' | 'TV' | 'UG' | 'UA' | 'AE' | 'GB' | 'UM' | 'US' | 'UY' | 'UZ' | 'VU' | 'VE' | 'VN' | 'VG' | 'VI' | 'WF' | 'EH' | 'YE' | 'ZM' | 'ZW' | '')> | null;
    show_in_shop?: boolean;
    /**
     * Activities of this type will be priced by this product.
     */
    activity_type_uid?: (string) | null;
    /**
     * Enter from which start date activities of this type should be in the to invoice list.
     */
    to_invoice_start_date?: (string) | null;
    shipping_slip_number_start?: string;
    show_on_insemination_route?: boolean;
    /**
     * For which shipping products should an insemination product automatically be added
     */
    insemination_shipping_products?: Array<(string)>;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedProductionBalanceItem = {
    readonly uid?: string;
    /**
     * name of this balance item. Must be unique with contact, year fertilizer origin and mutation type.
     */
    name?: string;
    contact_uid?: string;
    /**
     * e.g. 2025
     */
    year?: number;
    /**
     * indicate the type of this fertilizer or where it originated from
     *
     * * `ANIMAL_MANURE_SUPPLY` - animal manure supply
     * * `MILK_PRODUCING_COWS` - milk producing cows
     * * `GRAZING_ANIMALS` - grazing animals
     * * `EQUINEM_HORSES` - equinem horses
     * * `STABLE_ANIMALS_FEED` - stable animals feed
     * * `OTHER_ORGANIC_SUPPLY` - other organic supply
     * * `ANORGANIC_SUPPLY` - anorganic supply
     */
    fertilizer_origin?: (FertilizerOriginEnum);
    /**
     * End amounts and Exports are subtractions on the balance, the others are additions
     *
     * * `BEGIN_AMOUNT` - begin amount
     * * `IMPORT` - import
     * * `PRODUCTION` - production
     * * `EXPORT` - export
     * * `END_AMOUNT` - end amount
     */
    mutation_type?: (MutationTypeEnum);
    /**
     * how much kg of nitrogen this item accounts for
     */
    nitrogen_weight?: (number) | null;
    /**
     * how much kg of phosphate this item accounts for
     */
    phosphate_weight?: (number) | null;
    readonly operator?: (OperatorEnum);
    readonly is_animal_manure?: boolean;
};

/**
 * Only accepts updates done to purchaser and only to organisations that are available to the requesting user.
 */
export type PatchedPurchaserOrderUpdate = {
    readonly uid?: string;
    readonly public_access_uuid?: (string) | null;
    readonly number?: string;
    customer_uid?: string;
    purchaser_uid?: (string) | null;
    supplier?: string;
    readonly customer_note?: string;
    readonly created_on?: string;
    readonly last_modified_on?: string;
    readonly payment_summary?: (PaymentSummary);
    readonly shipping_date?: (string) | null;
    order_items?: Array<PurchaserOrderItem>;
    dry_run?: boolean;
    readonly shipping_name?: string;
    readonly shipping_address_line1?: string;
    readonly shipping_address_line2?: string;
    readonly shipping_address_line3?: string;
    readonly shipping_city?: string;
    readonly shipping_state?: string;
    readonly shipping_postcode?: string;
    readonly shipping_country?: (CountryEnum);
    readonly shipping_phone_number?: string;
    readonly shipping_location_traces_number?: string;
    readonly shipping_search_text?: string;
    readonly breeding_plan?: (PurchaserNestedBreedingPlan | null);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedPurchaserServiceContract = {
    readonly uid?: string;
    customer_uid?: string;
    product_uid?: string;
    readonly module?: (ModuleEnum);
    readonly pricing_model?: (PricingModelEnum);
    readonly start_dt?: string;
    /**
     * The contract will last for this number of duration units. Define together with duration_unit.
     */
    readonly duration_amount?: (number) | null;
    /**
     * The contract will last for the duration amount of this time frame. Define together with duration_amount.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    readonly duration_unit?: (TimeFrameEnum);
    /**
     * New contracts start out with a notice period of the contract duration. Automatically extended contracts get a one-month notice period.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    readonly notice_period?: (TimeFrameEnum);
    /**
     * Typically, this is one year from now for flat_fee and tiered pricing models and left blank for the credits pricing model. But it may be left blank to indicate the contract has no end. This will be inferred form duration unit and amount.
     */
    readonly end_dt?: (string) | null;
    /**
     * Contracts with overdue payments may be suspended. Suspended contracts will be denied access to the related service until the suspension is lifted or a new contract on said service is made. Suspendedcontract cannot be upgraded / downgraded or canceled.
     */
    readonly is_suspended?: boolean;
    /**
     * This is the fixed_price currency, but you may assume that it also applies to 'estimated_cost', 'next_tiered_instance_cost' and 'total_vat'.
     */
    readonly currency?: (string) | null;
    /**
     * For subscriptions applying a flat fee or stair-step plan, this is the monthly fee. For Tiered subscription this will typically be 0,00 because their cost are indicated by the estimated_cost. A value of "null" indicates that a fixed price does not apply (e.g. for a pay-once credits based service contract).
     */
    readonly fixed_price?: string;
    /**
     * The VAT amount over the sum of fixed price and estimated cost. If this contract has the latter, than this too is an estimate.
     */
    readonly total_vat?: (string) | null;
    readonly vat_percentage?: (NestedVATPercentage | null);
    readonly discount_percentage?: number;
    /**
     * When checked, a new contract with similar conditions will be generated when this contract nears the end date. Requires that end_dt is defined.
     */
    readonly extend_automatically?: boolean;
    /**
     * Whether the invoice is billed monthly or yearly.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    readonly invoice_period?: (TimeFrameEnum);
    readonly followup_contract_uid?: string;
    readonly horse_uid?: (string) | null;
    /**
     * For the supplier to fill-out any specifics / reminders for this contact.
     */
    readonly comment?: string;
    readonly purchaser?: (string) | null;
    /**
     * The monthly cost estimation based on the current use of the services related to the contract. Typically, this applies to subscriptions on a Tiered plan where the fixed cost is 0,00 and the variable cost is calculated after use of the respective services. A value of "null" indicates that this cost does not apply for the service contract.
     */
    estimated_cost?: (string) | null;
    /**
     * Number of instances that are serviced under this contract. Shows "null" if this is nonsensical, for example in a Flat-fee priced contract that allows access to a certain module. Typically, this is useful for Tiered, Stair-step and Credits contracts.
     */
    applied_unit_count?: (number) | null;
    /**
     * Number of additional instances allowed under this service contract. The number shows 0 if the contract is expired; it shows "null" if this is not applicable. Intended for Stair-step and Credits contracts.
     */
    available_unit_count?: (number) | null;
    /**
     * Maximum number of instances allowed under this service contract. The number shows "null" if there is no limit, like for flat-fee or pay-after-use (tiered) services.
     */
    maximum_unit_count?: (number) | null;
    /**
     * For a contract applying the Tiered pricing model, this shows the addition to the estimated costif another instance would be added. The number shows "null" for non-tiered contracts.
     */
    next_tiered_instance_cost?: (string) | null;
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type PatchedRealActivitiesSetDoneAndUnDone = {
    readonly uid?: string;
    readonly horse_uid?: string;
    readonly activity_type_uid?: string;
    readonly remind?: boolean;
    readonly done_on?: (string) | null;
    readonly set_done?: boolean;
    readonly done_by_uid?: (string) | null;
    readonly parent_uid?: (string) | null;
    readonly dry_run?: boolean;
    readonly daypart?: (number) | null;
    readonly ordering?: number;
    readonly status?: (EventStatus);
    /**
     * Cached because the cached answer is used in the post_delete signal!
     */
    readonly action_holder_uid?: (string) | null;
    readonly last_modified_on?: string;
    readonly created_by_uid?: string;
    readonly created_on?: string;
    readonly last_modified_by_uid?: (string) | null;
    readonly activitycontactrole_set?: Array<ActivityContactRole>;
    readonly stallionmount_uid?: string;
    readonly marecyclecheck_uid?: string;
    readonly order_item_uid?: (string) | null;
    readonly stallion_uid?: (string) | null;
    readonly facility_uids?: Array<(string)>;
    breeding_box_no?: (number) | null;
    readonly level?: string;
    /**
     * (optional) Write down extra information about this activity.
     */
    readonly extra_info?: string;
    /**
     * How intense was the activity?
     */
    readonly intensity?: (number) | null;
    readonly estimated_intensity?: (WorkloadEnum | NullEnum);
    readonly show?: (string) | null;
    readonly sire?: string;
    readonly external_url?: string;
    /**
     * In beats per minute
     */
    readonly heart_rate?: (number) | null;
    readonly race_time?: (string) | null;
    readonly show_status?: (ShowStatusEnum | BlankEnum | NullEnum);
    readonly workload?: (WorkloadEnum | NullEnum);
    /**
     * When was the check (relative to insemination)
     *
     * * `FIRST` - First
     * * `SECOND` - Second
     * * `THIRD` - Third
     */
    readonly pregnancy_check_term?: (PregnancyCheckTermEnum | BlankEnum | NullEnum);
    readonly start?: (DatetimeOrDateField);
    readonly end?: (DatetimeOrDateField);
    readonly all_day_event?: boolean;
    readonly endTimeUnspecified?: boolean;
    readonly recurrence?: string;
    readonly events_to_change?: (EventsToChangeEnum);
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type PatchedRealActivitiesUpdate = {
    readonly uid?: string;
    horse_uid?: string;
    activity_type_uid?: string;
    remind?: boolean;
    readonly done_on?: (string) | null;
    set_done?: boolean;
    readonly done_by_uid?: (string) | null;
    readonly parent_uid?: (string) | null;
    dry_run?: boolean;
    daypart?: (number) | null;
    ordering?: number;
    status?: (EventStatus);
    /**
     * Cached because the cached answer is used in the post_delete signal!
     */
    readonly action_holder_uid?: (string) | null;
    readonly last_modified_on?: string;
    readonly created_by_uid?: string;
    readonly created_on?: string;
    readonly last_modified_by_uid?: (string) | null;
    activitycontactrole_set?: Array<ActivityContactRole>;
    readonly stallionmount_uid?: string;
    readonly marecyclecheck_uid?: string;
    order_item_uid?: (string) | null;
    readonly stallion_uid?: (string) | null;
    facility_uids?: Array<(string)>;
    breeding_box_no?: (number) | null;
    level?: string;
    /**
     * (optional) Write down extra information about this activity.
     */
    extra_info?: string;
    /**
     * How intense was the activity?
     */
    intensity?: (number) | null;
    estimated_intensity?: (WorkloadEnum | NullEnum);
    show?: (string) | null;
    sire?: string;
    external_url?: string;
    /**
     * In beats per minute
     */
    heart_rate?: (number) | null;
    race_time?: (string) | null;
    show_status?: (ShowStatusEnum | BlankEnum | NullEnum);
    workload?: (WorkloadEnum | NullEnum);
    /**
     * When was the check (relative to insemination)
     *
     * * `FIRST` - First
     * * `SECOND` - Second
     * * `THIRD` - Third
     */
    pregnancy_check_term?: (PregnancyCheckTermEnum | BlankEnum | NullEnum);
    start?: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    recurrence?: string;
    events_to_change?: (EventsToChangeEnum);
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type PatchedRole = {
    readonly uid?: string;
    name?: string;
    readonly default_id?: (number) | null;
    stable_uid?: (string) | null;
    readonly last_modified_on?: string;
    readonly created_on?: string;
    hidden?: boolean;
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type PatchedService = {
    readonly uid?: string;
    name?: string;
    price?: string;
    readonly price_currency?: string;
    vat_percentage_uid?: string;
    /**
     * The category used when creating an invoice line for this service.
     */
    category_uid?: string;
    vat_included_in_price?: boolean;
    description?: string;
    readonly created_on?: string;
    readonly last_modified_on?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedServiceContact = {
    readonly uid?: string;
    start_date?: string;
    end_date?: (string) | null;
    price?: string;
    readonly price_currency?: string;
    vat_percentage_uid?: string;
    customer_uid?: string;
    service_uid?: string;
    vat_included_in_price?: boolean;
    horse_uid?: (string) | null;
    created_by_uid?: (string) | null;
    readonly created_on?: string;
    readonly last_modified_on?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedStable = {
    readonly uid?: string;
    readonly created_by_uid?: string;
    readonly location_uid?: string;
    timezone?: TimezoneEnum;
    location?: StableContact;
    is_primary?: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedStallionMount = {
    readonly uid?: string;
    stallion_uid?: string;
    collection_date?: string;
    volume?: number;
    concentration?: number;
    storage_container?: string;
    storage_canister?: string;
    portions_fresh?: number;
    portions_fresh_available?: number;
    readonly portions_fresh_destroyed_amount?: number;
    readonly portions_fresh_destroyed_on?: (string) | null;
    straws_frozen?: number;
    straws_frozen_available?: number;
    readonly straws_frozen_destroyed_amount?: number;
    readonly straws_frozen_destroyed_on?: (string) | null;
    NIFA_straw_color?: (NIFAStrawColorEnum | BlankEnum);
    morphology?: number;
    moving_cells_percentage?: number;
    readonly created_on?: string;
    readonly created_by?: string;
    readonly last_modified_on?: string;
    readonly last_modified_by?: string;
    semen_collection_station?: (string) | null;
    activity_uid?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedSupplierOrderDetail = {
    readonly uid?: string;
    readonly public_access_uuid?: (string) | null;
    readonly number?: string;
    customer_uid?: (string) | null;
    requester_uid?: (string) | null;
    supplier_note?: string;
    readonly customer_note?: string;
    /**
     * The traces certificate number is (not always) required for shipping to another country in the EU
     */
    traces_certificate_number?: (string) | null;
    /**
     * The ecert certificate number is always required for export outside the EU
     */
    ecert_certificate_number?: (number) | null;
    readonly created_on?: string;
    readonly created_by?: string;
    readonly last_modified_on?: string;
    readonly last_modified_by?: string;
    shipping_date?: (string) | null;
    readonly payment_summary?: (PaymentSummary);
    dry_run?: boolean;
    readonly supplier_uid?: string;
    order_items?: Array<SupplierOrderItemDetail>;
    shipping_name?: string;
    shipping_address_line1?: string;
    shipping_address_line2?: string;
    shipping_address_line3?: string;
    shipping_city?: string;
    shipping_state?: string;
    shipping_postcode?: string;
    shipping_country?: (CountryEnum | BlankEnum);
    shipping_phone_number?: string;
    shipping_slip_status?: (ShippingSlipStatusEnum | BlankEnum);
    readonly shipping_slip_number?: string;
    readonly shipping_search_text?: string;
    shipping_location_traces_number?: string;
    /**
     * A purchaser needs to accept the terms and conditions of the supplying organisation.
     */
    readonly terms_accepted_on?: (string) | null;
    readonly is_complete?: boolean;
    breeding_plan_uid?: (string) | null;
    readonly breeding_plan?: (SupplierNestedBreedingPlan | null);
    readonly order_origin?: (OrderOriginEnum);
    inseminator_uid?: (string) | null;
    sorting?: (number) | null;
    readonly historic_customer?: (PurchaserNameAndAddress | null);
    send_order_confirmation?: boolean;
    traces_seal_number_1?: (number) | null;
    traces_seal_number_2?: (number) | null;
};

/**
 * - fixed_price serializes the amount.
 * - currency and vat are inferred from product; we'd like to use the same currency
 * - module and pricing_model are inferred from product.plan
 * - extend_automatically defaults to False Supplier provided service contracts cannot be extended.
 * Contracts can run indefinitely by omitting end_dt. These are called 'open-ended contracts.
 * - discount and invoice periods are todo's
 */
export type PatchedSupplierServiceContractUpdate = {
    readonly uid?: string;
    readonly customer_uid?: string;
    product_uid?: string;
    readonly module?: (ModuleEnum);
    readonly pricing_model?: (PricingModelEnum);
    start_dt?: string;
    /**
     * The contract will last for this number of duration units. Define together with duration_unit.
     */
    readonly duration_amount?: (number) | null;
    /**
     * The contract will last for the duration amount of this time frame. Define together with duration_amount.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    readonly duration_unit?: (TimeFrameEnum);
    /**
     * New contracts start out with a notice period of the contract duration. Automatically extended contracts get a one-month notice period.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    notice_period?: (TimeFrameEnum);
    /**
     * Typically, this is one year from now for flat_fee and tiered pricing models and left blank for the credits pricing model. But it may be left blank to indicate the contract has no end. This will be inferred form duration unit and amount.
     */
    end_dt?: (string) | null;
    /**
     * Contracts with overdue payments may be suspended. Suspended contracts will be denied access to the related service until the suspension is lifted or a new contract on said service is made. Suspendedcontract cannot be upgraded / downgraded or canceled.
     */
    is_suspended?: boolean;
    /**
     * This is the fixed_price currency, but you may assume that it also applies to 'estimated_cost', 'next_tiered_instance_cost' and 'total_vat'.
     */
    readonly currency?: (string) | null;
    /**
     * For subscriptions applying a flat fee or stair-step plan, this is the monthly fee. For Tiered subscription this will typically be 0,00 because their cost are indicated by the estimated_cost. A value of "null" indicates that a fixed price does not apply (e.g. for a pay-once credits based service contract).
     */
    fixed_price?: string;
    /**
     * The VAT amount over the sum of fixed price and estimated cost. If this contract has the latter, than this too is an estimate.
     */
    readonly total_vat?: (string) | null;
    readonly vat_percentage?: (NestedVATPercentage | null);
    readonly discount_percentage?: number;
    /**
     * When checked, a new contract with similar conditions will be generated when this contract nears the end date. Requires that end_dt is defined.
     */
    readonly extend_automatically?: boolean;
    /**
     * Whether the invoice is billed monthly or yearly.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    readonly invoice_period?: (TimeFrameEnum);
    readonly followup_contract_uid?: string;
    readonly horse_uid?: (string) | null;
    /**
     * For the supplier to fill-out any specifics / reminders for this contact.
     */
    comment?: string;
};

/**
 * CRUD your Transactions in combination with TransactionItems: they are nested under `items`.
 *
 * Note on the agency: The transaction is managed by your organisation. It lists goods that were bought by
 * your organisation, possibly as (part of) a service to one of your customer. The Transaction's `supplier` contact
 * field can track where the goods originated from (the field is optional). The TransactionItem's `customer` contact
 * field can track for whom they are intended So:
 * - `supplier_uid` is the Contact where the goods (transaction items) came from (optional)
 * - `organisation_uid` is your organisation.
 * - `item.customer_uid` is for whom the goods are intended (optional)
 *
 * Note on Updating transaction items:
 * - If `transaction_items` is *not* supplied:
 * - no change to existing transaction items.
 *
 * - If `transaction_items` is supplied:
 * - All items that specify a matching 'uid' are PATCHED with the additionally supplied fields.
 * - All items that don't have a 'uid' are CREATED.
 * - All *existing* transaction_items that are *not* mentioned by 'uid', are DELETED.
 *
 * I.e. if you want nothing to be done to the transaction items, you can list all the transaction items'
 * 'uid' field or omit 'transaction_items' al together. The behavior is the same with Invoice and Order.
 */
export type PatchedTransactionDetail = {
    readonly uid?: string;
    date?: string;
    supplier_uid?: (string) | null;
    currency?: CurrencyEnum;
    readonly created_on?: string;
    readonly created_by_uid?: string;
    readonly last_modified_on?: string;
    readonly last_modified_by_uid?: string;
    items?: Array<NestedTransactionItem>;
    media?: Array<NestedTransactionMedia>;
};

export type PatchedUpgradeDowngradePurchaserServiceContract = {
    max_amount?: (number) | null;
};

/**
 * Serializer for the URL POI.
 */
export type PatchedURLPointOfInterest = {
    readonly uid?: string;
    parent_map_uid?: string;
    coordinate_x?: number;
    coordinate_y?: number;
    url?: string;
    readonly resourcetype?: 'url';
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type PatchedVaccinationRule = {
    readonly uid?: string;
    name?: string;
    readonly organisation_uid?: (string) | null;
    months_between_vaccination?: number;
    optional_extra_days?: number;
    number_of_days_not_competing_after_vaccination?: number;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedVATPercentageExternalProviderId = {
    readonly uid?: string;
    vat_percentage_uid?: string;
    provider?: ProviderEnum;
    external_provider_sales_id?: string;
    external_provider_purchases_id?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PatchedVATPercentageUpdate = {
    hidden?: boolean;
};

/**
 * Serializes Payments related to the orders supplied by the path's organisation.
 * All fields are read only and cannot be altered by this serializer.
 */
export type Payment = {
    readonly uid: string;
    type?: (PaymentTypeEnum);
    date?: (string) | null;
    amount: string;
    readonly amount_currency: string;
    status?: (PaymentStatus);
    readonly created_on: string;
    mollie_payment_id?: (string) | null;
    invoice?: (string) | null;
    order?: (string) | null;
};

export type PaymentLink = {
    redirectUrl: string;
};

/**
 * * `FULL` - full
 * * `UPFRONT` - upfront
 * * `REMAINDER` - remainder
 */
export enum PaymentPartEnum {
    FULL = 'FULL',
    UPFRONT = 'UPFRONT',
    REMAINDER = 'REMAINDER'
}

/**
 * * `OPEN` - Open
 * * `PAID` - Paid
 * * `FAILED` - Failed
 */
export enum PaymentStatus {
    OPEN = 'OPEN',
    PAID = 'PAID',
    FAILED = 'FAILED'
}

export type PaymentSummary = {
    paid: string;
    status: PaymentStatus;
};

/**
 * * `Bank` - Bank
 * * `Cash` - Cash
 * * `Mollie` - Mollie
 * * `PayPal` - PayPal
 * * `Pin` - Pin
 * * `CreditCard` - CreditCard
 */
export enum PaymentTypeEnum {
    BANK = 'Bank',
    CASH = 'Cash',
    MOLLIE = 'Mollie',
    PAY_PAL = 'PayPal',
    PIN = 'Pin',
    CREDIT_CARD = 'CreditCard'
}

/**
 * * `F1` - F1
 * * `F2` - F2
 * * `F3` - F3
 * * `F4` - F4
 * * `F5` - F5
 * * `trial` - Trial
 * * `lesson` - Les
 */
export enum PhaseStatusEnum {
    F1 = 'F1',
    F2 = 'F2',
    F3 = 'F3',
    F4 = 'F4',
    F5 = 'F5',
    TRIAL = 'trial',
    LESSON = 'lesson'
}

/**
 * To pick a Stallion mount to be used for an OrderItem in an Order.
 * The OrderItem should be provided in the path.
 */
export type PickedStallionMount = {
    stallion_mount: string;
    amount: number;
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type Plan = {
    readonly uid: string;
    /**
     * The name is listed in the subscription product's plan.
     */
    readonly name: string;
    readonly description: string;
    /**
     * Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     */
    readonly module: (ModuleEnum);
    readonly pricing_model: (PricingModelEnum);
    /**
     * Indicate whether this plan may be applied in subscription products offered by other organisations than Equinem. If a plan *is not* generic, the access controller (ActiveServiceContractPermission) will search within Equinem's subscription products for instances that match on the (required) module. If a plan *is* generic, the access controller will look inside the affected object or respective request for a *supplier organisation to look-up the required-module matching subscription products.
     */
    readonly is_generic: boolean;
};

export type PointOfInterest = FilePointOfInterest | MapPointOfInterest | URLPointOfInterest;

/**
 * Apart from a "general" calendar hash with all activity types and all horses,
 * we have these fields to possibly filter the calendar by.
 */
export type PossibleCalendarHashObjects = {
    activity_type_uids?: Array<(string)> | null;
    horse_uids?: Array<(string)> | null;
};

/**
 * * `FIRST` - First
 * * `SECOND` - Second
 * * `THIRD` - Third
 */
export enum PregnancyCheckTermEnum {
    FIRST = 'FIRST',
    SECOND = 'SECOND',
    THIRD = 'THIRD'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PricePoint = {
    /**
     * Indicate the *total* instance count after which this price point should transition to the next price point for the related (tiered) product. This price point's unit price will be applied to all instances that fall outside of the previous price point and under this max amount. Instances that fall outside of this max_units are free of change if no price point with a higher max_units is defined in the same (tiered) product. Leave empty if you don't want to set an upper limit and want this unit price to be applied for indefinite follow-up instances.
     */
    max_units?: (number) | null;
    /**
     * The intended functionality depends on the pricing model that is applied to the product: - For a product on a Tiered pricing plan, this indicates the monthly price that should be charged per additional unit as long as the total number of related units is at or below max_units. <br>- For a product on a Stair-step based plan, this is the monthly price that should be applied if the total number of related units is at pr below this max_amount. <br>- For a credit based product this is the one-time price to buy the number of credits listed by max_amount.
     */
    price?: (string) | null;
    readonly price_currency: (string) | null;
};

/**
 * * `FLAT_FEE` - flat fee
 * * `STAIR_STEP` - stair step
 * * `TIERED` - tiered
 * * `CREDITS` - credits
 */
export enum PricingModelEnum {
    FLAT_FEE = 'FLAT_FEE',
    STAIR_STEP = 'STAIR_STEP',
    TIERED = 'TIERED',
    CREDITS = 'CREDITS'
}

/**
 * * `1` - Private
 * * `2` - Public
 * * `3` - Hidden
 */
export enum PrivateEnum {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type Product = {
    readonly uid: string;
    name?: string;
    hidden?: boolean;
    description?: string;
    /**
     * The date is exclusive: on this date the product will not be available anymore.
     */
    available_until?: (string) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    category_uid?: string;
    taxation_type?: (TaxationTypeEnum);
    /**
     * Every product needs a product type. This is used in the business logic to identify the type of the product.
     *
     * * `HEALTH_CERTIFICATE` - health certificate
     * * `BREEDING_ADMINISTRATION` - breeding administration
     * * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     * * `ACTIVITY` - Activity
     */
    product_type: (ProductTypeEnum);
    /**
     * Pick a plan for which you want to offer a subscription in your organisation's catalogue.
     */
    plan_uid?: (string) | null;
    /**
     * The number of instances (for a credits or tiered plan) that should be permitted by a contract on the plan's module. Leave blank to indicate there is no no limit (in case of a flat fee plan). This is only relevant for subscription products.
     */
    max_amount?: (number) | null;
    /**
     * discount percentage [0-100] if the customer pays for a whole year in the first invoice
     */
    yearly_invoice_discount_percentage?: number;
    /**
     * The unit this product comes in, e.g. 'ml', 'portion', 'kg'
     */
    qualifier?: string;
    readonly price_points: Array<PricePoint>;
    current_price?: (string) | null;
    current_price_currency?: string;
    future_price?: (string) | null;
    future_price_currency?: string;
    future_price_application_date?: (string) | null;
    /**
     * Indicates the amount for this product that will be applied as down payment on the invoice. Set to 0 to apply the full amount.
     */
    upfront_cost?: string;
    readonly upfront_cost_currency: string;
    /**
     * Indicates if orders with this product should include at least one shipping product.
     */
    readonly requires_shipping: boolean;
    /**
     * Select a stallion when the category is breeding.
     */
    stallion_uid?: (string) | null;
    fresh_available?: boolean;
    frozen_available?: boolean;
    shipping_provider_name?: (string) | null;
    postcodes_for_staff_delivery?: string;
    shipping_service_type?: (ShippingServiceTypeEnum | BlankEnum | NullEnum);
    shipping_countries?: Array<('AF' | 'AX' | 'AL' | 'DZ' | 'AS' | 'AD' | 'AO' | 'AI' | 'AQ' | 'AG' | 'AR' | 'AM' | 'AW' | 'AU' | 'AT' | 'AZ' | 'BS' | 'BH' | 'BD' | 'BB' | 'BY' | 'BE' | 'BZ' | 'BJ' | 'BM' | 'BT' | 'BO' | 'BQ' | 'BA' | 'BW' | 'BV' | 'BR' | 'IO' | 'BN' | 'BG' | 'BF' | 'BI' | 'CV' | 'KH' | 'CM' | 'CA' | 'KY' | 'CF' | 'TD' | 'CL' | 'CN' | 'CX' | 'CC' | 'CO' | 'KM' | 'CG' | 'CD' | 'CK' | 'CR' | 'CI' | 'HR' | 'CU' | 'CW' | 'CY' | 'CZ' | 'DK' | 'DJ' | 'DM' | 'DO' | 'EC' | 'EG' | 'SV' | 'GQ' | 'ER' | 'EE' | 'SZ' | 'ET' | 'FK' | 'FO' | 'FJ' | 'FI' | 'FR' | 'GF' | 'PF' | 'TF' | 'GA' | 'GM' | 'GE' | 'DE' | 'GH' | 'GI' | 'GR' | 'GL' | 'GD' | 'GP' | 'GU' | 'GT' | 'GG' | 'GN' | 'GW' | 'GY' | 'HT' | 'HM' | 'VA' | 'HN' | 'HK' | 'HU' | 'IS' | 'IN' | 'ID' | 'IR' | 'IQ' | 'IE' | 'IM' | 'IL' | 'IT' | 'JM' | 'JP' | 'JE' | 'JO' | 'KZ' | 'KE' | 'KI' | 'KW' | 'KG' | 'LA' | 'LV' | 'LB' | 'LS' | 'LR' | 'LY' | 'LI' | 'LT' | 'LU' | 'MO' | 'MG' | 'MW' | 'MY' | 'MV' | 'ML' | 'MT' | 'MH' | 'MQ' | 'MR' | 'MU' | 'YT' | 'MX' | 'FM' | 'MD' | 'MC' | 'MN' | 'ME' | 'MS' | 'MA' | 'MZ' | 'MM' | 'NA' | 'NR' | 'NP' | 'NL' | 'NC' | 'NZ' | 'NI' | 'NE' | 'NG' | 'NU' | 'NF' | 'KP' | 'MK' | 'MP' | 'NO' | 'OM' | 'PK' | 'PW' | 'PS' | 'PA' | 'PG' | 'PY' | 'PE' | 'PH' | 'PN' | 'PL' | 'PT' | 'PR' | 'QA' | 'RE' | 'RO' | 'RU' | 'RW' | 'BL' | 'SH' | 'KN' | 'LC' | 'MF' | 'PM' | 'VC' | 'WS' | 'SM' | 'ST' | 'SA' | 'SN' | 'RS' | 'SC' | 'SL' | 'SG' | 'SX' | 'SK' | 'SI' | 'SB' | 'SO' | 'ZA' | 'GS' | 'KR' | 'SS' | 'ES' | 'LK' | 'SD' | 'SR' | 'SJ' | 'SE' | 'CH' | 'SY' | 'TW' | 'TJ' | 'TZ' | 'TH' | 'TL' | 'TG' | 'TK' | 'TO' | 'TT' | 'TN' | 'TR' | 'TM' | 'TC' | 'TV' | 'UG' | 'UA' | 'AE' | 'GB' | 'UM' | 'US' | 'UY' | 'UZ' | 'VU' | 'VE' | 'VN' | 'VG' | 'VI' | 'WF' | 'EH' | 'YE' | 'ZM' | 'ZW' | '')> | null;
    show_in_shop?: boolean;
    /**
     * Activities of this type will be priced by this product.
     */
    activity_type_uid?: (string) | null;
    /**
     * Enter from which start date activities of this type should be in the to invoice list.
     */
    to_invoice_start_date?: (string) | null;
    shipping_slip_number_start?: string;
    show_on_insemination_route?: boolean;
    /**
     * For which shipping products should an insemination product automatically be added
     */
    insemination_shipping_products?: Array<(string)>;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type ProductionBalanceItem = {
    readonly uid: string;
    /**
     * name of this balance item. Must be unique with contact, year fertilizer origin and mutation type.
     */
    name: string;
    contact_uid: string;
    /**
     * e.g. 2025
     */
    year: number;
    /**
     * indicate the type of this fertilizer or where it originated from
     *
     * * `ANIMAL_MANURE_SUPPLY` - animal manure supply
     * * `MILK_PRODUCING_COWS` - milk producing cows
     * * `GRAZING_ANIMALS` - grazing animals
     * * `EQUINEM_HORSES` - equinem horses
     * * `STABLE_ANIMALS_FEED` - stable animals feed
     * * `OTHER_ORGANIC_SUPPLY` - other organic supply
     * * `ANORGANIC_SUPPLY` - anorganic supply
     */
    fertilizer_origin: (FertilizerOriginEnum);
    /**
     * End amounts and Exports are subtractions on the balance, the others are additions
     *
     * * `BEGIN_AMOUNT` - begin amount
     * * `IMPORT` - import
     * * `PRODUCTION` - production
     * * `EXPORT` - export
     * * `END_AMOUNT` - end amount
     */
    mutation_type: (MutationTypeEnum);
    /**
     * how much kg of nitrogen this item accounts for
     */
    nitrogen_weight?: (number) | null;
    /**
     * how much kg of phosphate this item accounts for
     */
    phosphate_weight?: (number) | null;
    readonly operator: (OperatorEnum);
    readonly is_animal_manure: boolean;
};

/**
 * * `HEALTH_CERTIFICATE` - health certificate
 * * `BREEDING_ADMINISTRATION` - breeding administration
 * * `BREEDING` - Breeding
 * * `SHIPPING` - Shipping
 * * `SUBSCRIPTION` - Subscription
 * * `ACTIVITY` - Activity
 */
export enum ProductTypeEnum {
    HEALTH_CERTIFICATE = 'HEALTH_CERTIFICATE',
    BREEDING_ADMINISTRATION = 'BREEDING_ADMINISTRATION',
    BREEDING = 'BREEDING',
    SHIPPING = 'SHIPPING',
    SUBSCRIPTION = 'SUBSCRIPTION',
    ACTIVITY = 'ACTIVITY'
}

export type Progress = {
    percent?: number;
    description?: string;
    current?: number;
    total?: number;
};

/**
 * * `moneybird` - moneybird
 * * `exactnl` - exactnl
 * * `yuki` - yuki
 * * `snelstart` - snelstart
 */
export enum ProviderEnum {
    MONEYBIRD = 'moneybird',
    EXACTNL = 'exactnl',
    YUKI = 'yuki',
    SNELSTART = 'snelstart'
}

/**
 * * `PURCHASE` - Purchase
 * * `SALE` - Sale
 */
export enum PSTypeEnum {
    PURCHASE = 'PURCHASE',
    SALE = 'SALE'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PublicCategory = {
    readonly uid: string;
    readonly p_s_type: (PSTypeEnum);
    readonly name: string;
    readonly default: (DefaultProductTypeEnum | NullEnum);
};

/**
 * Applicable for public endpoint. Serializes the horse's fields that may be known to the public.
 */
export type PublicHorse = {
    readonly uid: string;
    readonly display_name: string;
    readonly name: string;
    readonly date_of_birth: (string) | null;
    readonly color: (ColorEnum | NullEnum);
    readonly sex: (SexEnum | NullEnum);
    readonly sire: string;
    readonly dam: string;
    readonly damsire: string;
    readonly siredam: string;
    readonly damdam: string;
    readonly siresire: string;
    readonly siregrandsire1: string;
    readonly siregrandsire2: string;
    readonly siregranddam1: string;
    readonly siregranddam2: string;
    readonly damgranddam1: string;
    readonly damgranddam2: string;
    readonly damgrandsire1: string;
    readonly damgrandsire2: string;
    readonly breeder: string;
    readonly studbook: string;
    /**
     * Universal Equine Life Number
     */
    readonly UELN: string;
    readonly chip_nr: string;
    readonly id_horsetelex: string;
    readonly avatar_file: (string) | null;
};

/**
 * '
 * Adds support for UID fields.
 *
 * Also remove all fields with value 'null' (None) from the output.
 */
export type PublicHorseMediaSet = {
    readonly uid: string;
    url: string;
    readonly filename: string;
    readonly description: string;
    readonly YTVim: (string) | null;
    readonly content_type: string;
    readonly private: (PrivateEnum);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PublicHorsePage = {
    readonly public_access_uuid: string;
    horse: PublicHorsePageHorse;
    readonly expires_at: (string) | null;
    readonly include_medical_documents: boolean;
};

/**
 * '
 * Adds support for UID fields.
 *
 * Also remove all fields with value 'null' (None) from the output.
 */
export type PublicHorsePageHorse = {
    readonly uid: string;
    readonly display_name: string;
    readonly name: string;
    readonly date_of_birth: (string) | null;
    readonly color: (ColorEnum | NullEnum);
    readonly sex: (SexEnum | NullEnum);
    readonly breeder: string;
    readonly studbook: string;
    /**
     * Universal Equine Life Number
     */
    readonly UELN: string;
    readonly chip_nr: string;
    readonly id_horsetelex: string;
    readonly avatar_file: (string) | null;
    horsemedia_set: Array<PublicHorseMediaSet>;
    organisation: PublicHorsePageOrganisation;
    readonly withers_height: (number) | null;
    readonly FEI_pass_nr: string;
    readonly sire: string;
    readonly dam: string;
    readonly damdam: string;
    readonly damsire: string;
    readonly siredam: string;
    readonly siresire: string;
    readonly damgranddam1: string;
    readonly damgranddam2: string;
    readonly damgrandsire1: string;
    readonly damgrandsire2: string;
    readonly siregranddam1: string;
    readonly siregranddam2: string;
    readonly siregrandsire1: string;
    readonly siregrandsire2: string;
};

/**
 * '
 * Adds support for UID fields.
 *
 * Also remove all fields with value 'null' (None) from the output.
 */
export type PublicHorsePageOrganisation = {
    readonly public_access_uuid: string;
    primary_stable_contact: OrganisationNAW;
    readonly name: string;
    readonly logo: (string) | null;
    readonly website: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PublicInvoice = {
    readonly uid: string;
    readonly public_access_uuid: (string) | null;
    readonly customer_uid: string;
    readonly supplier_uid: string;
    readonly total: string;
    readonly currency: string;
    readonly total_incl_vat: string;
    /**
     * (optional)
     */
    readonly invoice_no: string;
    readonly draft: boolean;
    readonly finalized_on: (string) | null;
    readonly date: (string) | null;
    readonly sent_on: (string) | null;
    readonly moneybird_invoice_id: (number) | null;
    readonly exactnl_invoice_id: string;
    readonly snelstart_invoice_id: string;
    readonly yuki_invoice_id: string;
    readonly payment_status: (PaymentStatus);
    readonly created_on: (string) | null;
    readonly last_modified_on: (string) | null;
    readonly start_date_activities: (string) | null;
    readonly end_date_activities: (string) | null;
    readonly start_date_services: (string) | null;
    readonly end_date_services: (string) | null;
    readonly created_by_uid: string;
    readonly expiration_date: (string) | null;
    readonly first_due_interval: number;
    readonly payment_summary: (PaymentSummary);
    readonly automatically_generated: boolean;
    readonly automatic_payment: boolean;
    order?: NestedOrder;
    readonly historic_supplier: (SupplierNameAndAddress);
    readonly language: string;
    items: Array<PublicInvoiceItem>;
    readonly historic_customer: (PurchaserNameAndAddress);
    readonly exactnl_url: (string) | null;
    readonly exactnl_entry_no: string;
    readonly snelstart_entry_no: string;
    /**
     * indicates whether this instance exists in the database or not
     */
    readonly is_persistent: boolean;
    /**
     * defaults to false
     */
    finalize?: boolean;
    /**
     * defaults to false
     */
    send_email?: boolean;
    /**
     * defaults to false
     */
    send_to_accounting_software?: boolean;
    can_create_payment_link: boolean;
    logo: string;
    website: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PublicInvoiceItem = {
    readonly uid: string;
    readonly description: string;
    readonly unit_price: (string) | null;
    readonly unit_price_currency: (string) | null;
    readonly category_uid: string;
    readonly quantity: (string) | null;
    readonly qualifier: string;
    readonly vat_percentage_uid: (string) | null;
    readonly vat_percentage: (NestedVATPercentage | null);
    readonly vat_included_in_price: boolean;
    readonly deferred: boolean;
    readonly realactivities: Array<(string)>;
    readonly service_uid: (string) | null;
    readonly created_on: (string) | null;
    readonly transactionitems: Array<(string)>;
    readonly last_modified_on: (string) | null;
    readonly horse_uid: (string) | null;
    readonly horse: (NamedHorse);
    readonly total_vat: (Money | null);
    billableitem_set: Array<((string) | null)>;
    /**
     * indicates whether this instance exists in the database or not
     */
    readonly is_persistent: boolean;
    readonly order_item: (PublicOrderItem);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PublicOrderItem = {
    readonly uid: string;
    studbook?: (StudbookEnum | BlankEnum);
};

export type PublicOrganisation = {
    readonly public_access_uuid: string;
    name: string;
    logo?: (string) | null;
    primary_color?: string;
    secondary_color?: string;
    shop_terms_conditions?: (string) | null;
    readonly can_create_payment_link: boolean;
};

/**
 * A Contact serializer with a reduced set of fields intended to be used as a read only, nested
 * contact serializer showing name and address data for contact related objects like Order or Invoice.
 */
export type PurchaserNameAndAddress = {
    /**
     * Max three initials
     */
    readonly initials: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly business_name: string;
    readonly phone_number: string;
    readonly email: string;
    readonly address_line1: string;
    readonly address_line2: string;
    readonly address_line3: string;
    readonly country: (CountryEnum);
    readonly state: string;
    readonly postcode: string;
    readonly city: string;
    readonly title: (TitleEnum | BlankEnum);
    readonly vat_number: string;
    readonly vat_number_checked: (boolean) | null;
    readonly studbook_preference: (StudbookEnum | BlankEnum);
    readonly customer_id: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PurchaserNestedBreedingPlan = {
    readonly uid: string;
    mare_uid?: string;
    biological_mare_uid?: string;
    year: number;
    readonly sequence: number;
    stallion: PublicHorse;
    /**
     * Not-empty, generated number, unique per organization.
     */
    readonly number: number;
    semen_type?: (SemenTypeEnum | BlankEnum);
    usage_type?: (UsageTypeEnum | BlankEnum);
    studbook?: (StudbookEnum | BlankEnum);
    requester_uid?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PurchaserOrder = {
    readonly uid: string;
    readonly public_access_uuid: (string) | null;
    readonly number: string;
    customer_uid: string;
    readonly purchaser_uid: (string) | null;
    supplier: string;
    customer_note?: string;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly payment_summary: (PaymentSummary);
    shipping_date?: (string) | null;
    order_items: Array<PurchaserOrderItem>;
    dry_run?: boolean;
    terms_accepted: boolean;
    shipping_name?: string;
    shipping_address_line1?: string;
    shipping_address_line2?: string;
    shipping_address_line3?: string;
    shipping_city?: string;
    shipping_state?: string;
    shipping_postcode?: string;
    shipping_country?: (CountryEnum);
    shipping_phone_number?: string;
    shipping_location_traces_number?: string;
    readonly shipping_search_text: string;
    readonly breeding_plan: (PurchaserNestedBreedingPlan | null);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PurchaserOrderDetail = {
    readonly uid: string;
    readonly public_access_uuid: (string) | null;
    readonly number: string;
    customer_uid: string;
    readonly purchaser_uid: (string) | null;
    supplier: string;
    customer_note?: string;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly payment_summary: (PaymentSummary);
    shipping_date?: (string) | null;
    order_items: Array<PurchaserOrderItem>;
    dry_run?: boolean;
    terms_accepted: boolean;
    shipping_name?: string;
    shipping_address_line1?: string;
    shipping_address_line2?: string;
    shipping_address_line3?: string;
    shipping_city?: string;
    shipping_state?: string;
    shipping_postcode?: string;
    shipping_country?: (CountryEnum);
    shipping_phone_number?: string;
    shipping_location_traces_number?: string;
    readonly shipping_search_text: string;
    readonly breeding_plan: (PurchaserNestedBreedingPlan | null);
    readonly historic_customer: (PurchaserNameAndAddress);
};

/**
 * Purchase order item serializer that supplies the *Purchaser's* mare.
 */
export type PurchaserOrderItem = {
    readonly uid: string;
    readonly order_uid: string;
    product_uid: string;
    product_type?: ProductTypeEnum;
    /**
     * If a product uses one or more price points, use this field to indicate the desired variation. This number should match one of the related price points' 'max_units' value.
     */
    price_point_unit_count?: (number) | null;
    /**
     * Price of a single unit excl vat
     */
    readonly unit_price: (string) | null;
    readonly unit_price_currency: (string) | null;
    /**
     * Required upfront payment
     */
    readonly upfront_payment: (string) | null;
    readonly upfront_payment_currency: (string) | null;
    /**
     * Whether a subscription should be billed monthly or yearly. Can be left blank if not relevant
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    invoice_period?: (TimeFrameEnum | BlankEnum);
    readonly vat_percentage: (NestedVATPercentage | null);
    /**
     * number of units that are ordered
     */
    quantity?: number;
    readonly last_modified_by_uid: string;
    readonly last_modified_on: string;
    readonly picked_on: (string) | null;
    readonly picked_by_uid: string;
    mare_uid?: string;
    semen_type?: (SemenTypeEnum | BlankEnum);
    usage_type?: (UsageTypeEnum | BlankEnum);
    studbook?: (StudbookEnum | BlankEnum);
    parent_semen_order_item_uid?: string;
    readonly total_vat: (Money | null);
    readonly variable_cost_estimate: (Money | null);
};

/**
 * Only accepts updates done to purchaser and only to organisations that are available to the requesting user.
 */
export type PurchaserOrderUpdate = {
    readonly uid: string;
    readonly public_access_uuid: (string) | null;
    readonly number: string;
    customer_uid: string;
    purchaser_uid?: (string) | null;
    supplier: string;
    readonly customer_note: string;
    readonly created_on: string;
    readonly last_modified_on: string;
    readonly payment_summary: (PaymentSummary);
    readonly shipping_date: (string) | null;
    order_items: Array<PurchaserOrderItem>;
    dry_run?: boolean;
    readonly shipping_name: string;
    readonly shipping_address_line1: string;
    readonly shipping_address_line2: string;
    readonly shipping_address_line3: string;
    readonly shipping_city: string;
    readonly shipping_state: string;
    readonly shipping_postcode: string;
    readonly shipping_country: (CountryEnum);
    readonly shipping_phone_number: string;
    readonly shipping_location_traces_number: string;
    readonly shipping_search_text: string;
    readonly breeding_plan: (PurchaserNestedBreedingPlan | null);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PurchaserPaymentProvider = {
    readonly uid: string;
    supplier: string;
    contact_uid: string;
    readonly purchaser: string;
    readonly broker_type: (BrokerTypeEnum);
    readonly created_on: string;
    readonly created_by: (string) | null;
    readonly use_as_default: boolean;
    readonly mandate_id: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PurchaserPaymentProviderRedirect = {
    readonly uid: string;
    supplier: string;
    contact_uid: string;
    readonly purchaser: string;
    readonly broker_type: (BrokerTypeEnum);
    readonly created_on: string;
    readonly created_by: (string) | null;
    readonly use_as_default: boolean;
    readonly mandate_id: string;
    /**
     * Frontend provided url to which the provider will redirect, following payment completion.
     */
    redirectUrl: string;
    /**
     * Backend provided url to where frontend should redirect to set the mandate or pay for the goods.
     */
    readonly payment_url: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type PurchaserServiceContract = {
    readonly uid: string;
    customer_uid?: string;
    product_uid: string;
    readonly module: (ModuleEnum);
    readonly pricing_model: (PricingModelEnum);
    readonly start_dt: string;
    /**
     * The contract will last for this number of duration units. Define together with duration_unit.
     */
    readonly duration_amount: (number) | null;
    /**
     * The contract will last for the duration amount of this time frame. Define together with duration_amount.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    readonly duration_unit: (TimeFrameEnum);
    /**
     * New contracts start out with a notice period of the contract duration. Automatically extended contracts get a one-month notice period.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    readonly notice_period: (TimeFrameEnum);
    /**
     * Typically, this is one year from now for flat_fee and tiered pricing models and left blank for the credits pricing model. But it may be left blank to indicate the contract has no end. This will be inferred form duration unit and amount.
     */
    readonly end_dt: (string) | null;
    /**
     * Contracts with overdue payments may be suspended. Suspended contracts will be denied access to the related service until the suspension is lifted or a new contract on said service is made. Suspendedcontract cannot be upgraded / downgraded or canceled.
     */
    readonly is_suspended: boolean;
    /**
     * This is the fixed_price currency, but you may assume that it also applies to 'estimated_cost', 'next_tiered_instance_cost' and 'total_vat'.
     */
    readonly currency: (string) | null;
    /**
     * For subscriptions applying a flat fee or stair-step plan, this is the monthly fee. For Tiered subscription this will typically be 0,00 because their cost are indicated by the estimated_cost. A value of "null" indicates that a fixed price does not apply (e.g. for a pay-once credits based service contract).
     */
    readonly fixed_price: string;
    /**
     * The VAT amount over the sum of fixed price and estimated cost. If this contract has the latter, than this too is an estimate.
     */
    readonly total_vat: (string) | null;
    readonly vat_percentage: (NestedVATPercentage | null);
    readonly discount_percentage: number;
    /**
     * When checked, a new contract with similar conditions will be generated when this contract nears the end date. Requires that end_dt is defined.
     */
    readonly extend_automatically: boolean;
    /**
     * Whether the invoice is billed monthly or yearly.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    readonly invoice_period: (TimeFrameEnum);
    readonly followup_contract_uid: string;
    readonly horse_uid: (string) | null;
    /**
     * For the supplier to fill-out any specifics / reminders for this contact.
     */
    readonly comment: string;
    readonly purchaser: (string) | null;
    /**
     * The monthly cost estimation based on the current use of the services related to the contract. Typically, this applies to subscriptions on a Tiered plan where the fixed cost is 0,00 and the variable cost is calculated after use of the respective services. A value of "null" indicates that this cost does not apply for the service contract.
     */
    estimated_cost: (string) | null;
    /**
     * Number of instances that are serviced under this contract. Shows "null" if this is nonsensical, for example in a Flat-fee priced contract that allows access to a certain module. Typically, this is useful for Tiered, Stair-step and Credits contracts.
     */
    applied_unit_count: (number) | null;
    /**
     * Number of additional instances allowed under this service contract. The number shows 0 if the contract is expired; it shows "null" if this is not applicable. Intended for Stair-step and Credits contracts.
     */
    available_unit_count: (number) | null;
    /**
     * Maximum number of instances allowed under this service contract. The number shows "null" if there is no limit, like for flat-fee or pay-after-use (tiered) services.
     */
    maximum_unit_count: (number) | null;
    /**
     * For a contract applying the Tiered pricing model, this shows the addition to the estimated costif another instance would be added. The number shows "null" for non-tiered contracts.
     */
    next_tiered_instance_cost: (string) | null;
};

/**
 * * `horse_scoop` - horsefeed scoop (1½l)
 * * `imperial_tsp` - teaspoon (5ml)
 * * `imperial_tbsp` - tablespoon (15ml)
 * * `imperial_cup` - cup (240ml)
 * * `ml` - Millilitre
 * * `l` - Litre
 * * `g` - Gram
 * * `kg` - Kilogram
 * * `custom` - Custom
 */
export enum QuantityMeasureEnum {
    HORSE_SCOOP = 'horse_scoop',
    IMPERIAL_TSP = 'imperial_tsp',
    IMPERIAL_TBSP = 'imperial_tbsp',
    IMPERIAL_CUP = 'imperial_cup',
    ML = 'ml',
    L = 'l',
    G = 'g',
    KG = 'kg',
    CUSTOM = 'custom'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type RealActivities = {
    readonly uid: string;
    horse_uid: string;
    activity_type_uid: string;
    remind?: boolean;
    readonly done_on: (string) | null;
    set_done?: boolean;
    readonly done_by_uid: (string) | null;
    readonly parent_uid: (string) | null;
    dry_run?: boolean;
    daypart?: (number) | null;
    ordering?: number;
    status?: (EventStatus);
    /**
     * Cached because the cached answer is used in the post_delete signal!
     */
    readonly action_holder_uid: (string) | null;
    readonly last_modified_on: string;
    readonly created_by_uid: string;
    readonly created_on: string;
    readonly last_modified_by_uid: (string) | null;
    activitycontactrole_set?: Array<ActivityContactRole>;
    readonly stallionmount_uid: string;
    readonly marecyclecheck_uid: string;
    order_item_uid?: (string) | null;
    readonly stallion_uid: (string) | null;
    facility_uids?: Array<(string)>;
    breeding_box_no?: (number) | null;
    level?: string;
    /**
     * (optional) Write down extra information about this activity.
     */
    extra_info?: string;
    /**
     * How intense was the activity?
     */
    intensity?: (number) | null;
    estimated_intensity?: (WorkloadEnum | NullEnum);
    show?: (string) | null;
    sire?: string;
    external_url?: string;
    /**
     * In beats per minute
     */
    heart_rate?: (number) | null;
    race_time?: (string) | null;
    show_status?: (ShowStatusEnum | BlankEnum | NullEnum);
    workload?: (WorkloadEnum | NullEnum);
    /**
     * When was the check (relative to insemination)
     *
     * * `FIRST` - First
     * * `SECOND` - Second
     * * `THIRD` - Third
     */
    pregnancy_check_term?: (PregnancyCheckTermEnum | BlankEnum | NullEnum);
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    recurrence?: string;
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type RealActivitiesSetDoneAndUnDone = {
    readonly uid: string;
    readonly horse_uid: string;
    readonly activity_type_uid: string;
    readonly remind: boolean;
    readonly done_on: (string) | null;
    readonly set_done: boolean;
    readonly done_by_uid: (string) | null;
    readonly parent_uid: (string) | null;
    readonly dry_run: boolean;
    readonly daypart: (number) | null;
    readonly ordering: number;
    readonly status: (EventStatus);
    /**
     * Cached because the cached answer is used in the post_delete signal!
     */
    readonly action_holder_uid: (string) | null;
    readonly last_modified_on: string;
    readonly created_by_uid: string;
    readonly created_on: string;
    readonly last_modified_by_uid: (string) | null;
    readonly activitycontactrole_set: Array<ActivityContactRole>;
    readonly stallionmount_uid: string;
    readonly marecyclecheck_uid: string;
    readonly order_item_uid: (string) | null;
    readonly stallion_uid: (string) | null;
    readonly facility_uids: Array<(string)>;
    breeding_box_no?: (number) | null;
    readonly level: string;
    /**
     * (optional) Write down extra information about this activity.
     */
    readonly extra_info: string;
    /**
     * How intense was the activity?
     */
    readonly intensity: (number) | null;
    readonly estimated_intensity: (WorkloadEnum | NullEnum);
    readonly show: (string) | null;
    readonly sire: string;
    readonly external_url: string;
    /**
     * In beats per minute
     */
    readonly heart_rate: (number) | null;
    readonly race_time: (string) | null;
    readonly show_status: (ShowStatusEnum | BlankEnum | NullEnum);
    readonly workload: (WorkloadEnum | NullEnum);
    /**
     * When was the check (relative to insemination)
     *
     * * `FIRST` - First
     * * `SECOND` - Second
     * * `THIRD` - Third
     */
    readonly pregnancy_check_term: (PregnancyCheckTermEnum | BlankEnum | NullEnum);
    readonly start: (DatetimeOrDateField);
    readonly end: (DatetimeOrDateField);
    readonly all_day_event: boolean;
    readonly endTimeUnspecified: boolean;
    readonly recurrence: string;
    readonly events_to_change: (EventsToChangeEnum);
};

/**
 * Serializer for updates of RealActivities. It's only job is to add the
 * events_to_change field to the normal RealActivitiesSerializer fields.
 */
export type RealActivitiesUpdate = {
    readonly uid: string;
    horse_uid: string;
    activity_type_uid: string;
    remind?: boolean;
    readonly done_on: (string) | null;
    set_done?: boolean;
    readonly done_by_uid: (string) | null;
    readonly parent_uid: (string) | null;
    dry_run?: boolean;
    daypart?: (number) | null;
    ordering?: number;
    status?: (EventStatus);
    /**
     * Cached because the cached answer is used in the post_delete signal!
     */
    readonly action_holder_uid: (string) | null;
    readonly last_modified_on: string;
    readonly created_by_uid: string;
    readonly created_on: string;
    readonly last_modified_by_uid: (string) | null;
    activitycontactrole_set?: Array<ActivityContactRole>;
    readonly stallionmount_uid: string;
    readonly marecyclecheck_uid: string;
    order_item_uid?: (string) | null;
    readonly stallion_uid: (string) | null;
    facility_uids?: Array<(string)>;
    breeding_box_no?: (number) | null;
    level?: string;
    /**
     * (optional) Write down extra information about this activity.
     */
    extra_info?: string;
    /**
     * How intense was the activity?
     */
    intensity?: (number) | null;
    estimated_intensity?: (WorkloadEnum | NullEnum);
    show?: (string) | null;
    sire?: string;
    external_url?: string;
    /**
     * In beats per minute
     */
    heart_rate?: (number) | null;
    race_time?: (string) | null;
    show_status?: (ShowStatusEnum | BlankEnum | NullEnum);
    workload?: (WorkloadEnum | NullEnum);
    /**
     * When was the check (relative to insemination)
     *
     * * `FIRST` - First
     * * `SECOND` - Second
     * * `THIRD` - Third
     */
    pregnancy_check_term?: (PregnancyCheckTermEnum | BlankEnum | NullEnum);
    start: DatetimeOrDateField;
    end?: DatetimeOrDateField;
    all_day_event?: boolean;
    endTimeUnspecified?: boolean;
    recurrence?: string;
    events_to_change?: (EventsToChangeEnum);
};

/**
 * '
 * Adds support for UID fields.
 *
 * Also remove all fields with value 'null' (None) from the output.
 */
export type ReceivedInvitation = {
    readonly uuid: string;
    readonly created_on: string;
    readonly sent_on: (string) | null;
    readonly resend_on: (string) | null;
    readonly resend_attempts: number;
    readonly accepted_on: (string) | null;
    readonly declined_on: (string) | null;
    readonly declined_reason: string;
    readonly inviter_organisation: (InviterOrganisation);
    readonly inviter: (Inviter);
    readonly contact: (ContactData | null);
    invitee_email?: (string) | null;
};

export type Redirect = {
    redirect_uri: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type ReportedHorseRelocation = {
    readonly uid: string;
    horse_uid: string;
    horselocation_uid?: (string) | null;
    report_type: (ReportTypeEnum);
    meldingnummer?: string;
    last_modified_by_uid?: (string) | null;
    created_by_uid?: (string) | null;
    readonly last_modified_on: string;
    external_location?: string;
    status?: (ReportedHorseRelocationStatusEnum | BlankEnum);
    statusOms?: string;
    readonly created_on: string;
    date: string;
};

/**
 * * `IC` - inconsistent
 * * `DG` - final
 * * `VG` - provisional
 * * `IT` - withdrawn
 * * `ID` - submitted
 * * `HE` - recovered
 * * `` - ---
 */
export enum ReportedHorseRelocationStatusEnum {
    IC = 'IC',
    DG = 'DG',
    VG = 'VG',
    IT = 'IT',
    ID = 'ID',
    HE = 'HE'
}

/**
 * * `1` - arrival
 * * `2` - departure
 * * `3` - import
 * * `4` - born
 * * `5` - dead
 * * `6` - born dead
 * * `7` - export
 */
export enum ReportTypeEnum {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
    '_7' = 7
}

export type RestAuthDetail = {
    readonly detail: string;
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type Role = {
    readonly uid: string;
    name?: string;
    readonly default_id: (number) | null;
    stable_uid?: (string) | null;
    readonly last_modified_on: string;
    readonly created_on: string;
    hidden?: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type RoleNames = {
    readonly uid: string;
    readonly name: string;
    readonly default_id: (number) | null;
};

export type RvOHorseHairColor = {
    code: string;
    omschrijving: string;
    dierSoort: number;
    datumIngang: string;
    datumEinde?: string;
};

export type SearchHorse = {
    q?: (string) | null;
    name?: (string) | null;
    sire?: (string) | null;
    dam?: (string) | null;
    damsire?: (string) | null;
    year_of_birth?: (number) | null;
    UELN?: (string) | null;
    FEI_pass_nr?: (string) | null;
    chip_nr?: (string) | null;
    page?: (number) | null;
    pageSize?: (number) | null;
    db?: externalDbEnum;
};

/**
 * * `FRESH` - fresh
 * * `FROZEN` - frozen
 * * `UNDILUTED` - UNDILUTED
 */
export enum SemenTypeEnum {
    FRESH = 'FRESH',
    FROZEN = 'FROZEN',
    UNDILUTED = 'UNDILUTED'
}

/**
 * This Class is the Serializer for the Detail View
 */
export type SentInvitation = {
    readonly uuid: string;
    readonly created_on: string;
    readonly sent_on: (string) | null;
    readonly resend_on: (string) | null;
    readonly resend_attempts: number;
    readonly accepted_on: (string) | null;
    readonly declined_on: (string) | null;
    readonly declined_reason: string;
    readonly contact: (ContactData | null);
    invitee_email: (string) | null;
    contact_uid?: (string) | null;
    roles: Array<(string)>;
    stables: Array<(string)>;
    readonly inviter_organisation_uid: string;
    readonly inviter_uid: string;
};

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type Service = {
    readonly uid: string;
    name: string;
    price: string;
    readonly price_currency: string;
    vat_percentage_uid: string;
    /**
     * The category used when creating an invoice line for this service.
     */
    category_uid: string;
    vat_included_in_price?: boolean;
    description: string;
    readonly created_on: string;
    readonly last_modified_on: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type ServiceContact = {
    readonly uid: string;
    start_date: string;
    end_date?: (string) | null;
    price: string;
    readonly price_currency: string;
    vat_percentage_uid: string;
    customer_uid: string;
    service_uid: string;
    vat_included_in_price?: boolean;
    horse_uid?: (string) | null;
    created_by_uid?: (string) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
};

/**
 * * `1` - stallion
 * * `2` - mare
 * * `3` - gelding
 */
export enum SexEnum {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type ShallowContact = {
    readonly uid: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly business_name: string;
    readonly color: string;
    readonly stables: Array<(string)>;
    /**
     * Max three initials
     */
    readonly initials: string;
    readonly lookup: string;
    readonly show_in_daily: boolean;
    readonly external_location: boolean;
    readonly roles: Array<(string)>;
    readonly hidden: boolean;
    readonly stable_location_uid: string;
};

/**
 * * `REGULAR` - Regular
 * * `PICK_UP` - Pick up
 * * `SAME_DAY_DELIVERY` - Same day delivery
 * * `NEXT_DAY_DELIVERY` - Next day delivery
 * * `SUNDAY_HOLIDAY_DELIVERY` - Sunday and holiday delivery
 * * `STAFF_DELIVERY` - staff delivery
 */
export enum ShippingServiceTypeEnum {
    REGULAR = 'REGULAR',
    PICK_UP = 'PICK_UP',
    SAME_DAY_DELIVERY = 'SAME_DAY_DELIVERY',
    NEXT_DAY_DELIVERY = 'NEXT_DAY_DELIVERY',
    SUNDAY_HOLIDAY_DELIVERY = 'SUNDAY_HOLIDAY_DELIVERY',
    STAFF_DELIVERY = 'STAFF_DELIVERY'
}

/**
 * * `CONCEPT` - Concept
 * * `FINAL` - Final
 * * `OMITTED` - Omitted
 */
export enum ShippingSlipStatusEnum {
    CONCEPT = 'CONCEPT',
    FINAL = 'FINAL',
    OMITTED = 'OMITTED'
}

/**
 * * `PLA` - Planned
 * * `SIG` - Signed up
 * * `OK` - Signed up and approved
 * * `NOK` - Signed up and declined
 * * `POS` - Maybe
 * * `` - ---
 */
export enum ShowStatusEnum {
    PLA = 'PLA',
    SIG = 'SIG',
    OK = 'OK',
    NOK = 'NOK',
    POS = 'POS'
}

/**
 * * `ADVERTISEMENT` - Advertisement
 * * `INTERNET` - Internet (search)
 * * `EVENTS` - Events
 * * `PAARD_EN_WINST` - Paard en winst (Susanne Blijleven)
 * * `FLORIAN` - Florian horsefood
 * * `WULFFDEN` - Wulffden Equestrian
 * * `LK_DRESSAGE` - LK Dressage (Estonia)
 * * `OTHER` - Other
 */
export enum SignupReferenceEnum {
    ADVERTISEMENT = 'ADVERTISEMENT',
    INTERNET = 'INTERNET',
    EVENTS = 'EVENTS',
    PAARD_EN_WINST = 'PAARD_EN_WINST',
    FLORIAN = 'FLORIAN',
    WULFFDEN = 'WULFFDEN',
    LK_DRESSAGE = 'LK_DRESSAGE',
    OTHER = 'OTHER'
}

/**
 * Serializer for JWT authentication.
 */
export type SignupResponse = {
    access: string;
    refresh: string;
    user: SignupUser;
};

/**
 * User model w/o password
 */
export type SignupUser = {
    readonly id: number;
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     */
    username: string;
    readonly email: string;
    first_name?: string;
    last_name?: string;
};

export type SignupWithInvitation = {
    password1: string;
    password2: string;
    invitation_uuid: string;
    first_name: string;
    last_name: string;
    agreed_to_terms_and_privacy: boolean;
};

/**
 * Serializer to return a social login
 */
export type SocialLogin = {
    access_token?: string;
    code?: string;
    id_token?: string;
};

/**
 * * `HARD` - Hard
 * * `QUITE HARD` - Quite Hard
 * * `QUITE SOFT` - Quite Soft
 * * `SOFT` - Soft
 */
export enum SoftnessEnum {
    HARD = 'HARD',
    QUITE_HARD = 'QUITE HARD',
    QUITE_SOFT = 'QUITE SOFT',
    SOFT = 'SOFT'
}

export type SSO = {
    providers: (string) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type Stable = {
    readonly uid: string;
    readonly created_by_uid: string;
    readonly location_uid: string;
    timezone?: TimezoneEnum;
    location: StableContact;
    is_primary?: boolean;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type StableContact = {
    readonly uid: string;
    color?: string;
    readonly user_uid: (string) | null;
    stables?: Array<((string) | null)>;
    /**
     * Max three initials
     */
    initials?: string;
    readonly hidden: boolean;
    roles?: Array<((string) | null)>;
    first_name?: string;
    last_name?: string;
    studbook_preference?: (StudbookEnum | BlankEnum);
    business_name: string;
    phone_number: string;
    email?: string;
    external_location?: boolean;
    customer_id?: string;
    moneybird_contact_id?: (number) | null;
    exactnl_contact_id?: string;
    snelstart_contact_id?: string;
    is_inseminator?: boolean;
    is_semen_collection_station?: boolean;
    is_insemination_station?: boolean;
    /**
     * only show orders where requester is a contact with use_for_picking in the picklist
     */
    use_for_picking?: boolean;
    vat_number?: string;
    readonly vat_number_checked: (boolean) | null;
    readonly created_on: string;
    readonly last_modified_on: string;
    address_line1: string;
    address_line2?: string;
    address_line3?: string;
    country?: (CountryEnum | BlankEnum);
    state?: string;
    postcode: string;
    city: string;
    title?: (TitleEnum | BlankEnum);
    date_of_birth?: (string) | null;
    show_in_daily?: boolean;
    show_in_work_schedule?: boolean;
    note?: string;
    readonly stable_location_uid: string;
    UBN?: string;
    invoice_language?: (InvoiceLanguageEnum | BlankEnum);
    business_type?: (BusinessTypeEnum | NullEnum);
    readonly lookup: string;
    readonly manage_horse_location_history: boolean;
    readonly machtiging_rvo_gegeven: (string) | null;
    readonly machtiging_rvo_gegeven_by_uid: (string) | null;
    readonly invitation: (SentInvitation | null);
    create_user_invitation?: boolean;
    parent_stable?: (string) | null;
    IBAN?: string;
    bank_code?: string;
    account_number?: string;
    bank_name?: string;
    second_phone_number?: string;
    company_registration_number?: string;
    /**
     * In case the contact represents a (supplier side) customer, this product can be used as suggestion or default in orders, that require shipping.
     */
    default_shipping_product?: (string) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type StableNames = {
    readonly uid: string;
    readonly name: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type StallionMount = {
    readonly uid: string;
    stallion_uid: string;
    collection_date?: string;
    volume?: number;
    concentration?: number;
    storage_container?: string;
    storage_canister?: string;
    portions_fresh?: number;
    portions_fresh_available?: number;
    readonly portions_fresh_destroyed_amount: number;
    readonly portions_fresh_destroyed_on: (string) | null;
    straws_frozen?: number;
    straws_frozen_available?: number;
    readonly straws_frozen_destroyed_amount: number;
    readonly straws_frozen_destroyed_on: (string) | null;
    NIFA_straw_color?: (NIFAStrawColorEnum | BlankEnum);
    morphology?: number;
    moving_cells_percentage?: number;
    readonly created_on: string;
    readonly created_by: string;
    readonly last_modified_on: string;
    readonly last_modified_by: string;
    semen_collection_station?: (string) | null;
    activity_uid?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type StallionMountDetail = {
    readonly uid: string;
    stallion_uid: string;
    collection_date?: string;
    volume?: number;
    concentration?: number;
    storage_container?: string;
    storage_canister?: string;
    portions_fresh?: number;
    portions_fresh_available?: number;
    readonly portions_fresh_destroyed_amount: number;
    readonly portions_fresh_destroyed_on: (string) | null;
    straws_frozen?: number;
    straws_frozen_available?: number;
    readonly straws_frozen_destroyed_amount: number;
    readonly straws_frozen_destroyed_on: (string) | null;
    NIFA_straw_color?: (NIFAStrawColorEnum | BlankEnum);
    morphology?: number;
    moving_cells_percentage?: number;
    readonly created_on: string;
    readonly created_by: string;
    readonly last_modified_on: string;
    readonly last_modified_by: string;
    semen_collection_station?: (string) | null;
    readonly used_in_orders: Array<SupplierOrder>;
    activity_uid?: string;
};

/**
 * * `PENDING` - PENDING
 * * `SUCCESS` - SUCCESS
 * * `RETRY` - RETRY
 * * `FAILURE` - FAILURE
 * * `STARTED` - STARTED
 * * `REVOKED` - REVOKED
 * * `RECEIVED` - RECEIVED
 * * `PROGRESS` - PROGRESS
 */
export enum StateEnum {
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    RETRY = 'RETRY',
    FAILURE = 'FAILURE',
    STARTED = 'STARTED',
    REVOKED = 'REVOKED',
    RECEIVED = 'RECEIVED',
    PROGRESS = 'PROGRESS'
}

/**
 * * `ACE` - ACE Studbook - Australian Continental Equestrian Group Inc. (ACE)
 * * `AHHA` - American Holsteiner Horse Association
 * * `RHEIN US` - American Rhinelander in the American Hanoverian Society (AHS-RHEIN US)
 * * `ATA` - American Trakehner Association (ATA)
 * * `AWR` - American Warmblood Registry & North American Sportpony Registry (AWR)
 * * `AES` - Anglo European Studbook (AES)
 * * `AWÖ` - Arbeitsgemeinschaft für Warmblutzucht in Österreich (AWÖ)
 * * `AAFE` - Asociacion Argentina de Fomento Equino (AAFE)
 * * `AECCAá` - Asociación Española de Criadores de Caballos Anglo-árabes (AECCAá)
 * * `PRE` - Asociación Nacional De Criadores De Caballos de Pura Raza Española / National Purebred Spanish Breed
 * * `CDE` - Asociación Nacional de Criadores del Caballo de Deporte Español (ANCADES)
 * * `BH` - Associação Brasileira de Criadores do Cavalo de Hipismo (ABCCH)
 * * `PSH` - Associação Portuguesa de Criadores de Racas Selectas / Portuguese Sport Horse Studbook (APCRS)
 * * `LUSIT` - Associação Portuguesa De Criadores do Cavalo Puro Sangue Lusitano (APSL)
 * * `AA` - Association Nationale Anglo-Arabe (ANAA)
 * * `RHEIN AU` - Australian Rhinlander in the Hanoverian Horse Society of Australia (HHSA-RHEIN AU)
 * * `AWHA` - Australian Warmblood Horse Association Ltd (AWHA)
 * * `BWB` - Baltic Horse Breeders Association (BHBA)
 * * `BWP` - Belgian Warmblood Studbook (BWP)
 * * `BE/SIES` - Breeders Elite Studbook for Irish & European Sporthorses Limited (BE-SIES)
 * * `RHEIN GB` - British Rhinelander in the British Hanoverian Horse Society (BHHS-RHEIN GB)
 * * `BSH` - Bulgarian Sport Horse Association (BSHA)
 * * `CSHA` - Canadian Sport Horse Association (CSHA)
 * * `CWHBA` - Canadian Warmblood Horse Breeders Association (CWHBA)
 * * `CCDM` - Criadores de Caballos Deportivos Mexicanos, A.C. (CCDM)
 * * `CABSH` - Croatian Association of Breeders of Sport Horses / Hrvatska Udruga Uzgajivaca Sportskih Konja (HUUSK)
 * * `DWB` - Danish Warmblood Society / Dansk Varmblod (DWB)
 * * `EBHA` - East Bulgarian Horse Association (EBHA)
 * * `ESH` - Estonian Sport Horse Breeders Society / Eesti Sporthobuste Kasvatajate Selts (ESHBS)
 * * `HANN` - Hannoveraner Verband e.V. (HANN)
 * * `HHSA` - Hanoverian Horse Society of Australia (HHSA)
 * * `HSH` - Hungarian Sport Horse Studbook / Magyar Sportlótenyésztok Országos Egyesülete (MSLT)
 * * `ISR-OLD NA` - International Sporthorse Registry Oldenburg Registry North America (ISREG)
 * * `TB` - International Studbook Committee of Thoroughbreds (ISBC) (Affiliate recognition)
 * * `ISH` - Irish Sport Horse Studbook (ISH)
 * * `MASAF` - Italian Sport Horse Studbook / Ministero dell'agricoltura, della sovranità alimentare e delle forest
 * * `KFPS` - Koninklijk Friesch Paarden-Stamboek (KFPS)
 * * `KWPN` - Koninklijk Warmbloed Paarden Stamboek Nederland / Royal Warmblood Studbook of the Netherlands (KWPN)
 * * `KWPN NA` - KWPN of North America, Inc. (KWPN NA)
 * * `DSP (BAVAR)` - Landesverband Bayerischer Pferdezüchter e.V. (DSP BAVAR)
 * * `LWB` - Latvian Horse Breeding Association / Latvian Warmblood Studbook (LWB)
 * * `LHBA` - Lithunaian Horse Breeders Association (LHBA)
 * * `NRPS` - Nederlands Rijpaarden en Pony Stamboek (NRPS)
 * * `NZHS` - New Zealand Hanoverian Society (NZHS)
 * * `RHEIN NZ` - New Zealand Rhinelander in the New Zealand Hanoverian Society (NZHS-RHEIN NZ)
 * * `NZWB` - New Zealand Warmblood Association (NZWA)
 * * `NAS` - North American Studbook (NAS)
 * * `NDWB` - Norwegian Danish Warmblood Society (NDWB)
 * * `NWB` - Norwegian Warmblood Association/Norsk Varmblod (NWB)
 * * `DSP (BAD-WÜ)` - Pferdezuchtverband Baden-Württemberg e.V. (DSP BAD-WÜ)
 * * `DSP (BRAND)` - Pferdezuchtverband Brandenburg-Anhalt (DSP BRAND)
 * * `DSP (ZWEIB)` - Pferdezuchtverband Rheinland-Pfalz-Saar e.V. (DSP ZWEIB)
 * * `SA` - Pferdezuchtverband Sachsen Anhalt e.V.
 * * `SACHS` - Pferdezuchtverband Sachsen e.V.
 * * `DSP (SATHÜ)` - Pferdezuchtverband Sachsen-Thüringen e.V (DSP SATHÜ)
 * * `RHEIN` - Rheinisches Reitpferd im Hannoveraner Verband (HANN-RHEIN)
 * * `SAWHS` - South African Warmblood Horse Society (SAWHS)
 * * `SHBGB` - Sport Horse Breeding of Great Britain (SHBGB)
 * * `OS` - Springpferdezuchtverband Oldenburg-International e.V (OS)
 * * `SF` - Stud Book du Cheval Selle Français (SBSF)
 * * `SCSL` - Studbook du Cheval de Selle Luxembourgeois (SCSL)
 * * `SBS` - Studbook sBs, Le Cheval de Sport Belge (SBS)
 * * `ZANG` - Studbook Zangersheide (ZANG)
 * * `ChS` - Studbook Cheval Suisse (ChS)
 * * `PZHK (M)` - Studbook for Polish Malopolska Horses - Polish Horse Breeders Association (PZHK M)
 * * `PZHK (SP)` - Studbook for Polish Sport Horses - Polish Horse Breeders Association (PZHK SP)
 * * `PZHK (WLKP)` - Studbook for Polish WielkopolskaHorses - Polish Horse Breeders Association (PZHK WLKP)
 * * `SSW` - Studbook for Slovenian Warmblood Horses (SSW)
 * * `SLS` - Studbook La Silla (SLS)
 * * `CZEWB` - Svaz chovatelu ceskéhoteplorevníka / Czech Warmblood Breeders Society (SCHCT)
 * * `SWB` - Swedish Warmblood Association (SWB)
 * * `AHS` - The American Hanovarian Society (AHS)
 * * `BHHS` - The British Hanoverian Horse Society (BHHS)
 * * `FWB` - The Finnish Horse Breeding Association/Suomen Hippos ry (FWB)
 * * `ZCHKS` - The Slovak Warmblood Studbook (ZCHKS)
 * * `TAF` - Trakehner Avlsforbundet i Danmark (TAF)
 * * `MECKL` - Verband der Pferdezüchter Mecklenburg-Vorpommern e.V. (MECKL)
 * * `THU` - Verband der Thüringen Pferdezüchter
 * * `HOLST` - Verband der Züchter des Holsteiner Pferdes e.V. (HOLST)
 * * `OLDBG` - Verband der Züchter des Oldenburger Pferdes e.V. (OL)
 * * `TRAK` - Verband der Züchter und Freunde des Ostpreussischen Warmblutpferdes Trakehner Abstammung e.V. (TRAK)
 * * `HESS` - Verband Hessischer Pferdezüchter e.V.
 * * `BWBS` - Warmblood Breeders Studbook (WBS-UK)
 * * `WSI` - Warmblood Studbook of Ireland (WSI)
 * * `WESTF` - Westfälisches Pferdestammbuch e.V. (WESTF)
 * * `CH` - Zuchtverband CH-Sportpferde Swiss Warmblood (ZVCH)
 * * `ZfDP` - Zuchtverband für Deutsche Pferde e.v. (ZfDP)
 * * `` - ---
 */
export enum StudbookEnum {
    ACE = 'ACE',
    AHHA = 'AHHA',
    RHEIN_US = 'RHEIN US',
    ATA = 'ATA',
    AWR = 'AWR',
    AES = 'AES',
    AWÖ = 'AWÖ',
    AAFE = 'AAFE',
    AECCAÁ = 'AECCAá',
    PRE = 'PRE',
    CDE = 'CDE',
    BH = 'BH',
    PSH = 'PSH',
    LUSIT = 'LUSIT',
    AA = 'AA',
    RHEIN_AU = 'RHEIN AU',
    AWHA = 'AWHA',
    BWB = 'BWB',
    BWP = 'BWP',
    BE_SIES = 'BE/SIES',
    RHEIN_GB = 'RHEIN GB',
    BSH = 'BSH',
    CSHA = 'CSHA',
    CWHBA = 'CWHBA',
    CCDM = 'CCDM',
    CABSH = 'CABSH',
    DWB = 'DWB',
    EBHA = 'EBHA',
    ESH = 'ESH',
    HANN = 'HANN',
    HHSA = 'HHSA',
    HSH = 'HSH',
    ISR_OLD_NA = 'ISR-OLD NA',
    TB = 'TB',
    ISH = 'ISH',
    MASAF = 'MASAF',
    KFPS = 'KFPS',
    KWPN = 'KWPN',
    KWPN_NA = 'KWPN NA',
    DSP__BAVAR_ = 'DSP (BAVAR)',
    LWB = 'LWB',
    LHBA = 'LHBA',
    NRPS = 'NRPS',
    NZHS = 'NZHS',
    RHEIN_NZ = 'RHEIN NZ',
    NZWB = 'NZWB',
    NAS = 'NAS',
    NDWB = 'NDWB',
    NWB = 'NWB',
    DSP__BAD_WÜ_ = 'DSP (BAD-WÜ)',
    DSP__BRAND_ = 'DSP (BRAND)',
    DSP__ZWEIB_ = 'DSP (ZWEIB)',
    SA = 'SA',
    SACHS = 'SACHS',
    DSP__SATHÜ_ = 'DSP (SATHÜ)',
    RHEIN = 'RHEIN',
    SAWHS = 'SAWHS',
    SHBGB = 'SHBGB',
    OS = 'OS',
    SF = 'SF',
    SCSL = 'SCSL',
    SBS = 'SBS',
    ZANG = 'ZANG',
    CH_S = 'ChS',
    PZHK__M_ = 'PZHK (M)',
    PZHK__SP_ = 'PZHK (SP)',
    PZHK__WLKP_ = 'PZHK (WLKP)',
    SSW = 'SSW',
    SLS = 'SLS',
    CZEWB = 'CZEWB',
    SWB = 'SWB',
    AHS = 'AHS',
    BHHS = 'BHHS',
    FWB = 'FWB',
    ZCHKS = 'ZCHKS',
    TAF = 'TAF',
    MECKL = 'MECKL',
    THU = 'THU',
    HOLST = 'HOLST',
    OLDBG = 'OLDBG',
    TRAK = 'TRAK',
    HESS = 'HESS',
    BWBS = 'BWBS',
    WSI = 'WSI',
    WESTF = 'WESTF',
    CH = 'CH',
    ZF_DP = 'ZfDP'
}

/**
 * A Contact serializer with a reduced set of fields intended to be used as a read only, nested
 * contact serializer showing name and address data for contact related objects like Order or Invoice.
 */
export type SupplierNameAndAddress = {
    /**
     * Max three initials
     */
    readonly initials: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly business_name: string;
    readonly phone_number: string;
    readonly email: string;
    readonly address_line1: string;
    readonly address_line2: string;
    readonly address_line3: string;
    readonly country: (CountryEnum);
    readonly state: string;
    readonly postcode: string;
    readonly city: string;
    readonly title: (TitleEnum | BlankEnum);
    readonly vat_number: string;
    readonly vat_number_checked: (boolean) | null;
    readonly account_number: string;
    readonly IBAN: string;
    readonly bank_code: string;
    readonly bank_name: string;
    readonly company_registration_number: string;
    readonly UBN: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type SupplierNestedBreedingPlan = {
    readonly uid: string;
    /**
     * The mare who is the subject of this plan. Can be the carrying mare or biological mare.
     */
    mare_uid: string;
    /**
     * The biological mare in case the plan's mare only carried the foal.
     */
    biological_mare_uid?: (string) | null;
    year: number;
    readonly sequence: number;
    /**
     * Breeding plans where this horse is the stallion.
     */
    stallion_uid?: (string) | null;
    /**
     * Not-empty, generated number, unique per organization.
     */
    readonly number: number;
    semen_type?: (SemenTypeEnum | BlankEnum);
    usage_type?: (UsageTypeEnum | BlankEnum);
    studbook?: (StudbookEnum | BlankEnum);
    requester_uid?: (string) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type SupplierOrder = {
    readonly uid: string;
    readonly public_access_uuid: (string) | null;
    readonly number: string;
    customer_uid?: (string) | null;
    requester_uid?: (string) | null;
    supplier_note?: string;
    readonly customer_note: string;
    /**
     * The traces certificate number is (not always) required for shipping to another country in the EU
     */
    traces_certificate_number?: (string) | null;
    /**
     * The ecert certificate number is always required for export outside the EU
     */
    ecert_certificate_number?: (number) | null;
    readonly created_on: string;
    readonly created_by: string;
    readonly last_modified_on: string;
    readonly last_modified_by: string;
    shipping_date?: (string) | null;
    readonly payment_summary: (PaymentSummary);
    dry_run?: boolean;
    readonly supplier_uid: string;
    order_items?: Array<SupplierOrderItem>;
    shipping_name?: string;
    shipping_address_line1?: string;
    shipping_address_line2?: string;
    shipping_address_line3?: string;
    shipping_city?: string;
    shipping_state?: string;
    shipping_postcode?: string;
    shipping_country?: (CountryEnum | BlankEnum);
    shipping_phone_number?: string;
    shipping_slip_status?: (ShippingSlipStatusEnum | BlankEnum);
    readonly shipping_slip_number: string;
    readonly shipping_search_text: string;
    shipping_location_traces_number?: string;
    /**
     * A purchaser needs to accept the terms and conditions of the supplying organisation.
     */
    readonly terms_accepted_on: (string) | null;
    readonly is_complete: boolean;
    breeding_plan_uid?: (string) | null;
    readonly breeding_plan: (SupplierNestedBreedingPlan | null);
    readonly order_origin: (OrderOriginEnum);
    inseminator_uid?: (string) | null;
    sorting?: (number) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type SupplierOrderDetail = {
    readonly uid: string;
    readonly public_access_uuid: (string) | null;
    readonly number: string;
    customer_uid?: (string) | null;
    requester_uid?: (string) | null;
    supplier_note?: string;
    readonly customer_note: string;
    /**
     * The traces certificate number is (not always) required for shipping to another country in the EU
     */
    traces_certificate_number?: (string) | null;
    /**
     * The ecert certificate number is always required for export outside the EU
     */
    ecert_certificate_number?: (number) | null;
    readonly created_on: string;
    readonly created_by: string;
    readonly last_modified_on: string;
    readonly last_modified_by: string;
    shipping_date?: (string) | null;
    readonly payment_summary: (PaymentSummary);
    dry_run?: boolean;
    readonly supplier_uid: string;
    order_items?: Array<SupplierOrderItemDetail>;
    shipping_name?: string;
    shipping_address_line1?: string;
    shipping_address_line2?: string;
    shipping_address_line3?: string;
    shipping_city?: string;
    shipping_state?: string;
    shipping_postcode?: string;
    shipping_country?: (CountryEnum | BlankEnum);
    shipping_phone_number?: string;
    shipping_slip_status?: (ShippingSlipStatusEnum | BlankEnum);
    readonly shipping_slip_number: string;
    readonly shipping_search_text: string;
    shipping_location_traces_number?: string;
    /**
     * A purchaser needs to accept the terms and conditions of the supplying organisation.
     */
    readonly terms_accepted_on: (string) | null;
    readonly is_complete: boolean;
    breeding_plan_uid?: (string) | null;
    readonly breeding_plan: (SupplierNestedBreedingPlan | null);
    readonly order_origin: (OrderOriginEnum);
    inseminator_uid?: (string) | null;
    sorting?: (number) | null;
    readonly historic_customer: (PurchaserNameAndAddress | null);
    send_order_confirmation?: boolean;
    traces_seal_number_1?: (number) | null;
    traces_seal_number_2?: (number) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type SupplierOrderItem = {
    uid?: string;
    readonly order_uid: string;
    product_uid?: (string) | null;
    product_type?: ProductTypeEnum;
    /**
     * If a product uses one or more price points, use this field to indicate the desired variation. This number should match one of the related price points' 'max_units' value.
     */
    price_point_unit_count?: (number) | null;
    /**
     * Price of a single unit excl vat
     */
    unit_price?: (string) | null;
    readonly unit_price_currency: (string) | null;
    /**
     * Required upfront payment
     */
    upfront_payment?: (string) | null;
    readonly upfront_payment_currency: (string) | null;
    /**
     * Whether a subscription should be billed monthly or yearly. Can be left blank if not relevant
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    invoice_period?: (TimeFrameEnum | BlankEnum);
    readonly vat_percentage: (NestedVATPercentage | null);
    /**
     * number of units that are ordered
     */
    quantity?: number;
    readonly last_modified_by_uid: (string) | null;
    readonly last_modified_on: string;
    readonly picked_on: (string) | null;
    readonly picked_by_uid: (string) | null;
    mare_uid?: (string) | null;
    semen_type?: (SemenTypeEnum | BlankEnum);
    usage_type?: (UsageTypeEnum | BlankEnum);
    studbook?: (StudbookEnum | BlankEnum);
    /**
     * Provide the previous semen order item if this instance is a follow-up for the same mare (whose impregnation failed).
     */
    parent_semen_order_item_uid?: (string) | null;
    readonly total_vat: (Money | null);
    readonly variable_cost_estimate: (Money | null);
    semen_collection_station?: (string) | null;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type SupplierOrderItemDetail = {
    uid?: string;
    readonly order_uid: string;
    product_uid?: string;
    product_type?: ProductTypeEnum;
    /**
     * If a product uses one or more price points, use this field to indicate the desired variation. This number should match one of the related price points' 'max_units' value.
     */
    price_point_unit_count?: (number) | null;
    /**
     * Price of a single unit excl vat
     */
    unit_price?: (string) | null;
    readonly unit_price_currency: (string) | null;
    /**
     * Required upfront payment
     */
    upfront_payment?: (string) | null;
    readonly upfront_payment_currency: (string) | null;
    /**
     * Whether a subscription should be billed monthly or yearly. Can be left blank if not relevant
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    invoice_period?: (TimeFrameEnum | BlankEnum);
    readonly vat_percentage: (NestedVATPercentage | null);
    /**
     * number of units that are ordered
     */
    quantity?: number;
    readonly last_modified_by_uid: (string) | null;
    readonly last_modified_on: string;
    readonly picked_on: (string) | null;
    readonly picked_by_uid: (string) | null;
    mare_uid?: (string) | null;
    semen_type?: (SemenTypeEnum | BlankEnum);
    usage_type?: (UsageTypeEnum | BlankEnum);
    studbook?: (StudbookEnum | BlankEnum);
    /**
     * Provide the previous semen order item if this instance is a follow-up for the same mare (whose impregnation failed).
     */
    parent_semen_order_item_uid?: (string) | null;
    readonly total_vat: (Money | null);
    readonly variable_cost_estimate: (Money | null);
    semen_collection_station?: (string) | null;
    readonly pickedstallionmount_set: Array<PickedStallionMount>;
};

/**
 * - fixed_price serializes the amount.
 * - currency and vat are inferred from product; we'd like to use the same currency
 * - module and pricing_model are inferred from product.plan
 * - extend_automatically defaults to False Supplier provided service contracts cannot be extended.
 * Contracts can run indefinitely by omitting end_dt. These are called 'open-ended contracts.
 * - discount and invoice periods are todo's
 */
export type SupplierServiceContract = {
    readonly uid: string;
    customer_uid: string;
    product_uid: string;
    readonly module: (ModuleEnum);
    readonly pricing_model: (PricingModelEnum);
    start_dt?: string;
    /**
     * The contract will last for this number of duration units. Define together with duration_unit.
     */
    readonly duration_amount: (number) | null;
    /**
     * The contract will last for the duration amount of this time frame. Define together with duration_amount.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    readonly duration_unit: (TimeFrameEnum);
    /**
     * New contracts start out with a notice period of the contract duration. Automatically extended contracts get a one-month notice period.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    notice_period?: (TimeFrameEnum);
    /**
     * Typically, this is one year from now for flat_fee and tiered pricing models and left blank for the credits pricing model. But it may be left blank to indicate the contract has no end. This will be inferred form duration unit and amount.
     */
    end_dt?: (string) | null;
    /**
     * Contracts with overdue payments may be suspended. Suspended contracts will be denied access to the related service until the suspension is lifted or a new contract on said service is made. Suspendedcontract cannot be upgraded / downgraded or canceled.
     */
    is_suspended?: boolean;
    /**
     * This is the fixed_price currency, but you may assume that it also applies to 'estimated_cost', 'next_tiered_instance_cost' and 'total_vat'.
     */
    readonly currency: (string) | null;
    /**
     * For subscriptions applying a flat fee or stair-step plan, this is the monthly fee. For Tiered subscription this will typically be 0,00 because their cost are indicated by the estimated_cost. A value of "null" indicates that a fixed price does not apply (e.g. for a pay-once credits based service contract).
     */
    fixed_price: string;
    /**
     * The VAT amount over the sum of fixed price and estimated cost. If this contract has the latter, than this too is an estimate.
     */
    readonly total_vat: (string) | null;
    readonly vat_percentage: (NestedVATPercentage | null);
    readonly discount_percentage: number;
    /**
     * When checked, a new contract with similar conditions will be generated when this contract nears the end date. Requires that end_dt is defined.
     */
    readonly extend_automatically: boolean;
    /**
     * Whether the invoice is billed monthly or yearly.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    readonly invoice_period: (TimeFrameEnum);
    readonly followup_contract_uid: string;
    horse_uid?: (string) | null;
    /**
     * For the supplier to fill-out any specifics / reminders for this contact.
     */
    comment?: string;
};

/**
 * - fixed_price serializes the amount.
 * - currency and vat are inferred from product; we'd like to use the same currency
 * - module and pricing_model are inferred from product.plan
 * - extend_automatically defaults to False Supplier provided service contracts cannot be extended.
 * Contracts can run indefinitely by omitting end_dt. These are called 'open-ended contracts.
 * - discount and invoice periods are todo's
 */
export type SupplierServiceContractUpdate = {
    readonly uid: string;
    readonly customer_uid: string;
    product_uid: string;
    readonly module: (ModuleEnum);
    readonly pricing_model: (PricingModelEnum);
    start_dt?: string;
    /**
     * The contract will last for this number of duration units. Define together with duration_unit.
     */
    readonly duration_amount: (number) | null;
    /**
     * The contract will last for the duration amount of this time frame. Define together with duration_amount.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    readonly duration_unit: (TimeFrameEnum);
    /**
     * New contracts start out with a notice period of the contract duration. Automatically extended contracts get a one-month notice period.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    notice_period?: (TimeFrameEnum);
    /**
     * Typically, this is one year from now for flat_fee and tiered pricing models and left blank for the credits pricing model. But it may be left blank to indicate the contract has no end. This will be inferred form duration unit and amount.
     */
    end_dt?: (string) | null;
    /**
     * Contracts with overdue payments may be suspended. Suspended contracts will be denied access to the related service until the suspension is lifted or a new contract on said service is made. Suspendedcontract cannot be upgraded / downgraded or canceled.
     */
    is_suspended?: boolean;
    /**
     * This is the fixed_price currency, but you may assume that it also applies to 'estimated_cost', 'next_tiered_instance_cost' and 'total_vat'.
     */
    readonly currency: (string) | null;
    /**
     * For subscriptions applying a flat fee or stair-step plan, this is the monthly fee. For Tiered subscription this will typically be 0,00 because their cost are indicated by the estimated_cost. A value of "null" indicates that a fixed price does not apply (e.g. for a pay-once credits based service contract).
     */
    fixed_price: string;
    /**
     * The VAT amount over the sum of fixed price and estimated cost. If this contract has the latter, than this too is an estimate.
     */
    readonly total_vat: (string) | null;
    readonly vat_percentage: (NestedVATPercentage | null);
    readonly discount_percentage: number;
    /**
     * When checked, a new contract with similar conditions will be generated when this contract nears the end date. Requires that end_dt is defined.
     */
    readonly extend_automatically: boolean;
    /**
     * Whether the invoice is billed monthly or yearly.
     *
     * * `DAY` - day
     * * `MONTH` - month
     * * `YEAR` - year
     */
    readonly invoice_period: (TimeFrameEnum);
    readonly followup_contract_uid: string;
    readonly horse_uid: (string) | null;
    /**
     * For the supplier to fill-out any specifics / reminders for this contact.
     */
    comment?: string;
};

/**
 * * `GOODS` - Goods
 * * `SERVICES` - Services
 * * `DIGITAL` - Digital services
 */
export enum TaxationTypeEnum {
    GOODS = 'GOODS',
    SERVICES = 'SERVICES',
    DIGITAL = 'DIGITAL'
}

/**
 * * `DAY` - day
 * * `MONTH` - month
 * * `YEAR` - year
 */
export enum TimeFrameEnum {
    DAY = 'DAY',
    MONTH = 'MONTH',
    YEAR = 'YEAR'
}

/**
 * * `Pacific/Pago_Pago` - (UTC-11:00) Pacific/Pago Pago
 * * `Pacific/Niue` - (UTC-11:00) Pacific/Niue
 * * `Pacific/Tahiti` - (UTC-10:00) Pacific/Tahiti
 * * `Pacific/Rarotonga` - (UTC-10:00) Pacific/Rarotonga
 * * `Pacific/Honolulu` - (UTC-10:00) Pacific/Honolulu
 * * `Pacific/Marquesas` - (UTC-09:30) Pacific/Marquesas
 * * `America/Adak` - (UTC-09:00) America/Adak
 * * `Pacific/Gambier` - (UTC-09:00) Pacific/Gambier
 * * `America/Sitka` - (UTC-08:00) America/Sitka
 * * `Pacific/Pitcairn` - (UTC-08:00) Pacific/Pitcairn
 * * `America/Anchorage` - (UTC-08:00) America/Anchorage
 * * `America/Yakutat` - (UTC-08:00) America/Yakutat
 * * `America/Metlakatla` - (UTC-08:00) America/Metlakatla
 * * `America/Nome` - (UTC-08:00) America/Nome
 * * `America/Juneau` - (UTC-08:00) America/Juneau
 * * `America/Tijuana` - (UTC-07:00) America/Tijuana
 * * `America/Los_Angeles` - (UTC-07:00) America/Los Angeles
 * * `US/Pacific` - (UTC-07:00) US/Pacific
 * * `America/Fort_Nelson` - (UTC-07:00) America/Fort Nelson
 * * `America/Hermosillo` - (UTC-07:00) America/Hermosillo
 * * `America/Whitehorse` - (UTC-07:00) America/Whitehorse
 * * `America/Dawson` - (UTC-07:00) America/Dawson
 * * `America/Dawson_Creek` - (UTC-07:00) America/Dawson Creek
 * * `America/Phoenix` - (UTC-07:00) America/Phoenix
 * * `America/Mazatlan` - (UTC-07:00) America/Mazatlan
 * * `America/Vancouver` - (UTC-07:00) America/Vancouver
 * * `America/Boise` - (UTC-06:00) America/Boise
 * * `America/Denver` - (UTC-06:00) America/Denver
 * * `Pacific/Galapagos` - (UTC-06:00) Pacific/Galapagos
 * * `America/Guatemala` - (UTC-06:00) America/Guatemala
 * * `America/Bahia_Banderas` - (UTC-06:00) America/Bahia Banderas
 * * `America/Cambridge_Bay` - (UTC-06:00) America/Cambridge Bay
 * * `America/El_Salvador` - (UTC-06:00) America/El Salvador
 * * `US/Mountain` - (UTC-06:00) US/Mountain
 * * `Canada/Mountain` - (UTC-06:00) Canada/Mountain
 * * `America/Inuvik` - (UTC-06:00) America/Inuvik
 * * `America/Tegucigalpa` - (UTC-06:00) America/Tegucigalpa
 * * `America/Regina` - (UTC-06:00) America/Regina
 * * `America/Edmonton` - (UTC-06:00) America/Edmonton
 * * `America/Costa_Rica` - (UTC-06:00) America/Costa Rica
 * * `America/Managua` - (UTC-06:00) America/Managua
 * * `America/Chihuahua` - (UTC-06:00) America/Chihuahua
 * * `America/Monterrey` - (UTC-06:00) America/Monterrey
 * * `America/Mexico_City` - (UTC-06:00) America/Mexico City
 * * `America/Belize` - (UTC-06:00) America/Belize
 * * `Pacific/Easter` - (UTC-06:00) Pacific/Easter
 * * `America/Ciudad_Juarez` - (UTC-06:00) America/Ciudad Juarez
 * * `America/Swift_Current` - (UTC-06:00) America/Swift Current
 * * `America/Merida` - (UTC-06:00) America/Merida
 * * `America/Winnipeg` - (UTC-05:00) America/Winnipeg
 * * `America/Resolute` - (UTC-05:00) America/Resolute
 * * `America/Bogota` - (UTC-05:00) America/Bogota
 * * `America/Matamoros` - (UTC-05:00) America/Matamoros
 * * `America/Panama` - (UTC-05:00) America/Panama
 * * `America/Rankin_Inlet` - (UTC-05:00) America/Rankin Inlet
 * * `America/Indiana/Tell_City` - (UTC-05:00) America/Indiana/Tell City
 * * `America/Jamaica` - (UTC-05:00) America/Jamaica
 * * `America/Guayaquil` - (UTC-05:00) America/Guayaquil
 * * `America/North_Dakota/New_Salem` - (UTC-05:00) America/North Dakota/New Salem
 * * `America/Menominee` - (UTC-05:00) America/Menominee
 * * `America/Eirunepe` - (UTC-05:00) America/Eirunepe
 * * `America/Cancun` - (UTC-05:00) America/Cancun
 * * `America/Rio_Branco` - (UTC-05:00) America/Rio Branco
 * * `America/North_Dakota/Beulah` - (UTC-05:00) America/North Dakota/Beulah
 * * `America/North_Dakota/Center` - (UTC-05:00) America/North Dakota/Center
 * * `America/Indiana/Knox` - (UTC-05:00) America/Indiana/Knox
 * * `America/Ojinaga` - (UTC-05:00) America/Ojinaga
 * * `America/Lima` - (UTC-05:00) America/Lima
 * * `US/Central` - (UTC-05:00) US/Central
 * * `America/Chicago` - (UTC-05:00) America/Chicago
 * * `America/Kentucky/Monticello` - (UTC-04:00) America/Kentucky/Monticello
 * * `America/Kentucky/Louisville` - (UTC-04:00) America/Kentucky/Louisville
 * * `America/New_York` - (UTC-04:00) America/New York
 * * `Canada/Eastern` - (UTC-04:00) Canada/Eastern
 * * `America/Barbados` - (UTC-04:00) America/Barbados
 * * `America/Puerto_Rico` - (UTC-04:00) America/Puerto Rico
 * * `America/Indiana/Petersburg` - (UTC-04:00) America/Indiana/Petersburg
 * * `America/Indiana/Vincennes` - (UTC-04:00) America/Indiana/Vincennes
 * * `America/Boa_Vista` - (UTC-04:00) America/Boa Vista
 * * `America/Toronto` - (UTC-04:00) America/Toronto
 * * `America/Grand_Turk` - (UTC-04:00) America/Grand Turk
 * * `America/Santo_Domingo` - (UTC-04:00) America/Santo Domingo
 * * `America/Indiana/Marengo` - (UTC-04:00) America/Indiana/Marengo
 * * `America/Indiana/Winamac` - (UTC-04:00) America/Indiana/Winamac
 * * `America/Campo_Grande` - (UTC-04:00) America/Campo Grande
 * * `US/Eastern` - (UTC-04:00) US/Eastern
 * * `America/Porto_Velho` - (UTC-04:00) America/Porto Velho
 * * `America/Martinique` - (UTC-04:00) America/Martinique
 * * `America/Port-au-Prince` - (UTC-04:00) America/Port-au-Prince
 * * `America/Indiana/Indianapolis` - (UTC-04:00) America/Indiana/Indianapolis
 * * `America/Caracas` - (UTC-04:00) America/Caracas
 * * `America/Cuiaba` - (UTC-04:00) America/Cuiaba
 * * `America/Detroit` - (UTC-04:00) America/Detroit
 * * `America/La_Paz` - (UTC-04:00) America/La Paz
 * * `America/Manaus` - (UTC-04:00) America/Manaus
 * * `America/Iqaluit` - (UTC-04:00) America/Iqaluit
 * * `America/Guyana` - (UTC-04:00) America/Guyana
 * * `America/Indiana/Vevay` - (UTC-04:00) America/Indiana/Vevay
 * * `America/Santiago` - (UTC-04:00) America/Santiago
 * * `America/Havana` - (UTC-04:00) America/Havana
 * * `America/Halifax` - (UTC-03:00) America/Halifax
 * * `America/Cayenne` - (UTC-03:00) America/Cayenne
 * * `America/Argentina/Catamarca` - (UTC-03:00) America/Argentina/Catamarca
 * * `America/Argentina/San_Juan` - (UTC-03:00) America/Argentina/San Juan
 * * `Antarctica/Palmer` - (UTC-03:00) Antarctica/Palmer
 * * `Atlantic/Stanley` - (UTC-03:00) Atlantic/Stanley
 * * `America/Asuncion` - (UTC-03:00) America/Asuncion
 * * `America/Argentina/Mendoza` - (UTC-03:00) America/Argentina/Mendoza
 * * `America/Araguaina` - (UTC-03:00) America/Araguaina
 * * `America/Argentina/San_Luis` - (UTC-03:00) America/Argentina/San Luis
 * * `America/Argentina/Rio_Gallegos` - (UTC-03:00) America/Argentina/Rio Gallegos
 * * `America/Argentina/Tucuman` - (UTC-03:00) America/Argentina/Tucuman
 * * `America/Sao_Paulo` - (UTC-03:00) America/Sao Paulo
 * * `Atlantic/Bermuda` - (UTC-03:00) Atlantic/Bermuda
 * * `Antarctica/Rothera` - (UTC-03:00) Antarctica/Rothera
 * * `America/Coyhaique` - (UTC-03:00) America/Coyhaique
 * * `America/Paramaribo` - (UTC-03:00) America/Paramaribo
 * * `America/Thule` - (UTC-03:00) America/Thule
 * * `America/Glace_Bay` - (UTC-03:00) America/Glace Bay
 * * `America/Punta_Arenas` - (UTC-03:00) America/Punta Arenas
 * * `America/Argentina/La_Rioja` - (UTC-03:00) America/Argentina/La Rioja
 * * `America/Argentina/Jujuy` - (UTC-03:00) America/Argentina/Jujuy
 * * `America/Argentina/Ushuaia` - (UTC-03:00) America/Argentina/Ushuaia
 * * `America/Argentina/Cordoba` - (UTC-03:00) America/Argentina/Cordoba
 * * `America/Recife` - (UTC-03:00) America/Recife
 * * `America/Argentina/Salta` - (UTC-03:00) America/Argentina/Salta
 * * `America/Moncton` - (UTC-03:00) America/Moncton
 * * `America/Bahia` - (UTC-03:00) America/Bahia
 * * `America/Belem` - (UTC-03:00) America/Belem
 * * `America/Montevideo` - (UTC-03:00) America/Montevideo
 * * `America/Maceio` - (UTC-03:00) America/Maceio
 * * `America/Argentina/Buenos_Aires` - (UTC-03:00) America/Argentina/Buenos Aires
 * * `America/Fortaleza` - (UTC-03:00) America/Fortaleza
 * * `America/Santarem` - (UTC-03:00) America/Santarem
 * * `America/Goose_Bay` - (UTC-03:00) America/Goose Bay
 * * `America/St_Johns` - (UTC-02:30) America/St Johns
 * * `Atlantic/South_Georgia` - (UTC-02:00) Atlantic/South Georgia
 * * `America/Noronha` - (UTC-02:00) America/Noronha
 * * `America/Miquelon` - (UTC-02:00) America/Miquelon
 * * `America/Scoresbysund` - (UTC-01:00) America/Scoresbysund
 * * `America/Nuuk` - (UTC-01:00) America/Nuuk
 * * `Atlantic/Cape_Verde` - (UTC-01:00) Atlantic/Cape Verde
 * * `Africa/Sao_Tome` - (UTC+00:00) Africa/Sao Tome
 * * `Africa/Monrovia` - (UTC+00:00) Africa/Monrovia
 * * `America/Danmarkshavn` - (UTC+00:00) America/Danmarkshavn
 * * `GMT-0` - (UTC+00:00) GMT-0
 * * `Africa/Bissau` - (UTC+00:00) Africa/Bissau
 * * `Africa/Abidjan` - (UTC+00:00) Africa/Abidjan
 * * `GMT` - (UTC+00:00) GMT
 * * `Atlantic/Azores` - (UTC+00:00) Atlantic/Azores
 * * `Africa/Ndjamena` - (UTC+01:00) Africa/Ndjamena
 * * `Europe/Dublin` - (UTC+01:00) Europe/Dublin
 * * `Atlantic/Canary` - (UTC+01:00) Atlantic/Canary
 * * `Atlantic/Faroe` - (UTC+01:00) Atlantic/Faroe
 * * `Europe/London` - (UTC+01:00) Europe/London
 * * `Africa/Lagos` - (UTC+01:00) Africa/Lagos
 * * `Africa/Casablanca` - (UTC+01:00) Africa/Casablanca
 * * `Africa/Tunis` - (UTC+01:00) Africa/Tunis
 * * `Africa/Algiers` - (UTC+01:00) Africa/Algiers
 * * `Africa/El_Aaiun` - (UTC+01:00) Africa/El Aaiun
 * * `Europe/Lisbon` - (UTC+01:00) Europe/Lisbon
 * * `Atlantic/Madeira` - (UTC+01:00) Atlantic/Madeira
 * * `Europe/Stockholm` - (UTC+02:00) Europe/Stockholm
 * * `Europe/Madrid` - (UTC+02:00) Europe/Madrid
 * * `Europe/Prague` - (UTC+02:00) Europe/Prague
 * * `Europe/Warsaw` - (UTC+02:00) Europe/Warsaw
 * * `Africa/Juba` - (UTC+02:00) Africa/Juba
 * * `Africa/Maputo` - (UTC+02:00) Africa/Maputo
 * * `Europe/Malta` - (UTC+02:00) Europe/Malta
 * * `Africa/Windhoek` - (UTC+02:00) Africa/Windhoek
 * * `Africa/Ceuta` - (UTC+02:00) Africa/Ceuta
 * * `Europe/Zurich` - (UTC+02:00) Europe/Zurich
 * * `Antarctica/Troll` - (UTC+02:00) Antarctica/Troll
 * * `Europe/Gibraltar` - (UTC+02:00) Europe/Gibraltar
 * * `Europe/Berlin` - (UTC+02:00) Europe/Berlin
 * * `Europe/Paris` - (UTC+02:00) Europe/Paris
 * * `localtime` - (UTC+02:00) localtime
 * * `Africa/Johannesburg` - (UTC+02:00) Africa/Johannesburg
 * * `Europe/Amsterdam` - (UTC+02:00) Europe/Amsterdam
 * * `Europe/Brussels` - (UTC+02:00) Europe/Brussels
 * * `Europe/Kaliningrad` - (UTC+02:00) Europe/Kaliningrad
 * * `Europe/Oslo` - (UTC+02:00) Europe/Oslo
 * * `Africa/Khartoum` - (UTC+02:00) Africa/Khartoum
 * * `Europe/Rome` - (UTC+02:00) Europe/Rome
 * * `Africa/Tripoli` - (UTC+02:00) Africa/Tripoli
 * * `Europe/Andorra` - (UTC+02:00) Europe/Andorra
 * * `Europe/Vienna` - (UTC+02:00) Europe/Vienna
 * * `Europe/Belgrade` - (UTC+02:00) Europe/Belgrade
 * * `Europe/Tirane` - (UTC+02:00) Europe/Tirane
 * * `Europe/Budapest` - (UTC+02:00) Europe/Budapest
 * * `Asia/Gaza` - (UTC+03:00) Asia/Gaza
 * * `Asia/Kuwait` - (UTC+03:00) Asia/Kuwait
 * * `Europe/Chisinau` - (UTC+03:00) Europe/Chisinau
 * * `Asia/Amman` - (UTC+03:00) Asia/Amman
 * * `Europe/Simferopol` - (UTC+03:00) Europe/Simferopol
 * * `Europe/Moscow` - (UTC+03:00) Europe/Moscow
 * * `Europe/Istanbul` - (UTC+03:00) Europe/Istanbul
 * * `Europe/Sofia` - (UTC+03:00) Europe/Sofia
 * * `Europe/Athens` - (UTC+03:00) Europe/Athens
 * * `Africa/Nairobi` - (UTC+03:00) Africa/Nairobi
 * * `Europe/Helsinki` - (UTC+03:00) Europe/Helsinki
 * * `Europe/Kyiv` - (UTC+03:00) Europe/Kyiv
 * * `Europe/Volgograd` - (UTC+03:00) Europe/Volgograd
 * * `Europe/Vilnius` - (UTC+03:00) Europe/Vilnius
 * * `Asia/Beirut` - (UTC+03:00) Asia/Beirut
 * * `Asia/Qatar` - (UTC+03:00) Asia/Qatar
 * * `Asia/Famagusta` - (UTC+03:00) Asia/Famagusta
 * * `Europe/Kirov` - (UTC+03:00) Europe/Kirov
 * * `Asia/Hebron` - (UTC+03:00) Asia/Hebron
 * * `Asia/Nicosia` - (UTC+03:00) Asia/Nicosia
 * * `Europe/Tallinn` - (UTC+03:00) Europe/Tallinn
 * * `Europe/Riga` - (UTC+03:00) Europe/Riga
 * * `Asia/Riyadh` - (UTC+03:00) Asia/Riyadh
 * * `Africa/Cairo` - (UTC+03:00) Africa/Cairo
 * * `Europe/Bucharest` - (UTC+03:00) Europe/Bucharest
 * * `Asia/Damascus` - (UTC+03:00) Asia/Damascus
 * * `Asia/Baghdad` - (UTC+03:00) Asia/Baghdad
 * * `Asia/Jerusalem` - (UTC+03:00) Asia/Jerusalem
 * * `Europe/Minsk` - (UTC+03:00) Europe/Minsk
 * * `Asia/Tehran` - (UTC+03:30) Asia/Tehran
 * * `Asia/Baku` - (UTC+04:00) Asia/Baku
 * * `Asia/Yerevan` - (UTC+04:00) Asia/Yerevan
 * * `Europe/Astrakhan` - (UTC+04:00) Europe/Astrakhan
 * * `Europe/Samara` - (UTC+04:00) Europe/Samara
 * * `Asia/Dubai` - (UTC+04:00) Asia/Dubai
 * * `Asia/Tbilisi` - (UTC+04:00) Asia/Tbilisi
 * * `Europe/Saratov` - (UTC+04:00) Europe/Saratov
 * * `Indian/Mauritius` - (UTC+04:00) Indian/Mauritius
 * * `Europe/Ulyanovsk` - (UTC+04:00) Europe/Ulyanovsk
 * * `Asia/Kabul` - (UTC+04:30) Asia/Kabul
 * * `Antarctica/Mawson` - (UTC+05:00) Antarctica/Mawson
 * * `Asia/Ashgabat` - (UTC+05:00) Asia/Ashgabat
 * * `Asia/Yekaterinburg` - (UTC+05:00) Asia/Yekaterinburg
 * * `Antarctica/Vostok` - (UTC+05:00) Antarctica/Vostok
 * * `Asia/Dushanbe` - (UTC+05:00) Asia/Dushanbe
 * * `Asia/Karachi` - (UTC+05:00) Asia/Karachi
 * * `Asia/Atyrau` - (UTC+05:00) Asia/Atyrau
 * * `Asia/Qostanay` - (UTC+05:00) Asia/Qostanay
 * * `Indian/Maldives` - (UTC+05:00) Indian/Maldives
 * * `Asia/Almaty` - (UTC+05:00) Asia/Almaty
 * * `Asia/Oral` - (UTC+05:00) Asia/Oral
 * * `Asia/Qyzylorda` - (UTC+05:00) Asia/Qyzylorda
 * * `Asia/Aqtau` - (UTC+05:00) Asia/Aqtau
 * * `Asia/Tashkent` - (UTC+05:00) Asia/Tashkent
 * * `Asia/Aqtobe` - (UTC+05:00) Asia/Aqtobe
 * * `Asia/Samarkand` - (UTC+05:00) Asia/Samarkand
 * * `Asia/Kolkata` - (UTC+05:30) Asia/Kolkata
 * * `Asia/Colombo` - (UTC+05:30) Asia/Colombo
 * * `Asia/Kathmandu` - (UTC+05:45) Asia/Kathmandu
 * * `Asia/Urumqi` - (UTC+06:00) Asia/Urumqi
 * * `Indian/Chagos` - (UTC+06:00) Indian/Chagos
 * * `Asia/Bishkek` - (UTC+06:00) Asia/Bishkek
 * * `Asia/Dhaka` - (UTC+06:00) Asia/Dhaka
 * * `Asia/Thimphu` - (UTC+06:00) Asia/Thimphu
 * * `Asia/Omsk` - (UTC+06:00) Asia/Omsk
 * * `Asia/Yangon` - (UTC+06:30) Asia/Yangon
 * * `Asia/Hovd` - (UTC+07:00) Asia/Hovd
 * * `Asia/Novokuznetsk` - (UTC+07:00) Asia/Novokuznetsk
 * * `Asia/Tomsk` - (UTC+07:00) Asia/Tomsk
 * * `Asia/Jakarta` - (UTC+07:00) Asia/Jakarta
 * * `Asia/Krasnoyarsk` - (UTC+07:00) Asia/Krasnoyarsk
 * * `Asia/Bangkok` - (UTC+07:00) Asia/Bangkok
 * * `Asia/Pontianak` - (UTC+07:00) Asia/Pontianak
 * * `Antarctica/Davis` - (UTC+07:00) Antarctica/Davis
 * * `Asia/Novosibirsk` - (UTC+07:00) Asia/Novosibirsk
 * * `Asia/Ho_Chi_Minh` - (UTC+07:00) Asia/Ho Chi Minh
 * * `Asia/Barnaul` - (UTC+07:00) Asia/Barnaul
 * * `Asia/Kuching` - (UTC+08:00) Asia/Kuching
 * * `Asia/Hong_Kong` - (UTC+08:00) Asia/Hong Kong
 * * `Antarctica/Casey` - (UTC+08:00) Antarctica/Casey
 * * `Asia/Macau` - (UTC+08:00) Asia/Macau
 * * `Asia/Makassar` - (UTC+08:00) Asia/Makassar
 * * `Asia/Ulaanbaatar` - (UTC+08:00) Asia/Ulaanbaatar
 * * `Asia/Shanghai` - (UTC+08:00) Asia/Shanghai
 * * `Australia/Perth` - (UTC+08:00) Australia/Perth
 * * `Asia/Irkutsk` - (UTC+08:00) Asia/Irkutsk
 * * `Asia/Taipei` - (UTC+08:00) Asia/Taipei
 * * `Asia/Singapore` - (UTC+08:00) Asia/Singapore
 * * `Asia/Manila` - (UTC+08:00) Asia/Manila
 * * `Australia/Eucla` - (UTC+08:45) Australia/Eucla
 * * `Asia/Seoul` - (UTC+09:00) Asia/Seoul
 * * `Asia/Yakutsk` - (UTC+09:00) Asia/Yakutsk
 * * `Pacific/Palau` - (UTC+09:00) Pacific/Palau
 * * `Asia/Dili` - (UTC+09:00) Asia/Dili
 * * `Asia/Khandyga` - (UTC+09:00) Asia/Khandyga
 * * `Asia/Tokyo` - (UTC+09:00) Asia/Tokyo
 * * `Asia/Pyongyang` - (UTC+09:00) Asia/Pyongyang
 * * `Asia/Jayapura` - (UTC+09:00) Asia/Jayapura
 * * `Asia/Chita` - (UTC+09:00) Asia/Chita
 * * `Australia/Darwin` - (UTC+09:30) Australia/Darwin
 * * `Australia/Broken_Hill` - (UTC+09:30) Australia/Broken Hill
 * * `Australia/Adelaide` - (UTC+09:30) Australia/Adelaide
 * * `Antarctica/Macquarie` - (UTC+10:00) Antarctica/Macquarie
 * * `Asia/Vladivostok` - (UTC+10:00) Asia/Vladivostok
 * * `Asia/Ust-Nera` - (UTC+10:00) Asia/Ust-Nera
 * * `Australia/Lindeman` - (UTC+10:00) Australia/Lindeman
 * * `Australia/Melbourne` - (UTC+10:00) Australia/Melbourne
 * * `Pacific/Port_Moresby` - (UTC+10:00) Pacific/Port Moresby
 * * `Australia/Hobart` - (UTC+10:00) Australia/Hobart
 * * `Australia/Brisbane` - (UTC+10:00) Australia/Brisbane
 * * `Australia/Sydney` - (UTC+10:00) Australia/Sydney
 * * `Pacific/Guam` - (UTC+10:00) Pacific/Guam
 * * `Australia/Canberra` - (UTC+10:00) Australia/Canberra
 * * `Australia/Lord_Howe` - (UTC+10:30) Australia/Lord Howe
 * * `Asia/Sakhalin` - (UTC+11:00) Asia/Sakhalin
 * * `Pacific/Guadalcanal` - (UTC+11:00) Pacific/Guadalcanal
 * * `Asia/Magadan` - (UTC+11:00) Asia/Magadan
 * * `Pacific/Kosrae` - (UTC+11:00) Pacific/Kosrae
 * * `Pacific/Norfolk` - (UTC+11:00) Pacific/Norfolk
 * * `Pacific/Noumea` - (UTC+11:00) Pacific/Noumea
 * * `Pacific/Bougainville` - (UTC+11:00) Pacific/Bougainville
 * * `Pacific/Efate` - (UTC+11:00) Pacific/Efate
 * * `Asia/Srednekolymsk` - (UTC+11:00) Asia/Srednekolymsk
 * * `Pacific/Tarawa` - (UTC+12:00) Pacific/Tarawa
 * * `Asia/Anadyr` - (UTC+12:00) Asia/Anadyr
 * * `Pacific/Auckland` - (UTC+12:00) Pacific/Auckland
 * * `Asia/Kamchatka` - (UTC+12:00) Asia/Kamchatka
 * * `Pacific/Kwajalein` - (UTC+12:00) Pacific/Kwajalein
 * * `Pacific/Fiji` - (UTC+12:00) Pacific/Fiji
 * * `Pacific/Nauru` - (UTC+12:00) Pacific/Nauru
 * * `Pacific/Chatham` - (UTC+12:45) Pacific/Chatham
 * * `Pacific/Apia` - (UTC+13:00) Pacific/Apia
 * * `Pacific/Fakaofo` - (UTC+13:00) Pacific/Fakaofo
 * * `Pacific/Kanton` - (UTC+13:00) Pacific/Kanton
 * * `Pacific/Tongatapu` - (UTC+13:00) Pacific/Tongatapu
 * * `Pacific/Kiritimati` - (UTC+14:00) Pacific/Kiritimati
 */
export enum TimezoneEnum {
    PACIFIC_PAGO_PAGO = 'Pacific/Pago_Pago',
    PACIFIC_NIUE = 'Pacific/Niue',
    PACIFIC_TAHITI = 'Pacific/Tahiti',
    PACIFIC_RAROTONGA = 'Pacific/Rarotonga',
    PACIFIC_HONOLULU = 'Pacific/Honolulu',
    PACIFIC_MARQUESAS = 'Pacific/Marquesas',
    AMERICA_ADAK = 'America/Adak',
    PACIFIC_GAMBIER = 'Pacific/Gambier',
    AMERICA_SITKA = 'America/Sitka',
    PACIFIC_PITCAIRN = 'Pacific/Pitcairn',
    AMERICA_ANCHORAGE = 'America/Anchorage',
    AMERICA_YAKUTAT = 'America/Yakutat',
    AMERICA_METLAKATLA = 'America/Metlakatla',
    AMERICA_NOME = 'America/Nome',
    AMERICA_JUNEAU = 'America/Juneau',
    AMERICA_TIJUANA = 'America/Tijuana',
    AMERICA_LOS_ANGELES = 'America/Los_Angeles',
    US_PACIFIC = 'US/Pacific',
    AMERICA_FORT_NELSON = 'America/Fort_Nelson',
    AMERICA_HERMOSILLO = 'America/Hermosillo',
    AMERICA_WHITEHORSE = 'America/Whitehorse',
    AMERICA_DAWSON = 'America/Dawson',
    AMERICA_DAWSON_CREEK = 'America/Dawson_Creek',
    AMERICA_PHOENIX = 'America/Phoenix',
    AMERICA_MAZATLAN = 'America/Mazatlan',
    AMERICA_VANCOUVER = 'America/Vancouver',
    AMERICA_BOISE = 'America/Boise',
    AMERICA_DENVER = 'America/Denver',
    PACIFIC_GALAPAGOS = 'Pacific/Galapagos',
    AMERICA_GUATEMALA = 'America/Guatemala',
    AMERICA_BAHIA_BANDERAS = 'America/Bahia_Banderas',
    AMERICA_CAMBRIDGE_BAY = 'America/Cambridge_Bay',
    AMERICA_EL_SALVADOR = 'America/El_Salvador',
    US_MOUNTAIN = 'US/Mountain',
    CANADA_MOUNTAIN = 'Canada/Mountain',
    AMERICA_INUVIK = 'America/Inuvik',
    AMERICA_TEGUCIGALPA = 'America/Tegucigalpa',
    AMERICA_REGINA = 'America/Regina',
    AMERICA_EDMONTON = 'America/Edmonton',
    AMERICA_COSTA_RICA = 'America/Costa_Rica',
    AMERICA_MANAGUA = 'America/Managua',
    AMERICA_CHIHUAHUA = 'America/Chihuahua',
    AMERICA_MONTERREY = 'America/Monterrey',
    AMERICA_MEXICO_CITY = 'America/Mexico_City',
    AMERICA_BELIZE = 'America/Belize',
    PACIFIC_EASTER = 'Pacific/Easter',
    AMERICA_CIUDAD_JUAREZ = 'America/Ciudad_Juarez',
    AMERICA_SWIFT_CURRENT = 'America/Swift_Current',
    AMERICA_MERIDA = 'America/Merida',
    AMERICA_WINNIPEG = 'America/Winnipeg',
    AMERICA_RESOLUTE = 'America/Resolute',
    AMERICA_BOGOTA = 'America/Bogota',
    AMERICA_MATAMOROS = 'America/Matamoros',
    AMERICA_PANAMA = 'America/Panama',
    AMERICA_RANKIN_INLET = 'America/Rankin_Inlet',
    AMERICA_INDIANA_TELL_CITY = 'America/Indiana/Tell_City',
    AMERICA_JAMAICA = 'America/Jamaica',
    AMERICA_GUAYAQUIL = 'America/Guayaquil',
    AMERICA_NORTH_DAKOTA_NEW_SALEM = 'America/North_Dakota/New_Salem',
    AMERICA_MENOMINEE = 'America/Menominee',
    AMERICA_EIRUNEPE = 'America/Eirunepe',
    AMERICA_CANCUN = 'America/Cancun',
    AMERICA_RIO_BRANCO = 'America/Rio_Branco',
    AMERICA_NORTH_DAKOTA_BEULAH = 'America/North_Dakota/Beulah',
    AMERICA_NORTH_DAKOTA_CENTER = 'America/North_Dakota/Center',
    AMERICA_INDIANA_KNOX = 'America/Indiana/Knox',
    AMERICA_OJINAGA = 'America/Ojinaga',
    AMERICA_LIMA = 'America/Lima',
    US_CENTRAL = 'US/Central',
    AMERICA_CHICAGO = 'America/Chicago',
    AMERICA_KENTUCKY_MONTICELLO = 'America/Kentucky/Monticello',
    AMERICA_KENTUCKY_LOUISVILLE = 'America/Kentucky/Louisville',
    AMERICA_NEW_YORK = 'America/New_York',
    CANADA_EASTERN = 'Canada/Eastern',
    AMERICA_BARBADOS = 'America/Barbados',
    AMERICA_PUERTO_RICO = 'America/Puerto_Rico',
    AMERICA_INDIANA_PETERSBURG = 'America/Indiana/Petersburg',
    AMERICA_INDIANA_VINCENNES = 'America/Indiana/Vincennes',
    AMERICA_BOA_VISTA = 'America/Boa_Vista',
    AMERICA_TORONTO = 'America/Toronto',
    AMERICA_GRAND_TURK = 'America/Grand_Turk',
    AMERICA_SANTO_DOMINGO = 'America/Santo_Domingo',
    AMERICA_INDIANA_MARENGO = 'America/Indiana/Marengo',
    AMERICA_INDIANA_WINAMAC = 'America/Indiana/Winamac',
    AMERICA_CAMPO_GRANDE = 'America/Campo_Grande',
    US_EASTERN = 'US/Eastern',
    AMERICA_PORTO_VELHO = 'America/Porto_Velho',
    AMERICA_MARTINIQUE = 'America/Martinique',
    AMERICA_PORT_AU_PRINCE = 'America/Port-au-Prince',
    AMERICA_INDIANA_INDIANAPOLIS = 'America/Indiana/Indianapolis',
    AMERICA_CARACAS = 'America/Caracas',
    AMERICA_CUIABA = 'America/Cuiaba',
    AMERICA_DETROIT = 'America/Detroit',
    AMERICA_LA_PAZ = 'America/La_Paz',
    AMERICA_MANAUS = 'America/Manaus',
    AMERICA_IQALUIT = 'America/Iqaluit',
    AMERICA_GUYANA = 'America/Guyana',
    AMERICA_INDIANA_VEVAY = 'America/Indiana/Vevay',
    AMERICA_SANTIAGO = 'America/Santiago',
    AMERICA_HAVANA = 'America/Havana',
    AMERICA_HALIFAX = 'America/Halifax',
    AMERICA_CAYENNE = 'America/Cayenne',
    AMERICA_ARGENTINA_CATAMARCA = 'America/Argentina/Catamarca',
    AMERICA_ARGENTINA_SAN_JUAN = 'America/Argentina/San_Juan',
    ANTARCTICA_PALMER = 'Antarctica/Palmer',
    ATLANTIC_STANLEY = 'Atlantic/Stanley',
    AMERICA_ASUNCION = 'America/Asuncion',
    AMERICA_ARGENTINA_MENDOZA = 'America/Argentina/Mendoza',
    AMERICA_ARAGUAINA = 'America/Araguaina',
    AMERICA_ARGENTINA_SAN_LUIS = 'America/Argentina/San_Luis',
    AMERICA_ARGENTINA_RIO_GALLEGOS = 'America/Argentina/Rio_Gallegos',
    AMERICA_ARGENTINA_TUCUMAN = 'America/Argentina/Tucuman',
    AMERICA_SAO_PAULO = 'America/Sao_Paulo',
    ATLANTIC_BERMUDA = 'Atlantic/Bermuda',
    ANTARCTICA_ROTHERA = 'Antarctica/Rothera',
    AMERICA_COYHAIQUE = 'America/Coyhaique',
    AMERICA_PARAMARIBO = 'America/Paramaribo',
    AMERICA_THULE = 'America/Thule',
    AMERICA_GLACE_BAY = 'America/Glace_Bay',
    AMERICA_PUNTA_ARENAS = 'America/Punta_Arenas',
    AMERICA_ARGENTINA_LA_RIOJA = 'America/Argentina/La_Rioja',
    AMERICA_ARGENTINA_JUJUY = 'America/Argentina/Jujuy',
    AMERICA_ARGENTINA_USHUAIA = 'America/Argentina/Ushuaia',
    AMERICA_ARGENTINA_CORDOBA = 'America/Argentina/Cordoba',
    AMERICA_RECIFE = 'America/Recife',
    AMERICA_ARGENTINA_SALTA = 'America/Argentina/Salta',
    AMERICA_MONCTON = 'America/Moncton',
    AMERICA_BAHIA = 'America/Bahia',
    AMERICA_BELEM = 'America/Belem',
    AMERICA_MONTEVIDEO = 'America/Montevideo',
    AMERICA_MACEIO = 'America/Maceio',
    AMERICA_ARGENTINA_BUENOS_AIRES = 'America/Argentina/Buenos_Aires',
    AMERICA_FORTALEZA = 'America/Fortaleza',
    AMERICA_SANTAREM = 'America/Santarem',
    AMERICA_GOOSE_BAY = 'America/Goose_Bay',
    AMERICA_ST_JOHNS = 'America/St_Johns',
    ATLANTIC_SOUTH_GEORGIA = 'Atlantic/South_Georgia',
    AMERICA_NORONHA = 'America/Noronha',
    AMERICA_MIQUELON = 'America/Miquelon',
    AMERICA_SCORESBYSUND = 'America/Scoresbysund',
    AMERICA_NUUK = 'America/Nuuk',
    ATLANTIC_CAPE_VERDE = 'Atlantic/Cape_Verde',
    AFRICA_SAO_TOME = 'Africa/Sao_Tome',
    AFRICA_MONROVIA = 'Africa/Monrovia',
    AMERICA_DANMARKSHAVN = 'America/Danmarkshavn',
    GMT_0 = 'GMT-0',
    AFRICA_BISSAU = 'Africa/Bissau',
    AFRICA_ABIDJAN = 'Africa/Abidjan',
    GMT = 'GMT',
    ATLANTIC_AZORES = 'Atlantic/Azores',
    AFRICA_NDJAMENA = 'Africa/Ndjamena',
    EUROPE_DUBLIN = 'Europe/Dublin',
    ATLANTIC_CANARY = 'Atlantic/Canary',
    ATLANTIC_FAROE = 'Atlantic/Faroe',
    EUROPE_LONDON = 'Europe/London',
    AFRICA_LAGOS = 'Africa/Lagos',
    AFRICA_CASABLANCA = 'Africa/Casablanca',
    AFRICA_TUNIS = 'Africa/Tunis',
    AFRICA_ALGIERS = 'Africa/Algiers',
    AFRICA_EL_AAIUN = 'Africa/El_Aaiun',
    EUROPE_LISBON = 'Europe/Lisbon',
    ATLANTIC_MADEIRA = 'Atlantic/Madeira',
    EUROPE_STOCKHOLM = 'Europe/Stockholm',
    EUROPE_MADRID = 'Europe/Madrid',
    EUROPE_PRAGUE = 'Europe/Prague',
    EUROPE_WARSAW = 'Europe/Warsaw',
    AFRICA_JUBA = 'Africa/Juba',
    AFRICA_MAPUTO = 'Africa/Maputo',
    EUROPE_MALTA = 'Europe/Malta',
    AFRICA_WINDHOEK = 'Africa/Windhoek',
    AFRICA_CEUTA = 'Africa/Ceuta',
    EUROPE_ZURICH = 'Europe/Zurich',
    ANTARCTICA_TROLL = 'Antarctica/Troll',
    EUROPE_GIBRALTAR = 'Europe/Gibraltar',
    EUROPE_BERLIN = 'Europe/Berlin',
    EUROPE_PARIS = 'Europe/Paris',
    LOCALTIME = 'localtime',
    AFRICA_JOHANNESBURG = 'Africa/Johannesburg',
    EUROPE_AMSTERDAM = 'Europe/Amsterdam',
    EUROPE_BRUSSELS = 'Europe/Brussels',
    EUROPE_KALININGRAD = 'Europe/Kaliningrad',
    EUROPE_OSLO = 'Europe/Oslo',
    AFRICA_KHARTOUM = 'Africa/Khartoum',
    EUROPE_ROME = 'Europe/Rome',
    AFRICA_TRIPOLI = 'Africa/Tripoli',
    EUROPE_ANDORRA = 'Europe/Andorra',
    EUROPE_VIENNA = 'Europe/Vienna',
    EUROPE_BELGRADE = 'Europe/Belgrade',
    EUROPE_TIRANE = 'Europe/Tirane',
    EUROPE_BUDAPEST = 'Europe/Budapest',
    ASIA_GAZA = 'Asia/Gaza',
    ASIA_KUWAIT = 'Asia/Kuwait',
    EUROPE_CHISINAU = 'Europe/Chisinau',
    ASIA_AMMAN = 'Asia/Amman',
    EUROPE_SIMFEROPOL = 'Europe/Simferopol',
    EUROPE_MOSCOW = 'Europe/Moscow',
    EUROPE_ISTANBUL = 'Europe/Istanbul',
    EUROPE_SOFIA = 'Europe/Sofia',
    EUROPE_ATHENS = 'Europe/Athens',
    AFRICA_NAIROBI = 'Africa/Nairobi',
    EUROPE_HELSINKI = 'Europe/Helsinki',
    EUROPE_KYIV = 'Europe/Kyiv',
    EUROPE_VOLGOGRAD = 'Europe/Volgograd',
    EUROPE_VILNIUS = 'Europe/Vilnius',
    ASIA_BEIRUT = 'Asia/Beirut',
    ASIA_QATAR = 'Asia/Qatar',
    ASIA_FAMAGUSTA = 'Asia/Famagusta',
    EUROPE_KIROV = 'Europe/Kirov',
    ASIA_HEBRON = 'Asia/Hebron',
    ASIA_NICOSIA = 'Asia/Nicosia',
    EUROPE_TALLINN = 'Europe/Tallinn',
    EUROPE_RIGA = 'Europe/Riga',
    ASIA_RIYADH = 'Asia/Riyadh',
    AFRICA_CAIRO = 'Africa/Cairo',
    EUROPE_BUCHAREST = 'Europe/Bucharest',
    ASIA_DAMASCUS = 'Asia/Damascus',
    ASIA_BAGHDAD = 'Asia/Baghdad',
    ASIA_JERUSALEM = 'Asia/Jerusalem',
    EUROPE_MINSK = 'Europe/Minsk',
    ASIA_TEHRAN = 'Asia/Tehran',
    ASIA_BAKU = 'Asia/Baku',
    ASIA_YEREVAN = 'Asia/Yerevan',
    EUROPE_ASTRAKHAN = 'Europe/Astrakhan',
    EUROPE_SAMARA = 'Europe/Samara',
    ASIA_DUBAI = 'Asia/Dubai',
    ASIA_TBILISI = 'Asia/Tbilisi',
    EUROPE_SARATOV = 'Europe/Saratov',
    INDIAN_MAURITIUS = 'Indian/Mauritius',
    EUROPE_ULYANOVSK = 'Europe/Ulyanovsk',
    ASIA_KABUL = 'Asia/Kabul',
    ANTARCTICA_MAWSON = 'Antarctica/Mawson',
    ASIA_ASHGABAT = 'Asia/Ashgabat',
    ASIA_YEKATERINBURG = 'Asia/Yekaterinburg',
    ANTARCTICA_VOSTOK = 'Antarctica/Vostok',
    ASIA_DUSHANBE = 'Asia/Dushanbe',
    ASIA_KARACHI = 'Asia/Karachi',
    ASIA_ATYRAU = 'Asia/Atyrau',
    ASIA_QOSTANAY = 'Asia/Qostanay',
    INDIAN_MALDIVES = 'Indian/Maldives',
    ASIA_ALMATY = 'Asia/Almaty',
    ASIA_ORAL = 'Asia/Oral',
    ASIA_QYZYLORDA = 'Asia/Qyzylorda',
    ASIA_AQTAU = 'Asia/Aqtau',
    ASIA_TASHKENT = 'Asia/Tashkent',
    ASIA_AQTOBE = 'Asia/Aqtobe',
    ASIA_SAMARKAND = 'Asia/Samarkand',
    ASIA_KOLKATA = 'Asia/Kolkata',
    ASIA_COLOMBO = 'Asia/Colombo',
    ASIA_KATHMANDU = 'Asia/Kathmandu',
    ASIA_URUMQI = 'Asia/Urumqi',
    INDIAN_CHAGOS = 'Indian/Chagos',
    ASIA_BISHKEK = 'Asia/Bishkek',
    ASIA_DHAKA = 'Asia/Dhaka',
    ASIA_THIMPHU = 'Asia/Thimphu',
    ASIA_OMSK = 'Asia/Omsk',
    ASIA_YANGON = 'Asia/Yangon',
    ASIA_HOVD = 'Asia/Hovd',
    ASIA_NOVOKUZNETSK = 'Asia/Novokuznetsk',
    ASIA_TOMSK = 'Asia/Tomsk',
    ASIA_JAKARTA = 'Asia/Jakarta',
    ASIA_KRASNOYARSK = 'Asia/Krasnoyarsk',
    ASIA_BANGKOK = 'Asia/Bangkok',
    ASIA_PONTIANAK = 'Asia/Pontianak',
    ANTARCTICA_DAVIS = 'Antarctica/Davis',
    ASIA_NOVOSIBIRSK = 'Asia/Novosibirsk',
    ASIA_HO_CHI_MINH = 'Asia/Ho_Chi_Minh',
    ASIA_BARNAUL = 'Asia/Barnaul',
    ASIA_KUCHING = 'Asia/Kuching',
    ASIA_HONG_KONG = 'Asia/Hong_Kong',
    ANTARCTICA_CASEY = 'Antarctica/Casey',
    ASIA_MACAU = 'Asia/Macau',
    ASIA_MAKASSAR = 'Asia/Makassar',
    ASIA_ULAANBAATAR = 'Asia/Ulaanbaatar',
    ASIA_SHANGHAI = 'Asia/Shanghai',
    AUSTRALIA_PERTH = 'Australia/Perth',
    ASIA_IRKUTSK = 'Asia/Irkutsk',
    ASIA_TAIPEI = 'Asia/Taipei',
    ASIA_SINGAPORE = 'Asia/Singapore',
    ASIA_MANILA = 'Asia/Manila',
    AUSTRALIA_EUCLA = 'Australia/Eucla',
    ASIA_SEOUL = 'Asia/Seoul',
    ASIA_YAKUTSK = 'Asia/Yakutsk',
    PACIFIC_PALAU = 'Pacific/Palau',
    ASIA_DILI = 'Asia/Dili',
    ASIA_KHANDYGA = 'Asia/Khandyga',
    ASIA_TOKYO = 'Asia/Tokyo',
    ASIA_PYONGYANG = 'Asia/Pyongyang',
    ASIA_JAYAPURA = 'Asia/Jayapura',
    ASIA_CHITA = 'Asia/Chita',
    AUSTRALIA_DARWIN = 'Australia/Darwin',
    AUSTRALIA_BROKEN_HILL = 'Australia/Broken_Hill',
    AUSTRALIA_ADELAIDE = 'Australia/Adelaide',
    ANTARCTICA_MACQUARIE = 'Antarctica/Macquarie',
    ASIA_VLADIVOSTOK = 'Asia/Vladivostok',
    ASIA_UST_NERA = 'Asia/Ust-Nera',
    AUSTRALIA_LINDEMAN = 'Australia/Lindeman',
    AUSTRALIA_MELBOURNE = 'Australia/Melbourne',
    PACIFIC_PORT_MORESBY = 'Pacific/Port_Moresby',
    AUSTRALIA_HOBART = 'Australia/Hobart',
    AUSTRALIA_BRISBANE = 'Australia/Brisbane',
    AUSTRALIA_SYDNEY = 'Australia/Sydney',
    PACIFIC_GUAM = 'Pacific/Guam',
    AUSTRALIA_CANBERRA = 'Australia/Canberra',
    AUSTRALIA_LORD_HOWE = 'Australia/Lord_Howe',
    ASIA_SAKHALIN = 'Asia/Sakhalin',
    PACIFIC_GUADALCANAL = 'Pacific/Guadalcanal',
    ASIA_MAGADAN = 'Asia/Magadan',
    PACIFIC_KOSRAE = 'Pacific/Kosrae',
    PACIFIC_NORFOLK = 'Pacific/Norfolk',
    PACIFIC_NOUMEA = 'Pacific/Noumea',
    PACIFIC_BOUGAINVILLE = 'Pacific/Bougainville',
    PACIFIC_EFATE = 'Pacific/Efate',
    ASIA_SREDNEKOLYMSK = 'Asia/Srednekolymsk',
    PACIFIC_TARAWA = 'Pacific/Tarawa',
    ASIA_ANADYR = 'Asia/Anadyr',
    PACIFIC_AUCKLAND = 'Pacific/Auckland',
    ASIA_KAMCHATKA = 'Asia/Kamchatka',
    PACIFIC_KWAJALEIN = 'Pacific/Kwajalein',
    PACIFIC_FIJI = 'Pacific/Fiji',
    PACIFIC_NAURU = 'Pacific/Nauru',
    PACIFIC_CHATHAM = 'Pacific/Chatham',
    PACIFIC_APIA = 'Pacific/Apia',
    PACIFIC_FAKAOFO = 'Pacific/Fakaofo',
    PACIFIC_KANTON = 'Pacific/Kanton',
    PACIFIC_TONGATAPU = 'Pacific/Tongatapu',
    PACIFIC_KIRITIMATI = 'Pacific/Kiritimati'
}

/**
 * * `Mr` - Mr
 * * `Miss` - Miss
 * * `Mrs` - Mrs
 * * `Ms` - Ms
 * * `Dr` - Dr
 * * `` - ---
 */
export enum TitleEnum {
    MR = 'Mr',
    MISS = 'Miss',
    MRS = 'Mrs',
    MS = 'Ms',
    DR = 'Dr'
}

export type TokenObtainPair = {
    username: string;
    password: string;
    readonly access: string;
    readonly refresh: string;
};

export type TokenRefresh = {
    readonly access: string;
    refresh: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type Transaction = {
    readonly uid: string;
    date: string;
    supplier_uid?: (string) | null;
    currency?: CurrencyEnum;
    readonly created_on: string;
    readonly created_by_uid: string;
    readonly last_modified_on: string;
    readonly last_modified_by_uid: string;
};

/**
 * CRUD your Transactions in combination with TransactionItems: they are nested under `items`.
 *
 * Note on the agency: The transaction is managed by your organisation. It lists goods that were bought by
 * your organisation, possibly as (part of) a service to one of your customer. The Transaction's `supplier` contact
 * field can track where the goods originated from (the field is optional). The TransactionItem's `customer` contact
 * field can track for whom they are intended So:
 * - `supplier_uid` is the Contact where the goods (transaction items) came from (optional)
 * - `organisation_uid` is your organisation.
 * - `item.customer_uid` is for whom the goods are intended (optional)
 *
 * Note on Updating transaction items:
 * - If `transaction_items` is *not* supplied:
 * - no change to existing transaction items.
 *
 * - If `transaction_items` is supplied:
 * - All items that specify a matching 'uid' are PATCHED with the additionally supplied fields.
 * - All items that don't have a 'uid' are CREATED.
 * - All *existing* transaction_items that are *not* mentioned by 'uid', are DELETED.
 *
 * I.e. if you want nothing to be done to the transaction items, you can list all the transaction items'
 * 'uid' field or omit 'transaction_items' al together. The behavior is the same with Invoice and Order.
 */
export type TransactionDetail = {
    readonly uid: string;
    date: string;
    supplier_uid?: (string) | null;
    currency?: CurrencyEnum;
    readonly created_on: string;
    readonly created_by_uid: string;
    readonly last_modified_on: string;
    readonly last_modified_by_uid: string;
    items?: Array<NestedTransactionItem>;
    media?: Array<NestedTransactionMedia>;
};

/**
 * Read only serializer vor TransactionItems. To Create or update use the NestedTransactionItemSerializer
 */
export type TransactionItem = {
    readonly uid: string;
    /**
     * Provide a horse if this was purchased for a specific horse. The resulting billable items will be attributed to the customer if provided, else it will be attributed to this horse's owner(s).
     */
    readonly horse_uid: (string) | null;
    /**
     * Provide a contact if this items was purchased specifically for this customer and should be invoiced as such. A billable item will be generated for this item and customer if provided.
     */
    readonly customer_uid: (string) | null;
    price: string;
    price_currency?: string;
    readonly transaction_type: (TransactionTypeEnum);
    readonly vat_percentage_uid: string;
    readonly vat_percentage: (NestedVATPercentage | null);
    readonly vat_included_in_price: boolean;
    readonly total_vat: (Money | null);
    readonly description: (string) | null;
    readonly realactivity_uid: (string) | null;
    readonly created_on: string;
    readonly created_by_uid: string;
    readonly last_modified_on: string;
    readonly last_modified_by_uid: string;
    readonly transaction_uid: string;
    readonly transaction_date: string;
    readonly supplier_uid: string;
};

/**
 * * `EXPENSE` - Expense
 * * `INCOME` - Income
 */
export enum TransactionTypeEnum {
    EXPENSE = 'EXPENSE',
    INCOME = 'INCOME'
}

/**
 * * `0` - Unknown
 * * `1` - Private
 * * `2` - Professional
 */
export enum TypeOfOrganisationEnum {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2
}

export type UpgradeDowngradePurchaserServiceContract = {
    max_amount: (number) | null;
};

/**
 * Serializer for the URL POI.
 */
export type URLPointOfInterest = {
    readonly uid: string;
    parent_map_uid: string;
    coordinate_x?: number;
    coordinate_y?: number;
    url: string;
    readonly resourcetype: 'URLPointOfInterest';
};

/**
 * * `URLPointOfInterest` - URLPointOfInterest
 */
export enum URLPointOfInterestResourcetypeEnum {
    URLPOINT_OF_INTEREST = 'URLPointOfInterest'
}

/**
 * * `KI` - KI (self-pregnancy)
 * * `ET` - ET
 * * `ICSI` - ICSI
 */
export enum UsageTypeEnum {
    KI = 'KI',
    ET = 'ET',
    ICSI = 'ICSI'
}

/**
 * User model w/o password
 */
export type UserDetails = {
    readonly pk: number;
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     */
    username: string;
    readonly email: string;
    first_name?: string;
    last_name?: string;
};

/**
 * * `NO EDEMA` - Nothing
 * * `SMALL EDEMA` - Edema Small
 * * `MEDIUM EDEMA` - Edema Medium
 * * `LARGE EDEMA` - Edema Large
 */
export enum UterusEnum {
    NO_EDEMA = 'NO EDEMA',
    SMALL_EDEMA = 'SMALL EDEMA',
    MEDIUM_EDEMA = 'MEDIUM EDEMA',
    LARGE_EDEMA = 'LARGE EDEMA'
}

/**
 * This mixin will make sure that if for example 'name': 'test' is thrown at the API,
 * and 'name' is a TranslatedField, that 'test' will become the value of 'name' in the
 * current language.
 */
export type VaccinationRule = {
    readonly uid: string;
    name?: string;
    readonly organisation_uid: (string) | null;
    months_between_vaccination: number;
    optional_extra_days?: number;
    number_of_days_not_competing_after_vaccination: number;
};

/**
 * * `S` - Normal sale
 * * `AE` - Reverse-charging VAT
 * * `G` - Export
 */
export enum VatCategoryEnum {
    S = 'S',
    AE = 'AE',
    G = 'G'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type VatLevelCountry = {
    vat_level: VatLevelCountryVatLevelEnum;
    country: CountryEnum;
};

/**
 * * `REDUCED` - reduced
 * * `SECOND_REDUCED` - second reduced
 * * `SUPER_REDUCED` - super reduced
 * * `ZERO` - zero
 */
export enum VatLevelCountryVatLevelEnum {
    REDUCED = 'REDUCED',
    SECOND_REDUCED = 'SECOND_REDUCED',
    SUPER_REDUCED = 'SUPER_REDUCED',
    ZERO = 'ZERO'
}

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type VATPercentage = {
    readonly uid: string;
    percentage: string;
    vat_category: VatCategoryEnum;
    hidden?: boolean;
    readonly created_on: string;
    vat_level?: VATPercentageVatLevelEnum;
    start_date?: string;
    readonly is_active: boolean;
    country?: (CountryEnum | BlankEnum);
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type VATPercentageExternalProviderId = {
    readonly uid: string;
    vat_percentage_uid: string;
    provider: ProviderEnum;
    external_provider_sales_id?: string;
    external_provider_purchases_id?: string;
};

/**
 * Filters the queryset for a related field to those items the user has permissions for.
 *
 * Does work with all serializers, but in general on nested serializers you don't use the queryset method, so then it does not work.
 *
 * IN THE SERIALIZER
 *
 * Without this mixin, the browsable api would show all options, not only those of the user.
 *
 * Also without this mixin, it would be possible to post (=create) a horse in another stable, etc.
 *
 * The def bind method is for nested serializers and is very necessary!!!
 */
export type VATPercentageUpdate = {
    hidden?: boolean;
};

/**
 * * `STANDARD` - standard
 * * `REDUCED` - reduced
 * * `SECOND_REDUCED` - second reduced
 * * `SUPER_REDUCED` - super reduced
 * * `ZERO` - zero
 */
export enum VATPercentageVatLevelEnum {
    STANDARD = 'STANDARD',
    REDUCED = 'REDUCED',
    SECOND_REDUCED = 'SECOND_REDUCED',
    SUPER_REDUCED = 'SUPER_REDUCED',
    ZERO = 'ZERO'
}

export type VerifyEmail = {
    key: string;
};

/**
 * Extra serializer for the WorkDayField.
 */
export type WorkDay = {
    hours: number;
    start_time: string;
};

/**
 * Serializer for the WorkDayAvailability of an employee.
 */
export type WorkDayAvailabilities = {
    readonly available: (AvailableEnum);
};

/**
 * Serializer for the WorkDayAvailability of a manager.
 */
export type WorkDayAvailabilitiesManager = {
    readonly available: (AvailableEnum);
    readonly reason: string;
};

/**
 * Serializer for the WorkDayAvailability of an employee.
 */
export type WorkDayAvailability = {
    readonly contact_uid: string;
    availabilities: Array<WorkDayAvailabilities>;
    workschedule: Array<WorkDaySchedule>;
};

/**
 * Serializer for the WorkDayAvailability of a manager.
 */
export type WorkDayAvailabilityManager = {
    readonly contact_uid: string;
    availabilities: Array<WorkDayAvailabilitiesManager>;
    workschedule: Array<WorkDaySchedule>;
};

/**
 * Serializer for the WorkDayAvailability of an employee.
 */
export type WorkDaySchedule = {
    hours: number;
    start_time: string;
};

/**
 * * `1` - Light
 * * `2` - Medium
 * * `3` - Heavy
 */
export enum WorkloadEnum {
    '_1' = 1,
    '_2' = 2,
    '_3' = 3
}

/**
 * Extra serializer for the WorkWeekField.
 */
export type WorkWeek = {
    monday?: (WorkDay | null);
    tuesday?: (WorkDay | null);
    wednesday?: (WorkDay | null);
    thursday?: (WorkDay | null);
    friday?: (WorkDay | null);
    saturday?: (WorkDay | null);
    sunday?: (WorkDay | null);
};

export type ApiV5AllauthSchemeRetrieveResponse = (unknown);

export type ApiV5AccountRetrieveResponse = (Account);

export type ApiV5AccountUpdateData = {
    requestBody: Account;
};

export type ApiV5AccountUpdateResponse = (Account);

export type ApiV5AccountPartialUpdateData = {
    requestBody?: PatchedAccount;
};

export type ApiV5AccountPartialUpdateResponse = (Account);

export type ApiV5AccountDestroyResponse = (void);

export type ApiV5CheckSsoCreateData = {
    requestBody: Email;
};

export type ApiV5CheckSsoCreateResponse = (SSO);

export type ApiV5JwtObtainCreateData = {
    requestBody: TokenObtainPair;
};

export type ApiV5JwtObtainCreateResponse = (TokenObtainPair);

export type ApiV5JwtRefreshCreateData = {
    requestBody: TokenRefresh;
};

export type ApiV5JwtRefreshCreateResponse = (TokenRefresh);

export type ApiV5PasswordChangeCreateData = {
    requestBody: PasswordChange;
};

export type ApiV5PasswordChangeCreateResponse = (RestAuthDetail);

export type ApiV5PasswordResetCreateData = {
    requestBody: EquineMPasswordReset;
};

export type ApiV5PasswordResetCreateResponse = (EquineMPasswordReset);

export type ApiV5PasswordResetConfirmCreateData = {
    requestBody: PasswordResetConfirm;
};

export type ApiV5PasswordResetConfirmCreateResponse = (RestAuthDetail);

export type ApiV5SignupCreateData = {
    requestBody: EquineMRegister;
};

export type ApiV5SignupCreateResponse = (EquineMRegister);

export type ApiV5SignupWithInvitationCreateData = {
    requestBody: SignupWithInvitation;
};

export type ApiV5SignupWithInvitationCreateResponse = (SignupResponse);

export type ApiV5VerifyEmailCreateData = {
    requestBody: VerifyEmail;
};

export type ApiV5VerifyEmailCreateResponse = (RestAuthDetail);

export type ActivitiesListData = {
    /**
     * * `RIDING` - Riding
     * * `PADDOCK` - Paddock
     * * `LUNGING` - Lunging
     * * `FARRIER` - Farrier
     * * `VACCINATION` - Vaccination
     * * `VETERINARY` - Veterinary
     * * `SHOW` - Show
     * * `CUSTOMER` - Customer
     * * `DEWORM` - Deworm
     * * `DENTIST` - Dentist
     * * `LESSON` - Lesson
     * * `INSEMINATION` - Insemination
     * * `FOALING` - Foaling
     * * `MARE_CYCLE_CHECK` - Mare Cycle Check
     * * `RHINO` - Rhino
     * * `STALLION_MOUNT` - Stallion Mount
     */
    activityTypeDefault?: 'CUSTOMER' | 'DENTIST' | 'DEWORM' | 'FARRIER' | 'FOALING' | 'INSEMINATION' | 'LESSON' | 'LUNGING' | 'MARE_CYCLE_CHECK' | 'PADDOCK' | 'RHINO' | 'RIDING' | 'SHOW' | 'STALLION_MOUNT' | 'VACCINATION' | 'VETERINARY';
    /**
     * Multiple values may be separated by commas.
     */
    activityTypeDefaultIn?: Array<(string)>;
    activityTypeHidden?: boolean;
    activityTypeUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    activityTypeUidIn?: Array<(string)>;
    dtendGt?: string;
    dtstartLt?: string;
    horseGroupUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    horseGroupUidIn?: Array<(string)>;
    horseStableUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    horseStableUidIn?: Array<(string)>;
    /**
     * Multiple values may be separated by commas.
     */
    horseUidIn?: Array<(string)>;
    horseUserActive?: boolean;
    /**
     * Last done and first future per activity type and horse
     */
    lastDoneAndLastAndFirstFuturePerHorseAndActivityType?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    orderItemUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    orderItemUidIn?: Array<(string)>;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    remind?: boolean;
    /**
     * Multiple values may be separated by commas.
     */
    statusIn?: Array<(string)>;
};

export type ActivitiesListResponse = (PaginatedRealActivitiesList);

export type ActivitiesCreateData = {
    organisationUid: string;
    requestBody: RealActivities;
};

export type ActivitiesCreateResponse = (RealActivities);

export type ActivitiesRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type ActivitiesRetrieveResponse = (RealActivities);

export type ActivitiesUpdateData = {
    organisationUid: string;
    requestBody: RealActivitiesUpdate;
    uid: string;
};

export type ActivitiesUpdateResponse = (RealActivitiesUpdate);

export type ActivitiesPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedRealActivitiesUpdate;
    uid: string;
};

export type ActivitiesPartialUpdateResponse = (RealActivitiesUpdate);

export type ActivitiesDeletePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedEventDestroy;
    uid: string;
};

export type ActivitiesDeletePartialUpdateResponse = (unknown);

export type ActivitiesSetDonePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedRealActivitiesSetDoneAndUnDone;
    uid: string;
};

export type ActivitiesSetDonePartialUpdateResponse = (RealActivitiesSetDoneAndUnDone);

export type ActivitiesSetUndonePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedRealActivitiesSetDoneAndUnDone;
    uid: string;
};

export type ActivitiesSetUndonePartialUpdateResponse = (RealActivitiesSetDoneAndUnDone);

export type ActivitiesContactsListData = {
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
};

export type ActivitiesContactsListResponse = (PaginatedShallowContactList);

export type ActivitytypepricesListData = {
    activityTypeOrganisationUid: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
};

export type ActivitytypepricesListResponse = (Array<ActivityTypePrice>);

export type ActivitytypepricesCreateData = {
    activityTypeOrganisationUid: string;
    requestBody: ActivityTypePrice;
};

export type ActivitytypepricesCreateResponse = (ActivityTypePrice);

export type ActivitytypepricesRetrieveData = {
    activityTypeOrganisationUid: string;
    uid: string;
};

export type ActivitytypepricesRetrieveResponse = (ActivityTypePrice);

export type ActivitytypepricesUpdateData = {
    activityTypeOrganisationUid: string;
    requestBody: ActivityTypePrice;
    uid: string;
};

export type ActivitytypepricesUpdateResponse = (ActivityTypePrice);

export type ActivitytypepricesPartialUpdateData = {
    activityTypeOrganisationUid: string;
    requestBody?: PatchedActivityTypePrice;
    uid: string;
};

export type ActivitytypepricesPartialUpdateResponse = (ActivityTypePrice);

export type ActivitytypepricesDestroyData = {
    activityTypeOrganisationUid: string;
    uid: string;
};

export type ActivitytypepricesDestroyResponse = (void);

export type ActivitytypesListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
};

export type ActivitytypesListResponse = (Array<ActivityType>);

export type ActivitytypesCreateData = {
    organisationUid: string;
    requestBody?: ActivityType;
};

export type ActivitytypesCreateResponse = (ActivityType);

export type ActivitytypesRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type ActivitytypesRetrieveResponse = (ActivityType);

export type ActivitytypesUpdateData = {
    organisationUid: string;
    requestBody?: ActivityType;
    uid: string;
};

export type ActivitytypesUpdateResponse = (ActivityType);

export type ActivitytypesPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedActivityType;
    uid: string;
};

export type ActivitytypesPartialUpdateResponse = (ActivityType);

export type ActivitytypesDestroyData = {
    organisationUid: string;
    uid: string;
};

export type ActivitytypesDestroyResponse = (void);

export type ApiV5DeviceListResponse = (Array<NotificationSettings>);

export type ApiV5DeviceFcmListResponse = (Array<CustomFCMDevice>);

export type ApiV5DeviceFcmCreateData = {
    requestBody: CustomFCMDevice;
};

export type ApiV5DeviceFcmCreateResponse = (CustomFCMDevice);

export type ApiV5DeviceFcmRetrieveData = {
    registrationId: string;
};

export type ApiV5DeviceFcmRetrieveResponse = (CustomFCMDevice);

export type ApiV5DeviceFcmUpdateData = {
    registrationId: string;
    requestBody: CustomFCMDevice;
};

export type ApiV5DeviceFcmUpdateResponse = (CustomFCMDevice);

export type ApiV5DeviceFcmPartialUpdateData = {
    registrationId: string;
    requestBody?: PatchedCustomFCMDevice;
};

export type ApiV5DeviceFcmPartialUpdateResponse = (CustomFCMDevice);

export type ApiV5DeviceFcmDestroyData = {
    registrationId: string;
};

export type ApiV5DeviceFcmDestroyResponse = (void);

export type ApiV5DeviceFcmSettingsRetrieveResponse = (NotificationSettings);

export type ApiV5DeviceFcmSettingsPartialUpdateData = {
    requestBody?: PatchedNotificationSettings;
};

export type ApiV5DeviceFcmSettingsPartialUpdateResponse = (NotificationSettings);

export type ApiV5DeviceFcmSettingsPatchPartialUpdateData = {
    requestBody?: PatchedNotificationSettings;
};

export type ApiV5DeviceFcmSettingsPatchPartialUpdateResponse = (NotificationSettings);

export type ApiV5OauthUserMicrosoftLoginCreateData = {
    requestBody?: SocialLogin;
};

export type ApiV5OauthUserMicrosoftLoginCreateResponse = (JWT);

export type ApiV5PlansListData = {
    isGeneric?: boolean;
    /**
     * Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     */
    module?: 'ACCOUNTING' | 'FACILITY_PLANNING' | 'FEED_AND_MEDICINE' | 'FINANCIAL_AND_PAYMENT' | 'HORSE_SERVICES_CARE' | 'HORSE_SERVICES_FULL' | 'RVO_REPORTS' | 'SHOP_AND_BREEDING' | 'USER_ACCOUNTS' | 'WORKFORCE_MANAGEMENT';
    /**
     * Multiple values may be separated by commas.
     */
    moduleIn?: Array<(string)>;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * * `FLAT_FEE` - flat fee
     * * `STAIR_STEP` - stair step
     * * `TIERED` - tiered
     * * `CREDITS` - credits
     */
    pricingModel?: 'CREDITS' | 'FLAT_FEE' | 'STAIR_STEP' | 'TIERED';
    /**
     * Multiple values may be separated by commas.
     */
    pricingModelIn?: Array<(string)>;
};

export type ApiV5PlansListResponse = (Array<Plan>);

export type AvailabilityEmployeeListData = {
    /**
     * * `sick` - Sick
     * * `leave` - Leave
     * * `overtime` - Overtime
     */
    availabilityType?: 'leave' | 'overtime' | 'sick';
    /**
     * Multiple values may be separated by commas.
     */
    availabilityTypeIn?: Array<(string)>;
    dtendGt?: string;
    dtstartLt?: string;
    employmentUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    employmentUidIn?: Array<(string)>;
    hasLeaveAllowanceImpact?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * Multiple values may be separated by commas.
     */
    statusIn?: Array<(string)>;
};

export type AvailabilityEmployeeListResponse = (PaginatedAvailabilityList);

export type AvailabilityEmployeeCreateData = {
    organisationUid: string;
    requestBody: Availability;
};

export type AvailabilityEmployeeCreateResponse = (Availability);

export type AvailabilityEmployeeRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type AvailabilityEmployeeRetrieveResponse = (Availability);

export type AvailabilityEmployeeUpdateData = {
    organisationUid: string;
    requestBody?: AvailabilityEmployeeUpdate;
    uid: string;
};

export type AvailabilityEmployeeUpdateResponse = (AvailabilityEmployeeUpdate);

export type AvailabilityEmployeePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedAvailabilityEmployeeUpdate;
    uid: string;
};

export type AvailabilityEmployeePartialUpdateResponse = (AvailabilityEmployeeUpdate);

export type AvailabilityEmployeeDeletePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedAvailabilityDestroy;
    uid: string;
};

export type AvailabilityEmployeeDeletePartialUpdateResponse = (unknown);

export type AvailabilityManagerListData = {
    /**
     * * `sick` - Sick
     * * `leave` - Leave
     * * `overtime` - Overtime
     */
    availabilityType?: 'leave' | 'overtime' | 'sick';
    /**
     * Multiple values may be separated by commas.
     */
    availabilityTypeIn?: Array<(string)>;
    contactUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    contactUidIn?: Array<(string)>;
    dtendGt?: string;
    dtstartLt?: string;
    employmentUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    employmentUidIn?: Array<(string)>;
    hasLeaveAllowanceImpact?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    /**
     * Multiple values may be separated by commas.
     */
    statusIn?: Array<(string)>;
};

export type AvailabilityManagerListResponse = (Array<AvailabilityManager>);

export type AvailabilityManagerCreateData = {
    organisationUid: string;
    requestBody: AvailabilityManager;
};

export type AvailabilityManagerCreateResponse = (AvailabilityManager);

export type AvailabilityManagerRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type AvailabilityManagerRetrieveResponse = (AvailabilityManager);

export type AvailabilityManagerUpdateData = {
    organisationUid: string;
    requestBody?: AvailabilityManagerUpdate;
    uid: string;
};

export type AvailabilityManagerUpdateResponse = (AvailabilityManagerUpdate);

export type AvailabilityManagerPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedAvailabilityManagerUpdate;
    uid: string;
};

export type AvailabilityManagerPartialUpdateResponse = (AvailabilityManagerUpdate);

export type AvailabilityManagerApprovePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedAvailabilityApproveDecline;
    uid: string;
};

export type AvailabilityManagerApprovePartialUpdateResponse = (unknown);

export type AvailabilityManagerCancelPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedAvailabilityApproveDecline;
    uid: string;
};

export type AvailabilityManagerCancelPartialUpdateResponse = (AvailabilityApproveDecline);

export type AvailabilityManagerDeletePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedEventDestroy;
    uid: string;
};

export type AvailabilityManagerDeletePartialUpdateResponse = (unknown);

export type AvailabilityManagerRejectPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedAvailabilityApproveDecline;
    uid: string;
};

export type AvailabilityManagerRejectPartialUpdateResponse = (AvailabilityApproveDecline);

export type BillableitemsUpdateData = {
    organisationUid: string;
    requestBody: BillableItem;
    uid: string;
};

export type BillableitemsUpdateResponse = (BillableItem);

export type BillableitemsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedBillableItem;
    uid: string;
};

export type BillableitemsPartialUpdateResponse = (BillableItem);

export type BillableitemsInvoicedListData = {
    /**
     * * `RIDING` - Riding
     * * `PADDOCK` - Paddock
     * * `LUNGING` - Lunging
     * * `FARRIER` - Farrier
     * * `VACCINATION` - Vaccination
     * * `VETERINARY` - Veterinary
     * * `SHOW` - Show
     * * `CUSTOMER` - Customer
     * * `DEWORM` - Deworm
     * * `DENTIST` - Dentist
     * * `LESSON` - Lesson
     * * `INSEMINATION` - Insemination
     * * `FOALING` - Foaling
     * * `MARE_CYCLE_CHECK` - Mare Cycle Check
     * * `RHINO` - Rhino
     * * `STALLION_MOUNT` - Stallion Mount
     */
    activityActivityTypeDefault?: 'CUSTOMER' | 'DENTIST' | 'DEWORM' | 'FARRIER' | 'FOALING' | 'INSEMINATION' | 'LESSON' | 'LUNGING' | 'MARE_CYCLE_CHECK' | 'PADDOCK' | 'RHINO' | 'RIDING' | 'SHOW' | 'STALLION_MOUNT' | 'VACCINATION' | 'VETERINARY';
    /**
     * Multiple values may be separated by commas.
     */
    activityActivityTypeDefaultIn?: Array<(string)>;
    activityUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    activityUidIn?: Array<(string)>;
    customerUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    customerUidIn?: Array<(string)>;
    endDtGte?: string;
    endDtLte?: string;
    horseUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    horseUidIn?: Array<(string)>;
    invoiceItemUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    invoiceItemUidIn?: Array<(string)>;
    isActivity?: boolean;
    isOrderItem?: boolean;
    isServiceContract?: boolean;
    isTransactionItem?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    orderItemUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    orderItemUidIn?: Array<(string)>;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     */
    serviceContractProductPlanModule?: 'ACCOUNTING' | 'FACILITY_PLANNING' | 'FEED_AND_MEDICINE' | 'FINANCIAL_AND_PAYMENT' | 'HORSE_SERVICES_CARE' | 'HORSE_SERVICES_FULL' | 'RVO_REPORTS' | 'SHOP_AND_BREEDING' | 'USER_ACCOUNTS' | 'WORKFORCE_MANAGEMENT';
    /**
     * Multiple values may be separated by commas.
     */
    serviceContractProductPlanModuleIn?: Array<(string)>;
    serviceContractUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    serviceContractUidIn?: Array<(string)>;
    startDtGte?: string;
    startDtLte?: string;
    transactionItemUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    transactionItemUidIn?: Array<(string)>;
};

export type BillableitemsInvoicedListResponse = (PaginatedBillableItemList);

export type BillableitemsNotToInvoiceListData = {
    /**
     * * `RIDING` - Riding
     * * `PADDOCK` - Paddock
     * * `LUNGING` - Lunging
     * * `FARRIER` - Farrier
     * * `VACCINATION` - Vaccination
     * * `VETERINARY` - Veterinary
     * * `SHOW` - Show
     * * `CUSTOMER` - Customer
     * * `DEWORM` - Deworm
     * * `DENTIST` - Dentist
     * * `LESSON` - Lesson
     * * `INSEMINATION` - Insemination
     * * `FOALING` - Foaling
     * * `MARE_CYCLE_CHECK` - Mare Cycle Check
     * * `RHINO` - Rhino
     * * `STALLION_MOUNT` - Stallion Mount
     */
    activityActivityTypeDefault?: 'CUSTOMER' | 'DENTIST' | 'DEWORM' | 'FARRIER' | 'FOALING' | 'INSEMINATION' | 'LESSON' | 'LUNGING' | 'MARE_CYCLE_CHECK' | 'PADDOCK' | 'RHINO' | 'RIDING' | 'SHOW' | 'STALLION_MOUNT' | 'VACCINATION' | 'VETERINARY';
    /**
     * Multiple values may be separated by commas.
     */
    activityActivityTypeDefaultIn?: Array<(string)>;
    activityUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    activityUidIn?: Array<(string)>;
    customerUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    customerUidIn?: Array<(string)>;
    endDtGte?: string;
    endDtLte?: string;
    horseUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    horseUidIn?: Array<(string)>;
    invoiceItemUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    invoiceItemUidIn?: Array<(string)>;
    isActivity?: boolean;
    isOrderItem?: boolean;
    isServiceContract?: boolean;
    isTransactionItem?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    orderItemUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    orderItemUidIn?: Array<(string)>;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     */
    serviceContractProductPlanModule?: 'ACCOUNTING' | 'FACILITY_PLANNING' | 'FEED_AND_MEDICINE' | 'FINANCIAL_AND_PAYMENT' | 'HORSE_SERVICES_CARE' | 'HORSE_SERVICES_FULL' | 'RVO_REPORTS' | 'SHOP_AND_BREEDING' | 'USER_ACCOUNTS' | 'WORKFORCE_MANAGEMENT';
    /**
     * Multiple values may be separated by commas.
     */
    serviceContractProductPlanModuleIn?: Array<(string)>;
    serviceContractUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    serviceContractUidIn?: Array<(string)>;
    startDtGte?: string;
    startDtLte?: string;
    transactionItemUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    transactionItemUidIn?: Array<(string)>;
};

export type BillableitemsNotToInvoiceListResponse = (PaginatedBillableItemList);

export type BillableitemsToInvoiceListData = {
    /**
     * * `RIDING` - Riding
     * * `PADDOCK` - Paddock
     * * `LUNGING` - Lunging
     * * `FARRIER` - Farrier
     * * `VACCINATION` - Vaccination
     * * `VETERINARY` - Veterinary
     * * `SHOW` - Show
     * * `CUSTOMER` - Customer
     * * `DEWORM` - Deworm
     * * `DENTIST` - Dentist
     * * `LESSON` - Lesson
     * * `INSEMINATION` - Insemination
     * * `FOALING` - Foaling
     * * `MARE_CYCLE_CHECK` - Mare Cycle Check
     * * `RHINO` - Rhino
     * * `STALLION_MOUNT` - Stallion Mount
     */
    activityActivityTypeDefault?: 'CUSTOMER' | 'DENTIST' | 'DEWORM' | 'FARRIER' | 'FOALING' | 'INSEMINATION' | 'LESSON' | 'LUNGING' | 'MARE_CYCLE_CHECK' | 'PADDOCK' | 'RHINO' | 'RIDING' | 'SHOW' | 'STALLION_MOUNT' | 'VACCINATION' | 'VETERINARY';
    /**
     * Multiple values may be separated by commas.
     */
    activityActivityTypeDefaultIn?: Array<(string)>;
    activityUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    activityUidIn?: Array<(string)>;
    customerUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    customerUidIn?: Array<(string)>;
    endDtGte?: string;
    endDtLte?: string;
    horseUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    horseUidIn?: Array<(string)>;
    invoiceItemUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    invoiceItemUidIn?: Array<(string)>;
    isActivity?: boolean;
    isOrderItem?: boolean;
    isServiceContract?: boolean;
    isTransactionItem?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    orderItemUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    orderItemUidIn?: Array<(string)>;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     */
    serviceContractProductPlanModule?: 'ACCOUNTING' | 'FACILITY_PLANNING' | 'FEED_AND_MEDICINE' | 'FINANCIAL_AND_PAYMENT' | 'HORSE_SERVICES_CARE' | 'HORSE_SERVICES_FULL' | 'RVO_REPORTS' | 'SHOP_AND_BREEDING' | 'USER_ACCOUNTS' | 'WORKFORCE_MANAGEMENT';
    /**
     * Multiple values may be separated by commas.
     */
    serviceContractProductPlanModuleIn?: Array<(string)>;
    serviceContractUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    serviceContractUidIn?: Array<(string)>;
    startDtGte?: string;
    startDtLte?: string;
    transactionItemUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    transactionItemUidIn?: Array<(string)>;
};

export type BillableitemsToInvoiceListResponse = (PaginatedBillableItemList);

export type BreedingplanListData = {
    mareOrganisationUid: string;
    mareUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    mareUidIn?: Array<(string)>;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * * `KI` - KI (self-pregnancy)
     * * `ET` - ET
     * * `ICSI` - ICSI
     */
    usageType?: 'ET' | 'ICSI' | 'KI';
    /**
     * Multiple values may be separated by commas.
     */
    usageTypeIn?: Array<(string)>;
    year?: number;
    yearGt?: number;
    yearGte?: number;
    yearLt?: number;
    yearLte?: number;
};

export type BreedingplanListResponse = (PaginatedBreedingPlanList);

export type BreedingplanCreateData = {
    mareOrganisationUid: string;
    requestBody: BreedingPlan;
};

export type BreedingplanCreateResponse = (BreedingPlan);

export type BreedingplanRetrieveData = {
    mareOrganisationUid: string;
    uid: string;
};

export type BreedingplanRetrieveResponse = (BreedingPlan);

export type BreedingplanUpdateData = {
    mareOrganisationUid: string;
    requestBody: BreedingPlan;
    uid: string;
};

export type BreedingplanUpdateResponse = (BreedingPlan);

export type BreedingplanPartialUpdateData = {
    mareOrganisationUid: string;
    requestBody?: PatchedBreedingPlan;
    uid: string;
};

export type BreedingplanPartialUpdateResponse = (BreedingPlan);

export type BreedingplanDestroyData = {
    mareOrganisationUid: string;
    uid: string;
};

export type BreedingplanDestroyResponse = (void);

export type CategoriesListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
};

export type CategoriesListResponse = (Array<Category>);

export type CategoriesCreateData = {
    organisationUid: string;
    requestBody: Category;
};

export type CategoriesCreateResponse = (Category);

export type CategoriesRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type CategoriesRetrieveResponse = (Category);

export type CategoriesUpdateData = {
    organisationUid: string;
    requestBody: Category;
    uid: string;
};

export type CategoriesUpdateResponse = (Category);

export type CategoriesPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedCategory;
    uid: string;
};

export type CategoriesPartialUpdateResponse = (Category);

export type CategoriesDestroyData = {
    organisationUid: string;
    uid: string;
};

export type CategoriesDestroyResponse = (void);

export type ContactsListData = {
    hidden?: boolean;
    isDuplicate?: boolean;
    isInseminationStation?: boolean;
    isSemenCollectionStation?: boolean;
    isStable?: boolean;
    isUser?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    purchaserContact?: boolean;
    useForPicking?: boolean;
    userUid?: string;
};

export type ContactsListResponse = (PaginatedContactList);

export type ContactsCreateData = {
    organisationUid: string;
    requestBody?: ContactDetail;
};

export type ContactsCreateResponse = (ContactDetail);

export type ContactsRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type ContactsRetrieveResponse = (ContactDetail);

export type ContactsUpdateData = {
    organisationUid: string;
    requestBody?: ContactDetail;
    uid: string;
};

export type ContactsUpdateResponse = (ContactDetail);

export type ContactsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedContactDetail;
    uid: string;
};

export type ContactsPartialUpdateResponse = (ContactDetail);

export type ContactsDestroyData = {
    organisationUid: string;
    uid: string;
};

export type ContactsDestroyResponse = (void);

export type ContactsAuthorizeRvoCreateData = {
    organisationUid: string;
    uid: string;
};

export type ContactsAuthorizeRvoCreateResponse = (unknown);

export type ContactsAuthorizeRvoDestroyData = {
    organisationUid: string;
    uid: string;
};

export type ContactsAuthorizeRvoDestroyResponse = (void);

export type ContactsCheckAuthorizationRvoCreateData = {
    organisationUid: string;
    uid: string;
};

export type ContactsCheckAuthorizationRvoCreateResponse = (unknown);

export type ContactsIgnoreForDuplicatePartialUpdateData = {
    organisationUid: string;
    uid: string;
};

export type ContactsIgnoreForDuplicatePartialUpdateResponse = (unknown);

export type ContactsMergeAndUpdatePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedMergeContacts;
    uid: string;
};

export type ContactsMergeAndUpdatePartialUpdateResponse = (MergeContacts);

export type ContactsDuplicatesListData = {
    hidden?: boolean;
    isDuplicate?: boolean;
    isInseminationStation?: boolean;
    isSemenCollectionStation?: boolean;
    isStable?: boolean;
    isUser?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    purchaserContact?: boolean;
    useForPicking?: boolean;
    userUid?: string;
};

export type ContactsDuplicatesListResponse = (PaginatedContactDetailList);

export type DailynoteListData = {
    dtendGt?: string;
    dtstartLt?: string;
    executable?: boolean;
    noStable?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    stableUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    stableUidIn?: Array<(string)>;
    /**
     * Multiple values may be separated by commas.
     */
    statusIn?: Array<(string)>;
};

export type DailynoteListResponse = (Array<DailyNote>);

export type DailynoteCreateData = {
    organisationUid: string;
    requestBody: DailyNote;
};

export type DailynoteCreateResponse = (DailyNote);

export type DailynoteRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type DailynoteRetrieveResponse = (DailyNote);

export type DailynoteUpdateData = {
    organisationUid: string;
    requestBody: DailyNoteUpdate;
    uid: string;
};

export type DailynoteUpdateResponse = (DailyNoteUpdate);

export type DailynotePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedDailyNoteUpdate;
    uid: string;
};

export type DailynotePartialUpdateResponse = (DailyNoteUpdate);

export type DailynoteDeletePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedEventDestroy;
    uid: string;
};

export type DailynoteDeletePartialUpdateResponse = (unknown);

export type DailynoteSetDonePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedDailyNoteSetDoneAndUnDone;
    uid: string;
};

export type DailynoteSetDonePartialUpdateResponse = (DailyNoteSetDoneAndUnDone);

export type DailynoteSetUndonePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedDailyNoteSetDoneAndUnDone;
    uid: string;
};

export type DailynoteSetUndonePartialUpdateResponse = (DailyNoteSetDoneAndUnDone);

export type DaypartsListData = {
    organisationUid: string;
};

export type DaypartsListResponse = (Array<DayPartStartTime>);

export type DaypartsCreateData = {
    organisationUid: string;
    requestBody: DayPartStartTime;
};

export type DaypartsCreateResponse = (DayPartStartTime);

export type DaypartsRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type DaypartsRetrieveResponse = (DayPartStartTime);

export type DaypartsUpdateData = {
    organisationUid: string;
    requestBody: DayPartStartTime;
    uid: string;
};

export type DaypartsUpdateResponse = (DayPartStartTime);

export type DaypartsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedDayPartStartTime;
    uid: string;
};

export type DaypartsPartialUpdateResponse = (DayPartStartTime);

export type DaypartsDestroyData = {
    organisationUid: string;
    uid: string;
};

export type DaypartsDestroyResponse = (void);

export type EmploymentEmployeeListData = {
    all?: boolean;
    o?: string;
    organisationUid: string;
};

export type EmploymentEmployeeListResponse = (Array<Employment>);

export type EmploymentManagerListData = {
    all?: boolean;
    contactUid?: string;
    o?: string;
    organisationUid: string;
};

export type EmploymentManagerListResponse = (Array<Employment>);

export type EmploymentManagerCreateData = {
    organisationUid: string;
    requestBody: Employment;
};

export type EmploymentManagerCreateResponse = (Employment);

export type EmploymentManagerRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type EmploymentManagerRetrieveResponse = (Employment);

export type EmploymentManagerUpdateData = {
    organisationUid: string;
    requestBody: Employment;
    uid: string;
};

export type EmploymentManagerUpdateResponse = (Employment);

export type EmploymentManagerPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedEmployment;
    uid: string;
};

export type EmploymentManagerPartialUpdateResponse = (Employment);

export type EmploymentManagerDestroyData = {
    organisationUid: string;
    uid: string;
};

export type EmploymentManagerDestroyResponse = (void);

export type EventfeedsListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
};

export type EventfeedsListResponse = (Array<EventFeeds>);

export type EventfeedsCreateData = {
    organisationUid: string;
    requestBody: EventFeeds;
};

export type EventfeedsCreateResponse = (EventFeeds);

export type EventfeedsRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type EventfeedsRetrieveResponse = (EventFeeds);

export type EventfeedsUpdateData = {
    organisationUid: string;
    requestBody: EventFeeds;
    uid: string;
};

export type EventfeedsUpdateResponse = (EventFeeds);

export type EventfeedsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedEventFeeds;
    uid: string;
};

export type EventfeedsPartialUpdateResponse = (EventFeeds);

export type EventfeedsDestroyData = {
    organisationUid: string;
    uid: string;
};

export type EventfeedsDestroyResponse = (void);

export type FacilitiesListData = {
    availableFromLte?: string;
    availableToGte?: string;
    /**
     * * `TRANSPORT` - Transport
     * * `WATER_TREADMILL` - Water treadmill
     * * `INDOOR_ARENA` - Indoor arena
     * * `OUTDOOR_ARENA` - Outdoor arena
     * * `GALLOPING_TRACK` - Galloping track
     * * `LUNGING_RING` - Lunging ring
     * * `PADDOCK` - Paddock
     * * `SOLARIUM` - Solarium
     * * `JUMPING_YARD` - Jumping yard
     * * `TREADMILL` - Treadmill
     * * `VIBRATION_PLATE` - Vibration plate
     * * `PASTURES` - Pastures
     * * `WALKER` - walker
     * * `OTHER` - other
     */
    facilityType?: 'GALLOPING_TRACK' | 'INDOOR_ARENA' | 'JUMPING_YARD' | 'LUNGING_RING' | 'OTHER' | 'OUTDOOR_ARENA' | 'PADDOCK' | 'PASTURES' | 'SOLARIUM' | 'TRANSPORT' | 'TREADMILL' | 'VIBRATION_PLATE' | 'WALKER' | 'WATER_TREADMILL';
    /**
     * Multiple values may be separated by commas.
     */
    facilityTypeIn?: Array<(string)>;
    hidden?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    slotCapacityGte?: number;
    stableUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    stableUidIn?: Array<(string)>;
};

export type FacilitiesListResponse = (PaginatedFacilityList);

export type FacilitiesCreateData = {
    organisationUid: string;
    requestBody: Facility;
};

export type FacilitiesCreateResponse = (Facility);

export type FacilitiesRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type FacilitiesRetrieveResponse = (Facility);

export type FacilitiesUpdateData = {
    organisationUid: string;
    requestBody: Facility;
    uid: string;
};

export type FacilitiesUpdateResponse = (Facility);

export type FacilitiesPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedFacility;
    uid: string;
};

export type FacilitiesPartialUpdateResponse = (Facility);

export type FacilitiesDestroyData = {
    organisationUid: string;
    uid: string;
};

export type FacilitiesDestroyResponse = (void);

export type FacilitiesContactsListData = {
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
};

export type FacilitiesContactsListResponse = (PaginatedShallowContactList);

export type FacilitiesEventsListData = {
    activityActivityTypeUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    activityActivityTypeUidIn?: Array<(string)>;
    contactOrOwnerUid?: string;
    createdByUid?: string;
    dtendGt?: string;
    dtstartLt?: string;
    facilityStableUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    facilityStableUidIn?: Array<(string)>;
    facilityUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    facilityUidIn?: Array<(string)>;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
};

export type FacilitiesEventsListResponse = (PaginatedFacilityEventList);

export type FacilitiesEventsCreateData = {
    organisationUid: string;
    requestBody: FacilityEvent;
};

export type FacilitiesEventsCreateResponse = (FacilityEvent);

export type FacilitiesEventsRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type FacilitiesEventsRetrieveResponse = (FacilityEvent);

export type FacilitiesEventsUpdateData = {
    organisationUid: string;
    requestBody: FacilityEventUpdate;
    uid: string;
};

export type FacilitiesEventsUpdateResponse = (FacilityEventUpdate);

export type FacilitiesEventsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedFacilityEventUpdate;
    uid: string;
};

export type FacilitiesEventsPartialUpdateResponse = (FacilityEventUpdate);

export type FacilitiesEventsDeletePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedEventDestroy;
    uid: string;
};

export type FacilitiesEventsDeletePartialUpdateResponse = (unknown);

export type FacilitiesHorsesListData = {
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
};

export type FacilitiesHorsesListResponse = (PaginatedPublicHorseList);

export type FacilitiesMyEventsCreateData = {
    organisationUid: string;
    requestBody: MyFacilityEvent;
};

export type FacilitiesMyEventsCreateResponse = (MyFacilityEvent);

export type FacilitiesMyEventsUpdateData = {
    organisationUid: string;
    requestBody: MyFacilityEventUpdate;
    uid: string;
};

export type FacilitiesMyEventsUpdateResponse = (MyFacilityEventUpdate);

export type FacilitiesMyEventsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedMyFacilityEventUpdate;
    uid: string;
};

export type FacilitiesMyEventsPartialUpdateResponse = (MyFacilityEventUpdate);

export type FacilitiesMyEventsDeletePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedEventDestroy;
    uid: string;
};

export type FacilitiesMyEventsDeletePartialUpdateResponse = (unknown);

export type FeedingsListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    /**
     * Multiple values may be separated by commas.
     */
    uidIn?: Array<(string)>;
};

export type FeedingsListResponse = (Array<Feeding>);

export type FeedingsCreateData = {
    organisationUid: string;
    requestBody: Feeding;
};

export type FeedingsCreateResponse = (Feeding);

export type FeedingsRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type FeedingsRetrieveResponse = (Feeding);

export type FeedingsUpdateData = {
    organisationUid: string;
    requestBody: Feeding;
    uid: string;
};

export type FeedingsUpdateResponse = (Feeding);

export type FeedingsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedFeeding;
    uid: string;
};

export type FeedingsPartialUpdateResponse = (Feeding);

export type FeedingsDestroyData = {
    organisationUid: string;
    uid: string;
};

export type FeedingsDestroyResponse = (void);

export type FeedtypesListData = {
    displayNameIcontains?: string;
    hidden?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
};

export type FeedtypesListResponse = (Array<FeedType>);

export type FeedtypesCreateData = {
    organisationUid: string;
    requestBody: FeedType;
};

export type FeedtypesCreateResponse = (FeedType);

export type FeedtypesRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type FeedtypesRetrieveResponse = (FeedType);

export type FeedtypesUpdateData = {
    organisationUid: string;
    requestBody: FeedType;
    uid: string;
};

export type FeedtypesUpdateResponse = (FeedType);

export type FeedtypesPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedFeedType;
    uid: string;
};

export type FeedtypesPartialUpdateResponse = (FeedType);

export type FeedtypesDestroyData = {
    organisationUid: string;
    uid: string;
};

export type FeedtypesDestroyResponse = (void);

export type HolidayeventsListData = {
    dtend?: string;
    dtendGt?: string;
    dtstart?: string;
    dtstartLt?: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    year?: number;
};

export type HolidayeventsListResponse = (Array<HolidayEvent>);

export type HolidayeventsCreateData = {
    organisationUid: string;
    requestBody: HolidayEvent;
};

export type HolidayeventsCreateResponse = (HolidayEvent);

export type HolidayeventsRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type HolidayeventsRetrieveResponse = (HolidayEvent);

export type HolidayeventsUpdateData = {
    organisationUid: string;
    requestBody: HolidayEvent;
    uid: string;
};

export type HolidayeventsUpdateResponse = (HolidayEvent);

export type HolidayeventsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedHolidayEvent;
    uid: string;
};

export type HolidayeventsPartialUpdateResponse = (HolidayEvent);

export type HolidayeventsDestroyData = {
    organisationUid: string;
    uid: string;
};

export type HolidayeventsDestroyResponse = (void);

export type HolidayeventsCreateFromCountryTemplateCreateData = {
    organisationUid: string;
    requestBody: CountryYear;
};

export type HolidayeventsCreateFromCountryTemplateCreateResponse = (CountryYear);

export type HorsefeedsListData = {
    dtendGt?: string;
    dtstartLt?: string;
    /**
     * Multiple values may be separated by commas.
     */
    feedingUidIn?: Array<(string)>;
    /**
     * Multiple values may be separated by commas.
     */
    horseUidIn?: Array<(string)>;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * Multiple values may be separated by commas.
     */
    statusIn?: Array<(string)>;
};

export type HorsefeedsListResponse = (PaginatedFeedList);

export type HorsefeedsCreateData = {
    organisationUid: string;
    requestBody: Feed;
};

export type HorsefeedsCreateResponse = (Feed);

export type HorsefeedsRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type HorsefeedsRetrieveResponse = (Feed);

export type HorsefeedsUpdateData = {
    organisationUid: string;
    requestBody: FeedUpdate;
    uid: string;
};

export type HorsefeedsUpdateResponse = (FeedUpdate);

export type HorsefeedsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedFeedUpdate;
    uid: string;
};

export type HorsefeedsPartialUpdateResponse = (FeedUpdate);

export type HorsefeedsDeletePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedEventDestroy;
    uid: string;
};

export type HorsefeedsDeletePartialUpdateResponse = (unknown);

export type HorsegroupsListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
};

export type HorsegroupsListResponse = (Array<HorseGroup>);

export type HorsegroupsCreateData = {
    organisationUid: string;
    requestBody?: HorseGroup;
};

export type HorsegroupsCreateResponse = (HorseGroup);

export type HorsegroupsRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type HorsegroupsRetrieveResponse = (HorseGroup);

export type HorsegroupsUpdateData = {
    organisationUid: string;
    requestBody?: HorseGroup;
    uid: string;
};

export type HorsegroupsUpdateResponse = (HorseGroup);

export type HorsegroupsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedHorseGroup;
    uid: string;
};

export type HorsegroupsPartialUpdateResponse = (HorseGroup);

export type HorsegroupsDestroyData = {
    organisationUid: string;
    uid: string;
};

export type HorsegroupsDestroyResponse = (void);

export type HorselocationsListData = {
    arrivalDateGt?: string;
    arrivalDateLte?: string;
    departureDateGt?: string;
    departureDateLte?: string;
    horseOrLocationStable?: Array<(string)>;
    horseUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    horseUidIn?: Array<(string)>;
    location?: number;
    /**
     * Multiple values may be separated by commas.
     */
    locationIn?: Array<(number)>;
    locationOrganisationUid: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
};

export type HorselocationsListResponse = (PaginatedHorseLocationList);

export type HorselocationsRetrieveData = {
    locationOrganisationUid: string;
    uid: string;
};

export type HorselocationsRetrieveResponse = (HorseLocation);

export type HorselocationsUpdateData = {
    locationOrganisationUid: string;
    requestBody: HorseLocationUpdate;
    uid: string;
};

export type HorselocationsUpdateResponse = (HorseLocation);

export type HorselocationsPartialUpdateData = {
    locationOrganisationUid: string;
    requestBody?: PatchedHorseLocationUpdate;
    uid: string;
};

export type HorselocationsPartialUpdateResponse = (HorseLocation);

export type HorselocationsDestroyData = {
    locationOrganisationUid: string;
    uid: string;
};

export type HorselocationsDestroyResponse = (void);

export type HorselocationsHideArrivalCreateData = {
    locationOrganisationUid: string;
    uid: string;
};

export type HorselocationsHideArrivalCreateResponse = (unknown);

export type HorselocationsHideDepartureCreateData = {
    locationOrganisationUid: string;
    uid: string;
};

export type HorselocationsHideDepartureCreateResponse = (unknown);

export type HorselocationsMutationsWithoutReportListData = {
    arrivalDateGt?: string;
    arrivalDateLte?: string;
    departureDateGt?: string;
    departureDateLte?: string;
    horseOrLocationStable?: Array<(string)>;
    horseUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    horseUidIn?: Array<(string)>;
    location?: number;
    /**
     * Multiple values may be separated by commas.
     */
    locationIn?: Array<(number)>;
    locationOrganisationUid: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
};

export type HorselocationsMutationsWithoutReportListResponse = (PaginatedHorseLocationMutationList);

export type HorsemediaListData = {
    createdOnGte?: string;
    createdOnLte?: string;
    horseOrganisationUid: string;
    horseUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    horseUidIn?: Array<(string)>;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
};

export type HorsemediaListResponse = (PaginatedHorseMediaList);

export type HorsemediaCreateData = {
    horseOrganisationUid: string;
    requestBody: HorseMedia;
};

export type HorsemediaCreateResponse = (HorseMedia);

export type HorsemediaRetrieveData = {
    horseOrganisationUid: string;
    uid: string;
};

export type HorsemediaRetrieveResponse = (HorseMedia);

export type HorsemediaUpdateData = {
    horseOrganisationUid: string;
    requestBody: HorseMediaUpdate;
    uid: string;
};

export type HorsemediaUpdateResponse = (HorseMediaUpdate);

export type HorsemediaPartialUpdateData = {
    horseOrganisationUid: string;
    requestBody?: PatchedHorseMediaUpdate;
    uid: string;
};

export type HorsemediaPartialUpdateResponse = (HorseMediaUpdate);

export type HorsemediaDestroyData = {
    horseOrganisationUid: string;
    uid: string;
};

export type HorsemediaDestroyResponse = (void);

export type HorseownersListData = {
    contactUid?: string;
    horseOrganisationUid: string;
    horseUid?: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    ownerSinceGte?: string;
    ownerSinceLte?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
};

export type HorseownersListResponse = (PaginatedHorseOwnerList);

export type HorseownersCreateData = {
    horseOrganisationUid: string;
    requestBody: HorseOwner;
};

export type HorseownersCreateResponse = (HorseOwner);

export type HorseownersRetrieveData = {
    horseOrganisationUid: string;
    uid: string;
};

export type HorseownersRetrieveResponse = (HorseOwner);

export type HorseownersUpdateData = {
    horseOrganisationUid: string;
    requestBody: HorseOwner;
    uid: string;
};

export type HorseownersUpdateResponse = (HorseOwner);

export type HorseownersPartialUpdateData = {
    horseOrganisationUid: string;
    requestBody?: PatchedHorseOwner;
    uid: string;
};

export type HorseownersPartialUpdateResponse = (HorseOwner);

export type HorseownersDestroyData = {
    horseOrganisationUid: string;
    uid: string;
};

export type HorseownersDestroyResponse = (void);

export type HorseownersHistoryListData = {
    contactUid?: string;
    historyDateGte?: string;
    historyDateLte?: string;
    historyUserUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    historyUserUidIn?: Array<(string)>;
    horseOrganisationUid: string;
    horseUid?: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    ownerSinceGte?: string;
    ownerSinceLte?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
};

export type HorseownersHistoryListResponse = (PaginatedHorseOwnerHistoryList);

export type HorseownersHistoryRetrieveData = {
    horseOrganisationUid: string;
    uid: string;
};

export type HorseownersHistoryRetrieveResponse = (HorseOwnerHistory);

export type HorsesHorseemployabilitystatusListData = {
    horseOrganisationUid: string;
    horseUid: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
};

export type HorsesHorseemployabilitystatusListResponse = (Array<HorseEmployabilityStatus>);

export type HorsesHorseemployabilitystatusCreateData = {
    horseOrganisationUid: string;
    horseUid: string;
    requestBody: HorseEmployabilityStatus;
};

export type HorsesHorseemployabilitystatusCreateResponse = (HorseEmployabilityStatus);

export type HorsesHorseemployabilitystatusRetrieveData = {
    horseOrganisationUid: string;
    horseUid: string;
    /**
     * A unique integer value identifying this horse employability status.
     */
    id: number;
};

export type HorsesHorseemployabilitystatusRetrieveResponse = (HorseEmployabilityStatus);

export type HorsesHorsepagesCreateData = {
    horseOrganisationUid: string;
    horseUid: string;
    requestBody?: HorsePage;
};

export type HorsesHorsepagesCreateResponse = (HorsePage);

export type HorsesHorsephasestatusListData = {
    horseOrganisationUid: string;
    horseUid: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
};

export type HorsesHorsephasestatusListResponse = (Array<HorsePhaseStatus>);

export type HorsesHorsephasestatusCreateData = {
    horseOrganisationUid: string;
    horseUid: string;
    requestBody: HorsePhaseStatus;
};

export type HorsesHorsephasestatusCreateResponse = (HorsePhaseStatus);

export type HorsesHorsephasestatusRetrieveData = {
    horseOrganisationUid: string;
    horseUid: string;
    /**
     * A unique integer value identifying this horse phase status.
     */
    id: number;
};

export type HorsesHorsephasestatusRetrieveResponse = (HorsePhaseStatus);

export type HorsesListData = {
    chipNrIexact?: string;
    /**
     * Employability status
     *
     * * `1` - Full
     * * `2` - Limited for training
     * * `3` - Limited for service
     * * `4` - Limited for service and training
     * * `5` - Not employable
     */
    currentEmployabilityStatus?: Array<(1 | 2 | 3 | 4 | 5)>;
    /**
     * Phase status
     *
     * * `1` - F1
     * * `2` - F2
     * * `3` - F3
     * * `4` - F4
     * * `5` - F5
     * * `6` - Proef
     * * `7` - Les
     */
    currentPhaseStatus?: Array<(1 | 2 | 3 | 4 | 5 | 6 | 7)>;
    damIcontains?: string;
    damsireIcontains?: string;
    dateOfBirth?: string;
    /**
     * * `1` - Training
     * * `2` - youngsters
     * * `3` - mares for breeding
     * * `5` - full care
     */
    groupType?: 1 | 2 | 3 | 5;
    hasStable?: boolean;
    hidden?: boolean;
    isDuplicate?: boolean;
    isProduct?: boolean;
    nameIcontains?: string;
    nameIstartswith?: string;
    notOnLocation?: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    onLocations?: Array<(string)>;
    onUnknownLocation?: boolean;
    organisationUid: string;
    ownerUid?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    purchaserHorse?: boolean;
    /**
     * * `1` - stallion
     * * `2` - mare
     * * `3` - gelding
     */
    sex?: (1 | 2 | 3) | null;
    /**
     * Multiple values may be separated by commas.
     */
    sexIn?: Array<(number)>;
    siredamIcontains?: string;
    sireIcontains?: string;
    uelnIexact?: string;
    uid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    uidIn?: Array<(string)>;
};

export type HorsesListResponse = (PaginatedHorseList);

export type HorsesCreateData = {
    organisationUid: string;
    requestBody: HorseDetail;
};

export type HorsesCreateResponse = (HorseDetail);

export type HorsesRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type HorsesRetrieveResponse = (HorseDetail);

export type HorsesUpdateData = {
    organisationUid: string;
    requestBody: HorseDetail;
    uid: string;
};

export type HorsesUpdateResponse = (HorseDetail);

export type HorsesPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedHorseDetail;
    uid: string;
};

export type HorsesPartialUpdateResponse = (HorseDetail);

export type HorsesDestroyData = {
    organisationUid: string;
    uid: string;
};

export type HorsesDestroyResponse = (void);

export type HorsesIgnoreForDuplicatePartialUpdateData = {
    organisationUid: string;
    uid: string;
};

export type HorsesIgnoreForDuplicatePartialUpdateResponse = (unknown);

export type HorsesMergeAndUpdatePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedMergeHorses;
    uid: string;
};

export type HorsesMergeAndUpdatePartialUpdateResponse = (MergeHorses);

export type HorsesMoveCreateData = {
    organisationUid: string;
    requestBody: HorseMove;
    uid: string;
};

export type HorsesMoveCreateResponse = (HorseMoveResponse);

export type HorsesSetActiveCreateData = {
    organisationUid: string;
    uid: string;
};

export type HorsesSetActiveCreateResponse = (HorseDetail);

export type HorsesSetInactiveCreateData = {
    organisationUid: string;
    uid: string;
};

export type HorsesSetInactiveCreateResponse = (HorseDetail);

export type HorsesContactsListData = {
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
};

export type HorsesContactsListResponse = (PaginatedShallowContactList);

export type HorsesCreateGetHorsesFromRvoCreateData = {
    organisationUid: string;
};

export type HorsesCreateGetHorsesFromRvoCreateResponse = (unknown);

export type HorsesDuplicatesListData = {
    chipNrIexact?: string;
    /**
     * Employability status
     *
     * * `1` - Full
     * * `2` - Limited for training
     * * `3` - Limited for service
     * * `4` - Limited for service and training
     * * `5` - Not employable
     */
    currentEmployabilityStatus?: Array<(1 | 2 | 3 | 4 | 5)>;
    /**
     * Phase status
     *
     * * `1` - F1
     * * `2` - F2
     * * `3` - F3
     * * `4` - F4
     * * `5` - F5
     * * `6` - Proef
     * * `7` - Les
     */
    currentPhaseStatus?: Array<(1 | 2 | 3 | 4 | 5 | 6 | 7)>;
    damIcontains?: string;
    damsireIcontains?: string;
    dateOfBirth?: string;
    /**
     * * `1` - Training
     * * `2` - youngsters
     * * `3` - mares for breeding
     * * `5` - full care
     */
    groupType?: 1 | 2 | 3 | 5;
    hasStable?: boolean;
    hidden?: boolean;
    isDuplicate?: boolean;
    isProduct?: boolean;
    nameIcontains?: string;
    nameIstartswith?: string;
    notOnLocation?: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    onLocations?: Array<(string)>;
    onUnknownLocation?: boolean;
    organisationUid: string;
    ownerUid?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    purchaserHorse?: boolean;
    /**
     * * `1` - stallion
     * * `2` - mare
     * * `3` - gelding
     */
    sex?: (1 | 2 | 3) | null;
    /**
     * Multiple values may be separated by commas.
     */
    sexIn?: Array<(number)>;
    siredamIcontains?: string;
    sireIcontains?: string;
    uelnIexact?: string;
    uid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    uidIn?: Array<(string)>;
};

export type HorsesDuplicatesListResponse = (PaginatedHorseWithDuplicatesList);

export type HorsesGetHorsesFromRvoListData = {
    organisationUid: string;
};

export type HorsesGetHorsesFromRvoListResponse = (Array<LocationResponse>);

export type HorsesGetHorsesFromRvoCreateData = {
    organisationUid: string;
};

export type HorsesGetHorsesFromRvoCreateResponse = (unknown);

export type HorsesGetHorsetelexDetailCreateData = {
    organisationUid: string;
    requestBody: HorseTelexDetailInput;
};

export type HorsesGetHorsetelexDetailCreateResponse = (HorseDetailHorseTelex);

export type HorsesSearchHorseCreateData = {
    organisationUid: string;
    requestBody?: SearchHorse;
};

export type HorsesSearchHorseCreateResponse = (EquineMSearchLastPage);

export type ApiV5InvitationsListData = {
    acceptedOnIcontains?: string;
    contact?: number;
    declinedOnIcontains?: string;
    invitee?: string;
    inviter?: number;
    resendOnIcontains?: string;
    sentOnIcontains?: string;
    /**
     * status
     */
    status?: string;
};

export type ApiV5InvitationsListResponse = (Array<ReceivedInvitation>);

export type ApiV5InvitationsRetrieveData = {
    uuid: string;
};

export type ApiV5InvitationsRetrieveResponse = (ReceivedInvitation);

export type ApiV5InvitationsAcceptPartialUpdateData = {
    uuid: string;
};

export type ApiV5InvitationsAcceptPartialUpdateResponse = (unknown);

export type ApiV5InvitationsDeclinePartialUpdateData = {
    requestBody?: PatchedDeclinedInvitation;
    uuid: string;
};

export type ApiV5InvitationsDeclinePartialUpdateResponse = (DeclinedInvitation);

export type InvitationsListData = {
    acceptedOnIcontains?: string;
    contact?: number;
    declinedOnIcontains?: string;
    invitee?: string;
    inviter?: number;
    inviterOrganisationUid: string;
    resendOnIcontains?: string;
    sentOnIcontains?: string;
    /**
     * status
     */
    status?: string;
};

export type InvitationsListResponse = (Array<SentInvitation>);

export type InvitationsCreateData = {
    inviterOrganisationUid: string;
    requestBody: SentInvitation;
};

export type InvitationsCreateResponse = (SentInvitation);

export type InvitationsRetrieveData = {
    inviterOrganisationUid: string;
    uuid: string;
};

export type InvitationsRetrieveResponse = (SentInvitation);

export type InvitationsDestroyData = {
    inviterOrganisationUid: string;
    uuid: string;
};

export type InvitationsDestroyResponse = (void);

export type InvitationsResendInvitationPartialUpdateData = {
    inviterOrganisationUid: string;
    uuid: string;
};

export type InvitationsResendInvitationPartialUpdateResponse = (unknown);

export type InvoicefrombillableitemsInvoiceCreateData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    requestBody: Array<BillableItemUid>;
};

export type InvoicefrombillableitemsInvoiceCreateResponse = (Array<InMemoryInvoiceDetail>);

export type InvoicesInvoiceitemsListData = {
    invoiceOrganisationUid: string;
    invoiceUid: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
};

export type InvoicesInvoiceitemsListResponse = (Array<InvoiceItem>);

export type InvoicesInvoiceitemsCreateData = {
    invoiceOrganisationUid: string;
    invoiceUid: string;
    requestBody: InvoiceItem;
};

export type InvoicesInvoiceitemsCreateResponse = (InvoiceItem);

export type InvoicesInvoiceitemsRetrieveData = {
    invoiceOrganisationUid: string;
    invoiceUid: string;
    uid: string;
};

export type InvoicesInvoiceitemsRetrieveResponse = (InvoiceItem);

export type InvoicesInvoiceitemsUpdateData = {
    invoiceOrganisationUid: string;
    invoiceUid: string;
    requestBody: InvoiceItem;
    uid: string;
};

export type InvoicesInvoiceitemsUpdateResponse = (InvoiceItem);

export type InvoicesInvoiceitemsPartialUpdateData = {
    invoiceOrganisationUid: string;
    invoiceUid: string;
    requestBody?: PatchedInvoiceItem;
    uid: string;
};

export type InvoicesInvoiceitemsPartialUpdateResponse = (InvoiceItem);

export type InvoicesInvoiceitemsDestroyData = {
    invoiceOrganisationUid: string;
    invoiceUid: string;
    uid: string;
};

export type InvoicesInvoiceitemsDestroyResponse = (void);

export type InvoicesListData = {
    createdByUid?: string;
    createdOn?: string;
    createdOnGt?: string;
    createdOnGte?: string;
    createdOnLt?: string;
    createdOnLte?: string;
    customerCustomerId?: string;
    /**
     * Multiple values may be separated by commas.
     */
    customerCustomerIdIn?: Array<(string)>;
    customerUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    customerUidIn?: Array<(string)>;
    date?: string;
    dateGt?: string;
    dateGte?: string;
    dateLt?: string;
    dateLte?: string;
    draft?: boolean;
    endDateActivities?: string;
    endDateActivitiesGt?: string;
    endDateActivitiesGte?: string;
    endDateActivitiesLt?: string;
    endDateActivitiesLte?: string;
    endDateServices?: string;
    endDateServicesGt?: string;
    endDateServicesGte?: string;
    endDateServicesLt?: string;
    endDateServicesLte?: string;
    exactnlInvoiceId?: string;
    expirationDate?: string;
    expirationDateGt?: string;
    expirationDateGte?: string;
    expirationDateLt?: string;
    expirationDateLte?: string;
    finalizedOn?: string;
    finalizedOnGt?: string;
    finalizedOnGte?: string;
    finalizedOnLt?: string;
    finalizedOnLte?: string;
    invoiceNo?: string;
    lastModifiedOn?: string;
    lastModifiedOnGt?: string;
    lastModifiedOnGte?: string;
    lastModifiedOnLt?: string;
    lastModifiedOnLte?: string;
    moneybirdInvoiceId?: number;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    orderUid?: string;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * * `OPEN` - Open
     * * `PAID` - Paid
     * * `FAILED` - Failed
     */
    paymentStatus?: 'FAILED' | 'OPEN' | 'PAID';
    /**
     * Multiple values may be separated by commas.
     */
    paymentStatusIn?: Array<(string)>;
    sent?: boolean;
    sentToExactnl?: boolean;
    sentToMoneybird?: boolean;
    sentToSnelstart?: boolean;
    sentToYuki?: boolean;
    startDateActivities?: string;
    startDateActivitiesGt?: string;
    startDateActivitiesGte?: string;
    startDateActivitiesLt?: string;
    startDateActivitiesLte?: string;
    startDateServices?: string;
    startDateServicesGt?: string;
    startDateServicesGte?: string;
    startDateServicesLt?: string;
    startDateServicesLte?: string;
    supplierUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    supplierUidIn?: Array<(string)>;
    yukiInvoiceId?: string;
};

export type InvoicesListResponse = (PaginatedInvoiceList);

export type InvoicesCreateData = {
    organisationUid: string;
    requestBody: InvoiceDetail;
};

export type InvoicesCreateResponse = (InvoiceDetail);

export type InvoicesRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type InvoicesRetrieveResponse = (InvoiceDetail);

export type InvoicesUpdateData = {
    organisationUid: string;
    requestBody: InvoiceDetail;
    uid: string;
};

export type InvoicesUpdateResponse = (InvoiceDetail);

export type InvoicesPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedInvoiceDetail;
    uid: string;
};

export type InvoicesPartialUpdateResponse = (InvoiceDetail);

export type InvoicesDestroyData = {
    organisationUid: string;
    uid: string;
};

export type InvoicesDestroyResponse = (void);

export type InvoicesFinalizeCreateData = {
    organisationUid: string;
    requestBody?: InvoiceFinalize;
    uid: string;
};

export type InvoicesFinalizeCreateResponse = (InvoiceFinalize);

export type InvoicesRemoveLinkWithAccountingSoftwareCreateData = {
    organisationUid: string;
    uid: string;
};

export type InvoicesRemoveLinkWithAccountingSoftwareCreateResponse = (unknown);

export type InvoicesSendToAccountingSoftwareCreateData = {
    organisationUid: string;
    uid: string;
};

export type InvoicesSendToAccountingSoftwareCreateResponse = (unknown);

export type InvoicesSendToClientRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type InvoicesSendToClientRetrieveResponse = (BackGroundTask);

export type InvoicesSendToClientCreateData = {
    organisationUid: string;
    uid: string;
};

export type InvoicesSendToClientCreateResponse = (unknown);

export type InvoicesSendToClientCreateCreateData = {
    organisationUid: string;
    uid: string;
};

export type InvoicesSendToClientCreateCreateResponse = (unknown);

export type InvoicesUnfinalizeCreateData = {
    organisationUid: string;
    uid: string;
};

export type InvoicesUnfinalizeCreateResponse = (unknown);

export type LeaveMutationListData = {
    contactUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    contactUidIn?: Array<(string)>;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
};

export type LeaveMutationListResponse = (Array<LeaveAllowanceMutation>);

export type LeaveMutationCreateData = {
    organisationUid: string;
    requestBody: LeaveAllowanceMutation;
};

export type LeaveMutationCreateResponse = (LeaveAllowanceMutation);

export type LeaveMutationRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type LeaveMutationRetrieveResponse = (LeaveAllowanceMutation);

export type LeaveMutationUpdateData = {
    organisationUid: string;
    requestBody: LeaveAllowanceMutation;
    uid: string;
};

export type LeaveMutationUpdateResponse = (LeaveAllowanceMutation);

export type LeaveMutationPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedLeaveAllowanceMutation;
    uid: string;
};

export type LeaveMutationPartialUpdateResponse = (LeaveAllowanceMutation);

export type LeaveMutationDestroyData = {
    organisationUid: string;
    uid: string;
};

export type LeaveMutationDestroyResponse = (void);

export type ManureFertilizerConsumersListData = {
    contactOrganisationUid: string;
    contactUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    contactUidIn?: Array<(string)>;
    /**
     * * `ANIMAL_NITROGEN` - nitrogen from animals
     * * `TOTAL_NITROGEN` - total nitrogen
     * * `TOTAL_PHOSPHATE` - total phosphate
     */
    fertilizerBudgetType?: 'ANIMAL_NITROGEN' | 'TOTAL_NITROGEN' | 'TOTAL_PHOSPHATE';
    /**
     * Multiple values may be separated by commas.
     */
    fertilizerBudgetTypeIn?: Array<(string)>;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    year?: number;
};

export type ManureFertilizerConsumersListResponse = (PaginatedFertilizerConsumerList);

export type ManureFertilizerConsumersCreateData = {
    contactOrganisationUid: string;
    requestBody: FertilizerConsumer;
};

export type ManureFertilizerConsumersCreateResponse = (FertilizerConsumer);

export type ManureFertilizerConsumersRetrieveData = {
    contactOrganisationUid: string;
    uid: string;
};

export type ManureFertilizerConsumersRetrieveResponse = (FertilizerConsumer);

export type ManureFertilizerConsumersUpdateData = {
    contactOrganisationUid: string;
    requestBody: FertilizerConsumer;
    uid: string;
};

export type ManureFertilizerConsumersUpdateResponse = (FertilizerConsumer);

export type ManureFertilizerConsumersPartialUpdateData = {
    contactOrganisationUid: string;
    requestBody?: PatchedFertilizerConsumer;
    uid: string;
};

export type ManureFertilizerConsumersPartialUpdateResponse = (FertilizerConsumer);

export type ManureFertilizerConsumersDestroyData = {
    contactOrganisationUid: string;
    uid: string;
};

export type ManureFertilizerConsumersDestroyResponse = (void);

export type ManureFertilizerProducersBalanceListData = {
    contactOrganisationUid: string;
    contactUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    contactUidIn?: Array<(string)>;
    /**
     * indicate the type of this fertilizer or where it originated from
     *
     * * `ANIMAL_MANURE_SUPPLY` - animal manure supply
     * * `MILK_PRODUCING_COWS` - milk producing cows
     * * `GRAZING_ANIMALS` - grazing animals
     * * `EQUINEM_HORSES` - equinem horses
     * * `STABLE_ANIMALS_FEED` - stable animals feed
     * * `OTHER_ORGANIC_SUPPLY` - other organic supply
     * * `ANORGANIC_SUPPLY` - anorganic supply
     */
    fertilizerOrigin?: 'ANIMAL_MANURE_SUPPLY' | 'ANORGANIC_SUPPLY' | 'EQUINEM_HORSES' | 'GRAZING_ANIMALS' | 'MILK_PRODUCING_COWS' | 'OTHER_ORGANIC_SUPPLY' | 'STABLE_ANIMALS_FEED';
    /**
     * Multiple values may be separated by commas.
     */
    fertilizerOriginIn?: Array<(string)>;
    /**
     * End amounts and Exports are subtractions on the balance, the others are additions
     *
     * * `BEGIN_AMOUNT` - begin amount
     * * `IMPORT` - import
     * * `PRODUCTION` - production
     * * `EXPORT` - export
     * * `END_AMOUNT` - end amount
     */
    mutationType?: 'BEGIN_AMOUNT' | 'END_AMOUNT' | 'EXPORT' | 'IMPORT' | 'PRODUCTION';
    /**
     * Multiple values may be separated by commas.
     */
    mutationTypeIn?: Array<(string)>;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    year?: number;
};

export type ManureFertilizerProducersBalanceListResponse = (PaginatedProductionBalanceItemList);

export type ManureFertilizerProducersBalanceCreateData = {
    contactOrganisationUid: string;
    requestBody: ProductionBalanceItem;
};

export type ManureFertilizerProducersBalanceCreateResponse = (ProductionBalanceItem);

export type ManureFertilizerProducersBalanceRetrieveData = {
    contactOrganisationUid: string;
    uid: string;
};

export type ManureFertilizerProducersBalanceRetrieveResponse = (ProductionBalanceItem);

export type ManureFertilizerProducersBalanceUpdateData = {
    contactOrganisationUid: string;
    requestBody: ProductionBalanceItem;
    uid: string;
};

export type ManureFertilizerProducersBalanceUpdateResponse = (ProductionBalanceItem);

export type ManureFertilizerProducersBalancePartialUpdateData = {
    contactOrganisationUid: string;
    requestBody?: PatchedProductionBalanceItem;
    uid: string;
};

export type ManureFertilizerProducersBalancePartialUpdateResponse = (ProductionBalanceItem);

export type ManureFertilizerProducersBalanceDestroyData = {
    contactOrganisationUid: string;
    uid: string;
};

export type ManureFertilizerProducersBalanceDestroyResponse = (void);

export type ManureFertilizerProducersEffectiveNitrogenListData = {
    contactOrganisationUid: string;
    contactUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    contactUidIn?: Array<(string)>;
    isAnimalManure?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    year?: number;
};

export type ManureFertilizerProducersEffectiveNitrogenListResponse = (PaginatedNitrogenApplicationList);

export type ManureFertilizerProducersEffectiveNitrogenCreateData = {
    contactOrganisationUid: string;
    requestBody: NitrogenApplication;
};

export type ManureFertilizerProducersEffectiveNitrogenCreateResponse = (NitrogenApplication);

export type ManureFertilizerProducersEffectiveNitrogenRetrieveData = {
    contactOrganisationUid: string;
    uid: string;
};

export type ManureFertilizerProducersEffectiveNitrogenRetrieveResponse = (NitrogenApplication);

export type ManureFertilizerProducersEffectiveNitrogenUpdateData = {
    contactOrganisationUid: string;
    requestBody: NitrogenApplication;
    uid: string;
};

export type ManureFertilizerProducersEffectiveNitrogenUpdateResponse = (NitrogenApplication);

export type ManureFertilizerProducersEffectiveNitrogenPartialUpdateData = {
    contactOrganisationUid: string;
    requestBody?: PatchedNitrogenApplication;
    uid: string;
};

export type ManureFertilizerProducersEffectiveNitrogenPartialUpdateResponse = (NitrogenApplication);

export type ManureFertilizerProducersEffectiveNitrogenDestroyData = {
    contactOrganisationUid: string;
    uid: string;
};

export type ManureFertilizerProducersEffectiveNitrogenDestroyResponse = (void);

export type ManureStableHistoricHorseCountContactRetrieveData = {
    organisationUid: string;
    uid: string;
    year: string;
};

export type ManureStableHistoricHorseCountContactRetrieveResponse = (AveragedHistoricHorseCount);

export type MapsListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
};

export type MapsListResponse = (Array<Map>);

export type MapsCreateData = {
    organisationUid: string;
    requestBody: Map;
};

export type MapsCreateResponse = (Map);

export type MapsRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type MapsRetrieveResponse = (Map);

export type MapsUpdateData = {
    organisationUid: string;
    requestBody: Map;
    uid: string;
};

export type MapsUpdateResponse = (Map);

export type MapsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedMap;
    uid: string;
};

export type MapsPartialUpdateResponse = (Map);

export type MapsDestroyData = {
    organisationUid: string;
    uid: string;
};

export type MapsDestroyResponse = (void);

export type MarecyclecheckListData = {
    activityOrderItemUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    activityOrderItemUidIn?: Array<(string)>;
    date?: string;
    dateGt?: string;
    dateGte?: string;
    dateLt?: string;
    dateLte?: string;
    mareOrganisationUid: string;
    mareUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    mareUidIn?: Array<(string)>;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
};

export type MarecyclecheckListResponse = (PaginatedMareCycleCheckList);

export type MarecyclecheckCreateData = {
    mareOrganisationUid: string;
    requestBody: MareCycleCheck;
};

export type MarecyclecheckCreateResponse = (MareCycleCheck);

export type MarecyclecheckRetrieveData = {
    mareOrganisationUid: string;
    uid: string;
};

export type MarecyclecheckRetrieveResponse = (MareCycleCheck);

export type MarecyclecheckUpdateData = {
    mareOrganisationUid: string;
    requestBody: MareCycleCheck;
    uid: string;
};

export type MarecyclecheckUpdateResponse = (MareCycleCheck);

export type MarecyclecheckPartialUpdateData = {
    mareOrganisationUid: string;
    requestBody?: PatchedMareCycleCheck;
    uid: string;
};

export type MarecyclecheckPartialUpdateResponse = (MareCycleCheck);

export type MarecyclecheckDestroyData = {
    mareOrganisationUid: string;
    uid: string;
};

export type MarecyclecheckDestroyResponse = (void);

export type ApiV5AuthorizeRetrieveData = {
    provider: string;
};

export type ApiV5AuthorizeCreateData = {
    provider: string;
    requestBody?: Authorize;
};

export type ApiV5OauthLoginCreateData = {
    requestBody: OrganisationOAuth;
};

export type ApiV5OauthLoginCreateResponse = (Redirect);

export type OauthTokensListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
};

export type OauthTokensListResponse = (Array<OAuth2Token>);

export type OauthTokensRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type OauthTokensRetrieveResponse = (OAuth2Token);

export type OauthTokensDestroyData = {
    organisationUid: string;
    uid: string;
};

export type OauthTokensDestroyResponse = (void);

export type OrdersSuppliedSemenorderitemsPickstallionmountsCreateData = {
    orderSupplierUid: string;
    orderUid: string;
    requestBody: OrderItemStallionMountPicker;
    uid: string;
};

export type OrdersSuppliedSemenorderitemsPickstallionmountsCreateResponse = (OrderItemStallionMountPicker);

export type OrdersSuppliedSemenorderitemsUnpickstallionmountsDestroyData = {
    orderSupplierUid: string;
    orderUid: string;
    uid: string;
};

export type OrdersSuppliedSemenorderitemsUnpickstallionmountsDestroyResponse = (void);

export type OrdersPurchasedListData = {
    breedingPlanUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    breedingPlanUidIn?: Array<(string)>;
    number?: string;
    /**
     * Multiple values may be separated by commas.
     */
    numberIn?: Array<(string)>;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    orderitemMareUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    orderitemMareUidIn?: Array<(string)>;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * * `OPEN` - Open
     * * `PAID` - Paid
     * * `FAILED` - Failed
     */
    paymentStatus?: 'FAILED' | 'OPEN' | 'PAID';
    /**
     * Multiple values may be separated by commas.
     */
    paymentStatusIn?: Array<(string)>;
    purchaserUid: string;
    shippingDate?: string;
    shippingDateGt?: string;
    shippingDateGte?: string;
    shippingDateLt?: string;
    shippingDateLte?: string;
    supplierPublicAccessUuid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    supplierPublicAccessUuidIn?: Array<(string)>;
    uid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    uidIn?: Array<(string)>;
};

export type OrdersPurchasedListResponse = (PaginatedPurchaserOrderList);

export type OrdersPurchasedCreateData = {
    purchaserUid: string;
    requestBody: PurchaserOrderDetail;
};

export type OrdersPurchasedCreateResponse = (PurchaserOrderDetail);

export type OrdersPurchasedRetrieveData = {
    purchaserUid: string;
    uid: string;
};

export type OrdersPurchasedRetrieveResponse = (PurchaserOrderDetail);

export type OrdersPurchasedUpdateData = {
    purchaserUid: string;
    requestBody: PurchaserOrderUpdate;
    uid: string;
};

export type OrdersPurchasedUpdateResponse = (PurchaserOrderUpdate);

export type OrdersPurchasedPartialUpdateData = {
    purchaserUid: string;
    requestBody?: PatchedPurchaserOrderUpdate;
    uid: string;
};

export type OrdersPurchasedPartialUpdateResponse = (PurchaserOrderUpdate);

export type OrdersPurchasedFindParentSemenOrdersCreateData = {
    purchaserUid: string;
    requestBody: FindParentSemenOrderItemPurchaser;
};

export type OrdersPurchasedFindParentSemenOrdersCreateResponse = (Array<PurchaserOrderDetail>);

export type OrdersSuppliedListData = {
    breedingPlanUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    breedingPlanUidIn?: Array<(string)>;
    createdOnAfter?: string;
    createdOnBefore?: string;
    customerCustomerId?: string;
    /**
     * Multiple values may be separated by commas.
     */
    customerCustomerIdIn?: Array<(string)>;
    customerUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    customerUidIn?: Array<(string)>;
    hasExclusivelySubscriptionItems?: boolean;
    hasSubscriptionItems?: boolean;
    inseminatorUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    inseminatorUidIn?: Array<(string)>;
    isComplete?: boolean;
    /**
     * The order is picked when it has no pickable (default or breeding type) order items left without a 'picked_on' value.
     *
     * * `YES` - yes
     * * `NO` - no
     * * `NO_PICKING_NEEDED` - n/a
     */
    isPicked?: Array<('NO' | 'NO_PICKING_NEEDED' | 'YES')>;
    number?: string;
    /**
     * Multiple values may be separated by commas.
     */
    numberIn?: Array<(string)>;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    orderitemMareUidAnd?: Array<(string)>;
    /**
     * Every order item needs a product type. This is used in the business logic to identify the type of the order item.
     *
     * * `HEALTH_CERTIFICATE` - health certificate
     * * `BREEDING_ADMINISTRATION` - breeding administration
     * * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     * * `ACTIVITY` - Activity
     */
    orderitemProductTypeAnd?: Array<('' | 'ACTIVITY' | 'BREEDING' | 'BREEDING_ADMINISTRATION' | 'HEALTH_CERTIFICATE' | 'SHIPPING' | 'SUBSCRIPTION')>;
    orderitemProductUidAnd?: Array<(string)>;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * * `OPEN` - Open
     * * `PAID` - Paid
     * * `FAILED` - Failed
     */
    paymentStatus?: 'FAILED' | 'OPEN' | 'PAID';
    /**
     * Multiple values may be separated by commas.
     */
    paymentStatusIn?: Array<(string)>;
    q?: string;
    requesterUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    requesterUidIn?: Array<(string)>;
    /**
     * semen_collection_station
     */
    semenCollectionStationUidAnd?: Array<(string)>;
    shippingAddressLine1?: string;
    /**
     * Multiple values may be separated by commas.
     */
    shippingAddressLine1In?: Array<(string)>;
    shippingAddressLine2?: string;
    /**
     * Multiple values may be separated by commas.
     */
    shippingAddressLine2In?: Array<(string)>;
    shippingAddressLine3?: string;
    /**
     * Multiple values may be separated by commas.
     */
    shippingAddressLine3In?: Array<(string)>;
    shippingCity?: string;
    /**
     * Multiple values may be separated by commas.
     */
    shippingCityIn?: Array<(string)>;
    /**
     * * `AF` - Afghanistan
     * * `AX` - Åland Islands
     * * `AL` - Albania
     * * `DZ` - Algeria
     * * `AS` - American Samoa
     * * `AD` - Andorra
     * * `AO` - Angola
     * * `AI` - Anguilla
     * * `AQ` - Antarctica
     * * `AG` - Antigua and Barbuda
     * * `AR` - Argentina
     * * `AM` - Armenia
     * * `AW` - Aruba
     * * `AU` - Australia
     * * `AT` - Austria
     * * `AZ` - Azerbaijan
     * * `BS` - Bahamas
     * * `BH` - Bahrain
     * * `BD` - Bangladesh
     * * `BB` - Barbados
     * * `BY` - Belarus
     * * `BE` - Belgium
     * * `BZ` - Belize
     * * `BJ` - Benin
     * * `BM` - Bermuda
     * * `BT` - Bhutan
     * * `BO` - Bolivia
     * * `BQ` - Bonaire, Sint Eustatius and Saba
     * * `BA` - Bosnia and Herzegovina
     * * `BW` - Botswana
     * * `BV` - Bouvet Island
     * * `BR` - Brazil
     * * `IO` - British Indian Ocean Territory
     * * `BN` - Brunei
     * * `BG` - Bulgaria
     * * `BF` - Burkina Faso
     * * `BI` - Burundi
     * * `CV` - Cabo Verde
     * * `KH` - Cambodia
     * * `CM` - Cameroon
     * * `CA` - Canada
     * * `KY` - Cayman Islands
     * * `CF` - Central African Republic
     * * `TD` - Chad
     * * `CL` - Chile
     * * `CN` - China
     * * `CX` - Christmas Island
     * * `CC` - Cocos (Keeling) Islands
     * * `CO` - Colombia
     * * `KM` - Comoros
     * * `CG` - Congo
     * * `CD` - Congo (the Democratic Republic of the)
     * * `CK` - Cook Islands
     * * `CR` - Costa Rica
     * * `CI` - Côte d'Ivoire
     * * `HR` - Croatia
     * * `CU` - Cuba
     * * `CW` - Curaçao
     * * `CY` - Cyprus
     * * `CZ` - Czechia
     * * `DK` - Denmark
     * * `DJ` - Djibouti
     * * `DM` - Dominica
     * * `DO` - Dominican Republic
     * * `EC` - Ecuador
     * * `EG` - Egypt
     * * `SV` - El Salvador
     * * `GQ` - Equatorial Guinea
     * * `ER` - Eritrea
     * * `EE` - Estonia
     * * `SZ` - Eswatini
     * * `ET` - Ethiopia
     * * `FK` - Falkland Islands (Malvinas)
     * * `FO` - Faroe Islands
     * * `FJ` - Fiji
     * * `FI` - Finland
     * * `FR` - France
     * * `GF` - French Guiana
     * * `PF` - French Polynesia
     * * `TF` - French Southern Territories
     * * `GA` - Gabon
     * * `GM` - Gambia
     * * `GE` - Georgia
     * * `DE` - Germany
     * * `GH` - Ghana
     * * `GI` - Gibraltar
     * * `GR` - Greece
     * * `GL` - Greenland
     * * `GD` - Grenada
     * * `GP` - Guadeloupe
     * * `GU` - Guam
     * * `GT` - Guatemala
     * * `GG` - Guernsey
     * * `GN` - Guinea
     * * `GW` - Guinea-Bissau
     * * `GY` - Guyana
     * * `HT` - Haiti
     * * `HM` - Heard Island and McDonald Islands
     * * `VA` - Holy See
     * * `HN` - Honduras
     * * `HK` - Hong Kong
     * * `HU` - Hungary
     * * `IS` - Iceland
     * * `IN` - India
     * * `ID` - Indonesia
     * * `IR` - Iran
     * * `IQ` - Iraq
     * * `IE` - Ireland
     * * `IM` - Isle of Man
     * * `IL` - Israel
     * * `IT` - Italy
     * * `JM` - Jamaica
     * * `JP` - Japan
     * * `JE` - Jersey
     * * `JO` - Jordan
     * * `KZ` - Kazakhstan
     * * `KE` - Kenya
     * * `KI` - Kiribati
     * * `KW` - Kuwait
     * * `KG` - Kyrgyzstan
     * * `LA` - Laos
     * * `LV` - Latvia
     * * `LB` - Lebanon
     * * `LS` - Lesotho
     * * `LR` - Liberia
     * * `LY` - Libya
     * * `LI` - Liechtenstein
     * * `LT` - Lithuania
     * * `LU` - Luxembourg
     * * `MO` - Macao
     * * `MG` - Madagascar
     * * `MW` - Malawi
     * * `MY` - Malaysia
     * * `MV` - Maldives
     * * `ML` - Mali
     * * `MT` - Malta
     * * `MH` - Marshall Islands
     * * `MQ` - Martinique
     * * `MR` - Mauritania
     * * `MU` - Mauritius
     * * `YT` - Mayotte
     * * `MX` - Mexico
     * * `FM` - Micronesia
     * * `MD` - Moldova
     * * `MC` - Monaco
     * * `MN` - Mongolia
     * * `ME` - Montenegro
     * * `MS` - Montserrat
     * * `MA` - Morocco
     * * `MZ` - Mozambique
     * * `MM` - Myanmar
     * * `NA` - Namibia
     * * `NR` - Nauru
     * * `NP` - Nepal
     * * `NL` - Netherlands
     * * `NC` - New Caledonia
     * * `NZ` - New Zealand
     * * `NI` - Nicaragua
     * * `NE` - Niger
     * * `NG` - Nigeria
     * * `NU` - Niue
     * * `NF` - Norfolk Island
     * * `KP` - North Korea
     * * `MK` - North Macedonia
     * * `MP` - Northern Mariana Islands
     * * `NO` - Norway
     * * `OM` - Oman
     * * `PK` - Pakistan
     * * `PW` - Palau
     * * `PS` - Palestine, State of
     * * `PA` - Panama
     * * `PG` - Papua New Guinea
     * * `PY` - Paraguay
     * * `PE` - Peru
     * * `PH` - Philippines
     * * `PN` - Pitcairn
     * * `PL` - Poland
     * * `PT` - Portugal
     * * `PR` - Puerto Rico
     * * `QA` - Qatar
     * * `RE` - Réunion
     * * `RO` - Romania
     * * `RU` - Russia
     * * `RW` - Rwanda
     * * `BL` - Saint Barthélemy
     * * `SH` - Saint Helena, Ascension and Tristan da Cunha
     * * `KN` - Saint Kitts and Nevis
     * * `LC` - Saint Lucia
     * * `MF` - Saint Martin (French part)
     * * `PM` - Saint Pierre and Miquelon
     * * `VC` - Saint Vincent and the Grenadines
     * * `WS` - Samoa
     * * `SM` - San Marino
     * * `ST` - Sao Tome and Principe
     * * `SA` - Saudi Arabia
     * * `SN` - Senegal
     * * `RS` - Serbia
     * * `SC` - Seychelles
     * * `SL` - Sierra Leone
     * * `SG` - Singapore
     * * `SX` - Sint Maarten (Dutch part)
     * * `SK` - Slovakia
     * * `SI` - Slovenia
     * * `SB` - Solomon Islands
     * * `SO` - Somalia
     * * `ZA` - South Africa
     * * `GS` - South Georgia and the South Sandwich Islands
     * * `KR` - South Korea
     * * `SS` - South Sudan
     * * `ES` - Spain
     * * `LK` - Sri Lanka
     * * `SD` - Sudan
     * * `SR` - Suriname
     * * `SJ` - Svalbard and Jan Mayen
     * * `SE` - Sweden
     * * `CH` - Switzerland
     * * `SY` - Syria
     * * `TW` - Taiwan
     * * `TJ` - Tajikistan
     * * `TZ` - Tanzania
     * * `TH` - Thailand
     * * `TL` - Timor-Leste
     * * `TG` - Togo
     * * `TK` - Tokelau
     * * `TO` - Tonga
     * * `TT` - Trinidad and Tobago
     * * `TN` - Tunisia
     * * `TR` - Türkiye
     * * `TM` - Turkmenistan
     * * `TC` - Turks and Caicos Islands
     * * `TV` - Tuvalu
     * * `UG` - Uganda
     * * `UA` - Ukraine
     * * `AE` - United Arab Emirates
     * * `GB` - United Kingdom
     * * `UM` - United States Minor Outlying Islands
     * * `US` - United States of America
     * * `UY` - Uruguay
     * * `UZ` - Uzbekistan
     * * `VU` - Vanuatu
     * * `VE` - Venezuela
     * * `VN` - Vietnam
     * * `VG` - Virgin Islands (British)
     * * `VI` - Virgin Islands (U.S.)
     * * `WF` - Wallis and Futuna
     * * `EH` - Western Sahara
     * * `YE` - Yemen
     * * `ZM` - Zambia
     * * `ZW` - Zimbabwe
     */
    shippingCountry?: 'AD' | 'AE' | 'AF' | 'AG' | 'AI' | 'AL' | 'AM' | 'AO' | 'AQ' | 'AR' | 'AS' | 'AT' | 'AU' | 'AW' | 'AX' | 'AZ' | 'BA' | 'BB' | 'BD' | 'BE' | 'BF' | 'BG' | 'BH' | 'BI' | 'BJ' | 'BL' | 'BM' | 'BN' | 'BO' | 'BQ' | 'BR' | 'BS' | 'BT' | 'BV' | 'BW' | 'BY' | 'BZ' | 'CA' | 'CC' | 'CD' | 'CF' | 'CG' | 'CH' | 'CI' | 'CK' | 'CL' | 'CM' | 'CN' | 'CO' | 'CR' | 'CU' | 'CV' | 'CW' | 'CX' | 'CY' | 'CZ' | 'DE' | 'DJ' | 'DK' | 'DM' | 'DO' | 'DZ' | 'EC' | 'EE' | 'EG' | 'EH' | 'ER' | 'ES' | 'ET' | 'FI' | 'FJ' | 'FK' | 'FM' | 'FO' | 'FR' | 'GA' | 'GB' | 'GD' | 'GE' | 'GF' | 'GG' | 'GH' | 'GI' | 'GL' | 'GM' | 'GN' | 'GP' | 'GQ' | 'GR' | 'GS' | 'GT' | 'GU' | 'GW' | 'GY' | 'HK' | 'HM' | 'HN' | 'HR' | 'HT' | 'HU' | 'ID' | 'IE' | 'IL' | 'IM' | 'IN' | 'IO' | 'IQ' | 'IR' | 'IS' | 'IT' | 'JE' | 'JM' | 'JO' | 'JP' | 'KE' | 'KG' | 'KH' | 'KI' | 'KM' | 'KN' | 'KP' | 'KR' | 'KW' | 'KY' | 'KZ' | 'LA' | 'LB' | 'LC' | 'LI' | 'LK' | 'LR' | 'LS' | 'LT' | 'LU' | 'LV' | 'LY' | 'MA' | 'MC' | 'MD' | 'ME' | 'MF' | 'MG' | 'MH' | 'MK' | 'ML' | 'MM' | 'MN' | 'MO' | 'MP' | 'MQ' | 'MR' | 'MS' | 'MT' | 'MU' | 'MV' | 'MW' | 'MX' | 'MY' | 'MZ' | 'NA' | 'NC' | 'NE' | 'NF' | 'NG' | 'NI' | 'NL' | 'NO' | 'NP' | 'NR' | 'NU' | 'NZ' | 'OM' | 'PA' | 'PE' | 'PF' | 'PG' | 'PH' | 'PK' | 'PL' | 'PM' | 'PN' | 'PR' | 'PS' | 'PT' | 'PW' | 'PY' | 'QA' | 'RE' | 'RO' | 'RS' | 'RU' | 'RW' | 'SA' | 'SB' | 'SC' | 'SD' | 'SE' | 'SG' | 'SH' | 'SI' | 'SJ' | 'SK' | 'SL' | 'SM' | 'SN' | 'SO' | 'SR' | 'SS' | 'ST' | 'SV' | 'SX' | 'SY' | 'SZ' | 'TC' | 'TD' | 'TF' | 'TG' | 'TH' | 'TJ' | 'TK' | 'TL' | 'TM' | 'TN' | 'TO' | 'TR' | 'TT' | 'TV' | 'TW' | 'TZ' | 'UA' | 'UG' | 'UM' | 'US' | 'UY' | 'UZ' | 'VA' | 'VC' | 'VE' | 'VG' | 'VI' | 'VN' | 'VU' | 'WF' | 'WS' | 'YE' | 'YT' | 'ZA' | 'ZM' | 'ZW';
    /**
     * Multiple values may be separated by commas.
     */
    shippingCountryIn?: Array<(string)>;
    shippingDate?: string;
    shippingDateGt?: string;
    shippingDateGte?: string;
    shippingDateLt?: string;
    shippingDateLte?: string;
    shippingName?: string;
    /**
     * Multiple values may be separated by commas.
     */
    shippingNameIn?: Array<(string)>;
    shippingPostcode?: string;
    /**
     * Multiple values may be separated by commas.
     */
    shippingPostcodeIn?: Array<(string)>;
    shippingSearchText?: string;
    /**
     * Multiple values may be separated by commas.
     */
    shippingSearchTextIn?: Array<(string)>;
    shippingState?: string;
    /**
     * Multiple values may be separated by commas.
     */
    shippingStateIn?: Array<(string)>;
    /**
     * The order has a shipping order item that should be shown on the insemination route.
     */
    showShippingOnInseminationRoute?: boolean;
    supplierUid: string;
    uid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    uidIn?: Array<(string)>;
};

export type OrdersSuppliedListResponse = (PaginatedSupplierOrderList);

export type OrdersSuppliedCreateData = {
    requestBody?: SupplierOrderDetail;
    supplierUid: string;
};

export type OrdersSuppliedCreateResponse = (SupplierOrderDetail);

export type OrdersSuppliedRetrieveData = {
    supplierUid: string;
    uid: string;
};

export type OrdersSuppliedRetrieveResponse = (SupplierOrderDetail);

export type OrdersSuppliedUpdateData = {
    requestBody?: SupplierOrderDetail;
    supplierUid: string;
    uid: string;
};

export type OrdersSuppliedUpdateResponse = (SupplierOrderDetail);

export type OrdersSuppliedPartialUpdateData = {
    requestBody?: PatchedSupplierOrderDetail;
    supplierUid: string;
    uid: string;
};

export type OrdersSuppliedPartialUpdateResponse = (SupplierOrderDetail);

export type OrdersSuppliedDestroyData = {
    supplierUid: string;
    uid: string;
};

export type OrdersSuppliedDestroyResponse = (void);

export type OrdersSuppliedUpdateCustomerContactPartialUpdateData = {
    requestBody?: PatchedSupplierOrderDetail;
    supplierUid: string;
    uid: string;
};

export type OrdersSuppliedUpdateCustomerContactPartialUpdateResponse = (SupplierOrderDetail);

export type OrdersSuppliedFindParentSemenOrdersCreateData = {
    requestBody: FindParentSemenOrderItem;
    supplierUid: string;
};

export type OrdersSuppliedFindParentSemenOrdersCreateResponse = (Array<SupplierOrderDetail>);

export type RootListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
};

export type RootListResponse = (Array<OrganisationList>);

export type RootCreateData = {
    requestBody: Organisation;
};

export type RootCreateResponse = (Organisation);

export type RootRetrieveData = {
    uid: string;
};

export type RootRetrieveResponse = (Organisation);

export type RootUpdateData = {
    requestBody: Organisation;
    uid: string;
};

export type RootUpdateResponse = (Organisation);

export type RootPartialUpdateData = {
    requestBody?: PatchedOrganisation;
    uid: string;
};

export type RootPartialUpdateResponse = (Organisation);

export type RootDestroyData = {
    uid: string;
};

export type RootDestroyResponse = (void);

export type PaymentProvidersListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    purchaserUid: string;
};

export type PaymentProvidersListResponse = (PaginatedPurchaserPaymentProviderList);

export type PaymentProvidersRetrieveData = {
    purchaserUid: string;
    uid: string;
};

export type PaymentProvidersRetrieveResponse = (PurchaserPaymentProvider);

export type PaymentProvidersDestroyData = {
    purchaserUid: string;
    uid: string;
};

export type PaymentProvidersDestroyResponse = (void);

export type PaymentProvidersCreateWithMandateCreateData = {
    purchaserUid: string;
    requestBody: PurchaserPaymentProviderRedirect;
};

export type PaymentProvidersCreateWithMandateCreateResponse = (Redirect);

export type PaymentsListData = {
    amountGte?: number;
    amountLte?: number;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    orderUid?: string;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * * `OPEN` - Open
     * * `PAID` - Paid
     * * `FAILED` - Failed
     */
    status?: 'FAILED' | 'OPEN' | 'PAID';
    /**
     * * `Bank` - Bank
     * * `Cash` - Cash
     * * `Mollie` - Mollie
     * * `PayPal` - PayPal
     * * `Pin` - Pin
     * * `CreditCard` - CreditCard
     */
    type?: 'Bank' | 'Cash' | 'CreditCard' | 'Mollie' | 'PayPal' | 'Pin';
};

export type PaymentsListResponse = (PaginatedPaymentList);

export type PaymentsCreateData = {
    organisationUid: string;
    requestBody: Payment;
};

export type PaymentsCreateResponse = (Payment);

export type PaymentsRetrieveData = {
    /**
     * A unique integer value identifying this payment.
     */
    id: number;
    organisationUid: string;
};

export type PaymentsRetrieveResponse = (Payment);

export type PaymentsUpdateData = {
    /**
     * A unique integer value identifying this payment.
     */
    id: number;
    organisationUid: string;
    requestBody: Payment;
};

export type PaymentsUpdateResponse = (Payment);

export type PaymentsPartialUpdateData = {
    /**
     * A unique integer value identifying this payment.
     */
    id: number;
    organisationUid: string;
    requestBody?: PatchedPayment;
};

export type PaymentsPartialUpdateResponse = (Payment);

export type PaymentsDestroyData = {
    /**
     * A unique integer value identifying this payment.
     */
    id: number;
    organisationUid: string;
};

export type PaymentsDestroyResponse = (void);

export type PoiListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    parentMapOrganisationUid: string;
};

export type PoiListResponse = (Array<PointOfInterest>);

export type PoiCreateData = {
    parentMapOrganisationUid: string;
    requestBody?: PointOfInterest;
};

export type PoiCreateResponse = (PointOfInterest);

export type PoiRetrieveData = {
    parentMapOrganisationUid: string;
    uid: string;
};

export type PoiRetrieveResponse = (PointOfInterest);

export type PoiUpdateData = {
    parentMapOrganisationUid: string;
    requestBody?: PointOfInterest;
    uid: string;
};

export type PoiUpdateResponse = (PointOfInterest);

export type PoiPartialUpdateData = {
    parentMapOrganisationUid: string;
    requestBody?: PatchedPointOfInterest;
    uid: string;
};

export type PoiPartialUpdateResponse = (PointOfInterest);

export type PoiDestroyData = {
    parentMapOrganisationUid: string;
    uid: string;
};

export type PoiDestroyResponse = (void);

export type ProductsListData = {
    category?: number;
    /**
     * Multiple values may be separated by commas.
     */
    categoryDefaultIn?: Array<(string)>;
    /**
     * Current price is greater than or equal to
     */
    currentPriceGte?: number;
    /**
     * Current price is smaller than or equal to
     */
    currentPriceLte?: number;
    freshAvailable?: boolean;
    frozenAvailable?: boolean;
    /**
     * Future price is greater than or equal to
     */
    futurePriceGte?: number;
    /**
     * Future price is smaller than or equal to
     */
    futurePriceLte?: number;
    hidden?: boolean;
    isCustomProduct?: boolean;
    nameIcontains?: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     */
    planModule?: 'ACCOUNTING' | 'FACILITY_PLANNING' | 'FEED_AND_MEDICINE' | 'FINANCIAL_AND_PAYMENT' | 'HORSE_SERVICES_CARE' | 'HORSE_SERVICES_FULL' | 'RVO_REPORTS' | 'SHOP_AND_BREEDING' | 'USER_ACCOUNTS' | 'WORKFORCE_MANAGEMENT';
    /**
     * Multiple values may be separated by commas.
     */
    planModuleIn?: Array<(string)>;
    /**
     * Every product needs a product type. This is used in the business logic to identify the type of the product.
     *
     * * `HEALTH_CERTIFICATE` - health certificate
     * * `BREEDING_ADMINISTRATION` - breeding administration
     * * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     * * `ACTIVITY` - Activity
     */
    productType?: 'ACTIVITY' | 'BREEDING' | 'BREEDING_ADMINISTRATION' | 'HEALTH_CERTIFICATE' | 'SHIPPING' | 'SUBSCRIPTION';
    /**
     * Multiple values may be separated by commas.
     */
    productTypeIn?: Array<(string)>;
    shippingCountriesIcontains?: string;
    shippingProviderNameIcontains?: string;
    /**
     * * `REGULAR` - Regular
     * * `PICK_UP` - Pick up
     * * `SAME_DAY_DELIVERY` - Same day delivery
     * * `NEXT_DAY_DELIVERY` - Next day delivery
     * * `SUNDAY_HOLIDAY_DELIVERY` - Sunday and holiday delivery
     * * `STAFF_DELIVERY` - staff delivery
     */
    shippingServiceType?: ('NEXT_DAY_DELIVERY' | 'PICK_UP' | 'REGULAR' | 'SAME_DAY_DELIVERY' | 'STAFF_DELIVERY' | 'SUNDAY_HOLIDAY_DELIVERY') | null;
    showInShop?: boolean;
    stallionUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    stallionUidIn?: Array<(string)>;
};

export type ProductsListResponse = (PaginatedProductList);

export type ProductsCreateData = {
    organisationUid: string;
    requestBody: Product;
};

export type ProductsCreateResponse = (Product);

export type ProductsRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type ProductsRetrieveResponse = (Product);

export type ProductsUpdateData = {
    organisationUid: string;
    requestBody: Product;
    uid: string;
};

export type ProductsUpdateResponse = (Product);

export type ProductsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedProduct;
    uid: string;
};

export type ProductsPartialUpdateResponse = (Product);

export type ProductsDestroyData = {
    organisationUid: string;
    uid: string;
};

export type ProductsDestroyResponse = (void);

export type ApiV5AdministrationManureFertilizerNormsListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    year: string;
};

export type ApiV5AdministrationManureFertilizerNormsListResponse = (PaginatedFertilizerNormList);

export type ApiV5HorsepagesRetrieveData = {
    publicAccessUuid: string;
};

export type ApiV5HorsepagesRetrieveResponse = (PublicHorsePage);

export type ApiV5InvoicesRetrieveData = {
    publicAccessUuid: string;
};

export type ApiV5InvoicesRetrieveResponse = (PublicInvoice);

export type ApiV5InvoicesMolliePaymentLinkCreateData = {
    publicAccessUuid: string;
    requestBody: PaymentLink;
};

export type ApiV5InvoicesMolliePaymentLinkCreateResponse = (Redirect);

export type ApiV5OrdersRetrieveData = {
    publicAccessUuid: string;
};

export type ApiV5OrdersRetrieveResponse = (SupplierOrderDetail);

export type ApiV5OrdersUpdateData = {
    publicAccessUuid: string;
    requestBody: PurchaserOrderUpdate;
};

export type ApiV5OrdersUpdateResponse = (PurchaserOrderUpdate);

export type ApiV5OrdersPartialUpdateData = {
    publicAccessUuid: string;
    requestBody?: PatchedPurchaserOrderUpdate;
};

export type ApiV5OrdersPartialUpdateResponse = (PurchaserOrderUpdate);

export type ApiV5OrdersMolliePaymentLinkCreateData = {
    publicAccessUuid: string;
    requestBody: PaymentLink;
};

export type ApiV5OrdersMolliePaymentLinkCreateResponse = (Redirect);

export type ApiV5PublicOrganisationsProductCatalogueListData = {
    category?: number;
    /**
     * Multiple values may be separated by commas.
     */
    categoryDefaultIn?: Array<(string)>;
    /**
     * Current price is greater than or equal to
     */
    currentPriceGte?: number;
    /**
     * Current price is smaller than or equal to
     */
    currentPriceLte?: number;
    freshAvailable?: boolean;
    frozenAvailable?: boolean;
    /**
     * Future price is greater than or equal to
     */
    futurePriceGte?: number;
    /**
     * Future price is smaller than or equal to
     */
    futurePriceLte?: number;
    hidden?: boolean;
    isCustomProduct?: boolean;
    nameIcontains?: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationPublicAccessUuid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     */
    planModule?: 'ACCOUNTING' | 'FACILITY_PLANNING' | 'FEED_AND_MEDICINE' | 'FINANCIAL_AND_PAYMENT' | 'HORSE_SERVICES_CARE' | 'HORSE_SERVICES_FULL' | 'RVO_REPORTS' | 'SHOP_AND_BREEDING' | 'USER_ACCOUNTS' | 'WORKFORCE_MANAGEMENT';
    /**
     * Multiple values may be separated by commas.
     */
    planModuleIn?: Array<(string)>;
    /**
     * Every product needs a product type. This is used in the business logic to identify the type of the product.
     *
     * * `HEALTH_CERTIFICATE` - health certificate
     * * `BREEDING_ADMINISTRATION` - breeding administration
     * * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     * * `ACTIVITY` - Activity
     */
    productType?: 'ACTIVITY' | 'BREEDING' | 'BREEDING_ADMINISTRATION' | 'HEALTH_CERTIFICATE' | 'SHIPPING' | 'SUBSCRIPTION';
    /**
     * Multiple values may be separated by commas.
     */
    productTypeIn?: Array<(string)>;
    shippingCountriesIcontains?: string;
    shippingProviderNameIcontains?: string;
    /**
     * * `REGULAR` - Regular
     * * `PICK_UP` - Pick up
     * * `SAME_DAY_DELIVERY` - Same day delivery
     * * `NEXT_DAY_DELIVERY` - Next day delivery
     * * `SUNDAY_HOLIDAY_DELIVERY` - Sunday and holiday delivery
     * * `STAFF_DELIVERY` - staff delivery
     */
    shippingServiceType?: ('NEXT_DAY_DELIVERY' | 'PICK_UP' | 'REGULAR' | 'SAME_DAY_DELIVERY' | 'STAFF_DELIVERY' | 'SUNDAY_HOLIDAY_DELIVERY') | null;
    showInShop?: boolean;
    stallionUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    stallionUidIn?: Array<(string)>;
};

export type ApiV5PublicOrganisationsProductCatalogueListResponse = (PaginatedCatalogueProductList);

export type ApiV5PublicOrganisationsVatPercentagesListData = {
    countryIexact?: string;
    /**
     * The vat percentage is currently applicable for this country and product category
     */
    isActive?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationPublicAccessUuid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * * `S` - Normal sale
     * * `AE` - Reverse-charging VAT
     * * `G` - Export
     */
    vatCategory?: 'AE' | 'G' | 'S';
    /**
     * * `STANDARD` - standard
     * * `REDUCED` - reduced
     * * `SECOND_REDUCED` - second reduced
     * * `SUPER_REDUCED` - super reduced
     * * `ZERO` - zero
     */
    vatLevel?: 'REDUCED' | 'SECOND_REDUCED' | 'STANDARD' | 'SUPER_REDUCED' | 'ZERO';
    /**
     * Multiple values may be separated by commas.
     */
    vatLevelIn?: Array<(string)>;
};

export type ApiV5PublicOrganisationsVatPercentagesListResponse = (PaginatedVATPercentageList);

export type ApiV5PublicOrganisationsRetrieveData = {
    publicAccessUuid: string;
};

export type ApiV5PublicOrganisationsRetrieveResponse = (PublicOrganisation);

export type ReportedhorserelocationsListData = {
    /**
     * Filter by arrival (a) or departure (d)
     */
    arrivalOrDepartureType?: string;
    horse?: number;
    horselocation?: number;
    horseOrganisationUid: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
};

export type ReportedhorserelocationsListResponse = (PaginatedReportedHorseRelocationList);

export type ReportedhorserelocationsCreateData = {
    horseOrganisationUid: string;
    requestBody: CreateReportedHorseRelocation;
};

export type ReportedhorserelocationsCreateResponse = (CreateReportedHorseRelocation);

export type ReportedhorserelocationsRetrieveData = {
    horseOrganisationUid: string;
    uid: string;
};

export type ReportedhorserelocationsRetrieveResponse = (ReportedHorseRelocation);

export type ReportedhorserelocationsCheckStatusCreateData = {
    horseOrganisationUid: string;
    uid: string;
};

export type ReportedhorserelocationsCheckStatusCreateResponse = (ReportedHorseRelocation);

export type ReportedhorserelocationsWithdrawReportCreateData = {
    horseOrganisationUid: string;
    uid: string;
};

export type ReportedhorserelocationsWithdrawReportCreateResponse = (ReportedHorseRelocation);

export type ReportedhorserelocationsRvOHorseHairColorsListData = {
    horseOrganisationUid: string;
};

export type ReportedhorserelocationsRvOHorseHairColorsListResponse = (Array<RvOHorseHairColor>);

export type RolesListData = {
    organisationUid: string;
};

export type RolesListResponse = (Array<Role>);

export type RolesCreateData = {
    organisationUid: string;
    requestBody?: Role;
};

export type RolesCreateResponse = (Role);

export type RolesRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type RolesRetrieveResponse = (Role);

export type RolesUpdateData = {
    organisationUid: string;
    requestBody?: Role;
    uid: string;
};

export type RolesUpdateResponse = (Role);

export type RolesPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedRole;
    uid: string;
};

export type RolesPartialUpdateResponse = (Role);

export type RolesDestroyData = {
    organisationUid: string;
    uid: string;
};

export type RolesDestroyResponse = (void);

export type RolesModulePermissionsUpdateData = {
    organisationUid: string;
    requestBody: ModulePermissions;
    uid: string;
};

export type RolesModulePermissionsUpdateResponse = (ModulePermissions);

export type RolesAllModulePermissionsListData = {
    organisationUid: string;
};

export type RolesAllModulePermissionsListResponse = (Array<ModulePermissionsList>);

export type RolesModulePermissionsListData = {
    organisationUid: string;
};

export type RolesModulePermissionsListResponse = (Array<ModulePermissionsList>);

export type ServiceListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
};

export type ServiceListResponse = (Array<Service>);

export type ServiceCreateData = {
    organisationUid: string;
    requestBody: Service;
};

export type ServiceCreateResponse = (Service);

export type ServiceRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type ServiceRetrieveResponse = (Service);

export type ServiceUpdateData = {
    organisationUid: string;
    requestBody: Service;
    uid: string;
};

export type ServiceUpdateResponse = (Service);

export type ServicePartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedService;
    uid: string;
};

export type ServicePartialUpdateResponse = (Service);

export type ServiceDestroyData = {
    organisationUid: string;
    uid: string;
};

export type ServiceDestroyResponse = (void);

export type ServicecontactsListData = {
    customerOrganisationUid: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
};

export type ServicecontactsListResponse = (Array<ServiceContact>);

export type ServicecontactsCreateData = {
    customerOrganisationUid: string;
    requestBody: ServiceContact;
};

export type ServicecontactsCreateResponse = (ServiceContact);

export type ServicecontactsRetrieveData = {
    customerOrganisationUid: string;
    uid: string;
};

export type ServicecontactsRetrieveResponse = (ServiceContact);

export type ServicecontactsUpdateData = {
    customerOrganisationUid: string;
    requestBody: ServiceContact;
    uid: string;
};

export type ServicecontactsUpdateResponse = (ServiceContact);

export type ServicecontactsPartialUpdateData = {
    customerOrganisationUid: string;
    requestBody?: PatchedServiceContact;
    uid: string;
};

export type ServicecontactsPartialUpdateResponse = (ServiceContact);

export type ServicecontactsDestroyData = {
    customerOrganisationUid: string;
    uid: string;
};

export type ServicecontactsDestroyResponse = (void);

export type ServiceContractsSuppliedListData = {
    customerUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    customerUidIn?: Array<(string)>;
    endDtGte?: string;
    endDtLte?: string;
    horseUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    horseUidIn?: Array<(string)>;
    /**
     * A contract is active if start_dt < now() < end_dt
     */
    isActive?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     */
    productCategoryDefault?: ('BREEDING' | 'SHIPPING' | 'SUBSCRIPTION') | null;
    /**
     * Multiple values may be separated by commas.
     */
    productCategoryDefaultIn?: Array<(string)>;
    productName?: string;
    /**
     * Multiple values may be separated by commas.
     */
    productNameIn?: Array<(string)>;
    productOrganisationUid: string;
    /**
     * Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     */
    productPlanModule?: 'ACCOUNTING' | 'FACILITY_PLANNING' | 'FEED_AND_MEDICINE' | 'FINANCIAL_AND_PAYMENT' | 'HORSE_SERVICES_CARE' | 'HORSE_SERVICES_FULL' | 'RVO_REPORTS' | 'SHOP_AND_BREEDING' | 'USER_ACCOUNTS' | 'WORKFORCE_MANAGEMENT';
    /**
     * Multiple values may be separated by commas.
     */
    productPlanModuleIn?: Array<(string)>;
    startDtGte?: string;
    startDtLte?: string;
};

export type ServiceContractsSuppliedListResponse = (PaginatedSupplierServiceContractList);

export type ServiceContractsSuppliedCreateData = {
    productOrganisationUid: string;
    requestBody: SupplierServiceContract;
};

export type ServiceContractsSuppliedCreateResponse = (SupplierServiceContract);

export type ServiceContractsSuppliedRetrieveData = {
    productOrganisationUid: string;
    uid: string;
};

export type ServiceContractsSuppliedRetrieveResponse = (SupplierServiceContract);

export type ServiceContractsSuppliedUpdateData = {
    productOrganisationUid: string;
    requestBody: SupplierServiceContractUpdate;
    uid: string;
};

export type ServiceContractsSuppliedUpdateResponse = (SupplierServiceContractUpdate);

export type ServiceContractsSuppliedPartialUpdateData = {
    productOrganisationUid: string;
    requestBody?: PatchedSupplierServiceContractUpdate;
    uid: string;
};

export type ServiceContractsSuppliedPartialUpdateResponse = (SupplierServiceContractUpdate);

export type ServiceContractsPurchasedListData = {
    customerUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    customerUidIn?: Array<(string)>;
    endDtGte?: string;
    endDtLte?: string;
    horseUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    horseUidIn?: Array<(string)>;
    /**
     * A contract is active if start_dt < now() < end_dt
     */
    isActive?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * * `BREEDING` - Breeding
     * * `SHIPPING` - Shipping
     * * `SUBSCRIPTION` - Subscription
     */
    productCategoryDefault?: ('BREEDING' | 'SHIPPING' | 'SUBSCRIPTION') | null;
    /**
     * Multiple values may be separated by commas.
     */
    productCategoryDefaultIn?: Array<(string)>;
    productName?: string;
    /**
     * Multiple values may be separated by commas.
     */
    productNameIn?: Array<(string)>;
    /**
     * Required when the plan should restrict access to active service contracts.
     *
     * * `ACCOUNTING` - Accounting
     * * `SHOP_AND_BREEDING` - Shop and breeding
     * * `FEED_AND_MEDICINE` - Feed and medicine
     * * `FACILITY_PLANNING` - Facility planning
     * * `FINANCIAL_AND_PAYMENT` - Financial and payment
     * * `WORKFORCE_MANAGEMENT` - Workforce management
     * * `USER_ACCOUNTS` - User accounts
     * * `HORSE_SERVICES_CARE` - Horse services, care
     * * `HORSE_SERVICES_FULL` - Horse services, full
     * * `RVO_REPORTS` - RvO reports
     */
    productPlanModule?: 'ACCOUNTING' | 'FACILITY_PLANNING' | 'FEED_AND_MEDICINE' | 'FINANCIAL_AND_PAYMENT' | 'HORSE_SERVICES_CARE' | 'HORSE_SERVICES_FULL' | 'RVO_REPORTS' | 'SHOP_AND_BREEDING' | 'USER_ACCOUNTS' | 'WORKFORCE_MANAGEMENT';
    /**
     * Multiple values may be separated by commas.
     */
    productPlanModuleIn?: Array<(string)>;
    purchaserUid: string;
    startDtGte?: string;
    startDtLte?: string;
};

export type ServiceContractsPurchasedListResponse = (PaginatedPurchaserServiceContractList);

export type ServiceContractsPurchasedRetrieveData = {
    purchaserUid: string;
    uid: string;
};

export type ServiceContractsPurchasedRetrieveResponse = (PurchaserServiceContract);

export type ServiceContractsPurchasedCancelPartialUpdateData = {
    purchaserUid: string;
    requestBody?: PatchedPurchaserServiceContract;
    uid: string;
};

export type ServiceContractsPurchasedCancelPartialUpdateResponse = (PurchaserServiceContract);

export type ServiceContractsPurchasedChangePartialUpdateData = {
    purchaserUid: string;
    requestBody?: PatchedUpgradeDowngradePurchaserServiceContract;
    uid: string;
};

export type ServiceContractsPurchasedChangePartialUpdateResponse = (UpgradeDowngradePurchaserServiceContract);

export type ServiceContractsPurchasedReactivatePartialUpdateData = {
    purchaserUid: string;
    requestBody?: PatchedPurchaserServiceContract;
    uid: string;
};

export type ServiceContractsPurchasedReactivatePartialUpdateResponse = (PurchaserServiceContract);

export type ServiceContractsPurchasedContinueForFreeCreateData = {
    purchaserUid: string;
};

export type ServiceContractsPurchasedContinueForFreeCreateResponse = (unknown);

export type StablesListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
};

export type StablesListResponse = (Array<Stable>);

export type StablesCreateData = {
    organisationUid: string;
    requestBody: Stable;
};

export type StablesCreateResponse = (Stable);

export type StablesRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type StablesRetrieveResponse = (Stable);

export type StablesUpdateData = {
    organisationUid: string;
    requestBody: Stable;
    uid: string;
};

export type StablesUpdateResponse = (Stable);

export type StablesPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedStable;
    uid: string;
};

export type StablesPartialUpdateResponse = (Stable);

export type StablesDestroyData = {
    organisationUid: string;
    uid: string;
};

export type StablesDestroyResponse = (void);

export type StallionmountsListData = {
    collectionDate?: string;
    collectionDateGt?: string;
    collectionDateGte?: string;
    collectionDateLt?: string;
    collectionDateLte?: string;
    createdOnGt?: string;
    createdOnLt?: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    /**
     * Portions fresh available is greater than or equal to
     */
    portionsFreshAvailableGte?: number;
    portionsFreshGte?: number;
    portionsFreshLte?: number;
    stallionOrganisationUid: string;
    stallionUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    stallionUidIn?: Array<(string)>;
    /**
     * Frozen straws available is greater than or equal to
     */
    strawsFrozenAvailableGte?: number;
    strawsFrozenGte?: number;
    strawsFrozenLte?: number;
};

export type StallionmountsListResponse = (PaginatedStallionMountList);

export type StallionmountsCreateData = {
    requestBody: StallionMount;
    stallionOrganisationUid: string;
};

export type StallionmountsCreateResponse = (StallionMount);

export type StallionmountsRetrieveData = {
    stallionOrganisationUid: string;
    uid: string;
};

export type StallionmountsRetrieveResponse = (StallionMountDetail);

export type StallionmountsUpdateData = {
    requestBody: StallionMount;
    stallionOrganisationUid: string;
    uid: string;
};

export type StallionmountsUpdateResponse = (StallionMount);

export type StallionmountsPartialUpdateData = {
    requestBody?: PatchedStallionMount;
    stallionOrganisationUid: string;
    uid: string;
};

export type StallionmountsPartialUpdateResponse = (StallionMount);

export type StallionmountsDestroyData = {
    stallionOrganisationUid: string;
    uid: string;
};

export type StallionmountsDestroyResponse = (void);

export type StallionmountsDestroyFreshPartialUpdateData = {
    stallionOrganisationUid: string;
    uid: string;
};

export type StallionmountsDestroyFreshPartialUpdateResponse = (StallionMount);

export type StallionmountsDestroyFrozenPartialUpdateData = {
    stallionOrganisationUid: string;
    uid: string;
};

export type StallionmountsDestroyFrozenPartialUpdateResponse = (StallionMount);

export type StallionmountsDestroyRemainingPartialUpdateData = {
    stallionOrganisationUid: string;
    uid: string;
};

export type StallionmountsDestroyRemainingPartialUpdateResponse = (StallionMount);

export type TransactionsListData = {
    createdOnGte?: string;
    createdOnLte?: string;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    supplierUid?: string;
};

export type TransactionsListResponse = (PaginatedTransactionList);

export type TransactionsCreateData = {
    organisationUid: string;
    requestBody: TransactionDetail;
};

export type TransactionsCreateResponse = (TransactionDetail);

export type TransactionsRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type TransactionsRetrieveResponse = (TransactionDetail);

export type TransactionsUpdateData = {
    organisationUid: string;
    requestBody: TransactionDetail;
    uid: string;
};

export type TransactionsUpdateResponse = (TransactionDetail);

export type TransactionsPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedTransactionDetail;
    uid: string;
};

export type TransactionsPartialUpdateResponse = (TransactionDetail);

export type TransactionsDestroyData = {
    organisationUid: string;
    uid: string;
};

export type TransactionsDestroyResponse = (void);

export type TransactionsItemsListData = {
    amountGte?: number;
    amountLte?: number;
    createdOnGte?: string;
    createdOnLte?: string;
    customerUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    customerUidIn?: Array<(string)>;
    dateGt?: string;
    dateGte?: string;
    dateLt?: string;
    dateLte?: string;
    horseUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    horseUidIn?: Array<(string)>;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    /**
     * A page number within the paginated result set.
     */
    page?: number;
    /**
     * Number of results to return per page.
     */
    pageSize?: number;
    transactionOrganisationUid: string;
    transactionSupplierUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    transactionSupplierUidIn?: Array<(string)>;
    /**
     * * `EXPENSE` - Expense
     * * `INCOME` - Income
     */
    transactionType?: 'EXPENSE' | 'INCOME';
};

export type TransactionsItemsListResponse = (PaginatedTransactionItemList);

export type VaccinationrulesListData = {
    organisationUid: string;
};

export type VaccinationrulesListResponse = (Array<VaccinationRule>);

export type VaccinationrulesCreateData = {
    organisationUid: string;
    requestBody: VaccinationRule;
};

export type VaccinationrulesCreateResponse = (VaccinationRule);

export type VaccinationrulesRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type VaccinationrulesRetrieveResponse = (VaccinationRule);

export type VaccinationrulesUpdateData = {
    organisationUid: string;
    requestBody: VaccinationRule;
    uid: string;
};

export type VaccinationrulesUpdateResponse = (VaccinationRule);

export type VaccinationrulesPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedVaccinationRule;
    uid: string;
};

export type VaccinationrulesPartialUpdateResponse = (VaccinationRule);

export type VaccinationrulesDestroyData = {
    organisationUid: string;
    uid: string;
};

export type VaccinationrulesDestroyResponse = (void);

export type VatpercentageexternalprovideridsListData = {
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    vatPercentageOrganisationUid: string;
};

export type VatpercentageexternalprovideridsListResponse = (Array<VATPercentageExternalProviderId>);

export type VatpercentageexternalprovideridsCreateData = {
    requestBody: VATPercentageExternalProviderId;
    vatPercentageOrganisationUid: string;
};

export type VatpercentageexternalprovideridsCreateResponse = (VATPercentageExternalProviderId);

export type VatpercentageexternalprovideridsRetrieveData = {
    uid: string;
    vatPercentageOrganisationUid: string;
};

export type VatpercentageexternalprovideridsRetrieveResponse = (VATPercentageExternalProviderId);

export type VatpercentageexternalprovideridsUpdateData = {
    requestBody: VATPercentageExternalProviderId;
    uid: string;
    vatPercentageOrganisationUid: string;
};

export type VatpercentageexternalprovideridsUpdateResponse = (VATPercentageExternalProviderId);

export type VatpercentageexternalprovideridsPartialUpdateData = {
    requestBody?: PatchedVATPercentageExternalProviderId;
    uid: string;
    vatPercentageOrganisationUid: string;
};

export type VatpercentageexternalprovideridsPartialUpdateResponse = (VATPercentageExternalProviderId);

export type VatpercentageexternalprovideridsDestroyData = {
    uid: string;
    vatPercentageOrganisationUid: string;
};

export type VatpercentageexternalprovideridsDestroyResponse = (void);

export type VatpercentagesListData = {
    countryIexact?: string;
    /**
     * The vat percentage is currently applicable for this country and product category
     */
    isActive?: boolean;
    /**
     * Which field to use when ordering the results.
     */
    o?: string;
    organisationUid: string;
    /**
     * * `S` - Normal sale
     * * `AE` - Reverse-charging VAT
     * * `G` - Export
     */
    vatCategory?: 'AE' | 'G' | 'S';
    /**
     * * `STANDARD` - standard
     * * `REDUCED` - reduced
     * * `SECOND_REDUCED` - second reduced
     * * `SUPER_REDUCED` - super reduced
     * * `ZERO` - zero
     */
    vatLevel?: 'REDUCED' | 'SECOND_REDUCED' | 'STANDARD' | 'SUPER_REDUCED' | 'ZERO';
    /**
     * Multiple values may be separated by commas.
     */
    vatLevelIn?: Array<(string)>;
};

export type VatpercentagesListResponse = (Array<VATPercentage>);

export type VatpercentagesCreateData = {
    organisationUid: string;
    requestBody: VATPercentage;
};

export type VatpercentagesCreateResponse = (VATPercentage);

export type VatpercentagesRetrieveData = {
    organisationUid: string;
    uid: string;
};

export type VatpercentagesRetrieveResponse = (VATPercentage);

export type VatpercentagesUpdateData = {
    organisationUid: string;
    requestBody?: VATPercentageUpdate;
    uid: string;
};

export type VatpercentagesUpdateResponse = (VATPercentageUpdate);

export type VatpercentagesPartialUpdateData = {
    organisationUid: string;
    requestBody?: PatchedVATPercentageUpdate;
    uid: string;
};

export type VatpercentagesPartialUpdateResponse = (VATPercentageUpdate);

export type VatpercentagesDestroyData = {
    organisationUid: string;
    uid: string;
};

export type VatpercentagesDestroyResponse = (void);

export type VatpercentagesImportDefaultEuVatPercentagesCreateData = {
    organisationUid: string;
};

export type VatpercentagesImportDefaultEuVatPercentagesCreateResponse = (unknown);

export type ApiV5WebhookMollieMandateCreateData = {
    organisationPublicAccessUuid: string;
};

export type ApiV5WebhookMollieMandateCreateResponse = (unknown);

export type ApiV5WebhookMolliePaymentCreateData = {
    organisationPublicAccessUuid: string;
};

export type ApiV5WebhookMolliePaymentCreateResponse = (unknown);

export type ApiV5WebhookSnelstartCreateResponse = (unknown);

export type WorkdayAvailabilityActivitiesListData = {
    dendGt?: string;
    dstartLt?: string;
    organisationUid: string;
};

export type WorkdayAvailabilityActivitiesListResponse = (Array<WorkDayAvailability>);

export type WorkdayAvailabilityManagerListData = {
    contactUid?: string;
    /**
     * Multiple values may be separated by commas.
     */
    contactUidIn?: Array<(string)>;
    dendGt?: string;
    dstartLt?: string;
    organisationUid: string;
};

export type WorkdayAvailabilityManagerListResponse = (Array<WorkDayAvailabilityManager>);